import { Schema as As, Fragment as q, DOMParser as Ss, NodeRange as Pn, Slice as Ce, Node as Wu, Mark as _n } from "./index307.js";
import { DecorationSet as va, Decoration as fa, EditorView as da } from "./index308.js";
import { canSplit as Os, ReplaceAroundStep as Xt, liftTarget as Gu, StepMap as Xu } from "./index309.js";
import { PluginKey as pa, EditorState as Ds, Plugin as Ee, TextSelection as Dt, AllSelection as Is, Selection as It, NodeSelection as Qu, SelectionRange as Ku } from "./index310.js";
import { keymap as zt } from "./index311.js";
import { baseKeymap as di, chainCommands as Yu, setBlockType as ha, wrapIn as Zu, toggleMark as Qt, exitCode as Ns, selectAll as Ju, deleteSelection as ec, joinForward as tc, newlineInCode as rc } from "./index312.js";
import { InputRule as Rs, inputRules as Bs, undoInputRule as nc } from "./index313.js";
import { history as Hs, redo as Ps, undo as pr, undoDepth as ac } from "./index314.js";
/**
 * @toast-ui/editor
 * @version 3.2.2 | Fri Feb 17 2023
 * @author NHN Cloud FE Development Lab <dl_javascript@nhn.com>
 * @license MIT
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var qn = function(t, e) {
  return qn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, qn(t, e);
};
function x(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  qn(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var b = function() {
  return b = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, b.apply(this, arguments);
};
function ce(t, e, r) {
  if (arguments.length === 2) for (var n = 0, a = e.length, i; n < a; n++)
    (i || !(n in e)) && (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function R(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
function ic(t, e, r) {
  var n;
  r = r || null;
  for (n in t)
    if (t.hasOwnProperty(n) && e.call(r, t[n], n, t) === !1)
      break;
}
var Ct = ic;
function oc(t, e) {
  var r = Object.prototype.hasOwnProperty, n, a, i, o;
  for (i = 1, o = arguments.length; i < o; i += 1) {
    n = arguments[i];
    for (a in n)
      r.call(n, a) && (t[a] = n[a]);
  }
  return t;
}
var ma = oc;
function sc(t) {
  return typeof t == "string" || t instanceof String;
}
var Fe = sc;
function lc(t) {
  return t instanceof Array;
}
var Nt = lc;
function uc(t, e, r) {
  var n = 0, a = t.length;
  for (r = r || null; n < a && e.call(r, t[n], n, t) !== !1; n += 1)
    ;
}
var Tt = uc, cc = Nt, vc = Tt, fc = Ct;
function dc(t, e, r) {
  cc(t) ? vc(t, e, r) : fc(t, e, r);
}
var $r = dc, pc = Fe, hc = $r;
function mc(t, e, r) {
  var n = t.style;
  if (pc(e)) {
    n[e] = r;
    return;
  }
  hc(e, function(a, i) {
    n[i] = a;
  });
}
var Oe = mc, gc = Nt;
function yc(t, e, r) {
  var n, a;
  if (r = r || 0, !gc(e))
    return -1;
  if (Array.prototype.indexOf)
    return Array.prototype.indexOf.call(e, t, r);
  for (a = e.length, n = r; r >= 0 && n < a; n += 1)
    if (e[n] === t)
      return n;
  return -1;
}
var tt = yc;
function bc(t) {
  return t === void 0;
}
var Te = bc, wc = Te;
function Cc(t) {
  return !t || !t.className ? "" : wc(t.className.baseVal) ? t.className : t.className.baseVal;
}
var ga = Cc, Tc = Nt, kc = Te;
function Ec(t, e) {
  if (e = Tc(e) ? e.join(" ") : e, e = e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), kc(t.className.baseVal)) {
    t.className = e;
    return;
  }
  t.className.baseVal = e;
}
var _s = Ec, pi = $r, xc = tt, Lc = ga, Mc = _s;
function Ac(t) {
  var e = Array.prototype.slice.call(arguments, 1), r = t.classList, n = [], a;
  if (r) {
    pi(e, function(i) {
      t.classList.add(i);
    });
    return;
  }
  a = Lc(t), a && (e = [].concat(a.split(/\s+/), e)), pi(e, function(i) {
    xc(i, n) < 0 && n.push(i);
  }), Mc(t, n);
}
var Ae = Ac, hi = Tt, Sc = tt, Oc = ga, Dc = _s;
function Ic(t) {
  var e = Array.prototype.slice.call(arguments, 1), r = t.classList, n, a;
  if (r) {
    hi(e, function(i) {
      r.remove(i);
    });
    return;
  }
  n = Oc(t).split(/\s+/), a = [], hi(n, function(i) {
    Sc(i, e) < 0 && a.push(i);
  }), Dc(t, a);
}
var ye = Ic;
function Nc(t) {
  return typeof t == "number" || t instanceof Number;
}
var He = Nc;
function Rc(t) {
  return t === null;
}
var Tr = Rc, Bc = Ct;
function Hc(t, e) {
  var r = document.createElement("img"), n = "";
  return Bc(e, function(a, i) {
    n += "&" + i + "=" + a;
  }), n = n.substring(1), r.src = t + "?" + n, r.style.display = "none", document.body.appendChild(r), document.body.removeChild(r), r;
}
var Pc = Hc, _c = Te, qc = Pc, $c = 10080 * 60 * 1e3;
function Fc(t) {
  var e = (/* @__PURE__ */ new Date()).getTime();
  return e - t > $c;
}
function Uc(t, e) {
  var r = "https://www.google-analytics.com/collect", n = location.hostname, a = "event", i = "use", o = "TOAST UI " + t + " for " + n + ": Statistics", s = window.localStorage.getItem(o);
  !_c(window.tui) && window.tui.usageStatistics === !1 || s && !Fc(s) || (window.localStorage.setItem(o, (/* @__PURE__ */ new Date()).getTime()), setTimeout(function() {
    (document.readyState === "interactive" || document.readyState === "complete") && qc(r, {
      v: 1,
      t: a,
      tid: e,
      cid: n,
      dp: n,
      dh: t,
      el: t,
      ec: i
    });
  }, 1e3));
}
var Vc = Uc, jc = /[\u0020]+/g, zc = /[>(){}[\]+-.!#|]/g, mi = /<([a-zA-Z_][a-zA-Z0-9\-._]*)(\s|[^\\>])*\/?>|<(\/)([a-zA-Z_][a-zA-Z0-9\-._]*)\s*\/?>|<!--[^-]+-->|<([a-zA-Z_][a-zA-Z0-9\-.:/]*)>/g, gi = /\\[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]/g, Wc = /[*_~`]/g, yi = /!\[.*\]\(.*\)/g, Gc = /[[\]]/g, bi = /(?:^|[^\\])\\(?!\\)/g, Xc = '[&<>"]', wi = new RegExp(Xc, "g");
function Qc(t) {
  switch (t) {
    case "&":
      return "&amp;";
    case "<":
      return "&lt;";
    case ">":
      return "&gt;";
    case '"':
      return "&quot;";
    default:
      return t;
  }
}
function bt(t) {
  return wi.test(t) ? t.replace(wi, Qc) : t;
}
function Kc() {
  Vc("editor", "UA-129966929-1");
}
function te(t, e) {
  return t.indexOf(e) !== -1;
}
var Yc = ["rel", "target", "hreflang", "type"], Zc = {
  codeblock: /(^ {4}[^\n]+\n*)+/,
  thematicBreak: /^ *((\* *){3,}|(- *){3,} *|(_ *){3,}) */,
  atxHeading: /^(#{1,6}) +[\s\S]+/,
  seTextheading: /^([^\n]+)\n *(=|-){2,} */,
  blockquote: /^( *>[^\n]+.*)+/,
  list: /^ *(\*+|-+|\d+\.) [\s\S]+/,
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? */,
  link: /!?\[.*\]\(.*\)/,
  reflink: /!?\[.*\]\s*\[([^\]]*)\]/,
  verticalBar: /\u007C/,
  fencedCodeblock: /^((`|~){3,})/
};
function qs(t) {
  if (!t)
    return null;
  var e = {};
  return Yc.forEach(function(r) {
    Te(t[r]) || (e[r] = t[r]);
  }), e;
}
function kr(t, e) {
  for (var r = "", n = 0; n < e; n += 1)
    r += t;
  return r;
}
function Jc(t) {
  var e = !1;
  return Ct(Zc, function(r) {
    return r.test(t) && (e = !0), !e;
  }), e;
}
function Er(t) {
  for (var e = [], r = yi.exec(t); r; )
    e.push([r.index, r.index + r[0].length]), r = yi.exec(t);
  return t.replace(Gc, function(n, a) {
    var i = e.some(function(o) {
      return a > o[0] && a < o[1];
    });
    return i ? n : "\\" + n;
  });
}
function ev(t) {
  var e = function(a) {
    return "\\" + a;
  }, r = function(a) {
    return a + "\\";
  }, n = t.replace(jc, " ");
  return gi.test(n) && (n = n.replace(gi, e)), bi.test(n) && (n = n.replace(bi, r)), n = n.replace(Wc, e), mi.test(n) && (n = n.replace(mi, e)), Jc(n) && (n = n.replace(zc, e)), n;
}
function tv(t) {
  var e;
  return t.indexOf('"') === -1 ? e = '""' : e = t.indexOf("'") === -1 ? "''" : "()", e[0] + t + e[1];
}
function $n(t) {
  return Tr(t) || Te(t);
}
function ya(t, e) {
  if (t === null && t === e)
    return !0;
  if (typeof t != "object" || typeof e != "object" || $n(t) || $n(e))
    return t === e;
  for (var r in t)
    if (t[r] !== e[r])
      return !1;
  for (var r in e)
    if (!(r in t))
      return !1;
  return !0;
}
function se(t) {
  return t[t.length - 1];
}
function rv(t, e, r) {
  return t >= e && t <= r;
}
function ba(t) {
  return typeof t == "object" && t !== null;
}
function xr(t, e) {
  var r = b({}, t);
  return t && e && Object.keys(e).forEach(function(n) {
    ba(r[n]) ? Array.isArray(e[n]) ? r[n] = wa(e[n]) : r.hasOwnProperty(n) ? r[n] = xr(r[n], e[n]) : r[n] = Ca(e[n]) : r[n] = e[n];
  }), r;
}
function wa(t) {
  return t.map(function(e) {
    return ba(e) ? Array.isArray(e) ? wa(e) : Ca(e) : e;
  });
}
function Ca(t) {
  var e = Object.keys(t);
  return e.length ? e.reduce(function(r, n) {
    return ba(t[n]) ? r[n] = Array.isArray(t[n]) ? wa(t[n]) : Ca(t[n]) : r[n] = t[n], r;
  }, {}) : t;
}
function Ta(t, e) {
  return e === void 0 && (e = {}), Object.keys(e).forEach(function(r) {
    t.hasOwnProperty(r) && typeof t[r] == "object" ? Array.isArray(e[r]) ? t[r] = e[r] : Ta(t[r], e[r]) : t[r] = e[r];
  }), t;
}
function Ci(t, e) {
  return t > e ? [e, t] : [t, e];
}
var nv = Tt;
function av(t) {
  var e;
  try {
    e = Array.prototype.slice.call(t);
  } catch {
    e = [], nv(t, function(n) {
      e.push(n);
    });
  }
  return e;
}
var De = av;
function Lr(t, e) {
  var r = t.nodes.paragraph;
  return e ? r.create(null, Fe(e) ? t.text(e) : e) : r.createAndFill();
}
function ee(t, e, r) {
  return t.text(e, r);
}
function F(t, e, r) {
  r === void 0 && (r = e);
  var n = t.doc.content.size, a = n > 0 ? n - 1 : 1;
  return Dt.create(t.doc, Math.min(e, a), Math.min(r, a));
}
function ka(t, e, r) {
  var n = e.pos;
  return t.replaceWith(n, n, Lr(r)), t.setSelection(F(t, n + 1));
}
function Mr(t) {
  for (var e = t.state, r = t.from, n = t.startIndex, a = t.endIndex, i = t.createText, o = e.tr, s = e.doc, l = e.schema, u = n; u <= a; u += 1) {
    var c = s.child(u), v = c.nodeSize, f = c.textContent, d = c.content, p = i(f), h = p ? ee(l, p) : q.empty, m = o.mapping.map(r), y = m + d.size;
    o.replaceWith(m, y, h), r += v;
  }
  return o;
}
function Ea(t, e, r, n) {
  var a = r.length;
  t.split(e).delete(e - a, e).insert(t.mapping.map(e), n).setSelection(F(t, t.mapping.map(e) - a));
}
function Kt(t) {
  return t.sourcepos[0][0];
}
function Fr(t) {
  return t.sourcepos[1][0];
}
function Ur(t) {
  return t.sourcepos[0][1];
}
function We(t) {
  return t.sourcepos[1][1];
}
function iv(t) {
  var e = t.type;
  return e === "htmlBlock" || e === "htmlInline";
}
function ov(t) {
  var e = t.type;
  return e === "strike" || e === "strong" || e === "emph" || e === "code" || e === "link" || e === "image";
}
function sv(t) {
  return t && t.type === "codeBlock";
}
function rt(t) {
  return t && (t.type === "item" || t.type === "list");
}
function $s(t) {
  return rt(t) && t.listData.type === "ordered";
}
function lv(t) {
  return rt(t) && t.listData.type !== "ordered";
}
function Ti(t) {
  return t && (t.type === "tableCell" || t.type === "tableDelimCell");
}
function uv(t) {
  switch (t.type) {
    case "code":
    case "text":
    case "emph":
    case "strong":
    case "strike":
    case "link":
    case "image":
    case "htmlInline":
    case "linebreak":
    case "softbreak":
    case "customInline":
      return !0;
    default:
      return !1;
  }
}
function kt(t, e, r) {
  for (r === void 0 && (r = !0), t = r ? t : t.parent; t && t.type !== "document"; ) {
    if (e(t))
      return t;
    t = t.parent;
  }
  return null;
}
function cv(t, e, r) {
  for (r === void 0 && (r = !0), t = r ? t : t.parent; t && t.type !== "document"; )
    e(t), t = t.parent;
}
function Q(t, e) {
  return [t[0], t[1] + e];
}
function Ge(t, e) {
  return [t[0], e];
}
function vv(t) {
  var e = t.firstChild.literal;
  switch (t.type) {
    case "emph":
      return "*" + e + "*";
    case "strong":
      return "**" + e + "**";
    case "strike":
      return "~~" + e + "~~";
    case "code":
      return "`" + e + "`";
    case "link":
    case "image":
      var r = t, n = r.destination, a = r.title, i = t.type === "link" ? "" : "!";
      return i + "[" + e + "](" + n + (a ? ' "' + a + '"' : "") + ")";
    default:
      return null;
  }
}
function fv(t) {
  switch (t.type) {
    case "document":
    case "blockQuote":
    case "list":
    case "item":
    case "paragraph":
    case "heading":
    case "emph":
    case "strong":
    case "strike":
    case "link":
    case "image":
    case "table":
    case "tableHead":
    case "tableBody":
    case "tableRow":
    case "tableCell":
    case "tableDelimRow":
    case "customInline":
      return !0;
    default:
      return !1;
  }
}
function dv(t) {
  for (var e = [], r = t.walker(), n = null; n = r.next(); ) {
    var a = n.node;
    a.type === "text" && e.push(a.literal);
  }
  return e.join("");
}
var Wt = [], Fs = {}, ki = /\$\$widget\d+\s/;
function Vr(t) {
  var e = t.search(ki);
  if (e !== -1) {
    var r = t.substring(e), n = r.replace(ki, "").replace("$$", "");
    t = t.substring(0, e), t += Vr(n);
  }
  return t;
}
function Us(t, e) {
  return "$$" + t + " " + e + "$$";
}
function Vs(t, e) {
  var r = Fs[t], n = r.rule, a = r.toDOM, i = Vr(e).match(n);
  return i && (e = i[0]), a(e);
}
function pv() {
  return Wt;
}
function hv(t) {
  Wt = t, Wt.forEach(function(e, r) {
    Fs["widget" + r] = e;
  });
}
function hn(t, e, r, n) {
  return t.concat(et(e, r, n));
}
function et(t, e, r) {
  r === void 0 && (r = 0);
  var n = [], a = (Wt[r] || {}).rule, i = r + 1;
  if (t = Vr(t), a && a.test(t)) {
    for (var o = void 0; (o = t.search(a)) !== -1; ) {
      var s = t.substring(0, o);
      s && (n = hn(n, s, e, i)), t = t.substring(o);
      var l = t.match(a)[0], u = "widget" + r;
      n.push(e.nodes.widget.create({ info: u }, e.text(Us(u, l)))), t = t.substring(l.length);
    }
    t && (n = hn(n, t, e, i));
  } else t && (n = r < Wt.length - 1 ? hn(n, t, e, i) : [e.text(t)]);
  return n;
}
function js(t) {
  for (var e, r = "", n = t.walker(); e = n.next(); ) {
    var a = e.node, i = e.entering;
    i && (a !== t && a.type !== "text" ? (r += vv(a), n.resumeAt(t, !1), n.next()) : a.type === "text" && (r += a.literal));
  }
  return r;
}
function zs() {
  return {
    deleteSelection: function() {
      return ec;
    },
    selectAll: function() {
      return Ju;
    },
    undo: function() {
      return pr;
    },
    redo: function() {
      return Ps;
    }
  };
}
function mv(t) {
  return new Ee({
    props: {
      decorations: function(e) {
        var r = e.doc;
        if (t.text && r.childCount === 1 && r.firstChild.isTextblock && r.firstChild.content.size === 0) {
          var n = document.createElement("span");
          return Ae(n, "placeholder"), t.className && Ae(n, t.className), n.textContent = t.text, va.create(r, [fa.widget(1, n)]);
        }
        return null;
      }
    }
  });
}
var gv = tt, yv = ga;
function bv(t, e) {
  var r;
  return t.classList ? t.classList.contains(e) : (r = yv(t).split(/\s+/), gv(e, r) > -1);
}
var Ws = bv, wv = tt, Cv = De, nr = Element.prototype, Tv = nr.matches || nr.webkitMatchesSelector || nr.mozMatchesSelector || nr.msMatchesSelector || function(t) {
  var e = this.document || this.ownerDocument;
  return wv(this, Cv(e.querySelectorAll(t))) > -1;
};
function kv(t, e) {
  return Tv.call(t, e);
}
var Ev = kv, Gs = "[A-Za-z][A-Za-z0-9-]*", xv = "[a-zA-Z_:][a-zA-Z0-9:._-]*", Lv = "[^\"'=<>`\\x00-\\x20]+", Mv = "'[^']*'", Av = '"[^"]*"', Sv = "(?:" + Lv + "|" + Mv + "|" + Av + ")", Ov = "(?:\\s*=\\s*" + Sv + ")", Xs = "(?:\\s+" + xv + Ov + "?)", Qs = "<(" + Gs + ")(" + Xs + ")*\\s*/?>", Dv = "</(" + Gs + ")\\s*[>]", Ks = "(?:" + Qs + "|" + Dv + ")", Et = new RegExp("^" + Ks, "i"), Fn = /<br\s*\/*>/i, Iv = /<! ---->|<!--(?:-?[^>-])(?:-?[^-])*-->/, Ys = "</p><p>";
function xa(t, e, r) {
  var n = parseInt(t.left, 10), a = parseInt(t.top, 10), i = parseInt(t.width, 10) + parseInt(t.paddingLeft, 10) + parseInt(t.paddingRight, 10), o = parseInt(t.height, 10) + parseInt(t.paddingTop, 10) + parseInt(t.paddingBottom, 10);
  return e >= n && e <= n + i && r >= a && r <= a + o;
}
var Zs = "toastui-editor-";
function L() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  for (var r = [], n = 0, a = t; n < a.length; n++) {
    var i = a[n], o = void 0;
    Array.isArray(i) ? o = i[0] ? i[1] : null : o = i, o && r.push("" + Zs + o);
  }
  return r.join(" ");
}
function X() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return t.map(function(r) {
    return Zs + "md-" + r;
  }).join(" ");
}
function Nv(t) {
  return t?.nodeType === Node.TEXT_NODE;
}
function jr(t) {
  return t && t.nodeType === Node.ELEMENT_NODE;
}
function Rv(t, e) {
  var r = De(t.querySelectorAll(e));
  return r.length ? r : [];
}
function Bv(t, e) {
  e = Nt(e) ? De(e) : [e], e.forEach(function(r) {
    t.appendChild(r);
  });
}
function Hv(t, e) {
  e.parentNode && e.parentNode.insertBefore(t, e);
}
function nt(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function Pv(t) {
  for (var e = []; t.firstChild; )
    e.push(t.firstChild), t.parentNode && t.parentNode.insertBefore(t.firstChild, t);
  return nt(t), e;
}
function La(t, e, r) {
  Te(r) && (r = !Ws(t, e));
  var n = r ? Ae : ye;
  n(t, e);
}
function Js(t, e) {
  var r = document.createElement("div");
  Fe(t) ? r.innerHTML = t : r.appendChild(t);
  var n = r.firstChild;
  return e && e.appendChild(n), n;
}
function Ma(t) {
  var e = window.getComputedStyle(t);
  return ["margin-left", "margin-right"].reduce(function(r, n) {
    return r + parseInt(e.getPropertyValue(n), 10);
  }, 0) + t.offsetWidth;
}
function Se(t, e) {
  var r;
  for (Fe(e) ? r = function(n) {
    return Ev(n, e);
  } : r = function(n) {
    return n === e;
  }; t && t !== document; ) {
    if (jr(t) && r(t))
      return t;
    t = t.parentNode;
  }
  return null;
}
function el(t, e) {
  for (var r = 0, n = 0; t && t !== e; ) {
    var a = t.offsetTop, i = t.offsetLeft, o = t.offsetParent;
    if (r += a, n += i, o === e.offsetParent)
      break;
    t = t.offsetParent;
  }
  return { offsetTop: r, offsetLeft: n };
}
function Aa(t, e) {
  Object.keys(t).forEach(function(r) {
    $n(t[r]) ? e.removeAttribute(r) : e.setAttribute(r, t[r]);
  });
}
function _v(t) {
  var e = t.replace(/<p><br\s*\/*><\/p>/gi, "<p></p>"), r = new RegExp(Ks, "ig"), n = e.match(r);
  return n?.forEach(function(a, i) {
    if (Fn.test(a)) {
      var o = Ys;
      if (i) {
        var s = n[i - 1], l = s.match(Qs);
        if (l && !/br/i.test(l[1])) {
          var u = l[1];
          o = "</" + u + "><" + u + ">";
        }
      }
      e = e.replace(Fn, o);
    }
  }), e;
}
function Sa(t) {
  var e = /<img class="ProseMirror-separator" alt="">/g, r = / class="ProseMirror-trailingBreak"/g, n = t;
  return n = n.replace(e, ""), n = n.replace(r, ""), n;
}
var tl = new pa("widget"), Ei = 5, qv = (
  /** @class */
  (function() {
    function t(e, r) {
      var n = this;
      this.popup = null, this.removeWidget = function() {
        n.popup && (n.rootEl.removeChild(n.popup), n.popup = null);
      }, this.rootEl = e.dom.parentElement, this.eventEmitter = r, this.eventEmitter.listen("blur", this.removeWidget), this.eventEmitter.listen("loadUI", function() {
        n.rootEl = Se(e.dom.parentElement, "." + L("defaultUI"));
      }), this.eventEmitter.listen("removePopupWidget", this.removeWidget);
    }
    return t.prototype.update = function(e) {
      var r = tl.getState(e.state);
      if (this.removeWidget(), r) {
        var n = r.node, a = r.style, i = e.coordsAtPos(r.pos), o = i.top, s = i.left, l = i.bottom, u = l - o, c = this.rootEl.getBoundingClientRect(), v = o - c.top;
        Oe(n, { opacity: "0" }), this.rootEl.appendChild(n), Oe(n, {
          position: "absolute",
          left: s - c.left + Ei + "px",
          top: (a === "bottom" ? v + u - Ei : v - u) + "px",
          opacity: "1"
        }), this.popup = n, e.focus();
      }
    }, t.prototype.destroy = function() {
      this.eventEmitter.removeEventHandler("blur", this.removeWidget);
    }, t;
  })()
);
function $v(t) {
  return new Ee({
    key: tl,
    state: {
      init: function() {
        return null;
      },
      apply: function(e) {
        return e.getMeta("widget");
      }
    },
    view: function(e) {
      return new qv(e, t);
    }
  });
}
function Fv(t) {
  t.listen("addImageBlobHook", function(e, r) {
    var n = new FileReader();
    n.onload = function(a) {
      var i = a.target;
      return r(i.result);
    }, n.readAsDataURL(e);
  });
}
function Oa(t, e, r) {
  var n = function(a, i) {
    t.emit("command", "addImage", {
      imageUrl: a,
      altText: i || e.name || "image"
    });
  };
  t.emit("addImageBlobHook", e, n, r);
}
function rl(t) {
  var e = De(t).filter(function(n) {
    var a = n.type;
    return a.indexOf("image") !== -1;
  });
  if (e.length === 1) {
    var r = e[0];
    if (r)
      return r.getAsFile();
  }
  return null;
}
function Uv(t) {
  var e = t.eventEmitter;
  return new Ee({
    props: {
      handleDOMEvents: {
        drop: function(r, n) {
          var a, i = (a = n.dataTransfer) === null || a === void 0 ? void 0 : a.files;
          return i && Tt(i, function(o) {
            return o.type.indexOf("image") !== -1 ? (n.preventDefault(), n.stopPropagation(), Oa(e, o, n.type), !1) : !0;
          }), !0;
        }
      }
    }
  });
}
var $ = (
  /** @class */
  (function() {
    function t() {
    }
    return Object.defineProperty(t.prototype, "type", {
      get: function() {
        return "node";
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setContext = function(e) {
      this.context = e;
    }, t;
  })()
);
function nl(t) {
  var e = document.createElement("span"), r = Vs(t.attrs.info, t.textContent);
  return e.className = "tui-widget", e.appendChild(r), { dom: e };
}
function Un(t) {
  return t.type.name === "widget";
}
var al = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "widget";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: {
            info: { default: null }
          },
          group: "inline",
          inline: !0,
          content: "text*",
          selectable: !1,
          atom: !0,
          toDOM: function() {
            return ["span", { class: "tui-widget" }, 0];
          },
          parseDOM: [
            {
              tag: "span.tui-widget",
              getAttrs: function(r) {
                var n = r.textContent, a = n.match(/\$\$(widget\d+)/), i = a[1];
                return { info: i };
              }
            }
          ]
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), il = (
  /** @class */
  (function() {
    function t(e) {
      this.timer = null, this.el = document.createElement("div"), this.el.className = "toastui-editor", this.eventEmitter = e, this.placeholder = { text: "" };
    }
    return t.prototype.createState = function() {
      return Ds.create({
        schema: this.schema,
        plugins: this.createPlugins()
      });
    }, t.prototype.initEvent = function() {
      var e = this, r = e.eventEmitter, n = e.view, a = e.editorType;
      n.dom.addEventListener("focus", function() {
        return r.emit("focus", a);
      }), n.dom.addEventListener("blur", function() {
        return r.emit("blur", a);
      });
    }, t.prototype.emitChangeEvent = function(e) {
      this.eventEmitter.emit("caretChange", this.editorType), e.docChanged && this.eventEmitter.emit("change", this.editorType);
    }, Object.defineProperty(t.prototype, "defaultPlugins", {
      get: function() {
        var e = this.createInputRules(), r = ce(ce([], this.keymaps), [
          zt(b({ "Shift-Enter": di.Enter }, di)),
          Hs(),
          mv(this.placeholder),
          $v(this.eventEmitter),
          Uv(this.context)
        ]);
        return e ? r.concat(e) : r;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.createInputRules = function() {
      var e = pv(), r = e.map(function(n) {
        var a = n.rule;
        return new Rs(a, function(i, o, s, l) {
          var u = i.schema, c = i.tr, v = i.doc, f = o.input.match(new RegExp(a, "g")), d = v.resolve(s), p = d.parent, h = 0;
          if (Un(p) && (p = d.node(d.depth - 1)), p.forEach(function(w) {
            return Un(w) && (h += 1);
          }), f.length > h) {
            var m = se(f), y = et(m, u);
            return c.replaceWith(l - m.length + 1, l, y);
          }
          return null;
        });
      });
      return r.length ? Bs({ rules: r }) : null;
    }, t.prototype.clearTimer = function() {
      this.timer && (clearTimeout(this.timer), this.timer = null);
    }, t.prototype.createSchema = function() {
      return new As({
        nodes: this.specs.nodes,
        marks: this.specs.marks
      });
    }, t.prototype.createKeymaps = function(e) {
      var r = zs(), n = r.undo, a = r.redo, i = this.specs.keymaps(e), o = {
        "Mod-z": n(),
        "Shift-Mod-z": a()
      };
      return e ? i.concat(zt(o)) : i;
    }, t.prototype.createCommands = function() {
      return this.specs.commands(this.view);
    }, t.prototype.createPluginProps = function() {
      var e = this;
      return this.extraPlugins.map(function(r) {
        return r(e.eventEmitter);
      });
    }, t.prototype.focus = function() {
      var e = this;
      this.clearTimer(), this.timer = setTimeout(function() {
        e.view.focus(), e.view.dispatch(e.view.state.tr.scrollIntoView());
      });
    }, t.prototype.blur = function() {
      this.view.dom.blur();
    }, t.prototype.destroy = function() {
      var e = this;
      this.clearTimer(), this.view.destroy(), Object.keys(this).forEach(function(r) {
        delete e[r];
      });
    }, t.prototype.moveCursorToStart = function(e) {
      var r = this.view.state.tr;
      this.view.dispatch(r.setSelection(F(r, 1)).scrollIntoView()), e && this.focus();
    }, t.prototype.moveCursorToEnd = function(e) {
      var r = this.view.state.tr;
      this.view.dispatch(r.setSelection(F(r, r.doc.content.size - 1)).scrollIntoView()), e && this.focus();
    }, t.prototype.setScrollTop = function(e) {
      this.view.dom.scrollTop = e;
    }, t.prototype.getScrollTop = function() {
      return this.view.dom.scrollTop;
    }, t.prototype.setPlaceholder = function(e) {
      this.placeholder.text = e, this.view.dispatch(this.view.state.tr.scrollIntoView());
    }, t.prototype.setHeight = function(e) {
      Oe(this.el, { height: e + "px" });
    }, t.prototype.setMinHeight = function(e) {
      Oe(this.el, { minHeight: e + "px" });
    }, t.prototype.getElement = function() {
      return this.el;
    }, t;
  })()
);
function Vv(t) {
  return t instanceof Function;
}
var he = Vv, jv = [
  "Enter",
  "Shift-Enter",
  "Mod-Enter",
  "Tab",
  "Shift-Tab",
  "Delete",
  "Backspace",
  "Mod-Delete",
  "Mod-Backspace",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Mod-d",
  "Mod-D",
  "Alt-ArrowUp",
  "Alt-ArrowDown"
];
function ar(t, e, r) {
  return t.focus(), e(r)(t.state, t.dispatch, t);
}
var ol = (
  /** @class */
  (function() {
    function t(e) {
      this.specs = e;
    }
    return Object.defineProperty(t.prototype, "nodes", {
      get: function() {
        return this.specs.filter(function(e) {
          return e.type === "node";
        }).reduce(function(e, r) {
          var n, a = r.name, i = r.schema;
          return b(b({}, e), (n = {}, n[a] = i, n));
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "marks", {
      get: function() {
        return this.specs.filter(function(e) {
          return e.type === "mark";
        }).reduce(function(e, r) {
          var n, a = r.name, i = r.schema;
          return b(b({}, e), (n = {}, n[a] = i, n));
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.commands = function(e, r) {
      var n = this.specs.filter(function(i) {
        var o = i.commands;
        return o;
      }).reduce(function(i, o) {
        var s = {}, l = o.commands();
        return he(l) ? s[o.name] = function(u) {
          return ar(e, l, u);
        } : Object.keys(l).forEach(function(u) {
          s[u] = function(c) {
            return ar(e, l[u], c);
          };
        }), b(b({}, i), s);
      }, {}), a = zs();
      return Object.keys(a).forEach(function(i) {
        n[i] = function(o) {
          return ar(e, a[i], o);
        };
      }), r && Object.keys(r).forEach(function(i) {
        n[i] = function(o) {
          return ar(e, r[i], o);
        };
      }), n;
    }, t.prototype.keymaps = function(e) {
      var r = this.specs.filter(function(n) {
        return n.keymaps;
      }).map(function(n) {
        return n.keymaps();
      });
      return r.map(function(n) {
        return e || Object.keys(n).forEach(function(a) {
          te(jv, a) || delete n[a];
        }), zt(n);
      });
    }, t.prototype.setContext = function(e) {
      this.specs.forEach(function(r) {
        r.setContext(e);
      });
    }, t;
  })()
);
function sl(t) {
  var e = t.from, r = t.to;
  return t instanceof Is ? [e + 1, r - 1] : [e, r];
}
function xi(t) {
  return t.index(0) + 1;
}
function xt(t, e, r) {
  r === void 0 && (r = 1);
  var n = 0;
  return t.forEach(function(a, i) {
    Un(a) && i + 2 < e && (n += 2 * r);
  }), n;
}
function hr(t, e, r) {
  r === void 0 && (r = e);
  var n = e === r, a = t.resolve(e), i = xi(a), o = i, s = a.start(1), l = s;
  if (!n) {
    var u = t.resolve(r === t.content.size ? r - 1 : r);
    l = u.start(1), o = xi(u), u.pos === t.content.size && (r = t.content.size - 2);
  }
  var c = Math.max(e - s + 1, 1), v = Math.max(r - l + 1, 1);
  return [
    [i, c + xt(t.child(i - 1), c, -1)],
    [o, v + xt(t.child(o - 1), v, -1)]
  ];
}
function ll(t, e) {
  for (var r = [], n = 0, a = 0; n < e; n += 1) {
    var i = t.child(n);
    r[n] = a, a += i.nodeSize;
  }
  return r;
}
function Je(t, e, r) {
  var n = ll(t, r[0]), a = e[0] - 1, i = r[0] - 1, o = t.child(a), s = t.child(i), l = n[a], u = n[i];
  return l += e[1] + xt(o, e[1] - 1), u += r[1] + xt(s, r[1] - 1), [l, Math.min(u, t.content.size)];
}
function G(t) {
  var e = t.$from, r = t.$to, n = t.from, a = t.to, i = e.doc;
  return t instanceof Is && (e = i.resolve(n + 1), r = i.resolve(a - 1)), e.depth === 0 && (e = i.resolve(n - 1), r = e), {
    startFromOffset: e.start(1),
    endFromOffset: r.start(1),
    startToOffset: e.end(1),
    endToOffset: r.end(1),
    startIndex: e.index(0),
    endIndex: r.index(0),
    from: e.pos,
    to: r.pos
  };
}
function Ar(t, e) {
  for (var r = 1, n = 1, a = 0, i = 0; a < t.childCount; a += 1) {
    var o = t.child(a).nodeSize;
    if (r = i + 1, n = i + o - 1, a === e)
      break;
    i += o;
  }
  return { startOffset: r, endOffset: n };
}
var Li = "heading", zv = "blockQuote", Wv = "listItem", Gv = "table", Xv = "tableCell", Qv = "codeBlock", Kv = "thematicBreak", mr = "link", ir = "code", zr = "meta", at = "delimiter", Yv = "taskDelimiter", Da = "markedText", Zv = "html", Jv = "customBlock", Mi = {
  strong: 2,
  emph: 1,
  strike: 2
};
function H(t, e, r, n) {
  return { start: t, end: e, spec: { type: r, attrs: n } };
}
function ef(t, e, r) {
  var n = t.level, a = t.headingType, i = [H(e, r, Li, { level: n })];
  return a === "atx" ? i.push(H(e, Q(e, n), at)) : i.push(H(Ge(r, 0), r, Li, { seText: !0 })), i;
}
function mn(t, e, r) {
  var n = t.type, a = Q(e, Mi[n]), i = Q(r, -Mi[n]);
  return [
    H(a, i, n),
    H(e, a, at),
    H(i, r, at)
  ];
}
function ul(t, e, r, n) {
  return [
    H(t, e, mr),
    H(Ge(t, r[1] + 1), Ge(e, n), mr, {
      desc: !0
    }),
    H(Ge(e, n + 2), Q(e, -1), mr, { url: !0 })
  ];
}
function tf(t, e, r) {
  var n = t.lastChild, a = n ? We(n) + 1 : 3, i = Q(e, 1);
  return ce([H(e, i, zr)], ul(e, r, i, a));
}
function rf(t, e, r) {
  var n = t.lastChild, a = t.extendedAutolink, i = n ? We(n) + 1 : 2;
  return a ? [H(e, r, mr, { desc: !0 })] : ul(e, r, e, i);
}
function nf(t, e, r) {
  var n = t.tickCount, a = Q(e, n), i = Q(r, -n);
  return [
    H(e, r, ir),
    H(e, a, ir, { start: !0 }),
    H(a, i, ir, { marked: !0 }),
    H(i, r, ir, { end: !0 })
  ];
}
function cl(t, e, r, n) {
  var a = {
    start: e,
    end: r,
    spec: {
      attrs: { className: n + "-line-background", codeStart: e[0], codeEnd: r[0] }
    },
    lineBackground: !0
  };
  return t.type !== "item" && t.type !== "blockQuote" ? [
    b(b({}, a), { end: e, spec: { attrs: { className: n + "-line-background start" } } }),
    b(b({}, a), { start: [Math.min(e[0] + 1, r[0]), e[1]] })
  ] : null;
}
function af(t, e, r, n) {
  var a = t.fenceOffset, i = t.fenceLength, o = t.fenceChar, s = t.info, l = t.infoPadding, u = t.parent, c = a + i, v = [H(Ge(e, 1), r, Qv)];
  o && v.push(H(e, Q(e, c), at)), s && v.push(H(Q(e, i), Q(e, i + l + s.length), zr));
  var f = "^(\\s{0,4})(" + o + "{" + i + ",})", d = new RegExp(f);
  d.test(n) && v.push(H(Ge(r, 1), r, at));
  var p = cl(u, e, r, "code-block");
  return p ? v.concat(p) : v;
}
function of(t, e, r) {
  var n = t, a = n.offset, i = n.syntaxLength, o = n.info, s = n.parent, l = a + i, u = [H(Ge(e, 1), r, Jv)];
  u.push(H(e, Q(e, l), at)), o && u.push(H(Q(e, l), Q(e, i + o.length), zr)), u.push(H(Ge(r, 1), r, at));
  var c = cl(s, e, r, "custom-block");
  return c ? u.concat(c) : u;
}
function vl(t, e) {
  for (var r = []; t; ) {
    var n = t.type;
    (n === "paragraph" || n === "codeBlock") && r.push(H([Kt(t), Ur(t) - 1], [Fr(t), We(t) + 1], e)), t = t.next;
  }
  return r;
}
function sf(t) {
  for (var e = []; t; )
    e.push(H([Kt(t), Ur(t)], [Fr(t), We(t) + 1], Da)), t = t.next;
  return e;
}
function lf(t, e, r) {
  var n = t.parent && t.parent.type !== "blockQuote" ? [H(e, r, zv)] : [];
  if (t.firstChild) {
    var a = [];
    t.firstChild.type === "paragraph" ? a = sf(t.firstChild.firstChild) : t.firstChild.type === "list" && (a = vl(t.firstChild, Da)), n = ce(ce([], n), a);
  }
  return n;
}
function uf(t) {
  for (var e = 0; t.parent.parent && t.parent.parent.type === "item"; )
    t = t.parent.parent, e += 1;
  var r = [{ odd: !0 }, { even: !0 }][e % 2];
  return [Wv, b(b({}, r), { listStyle: !0 })];
}
function cf(t, e) {
  var r = t.listData, n = r.padding, a = r.task, i = uf(t), o = [H.apply(void 0, ce([e, Q(e, n)], i))];
  return a && (o.push(H(Q(e, n), Q(e, n + 3), Yv)), o.push(H(Q(e, n + 1), Q(e, n + 2), zr))), o.concat(vl(t.firstChild, Da));
}
var Ai = {
  heading: ef,
  strong: mn,
  emph: mn,
  strike: mn,
  link: rf,
  image: tf,
  code: nf,
  codeBlock: af,
  blockQuote: lf,
  item: cf,
  customBlock: of
}, Si = {
  thematicBreak: Kv,
  table: Gv,
  tableCell: Xv,
  htmlInline: Zv
};
function vf(t, e, r, n) {
  var a = t.type;
  return he(Ai[a]) ? Ai[a](t, e, r, n) : Si[a] ? [H(e, r, Si[a])] : null;
}
var Gt = {};
function ff(t) {
  var e = t.schema, r = t.toastMark;
  return new Ee({
    appendTransaction: function(n, a, i) {
      var o = n[0], s = i.tr;
      if (o.docChanged) {
        var l = [], u = o.getMeta("editResult");
        u.forEach(function(c) {
          var v = c.nodes, f = c.removedNodeRange;
          if (v.length) {
            l = l.concat(yf(s, v));
            for (var d = 0, p = v; d < p.length; d++)
              for (var h = p[d], m = h.walker(), y = m.next(); y; ) {
                var w = y.node, C = y.entering;
                C && (l = l.concat(bf(w, r))), y = m.next();
              }
          } else if (f)
            for (var T = s.doc.childCount - 1, k = f.line, M = k[0], O = k[1], I = Math.min(M, T), _ = Math.min(O, T), V = I; V <= _; V += 1)
              Gt[V] = !0;
        }), hf(s, e, l);
      }
      return s.setMeta("widget", o.getMeta("widget"));
    }
  });
}
function df(t, e, r) {
  return Object.keys(r).some(function(n) {
    return r[n] !== t.child(e).attrs[n];
  });
}
function pf(t, e, r, n, a) {
  a === void 0 && (a = {});
  for (var i = n.startIndex, o = n.endIndex, s = n.from, l = n.to, u = !1, c = i; c <= o; c += 1)
    delete Gt[c], u = df(e, c, a);
  u && t.setBlockType(s, l, r, a);
}
function hf(t, e, r) {
  var n = t.doc, a = e.nodes.paragraph, i = ll(n, n.childCount);
  r.forEach(function(o) {
    var s = o.start, l = o.end, u = o.spec, c = o.lineBackground, v = Math.min(s[0], n.childCount) - 1, f = Math.min(l[0], n.childCount) - 1, d = n.child(v), p = n.child(f), h = i[v], m = i[f];
    if (h += s[1] + xt(d, s[1] - 1), m += l[1] + xt(p, l[1] - 1), u)
      if (c) {
        var y = { from: h, to: m, startIndex: v, endIndex: f };
        pf(t, n, a, y, u.attrs);
      } else
        t.addMark(h, m, e.mark(u.type, u.attrs));
    else
      t.removeMark(h, m);
  }), mf(t, i, a);
}
function mf(t, e, r) {
  Object.keys(Gt).forEach(function(n) {
    var a = Number(n), i = Math.min(Number(n) + 1, t.doc.childCount - 1), o = e[a], s = e[i] - 1;
    a === i && (s += 2), t.setBlockType(o, s, r);
  });
}
function gf(t, e, r) {
  var n = [];
  Gt = {};
  for (var a = e[0] - 1; a < r[0]; a += 1) {
    var i = t.child(a), o = i.attrs.codeEnd, s = i.attrs.codeStart;
    if (s && o && !te(n, s)) {
      n.push(s), o = Math.min(o, t.childCount);
      for (var l = s - 1, u = r[0], c = l; c < u; c += 1)
        Gt[c] = !0;
    }
  }
}
function yf(t, e) {
  var r = t.doc, n = e[0].sourcepos[0], a = se(e).sourcepos, i = a[1], o = [n[0], n[1]], s = [i[0], i[1] + 1], l = [];
  return gf(r, n, i), l.push({ start: o, end: s }), l;
}
function bf(t, e) {
  var r = e.getLineTexts(), n = [Kt(t), Ur(t)], a = [Fr(t), We(t) + 1], i = vf(t, n, a, r[a[0] - 1]);
  return i ?? [];
}
var wf = [
  "taskList",
  "orderedList",
  "bulletList",
  "table",
  "strong",
  "emph",
  "strike",
  "heading",
  "thematicBreak",
  "blockQuote",
  "code",
  "codeBlock",
  "indent",
  "outdent"
];
function Cf(t) {
  var e = t.type;
  return rt(t) ? t.listData.task ? "taskList" : t.listData.type === "ordered" ? "orderedList" : "bulletList" : e.indexOf("table") !== -1 ? "table" : te(wf, e) ? e : null;
}
function Tf(t) {
  var e = {
    indent: { active: !1, disabled: !0 },
    outdent: { active: !1, disabled: !0 }
  }, r = !0;
  return cv(t, function(n) {
    var a = Cf(n);
    a && (a === "bulletList" || a === "orderedList" ? r && (e[a] = { active: !0 }, e.indent.disabled = !1, e.outdent.disabled = !1, r = !1) : e[a] = { active: !0 });
  }), e;
}
function kf(t) {
  var e = t.toastMark, r = t.eventEmitter;
  return new Ee({
    view: function() {
      return {
        update: function(n, a) {
          var i = n.state, o = i.doc, s = i.selection;
          if (!(a && a.doc.eq(o) && a.selection.eq(s))) {
            var l = s.from, u = i.doc.resolve(l).start(), c = i.doc.content.findIndex(l).index + 1, v = l - u;
            l === u && (v += 1);
            var f = [c, v], d = e.findNodeAtPosition(f), p = Tf(d);
            r.emit("changeToolbarState", {
              cursorPos: f,
              mdNode: d,
              toolbarState: p
            }), r.emit("setFocusedNode", d);
          }
        }
      };
    }
  });
}
var Ef = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "doc";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "block+"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), U = (
  /** @class */
  (function() {
    function t() {
    }
    return Object.defineProperty(t.prototype, "type", {
      get: function() {
        return "mark";
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setContext = function(e) {
      this.context = e;
    }, t;
  })()
);
function ve(t, e) {
  return Xe(t, e - 1);
}
function Xe(t, e) {
  return t.child(e).textContent;
}
var Ut = /^\s*> ?/, xf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "blockQuote";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("block-quote") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.createBlockQuoteText = function(r, n) {
      return n ? r.replace(Ut, "").trim() : "> " + r.trim();
    }, e.prototype.extendBlockQuote = function() {
      var r = this;
      return function(n, a) {
        var i = n.selection, o = n.doc, s = n.tr, l = n.schema, u = G(i), c = u.endFromOffset, v = u.endToOffset, f = u.endIndex, d = u.to, p = Xe(o, f), h = Ut.test(p);
        if (h && d > c && i.empty) {
          var m = !p.replace(Ut, "").trim();
          if (m)
            s.deleteRange(c, v).split(s.mapping.map(v));
          else {
            var y = p.slice(d - c).trim(), w = ee(l, r.createBlockQuoteText(y));
            Ea(s, v, y, w);
          }
          return a(s), !0;
        }
        return !1;
      };
    }, e.prototype.commands = function() {
      var r = this;
      return function() {
        return function(n, a) {
          var i = n.selection, o = n.doc, s = G(i), l = s.startFromOffset, u = s.endToOffset, c = s.startIndex, v = s.endIndex, f = Ut.test(Xe(o, c)), d = Mr({
            state: n,
            startIndex: c,
            endIndex: v,
            from: l,
            createText: function(p) {
              return r.createBlockQuoteText(p, f);
            }
          });
          return a(d.setSelection(F(d, d.mapping.map(u)))), !0;
        };
      };
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return {
        "alt-q": r,
        "alt-Q": r,
        Enter: this.extendBlockQuote()
      };
    }, e;
  })(U)
), it = /(^\s*)([-*+] |[\d]+\. )/, Ia = /(^\s*)([\d])+\.( \[[ xX]])? /, _e = /^(\s*)((\d+)([.)]\s(?:\[(?:x|\s)\]\s)?))(.*)/, Sr = /(^\s*)([-*+]|[\d]+\.)( \[[ xX]])? /, Lf = /^(\s*)([-*+]+(\s(?:\[(?:x|\s)\]\s)?))(.*)/, Mf = /(^\s*)([-*+] |[\d]+\. )(\[[ xX]] )/, Af = /(^\s*)([-*+])( \[[ xX]]) /;
function Na(t) {
  return Ia.test(t) ? "ordered" : "bullet";
}
function Ra(t) {
  for (var e = 0; t && t.type !== "document"; )
    t.type === "list" && (e += 1), t = t.parent;
  return e;
}
function Vn(t, e, r, n) {
  for (var a = t.getLineTexts(), i = a.length, o = [], s = e; n ? s < i : s > 1; ) {
    s = n ? s + 1 : s - 1;
    var l = t.findFirstNodeAtLine(s), u = Ra(l);
    if (u === r)
      o.push({ line: s, depth: r, mdNode: l });
    else if (u < r)
      break;
  }
  return o;
}
function Sf(t) {
  var e = t.toastMark, r = t.mdNode, n = t.line, a = Ra(r), i = Vn(e, n, a, !1).reverse(), o = Vn(e, n, a, !0);
  return i.concat([{ line: n, depth: a, mdNode: r }]).concat(o);
}
function Of(t) {
  if (!it.test(t))
    return "* " + t;
  var e = Na(t);
  return e === "bullet" && Sr.test(t) ? t = t.replace(Af, "$1$2 ") : e === "ordered" && (t = t.replace(Ia, "$1* ")), t;
}
function Df(t, e) {
  if (!it.test(t))
    return e + ". " + t;
  var r = Na(t);
  if (r === "bullet" || r === "ordered" && Sr.test(t))
    t = t.replace(Sr, "$1" + e + ". ");
  else if (r === "ordered") {
    var n = _e.exec(t)[3];
    Number(n) !== e && (t = t.replace(Ia, "$1" + e + ". "));
  }
  return t;
}
function fl(t, e, r, n) {
  n === void 0 && (n = 0);
  var a = Number.MAX_VALUE, i = 0, o = e.map(function(s, l) {
    var u = s.line;
    a = Math.min(u - 1, a), i = Math.max(u - 1, i);
    var c = ve(t, u);
    return c = r === "bullet" ? Of(c) : Df(c, l + 1 + n), { text: c, line: u };
  });
  return { changedResults: o, firstIndex: a, lastIndex: i };
}
function Oi(t, e) {
  var r = Sf(e);
  return fl(e.doc, r, t);
}
var If = {
  bullet: function(t) {
    return Oi("bullet", t);
  },
  ordered: function(t) {
    return Oi("ordered", t);
  },
  task: function(t) {
    var e = t.mdNode, r = t.doc, n = t.line, a = ve(r, n);
    return e.listData.task ? a = a.replace(Mf, "$1$2") : rt(e) && (a = a.replace(it, "$1$2[ ] ")), { changedResults: [{ text: a, line: n }] };
  }
}, Nf = {
  bullet: function(t) {
    var e = t.doc, r = t.line, n = ve(e, r), a = [{ text: "* " + n, line: r }];
    return { changedResults: a };
  },
  ordered: function(t) {
    for (var e = t.toastMark, r = t.doc, n = t.line, a = t.startLine, i = ve(r, n), o = 1, s = a, l = 0, u = a - 1; u > 0; u -= 1) {
      var c = e.findFirstNodeAtLine(u), v = ve(r, u), f = v && !!kt(c, function(C) {
        return rt(C);
      }), d = _e.exec(ve(r, u));
      if (!d && !f)
        break;
      if (!d && f) {
        l += 1;
        continue;
      }
      var p = d, h = p[1], m = p[3];
      if (!h) {
        o = Number(m), s = u;
        break;
      }
    }
    var y = o + n - s - l, w = [{ text: y + ". " + i, line: n }];
    return { changedResults: w };
  },
  task: function(t) {
    var e = t.doc, r = t.line, n = ve(e, r), a = [{ text: "* [ ] " + n, line: r }];
    return { changedResults: a };
  }
}, Rf = {
  bullet: function(t) {
    var e = t.line, r = t.doc, n = ve(r, e), a = Lf.exec(n), i = a[1], o = a[2];
    return { listSyntax: "" + i + o };
  },
  ordered: function(t) {
    var e = t.toastMark, r = t.line, n = t.mdNode, a = t.doc, i = Ra(n), o = ve(a, r), s = _e.exec(o), l = s[1], u = s[3], c = s[4], v = Number(u) + 1, f = "" + l + v + c, d = Vn(e, r, i, !0), p = d.filter(function(h) {
      var m = _e.exec(ve(a, h.line));
      return m && m[1].length === l.length && !!kt(h.mdNode, function(y) {
        return $s(y);
      });
    });
    return b({ listSyntax: f }, fl(a, p, "ordered", v));
  }
};
function dl(t, e, r, n, a) {
  for (var i = [], o = ve(t, r), s = _e.exec(o); s; ) {
    var l = s[1], u = s[4], c = s[5], v = l.length;
    if (v === a)
      i.push(ee(e, "" + l + n + u + c)), n += 1, r += 1;
    else if (v > a) {
      var f = dl(t, e, r, 1, v);
      r = f.line, i = i.concat(f.nodes);
    }
    if (v < a || r > t.childCount)
      break;
    o = ve(t, r), s = _e.exec(o);
  }
  return { nodes: i, line: r };
}
var Di = /(^\s{1,4})(.*)/;
function Ii(t, e, r) {
  return t < e || it.test(r) || Ut.test(r);
}
function Ni(t, e, r) {
  var n = r.$from;
  n.depth === 0 && (n = t.resolve(n.pos - 1));
  var a = n.node(1), i = n.start(1), o = a.content.size;
  return a.rangeHasMark(0, o, e.marks.table) && n.pos - i !== o && n.pos !== i;
}
function Ri(t, e) {
  var r = e.from, n = e.to;
  if (e.type === "indent") {
    var a = 4;
    r += a, n += (e.lineLen + 1) * a;
  } else {
    var i = e.spaceLenList;
    r -= i[0];
    for (var o = 0; o < i.length; o += 1)
      n -= i[o];
  }
  return F(t, r, n);
}
var Bf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "paragraph";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "inline*",
          attrs: {
            className: { default: null },
            codeStart: { default: null },
            codeEnd: { default: null }
          },
          selectable: !1,
          group: "block",
          parseDOM: [{ tag: "div" }],
          toDOM: function(r) {
            var n = r.attrs;
            return n.className ? ["div", { class: X(n.className) }, 0] : ["div", 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.reorderList = function(r, n) {
      for (var a = this.context, i = a.view, o = a.toastMark, s = a.schema, l = i.state, u = l.tr, c = l.selection, v = l.doc, f = o.findFirstNodeAtLine(r), d = f; f && !lv(f) && f.parent.type !== "document"; )
        if (f = f.parent, $s(f)) {
          d = f;
          break;
        }
      d && (r = d.sourcepos[0][0]);
      var p = _e.exec(ve(v, r)), h = p[1], m = p[3], y = h.length, w = dl(v, s, r, Number(m), y), C = w.line, T = w.nodes;
      n = Math.max(n, C - 1);
      for (var k = Ar(v, r - 1).startOffset, M = r - 1; M <= n - 1; M += 1) {
        var O = v.child(M), I = O.nodeSize, _ = O.content, V = u.mapping.map(k), Y = V + _.size;
        u.replaceWith(V, Y, T[M - r + 1]), k += I;
      }
      var pe = F(u, c.from, c.to);
      i.dispatch(u.setSelection(pe));
    }, e.prototype.indent = function(r) {
      var n = this;
      return r === void 0 && (r = !1), function() {
        return function(a, i) {
          var o = a.schema, s = a.selection, l = a.doc, u = G(s), c = u.from, v = u.to, f = u.startFromOffset, d = u.startIndex, p = u.endIndex;
          if (r && Ni(l, o, s))
            return !1;
          var h = Xe(l, d);
          if (r && Ii(c, v, h) || !r && it.test(h)) {
            var m = Mr({
              state: a,
              from: f,
              startIndex: d,
              endIndex: p,
              createText: function(w) {
                return "    " + w;
              }
            }), y = {
              type: "indent",
              from: c,
              to: v,
              lineLen: p - d
            };
            i(m.setSelection(Ri(m, y))), _e.test(h) && n.reorderList(d + 1, p + 1);
          } else r && i(a.tr.insert(v, ee(o, "    ")));
          return !0;
        };
      };
    }, e.prototype.outdent = function(r) {
      var n = this;
      return r === void 0 && (r = !1), function() {
        return function(a, i) {
          var o = a.selection, s = a.doc, l = a.schema, u = G(o), c = u.from, v = u.to, f = u.startFromOffset, d = u.startIndex, p = u.endIndex;
          if (r && Ni(s, l, o))
            return !1;
          var h = Xe(s, d);
          if (r && Ii(c, v, h) || !r && it.test(h)) {
            var m = [], y = Mr({
              state: a,
              from: f,
              startIndex: d,
              endIndex: p,
              createText: function(M) {
                var O = Di.exec(M);
                return m.push(O ? O[1].length : 0), M.replace(Di, "$2");
              }
            }), w = { type: "outdent", from: c, to: v, spaceLenList: m };
            i(y.setSelection(Ri(y, w))), _e.test(h) && n.reorderList(d + 1, p + 1);
          } else if (r) {
            var C = h.slice(0, v - f), T = C.replace(/\s{1,4}$/, ""), k = v - (C.length - T.length);
            i(a.tr.delete(k, v));
          }
          return !0;
        };
      };
    }, e.prototype.deleteLines = function() {
      var r = this;
      return function(n, a) {
        var i = r.context.view, o = G(n.selection), s = o.startFromOffset, l = o.endToOffset, u = function() {
          return a(n.tr.deleteRange(s, l)), !0;
        };
        return Yu(u, tc)(n, a, i);
      };
    }, e.prototype.moveDown = function() {
      return function(r, n) {
        var a = r.doc, i = r.tr, o = r.selection, s = r.schema, l = G(o), u = l.startFromOffset, c = l.endToOffset, v = l.endIndex;
        if (v < a.content.childCount - 1) {
          var f = a.child(v + 1), d = f.nodeSize, p = f.textContent;
          return i.delete(c, c + d).split(u).insert(i.mapping.map(u) - 2, ee(s, p)), n(i), !0;
        }
        return !1;
      };
    }, e.prototype.moveUp = function() {
      return function(r, n) {
        var a = r.tr, i = r.doc, o = r.selection, s = r.schema, l = G(o), u = l.startFromOffset, c = l.endToOffset, v = l.startIndex;
        if (v > 0) {
          var f = i.child(v - 1), d = f.nodeSize, p = f.textContent;
          return a.delete(u - d, u).split(a.mapping.map(c)).insert(a.mapping.map(c), ee(s, p)), n(a), !0;
        }
        return !1;
      };
    }, e.prototype.commands = function() {
      return {
        indent: this.indent(),
        outdent: this.outdent()
      };
    }, e.prototype.keymaps = function() {
      return {
        Tab: this.indent(!0)(),
        "Shift-Tab": this.outdent(!0)(),
        "Mod-d": this.deleteLines(),
        "Mod-D": this.deleteLines(),
        "Alt-ArrowUp": this.moveUp(),
        "Alt-ArrowDown": this.moveDown()
      };
    }, e;
  })($)
), Hf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "text";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          group: "inline"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), Pf = /^#{1,6}\s/, _f = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "heading";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: {
            level: { default: 1 },
            seText: { default: !1 }
          },
          toDOM: function(r) {
            var n = r.attrs, a = n.level, i = n.seText, o = "heading|heading" + a;
            return i && (o += "|delimiter|setext"), ["span", { class: X.apply(void 0, o.split("|")) }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.createHeadingText = function(r, n, a) {
      for (var i = n.replace(a, "").trim(), o = ""; r > 0; )
        o += "#", r -= 1;
      return o + " " + i;
    }, e.prototype.commands = function() {
      var r = this;
      return function(n) {
        return function(a, i) {
          var o = n.level, s = G(a.selection), l = s.startFromOffset, u = s.endToOffset, c = s.startIndex, v = s.endIndex, f = Mr({
            state: a,
            from: l,
            startIndex: c,
            endIndex: v,
            createText: function(d) {
              var p = d.match(Pf), h = p ? p[0] : "";
              return r.createHeadingText(o, d, h);
            }
          });
          return i(f.setSelection(F(f, f.mapping.map(u)))), !0;
        };
      };
    }, e;
  })(U)
), gn = "```", qf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "codeBlock";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("code-block") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n) {
          var a = r.selection, i = r.schema, o = r.tr, s = G(a), l = s.startFromOffset, u = s.endToOffset, c = ee(i, gn);
          return o.insert(l, c).split(l + gn.length), o.split(o.mapping.map(u)).insert(o.mapping.map(u), c), n(o.setSelection(
            // subtract fenced syntax length and open, close tag(2)
            F(o, o.mapping.map(u) - (gn.length + 2))
          )), !0;
        };
      };
    }, e.prototype.keepIndentation = function() {
      var r = this;
      return function(n, a) {
        var i = n.selection, o = n.tr, s = n.doc, l = n.schema, u = r.context.toastMark, c = G(i), v = c.startFromOffset, f = c.endToOffset, d = c.endIndex, p = c.from, h = c.to, m = Xe(s, d);
        if (p === h && m.trim()) {
          var y = m.match(/^\s+/), w = u.findFirstNodeAtLine(d + 1);
          if (sv(w) && y) {
            var C = y[0], T = m.slice(h - v), k = ee(l, C + T);
            return Ea(o, f, T, k), a(o), !0;
          }
        }
        return !1;
      };
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return {
        "Shift-Mod-p": r,
        "Shift-Mod-P": r,
        Enter: this.keepIndentation()
      };
    }, e;
  })(U)
), $f = /\||\s/g;
function Ff(t) {
  return [Or(t), Or(t, !0)];
}
function Uf(t, e) {
  for (var r = [], n = 0; n < e; n += 1)
    r.push(Or(t));
  return r;
}
function Or(t, e) {
  for (var r = "|", n = 0; n < t; n += 1)
    r += e ? " --- |" : "  |";
  return r;
}
function Vf(t) {
  return t ? { type: "next", parentType: "tableHead", childType: "firstChild" } : { type: "prev", parentType: "tableBody", childType: "lastChild" };
}
var jf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "table";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("table") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.extendTable = function() {
      var r = this;
      return function(n, a) {
        var i = n.selection, o = n.doc, s = n.tr, l = n.schema;
        if (!i.empty)
          return !1;
        var u = G(i), c = u.endFromOffset, v = u.endToOffset, f = u.endIndex, d = u.to, p = Xe(o, f), h = [f + 1, d - c + 1], m = r.context.toastMark.findNodeAtPosition(h), y = kt(m, function(M) {
          return Ti(M) && (M.parent.type === "tableDelimRow" || M.parent.parent.type === "tableBody");
        });
        if (y) {
          var w = !p.replace($f, "").trim(), C = y.parent, T = C.parent.parent.columns.length, k = Or(T);
          return w ? s.deleteRange(c, v).split(s.mapping.map(v)) : s.split(v).insert(s.mapping.map(v), ee(l, k)).setSelection(F(s, s.mapping.map(v) - 2)), a(s), !0;
        }
        return !1;
      };
    }, e.prototype.moveTableCell = function(r) {
      var n = this;
      return function(a, i) {
        var o = a.selection, s = a.tr, l = G(o), u = l.endFromOffset, c = l.endIndex, v = l.to, f = [c + 1, v - u], d = n.context.toastMark.findNodeAtPosition(f), p = kt(d, function(O) {
          return Ti(O);
        });
        if (p) {
          var h = p.parent, m = Vf(r), y = m.type, w = m.parentType, C = m.childType, T = We(p);
          if (p[y])
            T = We(p[y]) - 1;
          else {
            var k = !h[y] && h.parent.type === w ? h.parent[y][C] : h[y];
            if (y === "next") {
              var M = k ? We(k[C]) : 0;
              T += M + 2;
            } else y === "prev" && (T = k ? -4 : 0);
          }
          return i(s.setSelection(F(s, u + T))), !0;
        }
        return !1;
      };
    }, e.prototype.addTable = function() {
      return function(r) {
        return function(n, a) {
          var i = n.selection, o = n.tr, s = n.schema, l = r, u = l.columnCount, c = l.rowCount, v = G(i).endToOffset, f = Ff(u), d = Uf(u, c - 1), p = ce(ce([], f), d);
          return p.forEach(function(h) {
            o.split(o.mapping.map(v)).insert(o.mapping.map(v), ee(s, h));
          }), a(o.setSelection(F(o, v + 4))), !0;
        };
      };
    }, e.prototype.commands = function() {
      return { addTable: this.addTable() };
    }, e.prototype.keymaps = function() {
      return {
        Enter: this.extendTable(),
        Tab: this.moveTableCell(!0),
        "Shift-Tab": this.moveTableCell(!1)
      };
    }, e;
  })(U)
), zf = "***", Wf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "thematicBreak";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("thematic-break") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.hr = function() {
      return function() {
        return function(r, n) {
          var a = r.selection, i = r.schema, o = r.tr, s = G(a), l = s.from, u = s.to, c = s.endToOffset, v = ee(i, zf);
          return o.split(l).replaceWith(o.mapping.map(l), o.mapping.map(u), v).split(o.mapping.map(u)).setSelection(F(o, o.mapping.map(c))), n(o), !0;
        };
      };
    }, e.prototype.commands = function() {
      return { hr: this.hr() };
    }, e.prototype.keymaps = function() {
      var r = this.hr()();
      return { "Mod-l": r, "Mod-L": r };
    }, e;
  })(U)
);
function Gf(t, e) {
  var r = t.type, n = t.sourcepos, a = n[0][0];
  return e <= a && (r === "codeBlock" || r === "heading" || r.match("table"));
}
var Xf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "listItem";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: {
            odd: { default: !1 },
            even: { default: !1 },
            listStyle: { default: !1 }
          },
          toDOM: function(r) {
            var n = r.attrs, a = n.odd, i = n.even, o = n.listStyle, s = "list-item";
            return o && (s += "|list-item-style"), a && (s += "|list-item-odd"), i && (s += "|list-item-even"), ["span", { class: X.apply(void 0, s.split("|")) }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.extendList = function() {
      var r = this;
      return function(n, a) {
        var i = n.selection, o = n.doc, s = n.schema, l = n.tr, u = r.context.toastMark, c = G(i), v = c.to, f = c.startFromOffset, d = c.endFromOffset, p = c.endIndex, h = c.endToOffset, m = Xe(o, p), y = it.test(m);
        if (!y || i.from === f || !i.empty)
          return !1;
        var w = !m.replace(Sr, "").trim();
        if (w)
          l.deleteRange(d, h).split(l.mapping.map(h));
        else {
          var C = Na(m), T = u.findFirstNodeAtLine(p + 1), k = m.slice(v - d), M = { toastMark: u, mdNode: T, doc: o, line: p + 1 }, O = Rf[C](M), I = O.listSyntax, _ = O.changedResults;
          if (_?.length) {
            l.split(v), _.unshift({ text: I + k, line: p + 1 }), r.changeToListPerLine(l, _, {
              from: v,
              // don't subtract 1 because the line has increased through 'split' command.
              startLine: _[0].line,
              endLine: se(_).line
            });
            var V = l.mapping.map(h) - k.length;
            l.setSelection(F(l, V));
          } else {
            var Y = ee(s, I + k);
            Ea(l, h, k, Y);
          }
        }
        return a(l), !0;
      };
    }, e.prototype.toList = function(r) {
      var n = this;
      return function() {
        return function(a, i) {
          for (var o = a.doc, s = a.tr, l = a.selection, u = n.context.toastMark, c = G(l), v = c.startIndex + 1, f = c.endIndex + 1, d = c.endToOffset, p = [], h = v; h <= f; h += 1) {
            var m = u.findFirstNodeAtLine(h);
            if (m && Gf(m, h))
              break;
            if (p.indexOf(h) === -1) {
              var y = { toastMark: u, mdNode: m, doc: o, line: h, startLine: v }, w = (rt(m) ? If[r](y) : Nf[r](y)).changedResults, C = n.changeToListPerLine(s, w, {
                from: Ar(o, w[0].line - 1).startOffset,
                startLine: w[0].line,
                endLine: se(w).line,
                indexDiff: 1
              });
              d = Math.max(C, d), w && (p = p.concat(w.map(function(T) {
                return T.line;
              })));
            }
          }
          return i(s.setSelection(F(s, s.mapping.map(d)))), !0;
        };
      };
    }, e.prototype.changeToListPerLine = function(r, n, a) {
      for (var i = a.from, o = a.startLine, s = a.endLine, l = a.indexDiff, u = l === void 0 ? 0 : l, c = 0, v = function(p) {
        var h = r.doc.child(p), m = h.nodeSize, y = h.content, w = r.mapping.map(i), C = w + y.size, T = n.filter(function(k) {
          return k.line - u === p;
        })[0];
        T && (r.replaceWith(w, C, ee(f.context.schema, T.text)), c = Math.max(c, i + y.size)), i += m;
      }, f = this, d = o - u; d <= s - u; d += 1)
        v(d);
      return c;
    }, e.prototype.toggleTask = function() {
      var r = this;
      return function(n, a) {
        for (var i = n.selection, o = n.tr, s = n.doc, l = n.schema, u = r.context.toastMark, c = G(i), v = c.startIndex, f = c.endIndex, d = null, p = v; p <= f; p += 1) {
          var h = u.findFirstNodeAtLine(p + 1);
          if (rt(h) && h.listData.task) {
            var m = h.listData, y = m.checked, w = m.padding, C = y ? " " : "x", T = h.sourcepos[0], k = Ar(s, T[0] - 1).startOffset;
            k += T[1] + w, d = o.replaceWith(k, k + 1, l.text(C));
          }
        }
        return d ? (a(d), !0) : !1;
      };
    }, e.prototype.commands = function() {
      return {
        bulletList: this.toList("bullet"),
        orderedList: this.toList("ordered"),
        taskList: this.toList("task")
      };
    }, e.prototype.keymaps = function() {
      var r = this.toList("bullet")(), n = this.toList("ordered")(), a = this.toList("task")(), i = this.toggleTask();
      return {
        "Mod-u": r,
        "Mod-U": r,
        "Mod-o": n,
        "Mod-O": n,
        "alt-t": a,
        "alt-T": a,
        "Shift-Ctrl-x": i,
        "Shift-Ctrl-X": i,
        Enter: this.extendList()
      };
    }, e;
  })(U)
);
function Wr(t, e) {
  return function() {
    return function(r, n) {
      var a = r.tr, i = r.selection, o = he(t) ? t : function(C) {
        return t.test(C);
      }, s = e.length, l = a.doc, u = sl(i), c = u[0], v = u[1], f = Math.max(c - s, 1), d = Math.min(v + s, l.content.size - 1), p = i.content(), h = p.content.textBetween(0, p.content.size, `
`), m = l.textBetween(f, c, `
`), y = l.textBetween(v, d, `
`);
      if (h = "" + m + h + y, m && y && o(h))
        a.delete(d - s, d).delete(f, f + s);
      else {
        a.insertText(e, v).insertText(e, c);
        var w = i.empty ? F(a, c + s) : F(a, c + s, v + s);
        a.setSelection(w);
      }
      return n(a), !0;
    };
  };
}
var Qf = /^(\*{2}|_{2}).*([\s\S]*)\1$/m, Kf = "**", Yf = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "strong";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("strong") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.bold = function() {
      return Wr(Qf, Kf);
    }, e.prototype.commands = function() {
      return { bold: this.bold() };
    }, e.prototype.keymaps = function() {
      var r = this.bold()();
      return { "Mod-b": r, "Mod-B": r };
    }, e;
  })(U)
), Zf = /^(~{2}).*([\s\S]*)\1$/m, Jf = "~~", ed = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "strike";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("strike") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return Wr(Zf, Jf);
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return { "Mod-s": r, "Mod-S": r };
    }, e;
  })(U)
), td = /^(\*|_).*([\s\S]*)\1$/m, rd = "*", nd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "emph";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("emph") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.italic = function() {
      return Wr(td, rd);
    }, e.prototype.commands = function() {
      return { italic: this.italic() };
    }, e.prototype.keymaps = function() {
      var r = this.italic()();
      return { "Mod-i": r, "Mod-I": r };
    }, e;
  })(U)
), ad = /^(`).*([\s\S]*)\1$/m, id = "`", od = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "code";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: {
            start: { default: !1 },
            end: { default: !1 },
            marked: { default: !1 }
          },
          toDOM: function(r) {
            var n = r.attrs, a = n.start, i = n.end, o = n.marked, s = "code";
            return a && (s += "|delimiter|start"), i && (s += "|delimiter|end"), o && (s += "|marked-text"), ["span", { class: X.apply(void 0, s.split("|")) }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return Wr(ad, id);
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return { "Shift-Mod-c": r, "Shift-Mod-C": r };
    }, e;
  })(U)
), sd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "link";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: {
            url: { default: !1 },
            desc: { default: !1 }
          },
          toDOM: function(r) {
            var n = r.attrs, a = n.url, i = n.desc, o = "link";
            return a && (o += "|link-url|marked-text"), i && (o += "|link-desc|marked-text"), ["span", { class: X.apply(void 0, o.split("|")) }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addLinkOrImage = function(r) {
      return function(n) {
        return function(a, i) {
          var o = a.selection, s = a.tr, l = a.schema, u = sl(o), c = u[0], v = u[1], f = n, d = f.linkText, p = f.altText, h = f.linkUrl, m = f.imageUrl, y = d, w = h, C = "";
          return r === "image" && (y = p, w = m, C = "!"), y = Er(y), C += "[" + y + "](" + w + ")", i(s.replaceWith(c, v, ee(l, C))), !0;
        };
      };
    }, e.prototype.commands = function() {
      return {
        addImage: this.addLinkOrImage("image"),
        addLink: this.addLinkOrImage("link")
      };
    }, e;
  })(U)
), ld = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "taskDelimiter";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("delimiter", "list-item") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })(U)
), ud = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "delimiter";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("delimiter") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })(U)
), cd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "meta";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("meta") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })(U)
), vd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "markedText";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("marked-text") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })(U)
), fd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "tableCell";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("table-cell") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })(U)
), dd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "html";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("html") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })(U)
), yn = "$$", pd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "customBlock";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          toDOM: function() {
            return ["span", { class: X("custom-block") }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function(r) {
        return function(n, a) {
          var i = n.selection, o = n.schema, s = n.tr, l = G(i), u = l.startFromOffset, c = l.endToOffset;
          if (!r?.info)
            return !1;
          var v = "" + yn + r.info, f = ee(o, v), d = ee(o, yn);
          return s.insert(u, f).split(u + v.length), s.split(s.mapping.map(c)).insert(s.mapping.map(c), d), a(s.setSelection(F(s, s.mapping.map(c) - (yn.length + 2)))), !0;
        };
      };
    }, e;
  })(U)
), hd = /x|backspace/i, md = /^\[(\s*)(x?)(\s*)\](?:\s+)/i;
function gd(t) {
  var e = t.schema, r = t.toastMark;
  return new Ee({
    props: {
      handleDOMEvents: {
        keyup: function(n, a) {
          var i, o = n.state, s = o.doc, l = o.tr, u = o.selection;
          if (u.empty && hd.test(a.key)) {
            var c = G(u), v = c.startIndex, f = c.startFromOffset, d = c.from, p = [v + 1, d - f + 1], h = r.findNodeAtPosition(p), m = kt(h, function(Y) {
              var pe;
              return Y.type === "paragraph" && ((pe = Y.parent) === null || pe === void 0 ? void 0 : pe.type) === "item";
            });
            if (!((i = m?.firstChild) === null || i === void 0) && i.literal) {
              var y = m.firstChild, w = y.literal.match(md);
              if (w) {
                var C = y.sourcepos[0], T = w[1], k = w[2], M = w[3], O = T.length + M.length, I = Ar(s, C[0] - 1).startOffset, _ = C[1] + I;
                if (k) {
                  var V = O ? O + 1 : 0;
                  l.replaceWith(_, V + _, e.text(k)), n.dispatch(l);
                } else O || (l.insertText(" ", _), n.dispatch(l));
              }
            }
          }
          return !1;
        }
      }
    }
  });
}
var bn = "cut", Bi = /\r\n|\n|\r/, yd = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r, n) {
      var a = t.call(this, r) || this, i = n.toastMark, o = n.useCommandShortcut, s = o === void 0 ? !0 : o, l = n.mdPlugins, u = l === void 0 ? [] : l;
      return a.editorType = "markdown", a.el.classList.add("md-mode"), a.toastMark = i, a.extraPlugins = u, a.specs = a.createSpecs(), a.schema = a.createSchema(), a.context = a.createContext(), a.keymaps = a.createKeymaps(s), a.view = a.createView(), a.commands = a.createCommands(), a.specs.setContext(b(b({}, a.context), { view: a.view })), a.createClipboard(), a.eventEmitter.listen("changePreviewTabWrite", function(c) {
        return a.toggleActive(!0, c);
      }), a.eventEmitter.listen("changePreviewTabPreview", function() {
        return a.toggleActive(!1);
      }), a.initEvent(), a;
    }
    return e.prototype.toggleActive = function(r, n) {
      La(this.el, "active", r), r ? n || this.focus() : this.blur();
    }, e.prototype.createClipboard = function() {
      var r = this;
      this.clipboard = document.createElement("textarea"), this.clipboard.className = L("pseudo-clipboard"), this.clipboard.addEventListener("paste", function(n) {
        var a = n.clipboardData || window.clipboardData, i = a && a.items;
        if (i) {
          var o = De(i).some(function(l) {
            return l.kind === "string" && l.type === "text/rtf";
          });
          if (!o) {
            var s = rl(i);
            s && (n.preventDefault(), Oa(r.eventEmitter, s, n.type));
          }
        }
      }), this.clipboard.addEventListener("input", function(n) {
        var a = n.target.value;
        r.replaceSelection(a), n.preventDefault(), n.target.value = "";
      }), this.el.insertBefore(this.clipboard, this.view.dom);
    }, e.prototype.createContext = function() {
      return {
        toastMark: this.toastMark,
        schema: this.schema,
        eventEmitter: this.eventEmitter
      };
    }, e.prototype.createSpecs = function() {
      return new ol([
        new Ef(),
        new Bf(),
        new al(),
        new Hf(),
        new _f(),
        new xf(),
        new qf(),
        new pd(),
        new jf(),
        new fd(),
        new Wf(),
        new Xf(),
        new Yf(),
        new ed(),
        new nd(),
        new od(),
        new sd(),
        new ud(),
        new ld(),
        new vd(),
        new cd(),
        new dd()
      ]);
    }, e.prototype.createPlugins = function() {
      return ce([
        ff(this.context),
        kf(this.context),
        gd(this.context)
      ], this.createPluginProps()).concat(this.defaultPlugins);
    }, e.prototype.createView = function() {
      var r = this;
      return new da(this.el, {
        state: this.createState(),
        dispatchTransaction: function(n) {
          r.updateMarkdown(n);
          var a = r.view.state.applyTransaction(n).state;
          r.view.updateState(a), r.emitChangeEvent(n);
        },
        handleKeyDown: function(n, a) {
          return (a.metaKey || a.ctrlKey) && a.key.toUpperCase() === "V" && r.clipboard.focus(), r.eventEmitter.emit("keydown", r.editorType, a), !1;
        },
        handleDOMEvents: {
          copy: function(n, a) {
            return r.captureCopy(a);
          },
          cut: function(n, a) {
            return r.captureCopy(a, bn);
          },
          scroll: function() {
            return r.eventEmitter.emit("scroll", "editor"), !0;
          },
          keyup: function(n, a) {
            return r.eventEmitter.emit("keyup", r.editorType, a), !1;
          }
        },
        nodeViews: {
          widget: nl
        }
      });
    }, e.prototype.createCommands = function() {
      return this.specs.commands(this.view);
    }, e.prototype.captureCopy = function(r, n) {
      r.preventDefault();
      var a = this.view.state, i = a.selection, o = a.tr;
      if (i.empty)
        return !0;
      var s = this.getChanged(i.content());
      return r.clipboardData ? r.clipboardData.setData("text/plain", s) : window.clipboardData.setData("Text", s), n === bn && this.view.dispatch(o.deleteSelection().scrollIntoView().setMeta("uiEvent", bn)), !0;
    }, e.prototype.updateMarkdown = function(r) {
      var n = this;
      r.docChanged && r.steps.forEach(function(a, i) {
        if (a.slice && !(a instanceof Xt)) {
          var o = r.docs[i], s = [a.from, a.to], l = s[0], u = s[1], c = hr(o, l, u), v = c[0], f = c[1], d = n.getChanged(a.slice);
          v[0] === f[0] && v[1] === f[1] && d === "" && (d = `
`);
          var p = n.toastMark.editMarkdown(v, f, d);
          n.eventEmitter.emit("updatePreview", p), r.setMeta("editResult", p).scrollIntoView();
        }
      });
    }, e.prototype.getChanged = function(r) {
      var n = "", a = 0, i = r.content.size;
      return r.content.nodesBetween(a, i, function(o, s) {
        o.isText ? n += o.text.slice(Math.max(a, s) - s, i - s) : o.isBlock && s > 0 && (n += `
`);
      }), n;
    }, e.prototype.setSelection = function(r, n) {
      n === void 0 && (n = r);
      var a = this.view.state.tr, i = Je(a.doc, r, n), o = i[0], s = i[1];
      this.view.dispatch(a.setSelection(F(a, o, s)).scrollIntoView());
    }, e.prototype.replaceSelection = function(r, n, a) {
      var i, o = this.view.state, s = o.tr, l = o.schema, u = o.doc, c = r.split(Bi), v = c.map(function(m) {
        return Lr(l, et(m, l));
      }), f = new Ce(q.from(v), 1, 1);
      if (this.focus(), n && a) {
        var d = Je(u, n, a), p = d[0], h = d[1];
        i = s.replaceRange(p, h, f);
      } else
        i = s.replaceSelection(f);
      this.view.dispatch(i.scrollIntoView());
    }, e.prototype.deleteSelection = function(r, n) {
      var a, i = this.view.state, o = i.tr, s = i.doc;
      if (r && n) {
        var l = Je(s, r, n), u = l[0], c = l[1];
        a = o.deleteRange(u, c);
      } else
        a = o.deleteSelection();
      this.view.dispatch(a.scrollIntoView());
    }, e.prototype.getSelectedText = function(r, n) {
      var a = this.view.state, i = a.doc, o = a.selection, s = o.from, l = o.to;
      if (r && n) {
        var u = Je(i, r, n);
        s = u[0], l = u[1];
      }
      return i.textBetween(s, l, `
`);
    }, e.prototype.getSelection = function() {
      var r = this.view.state.selection, n = r.from, a = r.to;
      return hr(this.view.state.tr.doc, n, a);
    }, e.prototype.setMarkdown = function(r, n) {
      n === void 0 && (n = !0);
      var a = r.split(Bi), i = this.view.state, o = i.tr, s = i.doc, l = i.schema, u = a.map(function(c) {
        return Lr(l, et(c, l));
      });
      this.view.dispatch(o.replaceWith(0, s.content.size, u)), n && this.moveCursorToEnd(!0);
    }, e.prototype.addWidget = function(r, n, a) {
      var i = this.view.state, o = i.tr, s = i.doc, l = i.selection, u = a ? Je(s, a, a)[0] : l.to;
      this.view.dispatch(o.setMeta("widget", { pos: u, node: r, style: n }));
    }, e.prototype.replaceWithWidget = function(r, n, a) {
      var i = this.view.state, o = i.tr, s = i.schema, l = i.doc, u = Je(l, r, n), c = et(a, s);
      this.view.dispatch(o.replaceWith(u[0], u[1], c));
    }, e.prototype.getRangeInfoOfNode = function(r) {
      var n = this.view.state, a = n.doc, i = n.selection, o = r || hr(a, i.from)[0], s = this.toastMark.findNodeAtPosition(o);
      return s.type === "text" && s.parent.type !== "paragraph" && (s = s.parent), s.sourcepos[1][1] += 1, { range: s.sourcepos, type: s.type };
    }, e.prototype.getMarkdown = function() {
      return this.toastMark.getLineTexts().map(function(r) {
        return Vr(r);
      }).join(`
`);
    }, e.prototype.getToastMark = function() {
      return this.toastMark;
    }, e;
  })(il)
), Hi = "_feEventKey";
function bd(t, e) {
  var r = t[Hi], n;
  return r || (r = t[Hi] = {}), n = r[e], n || (n = r[e] = []), n;
}
var pl = bd, wd = Fe, Dr = $r, Cd = pl;
function Td(t, e, r) {
  if (wd(e)) {
    Dr(e.split(/\s+/g), function(n) {
      Pi(t, n, r);
    });
    return;
  }
  Dr(e, function(n, a) {
    Pi(t, a, n);
  });
}
function Pi(t, e, r) {
  var n = Cd(t, e), a;
  r ? (Dr(n, function(i, o) {
    return r === i.handler ? (_i(t, e, i.wrappedHandler), a = o, !1) : !0;
  }), n.splice(a, 1)) : (Dr(n, function(i) {
    _i(t, e, i.wrappedHandler);
  }), n.splice(0, n.length));
}
function _i(t, e, r) {
  "removeEventListener" in t ? t.removeEventListener(e, r) : "detachEvent" in t && t.detachEvent("on" + e, r);
}
var hl = Td, kd = Fe, jn = $r, Ed = pl;
function xd(t, e, r, n) {
  if (kd(e)) {
    jn(e.split(/\s+/g), function(a) {
      qi(t, a, r, n);
    });
    return;
  }
  jn(e, function(a, i) {
    qi(t, i, a, r);
  });
}
function qi(t, e, r, n) {
  function a(i) {
    r.call(n || t, i || window.event);
  }
  "addEventListener" in t ? t.addEventListener(e, a) : "attachEvent" in t && t.attachEvent("on" + e, a), Ld(t, e, r, a);
}
function Ld(t, e, r, n) {
  var a = Ed(t, e), i = !1;
  jn(a, function(o) {
    return o.handler === r ? (i = !0, !1) : !0;
  }), i || a.push({
    handler: r,
    wrappedHandler: n
  });
}
var ml = xd;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var zn = function(t, e) {
  return zn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, zn(t, e);
};
function me(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  zn(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var J = function() {
  return J = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, J.apply(this, arguments);
};
function Wn(t, e, r) {
  if (arguments.length === 2) for (var n = 0, a = e.length, i; n < a; n++)
    (i || !(n in e)) && (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var Lt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, $i = {};
function Md(t) {
  var e, r, n = $i[t];
  if (n)
    return n;
  for (n = $i[t] = [], e = 0; e < 128; e++)
    r = String.fromCharCode(e), /^[0-9a-z]$/i.test(r) ? n.push(r) : n.push("%" + ("0" + e.toString(16).toUpperCase()).slice(-2));
  for (e = 0; e < t.length; e++)
    n[t.charCodeAt(e)] = t[e];
  return n;
}
function Gr(t, e, r) {
  var n, a, i, o, s, l = "";
  for (typeof e != "string" && (r = e, e = Gr.defaultChars), typeof r > "u" && (r = !0), s = Md(e), n = 0, a = t.length; n < a; n++) {
    if (i = t.charCodeAt(n), r && i === 37 && n + 2 < a && /^[0-9a-f]{2}$/i.test(t.slice(n + 1, n + 3))) {
      l += t.slice(n, n + 3), n += 2;
      continue;
    }
    if (i < 128) {
      l += s[i];
      continue;
    }
    if (i >= 55296 && i <= 57343) {
      if (i >= 55296 && i <= 56319 && n + 1 < a && (o = t.charCodeAt(n + 1), o >= 56320 && o <= 57343)) {
        l += encodeURIComponent(t[n] + t[n + 1]), n++;
        continue;
      }
      l += "%EF%BF%BD";
      continue;
    }
    l += encodeURIComponent(t[n]);
  }
  return l;
}
Gr.defaultChars = ";/?:@&=+$,-_.!~*'()#";
Gr.componentChars = "-_.!~*'()";
var Ad = Gr, Ba = {}, qe = {}, Sd = "Á", Od = "á", Dd = "Ă", Id = "ă", Nd = "∾", Rd = "∿", Bd = "∾̳", Hd = "Â", Pd = "â", _d = "´", qd = "А", $d = "а", Fd = "Æ", Ud = "æ", Vd = "⁡", jd = "𝔄", zd = "𝔞", Wd = "À", Gd = "à", Xd = "ℵ", Qd = "ℵ", Kd = "Α", Yd = "α", Zd = "Ā", Jd = "ā", ep = "⨿", tp = "&", rp = "&", np = "⩕", ap = "⩓", ip = "∧", op = "⩜", sp = "⩘", lp = "⩚", up = "∠", cp = "⦤", vp = "∠", fp = "⦨", dp = "⦩", pp = "⦪", hp = "⦫", mp = "⦬", gp = "⦭", yp = "⦮", bp = "⦯", wp = "∡", Cp = "∟", Tp = "⊾", kp = "⦝", Ep = "∢", xp = "Å", Lp = "⍼", Mp = "Ą", Ap = "ą", Sp = "𝔸", Op = "𝕒", Dp = "⩯", Ip = "≈", Np = "⩰", Rp = "≊", Bp = "≋", Hp = "'", Pp = "⁡", _p = "≈", qp = "≊", $p = "Å", Fp = "å", Up = "𝒜", Vp = "𝒶", jp = "≔", zp = "*", Wp = "≈", Gp = "≍", Xp = "Ã", Qp = "ã", Kp = "Ä", Yp = "ä", Zp = "∳", Jp = "⨑", eh = "≌", th = "϶", rh = "‵", nh = "∽", ah = "⋍", ih = "∖", oh = "⫧", sh = "⊽", lh = "⌅", uh = "⌆", ch = "⌅", vh = "⎵", fh = "⎶", dh = "≌", ph = "Б", hh = "б", mh = "„", gh = "∵", yh = "∵", bh = "∵", wh = "⦰", Ch = "϶", Th = "ℬ", kh = "ℬ", Eh = "Β", xh = "β", Lh = "ℶ", Mh = "≬", Ah = "𝔅", Sh = "𝔟", Oh = "⋂", Dh = "◯", Ih = "⋃", Nh = "⨀", Rh = "⨁", Bh = "⨂", Hh = "⨆", Ph = "★", _h = "▽", qh = "△", $h = "⨄", Fh = "⋁", Uh = "⋀", Vh = "⤍", jh = "⧫", zh = "▪", Wh = "▴", Gh = "▾", Xh = "◂", Qh = "▸", Kh = "␣", Yh = "▒", Zh = "░", Jh = "▓", em = "█", tm = "=⃥", rm = "≡⃥", nm = "⫭", am = "⌐", im = "𝔹", om = "𝕓", sm = "⊥", lm = "⊥", um = "⋈", cm = "⧉", vm = "┐", fm = "╕", dm = "╖", pm = "╗", hm = "┌", mm = "╒", gm = "╓", ym = "╔", bm = "─", wm = "═", Cm = "┬", Tm = "╤", km = "╥", Em = "╦", xm = "┴", Lm = "╧", Mm = "╨", Am = "╩", Sm = "⊟", Om = "⊞", Dm = "⊠", Im = "┘", Nm = "╛", Rm = "╜", Bm = "╝", Hm = "└", Pm = "╘", _m = "╙", qm = "╚", $m = "│", Fm = "║", Um = "┼", Vm = "╪", jm = "╫", zm = "╬", Wm = "┤", Gm = "╡", Xm = "╢", Qm = "╣", Km = "├", Ym = "╞", Zm = "╟", Jm = "╠", eg = "‵", tg = "˘", rg = "˘", ng = "¦", ag = "𝒷", ig = "ℬ", og = "⁏", sg = "∽", lg = "⋍", ug = "⧅", cg = "\\", vg = "⟈", fg = "•", dg = "•", pg = "≎", hg = "⪮", mg = "≏", gg = "≎", yg = "≏", bg = "Ć", wg = "ć", Cg = "⩄", Tg = "⩉", kg = "⩋", Eg = "∩", xg = "⋒", Lg = "⩇", Mg = "⩀", Ag = "ⅅ", Sg = "∩︀", Og = "⁁", Dg = "ˇ", Ig = "ℭ", Ng = "⩍", Rg = "Č", Bg = "č", Hg = "Ç", Pg = "ç", _g = "Ĉ", qg = "ĉ", $g = "∰", Fg = "⩌", Ug = "⩐", Vg = "Ċ", jg = "ċ", zg = "¸", Wg = "¸", Gg = "⦲", Xg = "¢", Qg = "·", Kg = "·", Yg = "𝔠", Zg = "ℭ", Jg = "Ч", ey = "ч", ty = "✓", ry = "✓", ny = "Χ", ay = "χ", iy = "ˆ", oy = "≗", sy = "↺", ly = "↻", uy = "⊛", cy = "⊚", vy = "⊝", fy = "⊙", dy = "®", py = "Ⓢ", hy = "⊖", my = "⊕", gy = "⊗", yy = "○", by = "⧃", wy = "≗", Cy = "⨐", Ty = "⫯", ky = "⧂", Ey = "∲", xy = "”", Ly = "’", My = "♣", Ay = "♣", Sy = ":", Oy = "∷", Dy = "⩴", Iy = "≔", Ny = "≔", Ry = ",", By = "@", Hy = "∁", Py = "∘", _y = "∁", qy = "ℂ", $y = "≅", Fy = "⩭", Uy = "≡", Vy = "∮", jy = "∯", zy = "∮", Wy = "𝕔", Gy = "ℂ", Xy = "∐", Qy = "∐", Ky = "©", Yy = "©", Zy = "℗", Jy = "∳", eb = "↵", tb = "✗", rb = "⨯", nb = "𝒞", ab = "𝒸", ib = "⫏", ob = "⫑", sb = "⫐", lb = "⫒", ub = "⋯", cb = "⤸", vb = "⤵", fb = "⋞", db = "⋟", pb = "↶", hb = "⤽", mb = "⩈", gb = "⩆", yb = "≍", bb = "∪", wb = "⋓", Cb = "⩊", Tb = "⊍", kb = "⩅", Eb = "∪︀", xb = "↷", Lb = "⤼", Mb = "⋞", Ab = "⋟", Sb = "⋎", Ob = "⋏", Db = "¤", Ib = "↶", Nb = "↷", Rb = "⋎", Bb = "⋏", Hb = "∲", Pb = "∱", _b = "⌭", qb = "†", $b = "‡", Fb = "ℸ", Ub = "↓", Vb = "↡", jb = "⇓", zb = "‐", Wb = "⫤", Gb = "⊣", Xb = "⤏", Qb = "˝", Kb = "Ď", Yb = "ď", Zb = "Д", Jb = "д", ew = "‡", tw = "⇊", rw = "ⅅ", nw = "ⅆ", aw = "⤑", iw = "⩷", ow = "°", sw = "∇", lw = "Δ", uw = "δ", cw = "⦱", vw = "⥿", fw = "𝔇", dw = "𝔡", pw = "⥥", hw = "⇃", mw = "⇂", gw = "´", yw = "˙", bw = "˝", ww = "`", Cw = "˜", Tw = "⋄", kw = "⋄", Ew = "⋄", xw = "♦", Lw = "♦", Mw = "¨", Aw = "ⅆ", Sw = "ϝ", Ow = "⋲", Dw = "÷", Iw = "÷", Nw = "⋇", Rw = "⋇", Bw = "Ђ", Hw = "ђ", Pw = "⌞", _w = "⌍", qw = "$", $w = "𝔻", Fw = "𝕕", Uw = "¨", Vw = "˙", jw = "⃜", zw = "≐", Ww = "≑", Gw = "≐", Xw = "∸", Qw = "∔", Kw = "⊡", Yw = "⌆", Zw = "∯", Jw = "¨", eC = "⇓", tC = "⇐", rC = "⇔", nC = "⫤", aC = "⟸", iC = "⟺", oC = "⟹", sC = "⇒", lC = "⊨", uC = "⇑", cC = "⇕", vC = "∥", fC = "⤓", dC = "↓", pC = "↓", hC = "⇓", mC = "⇵", gC = "̑", yC = "⇊", bC = "⇃", wC = "⇂", CC = "⥐", TC = "⥞", kC = "⥖", EC = "↽", xC = "⥟", LC = "⥗", MC = "⇁", AC = "↧", SC = "⊤", OC = "⤐", DC = "⌟", IC = "⌌", NC = "𝒟", RC = "𝒹", BC = "Ѕ", HC = "ѕ", PC = "⧶", _C = "Đ", qC = "đ", $C = "⋱", FC = "▿", UC = "▾", VC = "⇵", jC = "⥯", zC = "⦦", WC = "Џ", GC = "џ", XC = "⟿", QC = "É", KC = "é", YC = "⩮", ZC = "Ě", JC = "ě", eT = "Ê", tT = "ê", rT = "≖", nT = "≕", aT = "Э", iT = "э", oT = "⩷", sT = "Ė", lT = "ė", uT = "≑", cT = "ⅇ", vT = "≒", fT = "𝔈", dT = "𝔢", pT = "⪚", hT = "È", mT = "è", gT = "⪖", yT = "⪘", bT = "⪙", wT = "∈", CT = "⏧", TT = "ℓ", kT = "⪕", ET = "⪗", xT = "Ē", LT = "ē", MT = "∅", AT = "∅", ST = "◻", OT = "∅", DT = "▫", IT = " ", NT = " ", RT = " ", BT = "Ŋ", HT = "ŋ", PT = " ", _T = "Ę", qT = "ę", $T = "𝔼", FT = "𝕖", UT = "⋕", VT = "⧣", jT = "⩱", zT = "ε", WT = "Ε", GT = "ε", XT = "ϵ", QT = "≖", KT = "≕", YT = "≂", ZT = "⪖", JT = "⪕", ek = "⩵", tk = "=", rk = "≂", nk = "≟", ak = "⇌", ik = "≡", ok = "⩸", sk = "⧥", lk = "⥱", uk = "≓", ck = "ℯ", vk = "ℰ", fk = "≐", dk = "⩳", pk = "≂", hk = "Η", mk = "η", gk = "Ð", yk = "ð", bk = "Ë", wk = "ë", Ck = "€", Tk = "!", kk = "∃", Ek = "∃", xk = "ℰ", Lk = "ⅇ", Mk = "ⅇ", Ak = "≒", Sk = "Ф", Ok = "ф", Dk = "♀", Ik = "ﬃ", Nk = "ﬀ", Rk = "ﬄ", Bk = "𝔉", Hk = "𝔣", Pk = "ﬁ", _k = "◼", qk = "▪", $k = "fj", Fk = "♭", Uk = "ﬂ", Vk = "▱", jk = "ƒ", zk = "𝔽", Wk = "𝕗", Gk = "∀", Xk = "∀", Qk = "⋔", Kk = "⫙", Yk = "ℱ", Zk = "⨍", Jk = "½", eE = "⅓", tE = "¼", rE = "⅕", nE = "⅙", aE = "⅛", iE = "⅔", oE = "⅖", sE = "¾", lE = "⅗", uE = "⅜", cE = "⅘", vE = "⅚", fE = "⅝", dE = "⅞", pE = "⁄", hE = "⌢", mE = "𝒻", gE = "ℱ", yE = "ǵ", bE = "Γ", wE = "γ", CE = "Ϝ", TE = "ϝ", kE = "⪆", EE = "Ğ", xE = "ğ", LE = "Ģ", ME = "Ĝ", AE = "ĝ", SE = "Г", OE = "г", DE = "Ġ", IE = "ġ", NE = "≥", RE = "≧", BE = "⪌", HE = "⋛", PE = "≥", _E = "≧", qE = "⩾", $E = "⪩", FE = "⩾", UE = "⪀", VE = "⪂", jE = "⪄", zE = "⋛︀", WE = "⪔", GE = "𝔊", XE = "𝔤", QE = "≫", KE = "⋙", YE = "⋙", ZE = "ℷ", JE = "Ѓ", ex = "ѓ", tx = "⪥", rx = "≷", nx = "⪒", ax = "⪤", ix = "⪊", ox = "⪊", sx = "⪈", lx = "≩", ux = "⪈", cx = "≩", vx = "⋧", fx = "𝔾", dx = "𝕘", px = "`", hx = "≥", mx = "⋛", gx = "≧", yx = "⪢", bx = "≷", wx = "⩾", Cx = "≳", Tx = "𝒢", kx = "ℊ", Ex = "≳", xx = "⪎", Lx = "⪐", Mx = "⪧", Ax = "⩺", Sx = ">", Ox = ">", Dx = "≫", Ix = "⋗", Nx = "⦕", Rx = "⩼", Bx = "⪆", Hx = "⥸", Px = "⋗", _x = "⋛", qx = "⪌", $x = "≷", Fx = "≳", Ux = "≩︀", Vx = "≩︀", jx = "ˇ", zx = " ", Wx = "½", Gx = "ℋ", Xx = "Ъ", Qx = "ъ", Kx = "⥈", Yx = "↔", Zx = "⇔", Jx = "↭", e1 = "^", t1 = "ℏ", r1 = "Ĥ", n1 = "ĥ", a1 = "♥", i1 = "♥", o1 = "…", s1 = "⊹", l1 = "𝔥", u1 = "ℌ", c1 = "ℋ", v1 = "⤥", f1 = "⤦", d1 = "⇿", p1 = "∻", h1 = "↩", m1 = "↪", g1 = "𝕙", y1 = "ℍ", b1 = "―", w1 = "─", C1 = "𝒽", T1 = "ℋ", k1 = "ℏ", E1 = "Ħ", x1 = "ħ", L1 = "≎", M1 = "≏", A1 = "⁃", S1 = "‐", O1 = "Í", D1 = "í", I1 = "⁣", N1 = "Î", R1 = "î", B1 = "И", H1 = "и", P1 = "İ", _1 = "Е", q1 = "е", $1 = "¡", F1 = "⇔", U1 = "𝔦", V1 = "ℑ", j1 = "Ì", z1 = "ì", W1 = "ⅈ", G1 = "⨌", X1 = "∭", Q1 = "⧜", K1 = "℩", Y1 = "Ĳ", Z1 = "ĳ", J1 = "Ī", eL = "ī", tL = "ℑ", rL = "ⅈ", nL = "ℐ", aL = "ℑ", iL = "ı", oL = "ℑ", sL = "⊷", lL = "Ƶ", uL = "⇒", cL = "℅", vL = "∞", fL = "⧝", dL = "ı", pL = "⊺", hL = "∫", mL = "∬", gL = "ℤ", yL = "∫", bL = "⊺", wL = "⋂", CL = "⨗", TL = "⨼", kL = "⁣", EL = "⁢", xL = "Ё", LL = "ё", ML = "Į", AL = "į", SL = "𝕀", OL = "𝕚", DL = "Ι", IL = "ι", NL = "⨼", RL = "¿", BL = "𝒾", HL = "ℐ", PL = "∈", _L = "⋵", qL = "⋹", $L = "⋴", FL = "⋳", UL = "∈", VL = "⁢", jL = "Ĩ", zL = "ĩ", WL = "І", GL = "і", XL = "Ï", QL = "ï", KL = "Ĵ", YL = "ĵ", ZL = "Й", JL = "й", e0 = "𝔍", t0 = "𝔧", r0 = "ȷ", n0 = "𝕁", a0 = "𝕛", i0 = "𝒥", o0 = "𝒿", s0 = "Ј", l0 = "ј", u0 = "Є", c0 = "є", v0 = "Κ", f0 = "κ", d0 = "ϰ", p0 = "Ķ", h0 = "ķ", m0 = "К", g0 = "к", y0 = "𝔎", b0 = "𝔨", w0 = "ĸ", C0 = "Х", T0 = "х", k0 = "Ќ", E0 = "ќ", x0 = "𝕂", L0 = "𝕜", M0 = "𝒦", A0 = "𝓀", S0 = "⇚", O0 = "Ĺ", D0 = "ĺ", I0 = "⦴", N0 = "ℒ", R0 = "Λ", B0 = "λ", H0 = "⟨", P0 = "⟪", _0 = "⦑", q0 = "⟨", $0 = "⪅", F0 = "ℒ", U0 = "«", V0 = "⇤", j0 = "⤟", z0 = "←", W0 = "↞", G0 = "⇐", X0 = "⤝", Q0 = "↩", K0 = "↫", Y0 = "⤹", Z0 = "⥳", J0 = "↢", eM = "⤙", tM = "⤛", rM = "⪫", nM = "⪭", aM = "⪭︀", iM = "⤌", oM = "⤎", sM = "❲", lM = "{", uM = "[", cM = "⦋", vM = "⦏", fM = "⦍", dM = "Ľ", pM = "ľ", hM = "Ļ", mM = "ļ", gM = "⌈", yM = "{", bM = "Л", wM = "л", CM = "⤶", TM = "“", kM = "„", EM = "⥧", xM = "⥋", LM = "↲", MM = "≤", AM = "≦", SM = "⟨", OM = "⇤", DM = "←", IM = "←", NM = "⇐", RM = "⇆", BM = "↢", HM = "⌈", PM = "⟦", _M = "⥡", qM = "⥙", $M = "⇃", FM = "⌊", UM = "↽", VM = "↼", jM = "⇇", zM = "↔", WM = "↔", GM = "⇔", XM = "⇆", QM = "⇋", KM = "↭", YM = "⥎", ZM = "↤", JM = "⊣", eA = "⥚", tA = "⋋", rA = "⧏", nA = "⊲", aA = "⊴", iA = "⥑", oA = "⥠", sA = "⥘", lA = "↿", uA = "⥒", cA = "↼", vA = "⪋", fA = "⋚", dA = "≤", pA = "≦", hA = "⩽", mA = "⪨", gA = "⩽", yA = "⩿", bA = "⪁", wA = "⪃", CA = "⋚︀", TA = "⪓", kA = "⪅", EA = "⋖", xA = "⋚", LA = "⪋", MA = "⋚", AA = "≦", SA = "≶", OA = "≶", DA = "⪡", IA = "≲", NA = "⩽", RA = "≲", BA = "⥼", HA = "⌊", PA = "𝔏", _A = "𝔩", qA = "≶", $A = "⪑", FA = "⥢", UA = "↽", VA = "↼", jA = "⥪", zA = "▄", WA = "Љ", GA = "љ", XA = "⇇", QA = "≪", KA = "⋘", YA = "⌞", ZA = "⇚", JA = "⥫", eS = "◺", tS = "Ŀ", rS = "ŀ", nS = "⎰", aS = "⎰", iS = "⪉", oS = "⪉", sS = "⪇", lS = "≨", uS = "⪇", cS = "≨", vS = "⋦", fS = "⟬", dS = "⇽", pS = "⟦", hS = "⟵", mS = "⟵", gS = "⟸", yS = "⟷", bS = "⟷", wS = "⟺", CS = "⟼", TS = "⟶", kS = "⟶", ES = "⟹", xS = "↫", LS = "↬", MS = "⦅", AS = "𝕃", SS = "𝕝", OS = "⨭", DS = "⨴", IS = "∗", NS = "_", RS = "↙", BS = "↘", HS = "◊", PS = "◊", _S = "⧫", qS = "(", $S = "⦓", FS = "⇆", US = "⌟", VS = "⇋", jS = "⥭", zS = "‎", WS = "⊿", GS = "‹", XS = "𝓁", QS = "ℒ", KS = "↰", YS = "↰", ZS = "≲", JS = "⪍", eO = "⪏", tO = "[", rO = "‘", nO = "‚", aO = "Ł", iO = "ł", oO = "⪦", sO = "⩹", lO = "<", uO = "<", cO = "≪", vO = "⋖", fO = "⋋", dO = "⋉", pO = "⥶", hO = "⩻", mO = "◃", gO = "⊴", yO = "◂", bO = "⦖", wO = "⥊", CO = "⥦", TO = "≨︀", kO = "≨︀", EO = "¯", xO = "♂", LO = "✠", MO = "✠", AO = "↦", SO = "↦", OO = "↧", DO = "↤", IO = "↥", NO = "▮", RO = "⨩", BO = "М", HO = "м", PO = "—", _O = "∺", qO = "∡", $O = " ", FO = "ℳ", UO = "𝔐", VO = "𝔪", jO = "℧", zO = "µ", WO = "*", GO = "⫰", XO = "∣", QO = "·", KO = "⊟", YO = "−", ZO = "∸", JO = "⨪", eD = "∓", tD = "⫛", rD = "…", nD = "∓", aD = "⊧", iD = "𝕄", oD = "𝕞", sD = "∓", lD = "𝓂", uD = "ℳ", cD = "∾", vD = "Μ", fD = "μ", dD = "⊸", pD = "⊸", hD = "∇", mD = "Ń", gD = "ń", yD = "∠⃒", bD = "≉", wD = "⩰̸", CD = "≋̸", TD = "ŉ", kD = "≉", ED = "♮", xD = "ℕ", LD = "♮", MD = " ", AD = "≎̸", SD = "≏̸", OD = "⩃", DD = "Ň", ID = "ň", ND = "Ņ", RD = "ņ", BD = "≇", HD = "⩭̸", PD = "⩂", _D = "Н", qD = "н", $D = "–", FD = "⤤", UD = "↗", VD = "⇗", jD = "↗", zD = "≠", WD = "≐̸", GD = "​", XD = "​", QD = "​", KD = "​", YD = "≢", ZD = "⤨", JD = "≂̸", eI = "≫", tI = "≪", rI = `
`, nI = "∄", aI = "∄", iI = "𝔑", oI = "𝔫", sI = "≧̸", lI = "≱", uI = "≱", cI = "≧̸", vI = "⩾̸", fI = "⩾̸", dI = "⋙̸", pI = "≵", hI = "≫⃒", mI = "≯", gI = "≯", yI = "≫̸", bI = "↮", wI = "⇎", CI = "⫲", TI = "∋", kI = "⋼", EI = "⋺", xI = "∋", LI = "Њ", MI = "њ", AI = "↚", SI = "⇍", OI = "‥", DI = "≦̸", II = "≰", NI = "↚", RI = "⇍", BI = "↮", HI = "⇎", PI = "≰", _I = "≦̸", qI = "⩽̸", $I = "⩽̸", FI = "≮", UI = "⋘̸", VI = "≴", jI = "≪⃒", zI = "≮", WI = "⋪", GI = "⋬", XI = "≪̸", QI = "∤", KI = "⁠", YI = " ", ZI = "𝕟", JI = "ℕ", eN = "⫬", tN = "¬", rN = "≢", nN = "≭", aN = "∦", iN = "∉", oN = "≠", sN = "≂̸", lN = "∄", uN = "≯", cN = "≱", vN = "≧̸", fN = "≫̸", dN = "≹", pN = "⩾̸", hN = "≵", mN = "≎̸", gN = "≏̸", yN = "∉", bN = "⋵̸", wN = "⋹̸", CN = "∉", TN = "⋷", kN = "⋶", EN = "⧏̸", xN = "⋪", LN = "⋬", MN = "≮", AN = "≰", SN = "≸", ON = "≪̸", DN = "⩽̸", IN = "≴", NN = "⪢̸", RN = "⪡̸", BN = "∌", HN = "∌", PN = "⋾", _N = "⋽", qN = "⊀", $N = "⪯̸", FN = "⋠", UN = "∌", VN = "⧐̸", jN = "⋫", zN = "⋭", WN = "⊏̸", GN = "⋢", XN = "⊐̸", QN = "⋣", KN = "⊂⃒", YN = "⊈", ZN = "⊁", JN = "⪰̸", eR = "⋡", tR = "≿̸", rR = "⊃⃒", nR = "⊉", aR = "≁", iR = "≄", oR = "≇", sR = "≉", lR = "∤", uR = "∦", cR = "∦", vR = "⫽⃥", fR = "∂̸", dR = "⨔", pR = "⊀", hR = "⋠", mR = "⊀", gR = "⪯̸", yR = "⪯̸", bR = "⤳̸", wR = "↛", CR = "⇏", TR = "↝̸", kR = "↛", ER = "⇏", xR = "⋫", LR = "⋭", MR = "⊁", AR = "⋡", SR = "⪰̸", OR = "𝒩", DR = "𝓃", IR = "∤", NR = "∦", RR = "≁", BR = "≄", HR = "≄", PR = "∤", _R = "∦", qR = "⋢", $R = "⋣", FR = "⊄", UR = "⫅̸", VR = "⊈", jR = "⊂⃒", zR = "⊈", WR = "⫅̸", GR = "⊁", XR = "⪰̸", QR = "⊅", KR = "⫆̸", YR = "⊉", ZR = "⊃⃒", JR = "⊉", eB = "⫆̸", tB = "≹", rB = "Ñ", nB = "ñ", aB = "≸", iB = "⋪", oB = "⋬", sB = "⋫", lB = "⋭", uB = "Ν", cB = "ν", vB = "#", fB = "№", dB = " ", pB = "≍⃒", hB = "⊬", mB = "⊭", gB = "⊮", yB = "⊯", bB = "≥⃒", wB = ">⃒", CB = "⤄", TB = "⧞", kB = "⤂", EB = "≤⃒", xB = "<⃒", LB = "⊴⃒", MB = "⤃", AB = "⊵⃒", SB = "∼⃒", OB = "⤣", DB = "↖", IB = "⇖", NB = "↖", RB = "⤧", BB = "Ó", HB = "ó", PB = "⊛", _B = "Ô", qB = "ô", $B = "⊚", FB = "О", UB = "о", VB = "⊝", jB = "Ő", zB = "ő", WB = "⨸", GB = "⊙", XB = "⦼", QB = "Œ", KB = "œ", YB = "⦿", ZB = "𝔒", JB = "𝔬", eH = "˛", tH = "Ò", rH = "ò", nH = "⧁", aH = "⦵", iH = "Ω", oH = "∮", sH = "↺", lH = "⦾", uH = "⦻", cH = "‾", vH = "⧀", fH = "Ō", dH = "ō", pH = "Ω", hH = "ω", mH = "Ο", gH = "ο", yH = "⦶", bH = "⊖", wH = "𝕆", CH = "𝕠", TH = "⦷", kH = "“", EH = "‘", xH = "⦹", LH = "⊕", MH = "↻", AH = "⩔", SH = "∨", OH = "⩝", DH = "ℴ", IH = "ℴ", NH = "ª", RH = "º", BH = "⊶", HH = "⩖", PH = "⩗", _H = "⩛", qH = "Ⓢ", $H = "𝒪", FH = "ℴ", UH = "Ø", VH = "ø", jH = "⊘", zH = "Õ", WH = "õ", GH = "⨶", XH = "⨷", QH = "⊗", KH = "Ö", YH = "ö", ZH = "⌽", JH = "‾", eP = "⏞", tP = "⎴", rP = "⏜", nP = "¶", aP = "∥", iP = "∥", oP = "⫳", sP = "⫽", lP = "∂", uP = "∂", cP = "П", vP = "п", fP = "%", dP = ".", pP = "‰", hP = "⊥", mP = "‱", gP = "𝔓", yP = "𝔭", bP = "Φ", wP = "φ", CP = "ϕ", TP = "ℳ", kP = "☎", EP = "Π", xP = "π", LP = "⋔", MP = "ϖ", AP = "ℏ", SP = "ℎ", OP = "ℏ", DP = "⨣", IP = "⊞", NP = "⨢", RP = "+", BP = "∔", HP = "⨥", PP = "⩲", _P = "±", qP = "±", $P = "⨦", FP = "⨧", UP = "±", VP = "ℌ", jP = "⨕", zP = "𝕡", WP = "ℙ", GP = "£", XP = "⪷", QP = "⪻", KP = "≺", YP = "≼", ZP = "⪷", JP = "≺", e_ = "≼", t_ = "≺", r_ = "⪯", n_ = "≼", a_ = "≾", i_ = "⪯", o_ = "⪹", s_ = "⪵", l_ = "⋨", u_ = "⪯", c_ = "⪳", v_ = "≾", f_ = "′", d_ = "″", p_ = "ℙ", h_ = "⪹", m_ = "⪵", g_ = "⋨", y_ = "∏", b_ = "∏", w_ = "⌮", C_ = "⌒", T_ = "⌓", k_ = "∝", E_ = "∝", x_ = "∷", L_ = "∝", M_ = "≾", A_ = "⊰", S_ = "𝒫", O_ = "𝓅", D_ = "Ψ", I_ = "ψ", N_ = " ", R_ = "𝔔", B_ = "𝔮", H_ = "⨌", P_ = "𝕢", __ = "ℚ", q_ = "⁗", $_ = "𝒬", F_ = "𝓆", U_ = "ℍ", V_ = "⨖", j_ = "?", z_ = "≟", W_ = '"', G_ = '"', X_ = "⇛", Q_ = "∽̱", K_ = "Ŕ", Y_ = "ŕ", Z_ = "√", J_ = "⦳", eq = "⟩", tq = "⟫", rq = "⦒", nq = "⦥", aq = "⟩", iq = "»", oq = "⥵", sq = "⇥", lq = "⤠", uq = "⤳", cq = "→", vq = "↠", fq = "⇒", dq = "⤞", pq = "↪", hq = "↬", mq = "⥅", gq = "⥴", yq = "⤖", bq = "↣", wq = "↝", Cq = "⤚", Tq = "⤜", kq = "∶", Eq = "ℚ", xq = "⤍", Lq = "⤏", Mq = "⤐", Aq = "❳", Sq = "}", Oq = "]", Dq = "⦌", Iq = "⦎", Nq = "⦐", Rq = "Ř", Bq = "ř", Hq = "Ŗ", Pq = "ŗ", _q = "⌉", qq = "}", $q = "Р", Fq = "р", Uq = "⤷", Vq = "⥩", jq = "”", zq = "”", Wq = "↳", Gq = "ℜ", Xq = "ℛ", Qq = "ℜ", Kq = "ℝ", Yq = "ℜ", Zq = "▭", Jq = "®", e$ = "®", t$ = "∋", r$ = "⇋", n$ = "⥯", a$ = "⥽", i$ = "⌋", o$ = "𝔯", s$ = "ℜ", l$ = "⥤", u$ = "⇁", c$ = "⇀", v$ = "⥬", f$ = "Ρ", d$ = "ρ", p$ = "ϱ", h$ = "⟩", m$ = "⇥", g$ = "→", y$ = "→", b$ = "⇒", w$ = "⇄", C$ = "↣", T$ = "⌉", k$ = "⟧", E$ = "⥝", x$ = "⥕", L$ = "⇂", M$ = "⌋", A$ = "⇁", S$ = "⇀", O$ = "⇄", D$ = "⇌", I$ = "⇉", N$ = "↝", R$ = "↦", B$ = "⊢", H$ = "⥛", P$ = "⋌", _$ = "⧐", q$ = "⊳", $$ = "⊵", F$ = "⥏", U$ = "⥜", V$ = "⥔", j$ = "↾", z$ = "⥓", W$ = "⇀", G$ = "˚", X$ = "≓", Q$ = "⇄", K$ = "⇌", Y$ = "‏", Z$ = "⎱", J$ = "⎱", eF = "⫮", tF = "⟭", rF = "⇾", nF = "⟧", aF = "⦆", iF = "𝕣", oF = "ℝ", sF = "⨮", lF = "⨵", uF = "⥰", cF = ")", vF = "⦔", fF = "⨒", dF = "⇉", pF = "⇛", hF = "›", mF = "𝓇", gF = "ℛ", yF = "↱", bF = "↱", wF = "]", CF = "’", TF = "’", kF = "⋌", EF = "⋊", xF = "▹", LF = "⊵", MF = "▸", AF = "⧎", SF = "⧴", OF = "⥨", DF = "℞", IF = "Ś", NF = "ś", RF = "‚", BF = "⪸", HF = "Š", PF = "š", _F = "⪼", qF = "≻", $F = "≽", FF = "⪰", UF = "⪴", VF = "Ş", jF = "ş", zF = "Ŝ", WF = "ŝ", GF = "⪺", XF = "⪶", QF = "⋩", KF = "⨓", YF = "≿", ZF = "С", JF = "с", eU = "⊡", tU = "⋅", rU = "⩦", nU = "⤥", aU = "↘", iU = "⇘", oU = "↘", sU = "§", lU = ";", uU = "⤩", cU = "∖", vU = "∖", fU = "✶", dU = "𝔖", pU = "𝔰", hU = "⌢", mU = "♯", gU = "Щ", yU = "щ", bU = "Ш", wU = "ш", CU = "↓", TU = "←", kU = "∣", EU = "∥", xU = "→", LU = "↑", MU = "­", AU = "Σ", SU = "σ", OU = "ς", DU = "ς", IU = "∼", NU = "⩪", RU = "≃", BU = "≃", HU = "⪞", PU = "⪠", _U = "⪝", qU = "⪟", $U = "≆", FU = "⨤", UU = "⥲", VU = "←", jU = "∘", zU = "∖", WU = "⨳", GU = "⧤", XU = "∣", QU = "⌣", KU = "⪪", YU = "⪬", ZU = "⪬︀", JU = "Ь", e2 = "ь", t2 = "⌿", r2 = "⧄", n2 = "/", a2 = "𝕊", i2 = "𝕤", o2 = "♠", s2 = "♠", l2 = "∥", u2 = "⊓", c2 = "⊓︀", v2 = "⊔", f2 = "⊔︀", d2 = "√", p2 = "⊏", h2 = "⊑", m2 = "⊏", g2 = "⊑", y2 = "⊐", b2 = "⊒", w2 = "⊐", C2 = "⊒", T2 = "□", k2 = "□", E2 = "⊓", x2 = "⊏", L2 = "⊑", M2 = "⊐", A2 = "⊒", S2 = "⊔", O2 = "▪", D2 = "□", I2 = "▪", N2 = "→", R2 = "𝒮", B2 = "𝓈", H2 = "∖", P2 = "⌣", _2 = "⋆", q2 = "⋆", $2 = "☆", F2 = "★", U2 = "ϵ", V2 = "ϕ", j2 = "¯", z2 = "⊂", W2 = "⋐", G2 = "⪽", X2 = "⫅", Q2 = "⊆", K2 = "⫃", Y2 = "⫁", Z2 = "⫋", J2 = "⊊", eV = "⪿", tV = "⥹", rV = "⊂", nV = "⋐", aV = "⊆", iV = "⫅", oV = "⊆", sV = "⊊", lV = "⫋", uV = "⫇", cV = "⫕", vV = "⫓", fV = "⪸", dV = "≻", pV = "≽", hV = "≻", mV = "⪰", gV = "≽", yV = "≿", bV = "⪰", wV = "⪺", CV = "⪶", TV = "⋩", kV = "≿", EV = "∋", xV = "∑", LV = "∑", MV = "♪", AV = "¹", SV = "²", OV = "³", DV = "⊃", IV = "⋑", NV = "⪾", RV = "⫘", BV = "⫆", HV = "⊇", PV = "⫄", _V = "⊃", qV = "⊇", $V = "⟉", FV = "⫗", UV = "⥻", VV = "⫂", jV = "⫌", zV = "⊋", WV = "⫀", GV = "⊃", XV = "⋑", QV = "⊇", KV = "⫆", YV = "⊋", ZV = "⫌", JV = "⫈", ej = "⫔", tj = "⫖", rj = "⤦", nj = "↙", aj = "⇙", ij = "↙", oj = "⤪", sj = "ß", lj = "	", uj = "⌖", cj = "Τ", vj = "τ", fj = "⎴", dj = "Ť", pj = "ť", hj = "Ţ", mj = "ţ", gj = "Т", yj = "т", bj = "⃛", wj = "⌕", Cj = "𝔗", Tj = "𝔱", kj = "∴", Ej = "∴", xj = "∴", Lj = "Θ", Mj = "θ", Aj = "ϑ", Sj = "ϑ", Oj = "≈", Dj = "∼", Ij = "  ", Nj = " ", Rj = " ", Bj = "≈", Hj = "∼", Pj = "Þ", _j = "þ", qj = "˜", $j = "∼", Fj = "≃", Uj = "≅", Vj = "≈", jj = "⨱", zj = "⊠", Wj = "×", Gj = "⨰", Xj = "∭", Qj = "⤨", Kj = "⌶", Yj = "⫱", Zj = "⊤", Jj = "𝕋", ez = "𝕥", tz = "⫚", rz = "⤩", nz = "‴", az = "™", iz = "™", oz = "▵", sz = "▿", lz = "◃", uz = "⊴", cz = "≜", vz = "▹", fz = "⊵", dz = "◬", pz = "≜", hz = "⨺", mz = "⃛", gz = "⨹", yz = "⧍", bz = "⨻", wz = "⏢", Cz = "𝒯", Tz = "𝓉", kz = "Ц", Ez = "ц", xz = "Ћ", Lz = "ћ", Mz = "Ŧ", Az = "ŧ", Sz = "≬", Oz = "↞", Dz = "↠", Iz = "Ú", Nz = "ú", Rz = "↑", Bz = "↟", Hz = "⇑", Pz = "⥉", _z = "Ў", qz = "ў", $z = "Ŭ", Fz = "ŭ", Uz = "Û", Vz = "û", jz = "У", zz = "у", Wz = "⇅", Gz = "Ű", Xz = "ű", Qz = "⥮", Kz = "⥾", Yz = "𝔘", Zz = "𝔲", Jz = "Ù", eW = "ù", tW = "⥣", rW = "↿", nW = "↾", aW = "▀", iW = "⌜", oW = "⌜", sW = "⌏", lW = "◸", uW = "Ū", cW = "ū", vW = "¨", fW = "_", dW = "⏟", pW = "⎵", hW = "⏝", mW = "⋃", gW = "⊎", yW = "Ų", bW = "ų", wW = "𝕌", CW = "𝕦", TW = "⤒", kW = "↑", EW = "↑", xW = "⇑", LW = "⇅", MW = "↕", AW = "↕", SW = "⇕", OW = "⥮", DW = "↿", IW = "↾", NW = "⊎", RW = "↖", BW = "↗", HW = "υ", PW = "ϒ", _W = "ϒ", qW = "Υ", $W = "υ", FW = "↥", UW = "⊥", VW = "⇈", jW = "⌝", zW = "⌝", WW = "⌎", GW = "Ů", XW = "ů", QW = "◹", KW = "𝒰", YW = "𝓊", ZW = "⋰", JW = "Ũ", e3 = "ũ", t3 = "▵", r3 = "▴", n3 = "⇈", a3 = "Ü", i3 = "ü", o3 = "⦧", s3 = "⦜", l3 = "ϵ", u3 = "ϰ", c3 = "∅", v3 = "ϕ", f3 = "ϖ", d3 = "∝", p3 = "↕", h3 = "⇕", m3 = "ϱ", g3 = "ς", y3 = "⊊︀", b3 = "⫋︀", w3 = "⊋︀", C3 = "⫌︀", T3 = "ϑ", k3 = "⊲", E3 = "⊳", x3 = "⫨", L3 = "⫫", M3 = "⫩", A3 = "В", S3 = "в", O3 = "⊢", D3 = "⊨", I3 = "⊩", N3 = "⊫", R3 = "⫦", B3 = "⊻", H3 = "∨", P3 = "⋁", _3 = "≚", q3 = "⋮", $3 = "|", F3 = "‖", U3 = "|", V3 = "‖", j3 = "∣", z3 = "|", W3 = "❘", G3 = "≀", X3 = " ", Q3 = "𝔙", K3 = "𝔳", Y3 = "⊲", Z3 = "⊂⃒", J3 = "⊃⃒", eG = "𝕍", tG = "𝕧", rG = "∝", nG = "⊳", aG = "𝒱", iG = "𝓋", oG = "⫋︀", sG = "⊊︀", lG = "⫌︀", uG = "⊋︀", cG = "⊪", vG = "⦚", fG = "Ŵ", dG = "ŵ", pG = "⩟", hG = "∧", mG = "⋀", gG = "≙", yG = "℘", bG = "𝔚", wG = "𝔴", CG = "𝕎", TG = "𝕨", kG = "℘", EG = "≀", xG = "≀", LG = "𝒲", MG = "𝓌", AG = "⋂", SG = "◯", OG = "⋃", DG = "▽", IG = "𝔛", NG = "𝔵", RG = "⟷", BG = "⟺", HG = "Ξ", PG = "ξ", _G = "⟵", qG = "⟸", $G = "⟼", FG = "⋻", UG = "⨀", VG = "𝕏", jG = "𝕩", zG = "⨁", WG = "⨂", GG = "⟶", XG = "⟹", QG = "𝒳", KG = "𝓍", YG = "⨆", ZG = "⨄", JG = "△", e4 = "⋁", t4 = "⋀", r4 = "Ý", n4 = "ý", a4 = "Я", i4 = "я", o4 = "Ŷ", s4 = "ŷ", l4 = "Ы", u4 = "ы", c4 = "¥", v4 = "𝔜", f4 = "𝔶", d4 = "Ї", p4 = "ї", h4 = "𝕐", m4 = "𝕪", g4 = "𝒴", y4 = "𝓎", b4 = "Ю", w4 = "ю", C4 = "ÿ", T4 = "Ÿ", k4 = "Ź", E4 = "ź", x4 = "Ž", L4 = "ž", M4 = "З", A4 = "з", S4 = "Ż", O4 = "ż", D4 = "ℨ", I4 = "​", N4 = "Ζ", R4 = "ζ", B4 = "𝔷", H4 = "ℨ", P4 = "Ж", _4 = "ж", q4 = "⇝", $4 = "𝕫", F4 = "ℤ", U4 = "𝒵", V4 = "𝓏", j4 = "‍", z4 = "‌", gl = {
  Aacute: Sd,
  aacute: Od,
  Abreve: Dd,
  abreve: Id,
  ac: Nd,
  acd: Rd,
  acE: Bd,
  Acirc: Hd,
  acirc: Pd,
  acute: _d,
  Acy: qd,
  acy: $d,
  AElig: Fd,
  aelig: Ud,
  af: Vd,
  Afr: jd,
  afr: zd,
  Agrave: Wd,
  agrave: Gd,
  alefsym: Xd,
  aleph: Qd,
  Alpha: Kd,
  alpha: Yd,
  Amacr: Zd,
  amacr: Jd,
  amalg: ep,
  amp: tp,
  AMP: rp,
  andand: np,
  And: ap,
  and: ip,
  andd: op,
  andslope: sp,
  andv: lp,
  ang: up,
  ange: cp,
  angle: vp,
  angmsdaa: fp,
  angmsdab: dp,
  angmsdac: pp,
  angmsdad: hp,
  angmsdae: mp,
  angmsdaf: gp,
  angmsdag: yp,
  angmsdah: bp,
  angmsd: wp,
  angrt: Cp,
  angrtvb: Tp,
  angrtvbd: kp,
  angsph: Ep,
  angst: xp,
  angzarr: Lp,
  Aogon: Mp,
  aogon: Ap,
  Aopf: Sp,
  aopf: Op,
  apacir: Dp,
  ap: Ip,
  apE: Np,
  ape: Rp,
  apid: Bp,
  apos: Hp,
  ApplyFunction: Pp,
  approx: _p,
  approxeq: qp,
  Aring: $p,
  aring: Fp,
  Ascr: Up,
  ascr: Vp,
  Assign: jp,
  ast: zp,
  asymp: Wp,
  asympeq: Gp,
  Atilde: Xp,
  atilde: Qp,
  Auml: Kp,
  auml: Yp,
  awconint: Zp,
  awint: Jp,
  backcong: eh,
  backepsilon: th,
  backprime: rh,
  backsim: nh,
  backsimeq: ah,
  Backslash: ih,
  Barv: oh,
  barvee: sh,
  barwed: lh,
  Barwed: uh,
  barwedge: ch,
  bbrk: vh,
  bbrktbrk: fh,
  bcong: dh,
  Bcy: ph,
  bcy: hh,
  bdquo: mh,
  becaus: gh,
  because: yh,
  Because: bh,
  bemptyv: wh,
  bepsi: Ch,
  bernou: Th,
  Bernoullis: kh,
  Beta: Eh,
  beta: xh,
  beth: Lh,
  between: Mh,
  Bfr: Ah,
  bfr: Sh,
  bigcap: Oh,
  bigcirc: Dh,
  bigcup: Ih,
  bigodot: Nh,
  bigoplus: Rh,
  bigotimes: Bh,
  bigsqcup: Hh,
  bigstar: Ph,
  bigtriangledown: _h,
  bigtriangleup: qh,
  biguplus: $h,
  bigvee: Fh,
  bigwedge: Uh,
  bkarow: Vh,
  blacklozenge: jh,
  blacksquare: zh,
  blacktriangle: Wh,
  blacktriangledown: Gh,
  blacktriangleleft: Xh,
  blacktriangleright: Qh,
  blank: Kh,
  blk12: Yh,
  blk14: Zh,
  blk34: Jh,
  block: em,
  bne: tm,
  bnequiv: rm,
  bNot: nm,
  bnot: am,
  Bopf: im,
  bopf: om,
  bot: sm,
  bottom: lm,
  bowtie: um,
  boxbox: cm,
  boxdl: vm,
  boxdL: fm,
  boxDl: dm,
  boxDL: pm,
  boxdr: hm,
  boxdR: mm,
  boxDr: gm,
  boxDR: ym,
  boxh: bm,
  boxH: wm,
  boxhd: Cm,
  boxHd: Tm,
  boxhD: km,
  boxHD: Em,
  boxhu: xm,
  boxHu: Lm,
  boxhU: Mm,
  boxHU: Am,
  boxminus: Sm,
  boxplus: Om,
  boxtimes: Dm,
  boxul: Im,
  boxuL: Nm,
  boxUl: Rm,
  boxUL: Bm,
  boxur: Hm,
  boxuR: Pm,
  boxUr: _m,
  boxUR: qm,
  boxv: $m,
  boxV: Fm,
  boxvh: Um,
  boxvH: Vm,
  boxVh: jm,
  boxVH: zm,
  boxvl: Wm,
  boxvL: Gm,
  boxVl: Xm,
  boxVL: Qm,
  boxvr: Km,
  boxvR: Ym,
  boxVr: Zm,
  boxVR: Jm,
  bprime: eg,
  breve: tg,
  Breve: rg,
  brvbar: ng,
  bscr: ag,
  Bscr: ig,
  bsemi: og,
  bsim: sg,
  bsime: lg,
  bsolb: ug,
  bsol: cg,
  bsolhsub: vg,
  bull: fg,
  bullet: dg,
  bump: pg,
  bumpE: hg,
  bumpe: mg,
  Bumpeq: gg,
  bumpeq: yg,
  Cacute: bg,
  cacute: wg,
  capand: Cg,
  capbrcup: Tg,
  capcap: kg,
  cap: Eg,
  Cap: xg,
  capcup: Lg,
  capdot: Mg,
  CapitalDifferentialD: Ag,
  caps: Sg,
  caret: Og,
  caron: Dg,
  Cayleys: Ig,
  ccaps: Ng,
  Ccaron: Rg,
  ccaron: Bg,
  Ccedil: Hg,
  ccedil: Pg,
  Ccirc: _g,
  ccirc: qg,
  Cconint: $g,
  ccups: Fg,
  ccupssm: Ug,
  Cdot: Vg,
  cdot: jg,
  cedil: zg,
  Cedilla: Wg,
  cemptyv: Gg,
  cent: Xg,
  centerdot: Qg,
  CenterDot: Kg,
  cfr: Yg,
  Cfr: Zg,
  CHcy: Jg,
  chcy: ey,
  check: ty,
  checkmark: ry,
  Chi: ny,
  chi: ay,
  circ: iy,
  circeq: oy,
  circlearrowleft: sy,
  circlearrowright: ly,
  circledast: uy,
  circledcirc: cy,
  circleddash: vy,
  CircleDot: fy,
  circledR: dy,
  circledS: py,
  CircleMinus: hy,
  CirclePlus: my,
  CircleTimes: gy,
  cir: yy,
  cirE: by,
  cire: wy,
  cirfnint: Cy,
  cirmid: Ty,
  cirscir: ky,
  ClockwiseContourIntegral: Ey,
  CloseCurlyDoubleQuote: xy,
  CloseCurlyQuote: Ly,
  clubs: My,
  clubsuit: Ay,
  colon: Sy,
  Colon: Oy,
  Colone: Dy,
  colone: Iy,
  coloneq: Ny,
  comma: Ry,
  commat: By,
  comp: Hy,
  compfn: Py,
  complement: _y,
  complexes: qy,
  cong: $y,
  congdot: Fy,
  Congruent: Uy,
  conint: Vy,
  Conint: jy,
  ContourIntegral: zy,
  copf: Wy,
  Copf: Gy,
  coprod: Xy,
  Coproduct: Qy,
  copy: Ky,
  COPY: Yy,
  copysr: Zy,
  CounterClockwiseContourIntegral: Jy,
  crarr: eb,
  cross: tb,
  Cross: rb,
  Cscr: nb,
  cscr: ab,
  csub: ib,
  csube: ob,
  csup: sb,
  csupe: lb,
  ctdot: ub,
  cudarrl: cb,
  cudarrr: vb,
  cuepr: fb,
  cuesc: db,
  cularr: pb,
  cularrp: hb,
  cupbrcap: mb,
  cupcap: gb,
  CupCap: yb,
  cup: bb,
  Cup: wb,
  cupcup: Cb,
  cupdot: Tb,
  cupor: kb,
  cups: Eb,
  curarr: xb,
  curarrm: Lb,
  curlyeqprec: Mb,
  curlyeqsucc: Ab,
  curlyvee: Sb,
  curlywedge: Ob,
  curren: Db,
  curvearrowleft: Ib,
  curvearrowright: Nb,
  cuvee: Rb,
  cuwed: Bb,
  cwconint: Hb,
  cwint: Pb,
  cylcty: _b,
  dagger: qb,
  Dagger: $b,
  daleth: Fb,
  darr: Ub,
  Darr: Vb,
  dArr: jb,
  dash: zb,
  Dashv: Wb,
  dashv: Gb,
  dbkarow: Xb,
  dblac: Qb,
  Dcaron: Kb,
  dcaron: Yb,
  Dcy: Zb,
  dcy: Jb,
  ddagger: ew,
  ddarr: tw,
  DD: rw,
  dd: nw,
  DDotrahd: aw,
  ddotseq: iw,
  deg: ow,
  Del: sw,
  Delta: lw,
  delta: uw,
  demptyv: cw,
  dfisht: vw,
  Dfr: fw,
  dfr: dw,
  dHar: pw,
  dharl: hw,
  dharr: mw,
  DiacriticalAcute: gw,
  DiacriticalDot: yw,
  DiacriticalDoubleAcute: bw,
  DiacriticalGrave: ww,
  DiacriticalTilde: Cw,
  diam: Tw,
  diamond: kw,
  Diamond: Ew,
  diamondsuit: xw,
  diams: Lw,
  die: Mw,
  DifferentialD: Aw,
  digamma: Sw,
  disin: Ow,
  div: Dw,
  divide: Iw,
  divideontimes: Nw,
  divonx: Rw,
  DJcy: Bw,
  djcy: Hw,
  dlcorn: Pw,
  dlcrop: _w,
  dollar: qw,
  Dopf: $w,
  dopf: Fw,
  Dot: Uw,
  dot: Vw,
  DotDot: jw,
  doteq: zw,
  doteqdot: Ww,
  DotEqual: Gw,
  dotminus: Xw,
  dotplus: Qw,
  dotsquare: Kw,
  doublebarwedge: Yw,
  DoubleContourIntegral: Zw,
  DoubleDot: Jw,
  DoubleDownArrow: eC,
  DoubleLeftArrow: tC,
  DoubleLeftRightArrow: rC,
  DoubleLeftTee: nC,
  DoubleLongLeftArrow: aC,
  DoubleLongLeftRightArrow: iC,
  DoubleLongRightArrow: oC,
  DoubleRightArrow: sC,
  DoubleRightTee: lC,
  DoubleUpArrow: uC,
  DoubleUpDownArrow: cC,
  DoubleVerticalBar: vC,
  DownArrowBar: fC,
  downarrow: dC,
  DownArrow: pC,
  Downarrow: hC,
  DownArrowUpArrow: mC,
  DownBreve: gC,
  downdownarrows: yC,
  downharpoonleft: bC,
  downharpoonright: wC,
  DownLeftRightVector: CC,
  DownLeftTeeVector: TC,
  DownLeftVectorBar: kC,
  DownLeftVector: EC,
  DownRightTeeVector: xC,
  DownRightVectorBar: LC,
  DownRightVector: MC,
  DownTeeArrow: AC,
  DownTee: SC,
  drbkarow: OC,
  drcorn: DC,
  drcrop: IC,
  Dscr: NC,
  dscr: RC,
  DScy: BC,
  dscy: HC,
  dsol: PC,
  Dstrok: _C,
  dstrok: qC,
  dtdot: $C,
  dtri: FC,
  dtrif: UC,
  duarr: VC,
  duhar: jC,
  dwangle: zC,
  DZcy: WC,
  dzcy: GC,
  dzigrarr: XC,
  Eacute: QC,
  eacute: KC,
  easter: YC,
  Ecaron: ZC,
  ecaron: JC,
  Ecirc: eT,
  ecirc: tT,
  ecir: rT,
  ecolon: nT,
  Ecy: aT,
  ecy: iT,
  eDDot: oT,
  Edot: sT,
  edot: lT,
  eDot: uT,
  ee: cT,
  efDot: vT,
  Efr: fT,
  efr: dT,
  eg: pT,
  Egrave: hT,
  egrave: mT,
  egs: gT,
  egsdot: yT,
  el: bT,
  Element: wT,
  elinters: CT,
  ell: TT,
  els: kT,
  elsdot: ET,
  Emacr: xT,
  emacr: LT,
  empty: MT,
  emptyset: AT,
  EmptySmallSquare: ST,
  emptyv: OT,
  EmptyVerySmallSquare: DT,
  emsp13: IT,
  emsp14: NT,
  emsp: RT,
  ENG: BT,
  eng: HT,
  ensp: PT,
  Eogon: _T,
  eogon: qT,
  Eopf: $T,
  eopf: FT,
  epar: UT,
  eparsl: VT,
  eplus: jT,
  epsi: zT,
  Epsilon: WT,
  epsilon: GT,
  epsiv: XT,
  eqcirc: QT,
  eqcolon: KT,
  eqsim: YT,
  eqslantgtr: ZT,
  eqslantless: JT,
  Equal: ek,
  equals: tk,
  EqualTilde: rk,
  equest: nk,
  Equilibrium: ak,
  equiv: ik,
  equivDD: ok,
  eqvparsl: sk,
  erarr: lk,
  erDot: uk,
  escr: ck,
  Escr: vk,
  esdot: fk,
  Esim: dk,
  esim: pk,
  Eta: hk,
  eta: mk,
  ETH: gk,
  eth: yk,
  Euml: bk,
  euml: wk,
  euro: Ck,
  excl: Tk,
  exist: kk,
  Exists: Ek,
  expectation: xk,
  exponentiale: Lk,
  ExponentialE: Mk,
  fallingdotseq: Ak,
  Fcy: Sk,
  fcy: Ok,
  female: Dk,
  ffilig: Ik,
  fflig: Nk,
  ffllig: Rk,
  Ffr: Bk,
  ffr: Hk,
  filig: Pk,
  FilledSmallSquare: _k,
  FilledVerySmallSquare: qk,
  fjlig: $k,
  flat: Fk,
  fllig: Uk,
  fltns: Vk,
  fnof: jk,
  Fopf: zk,
  fopf: Wk,
  forall: Gk,
  ForAll: Xk,
  fork: Qk,
  forkv: Kk,
  Fouriertrf: Yk,
  fpartint: Zk,
  frac12: Jk,
  frac13: eE,
  frac14: tE,
  frac15: rE,
  frac16: nE,
  frac18: aE,
  frac23: iE,
  frac25: oE,
  frac34: sE,
  frac35: lE,
  frac38: uE,
  frac45: cE,
  frac56: vE,
  frac58: fE,
  frac78: dE,
  frasl: pE,
  frown: hE,
  fscr: mE,
  Fscr: gE,
  gacute: yE,
  Gamma: bE,
  gamma: wE,
  Gammad: CE,
  gammad: TE,
  gap: kE,
  Gbreve: EE,
  gbreve: xE,
  Gcedil: LE,
  Gcirc: ME,
  gcirc: AE,
  Gcy: SE,
  gcy: OE,
  Gdot: DE,
  gdot: IE,
  ge: NE,
  gE: RE,
  gEl: BE,
  gel: HE,
  geq: PE,
  geqq: _E,
  geqslant: qE,
  gescc: $E,
  ges: FE,
  gesdot: UE,
  gesdoto: VE,
  gesdotol: jE,
  gesl: zE,
  gesles: WE,
  Gfr: GE,
  gfr: XE,
  gg: QE,
  Gg: KE,
  ggg: YE,
  gimel: ZE,
  GJcy: JE,
  gjcy: ex,
  gla: tx,
  gl: rx,
  glE: nx,
  glj: ax,
  gnap: ix,
  gnapprox: ox,
  gne: sx,
  gnE: lx,
  gneq: ux,
  gneqq: cx,
  gnsim: vx,
  Gopf: fx,
  gopf: dx,
  grave: px,
  GreaterEqual: hx,
  GreaterEqualLess: mx,
  GreaterFullEqual: gx,
  GreaterGreater: yx,
  GreaterLess: bx,
  GreaterSlantEqual: wx,
  GreaterTilde: Cx,
  Gscr: Tx,
  gscr: kx,
  gsim: Ex,
  gsime: xx,
  gsiml: Lx,
  gtcc: Mx,
  gtcir: Ax,
  gt: Sx,
  GT: Ox,
  Gt: Dx,
  gtdot: Ix,
  gtlPar: Nx,
  gtquest: Rx,
  gtrapprox: Bx,
  gtrarr: Hx,
  gtrdot: Px,
  gtreqless: _x,
  gtreqqless: qx,
  gtrless: $x,
  gtrsim: Fx,
  gvertneqq: Ux,
  gvnE: Vx,
  Hacek: jx,
  hairsp: zx,
  half: Wx,
  hamilt: Gx,
  HARDcy: Xx,
  hardcy: Qx,
  harrcir: Kx,
  harr: Yx,
  hArr: Zx,
  harrw: Jx,
  Hat: e1,
  hbar: t1,
  Hcirc: r1,
  hcirc: n1,
  hearts: a1,
  heartsuit: i1,
  hellip: o1,
  hercon: s1,
  hfr: l1,
  Hfr: u1,
  HilbertSpace: c1,
  hksearow: v1,
  hkswarow: f1,
  hoarr: d1,
  homtht: p1,
  hookleftarrow: h1,
  hookrightarrow: m1,
  hopf: g1,
  Hopf: y1,
  horbar: b1,
  HorizontalLine: w1,
  hscr: C1,
  Hscr: T1,
  hslash: k1,
  Hstrok: E1,
  hstrok: x1,
  HumpDownHump: L1,
  HumpEqual: M1,
  hybull: A1,
  hyphen: S1,
  Iacute: O1,
  iacute: D1,
  ic: I1,
  Icirc: N1,
  icirc: R1,
  Icy: B1,
  icy: H1,
  Idot: P1,
  IEcy: _1,
  iecy: q1,
  iexcl: $1,
  iff: F1,
  ifr: U1,
  Ifr: V1,
  Igrave: j1,
  igrave: z1,
  ii: W1,
  iiiint: G1,
  iiint: X1,
  iinfin: Q1,
  iiota: K1,
  IJlig: Y1,
  ijlig: Z1,
  Imacr: J1,
  imacr: eL,
  image: tL,
  ImaginaryI: rL,
  imagline: nL,
  imagpart: aL,
  imath: iL,
  Im: oL,
  imof: sL,
  imped: lL,
  Implies: uL,
  incare: cL,
  in: "∈",
  infin: vL,
  infintie: fL,
  inodot: dL,
  intcal: pL,
  int: hL,
  Int: mL,
  integers: gL,
  Integral: yL,
  intercal: bL,
  Intersection: wL,
  intlarhk: CL,
  intprod: TL,
  InvisibleComma: kL,
  InvisibleTimes: EL,
  IOcy: xL,
  iocy: LL,
  Iogon: ML,
  iogon: AL,
  Iopf: SL,
  iopf: OL,
  Iota: DL,
  iota: IL,
  iprod: NL,
  iquest: RL,
  iscr: BL,
  Iscr: HL,
  isin: PL,
  isindot: _L,
  isinE: qL,
  isins: $L,
  isinsv: FL,
  isinv: UL,
  it: VL,
  Itilde: jL,
  itilde: zL,
  Iukcy: WL,
  iukcy: GL,
  Iuml: XL,
  iuml: QL,
  Jcirc: KL,
  jcirc: YL,
  Jcy: ZL,
  jcy: JL,
  Jfr: e0,
  jfr: t0,
  jmath: r0,
  Jopf: n0,
  jopf: a0,
  Jscr: i0,
  jscr: o0,
  Jsercy: s0,
  jsercy: l0,
  Jukcy: u0,
  jukcy: c0,
  Kappa: v0,
  kappa: f0,
  kappav: d0,
  Kcedil: p0,
  kcedil: h0,
  Kcy: m0,
  kcy: g0,
  Kfr: y0,
  kfr: b0,
  kgreen: w0,
  KHcy: C0,
  khcy: T0,
  KJcy: k0,
  kjcy: E0,
  Kopf: x0,
  kopf: L0,
  Kscr: M0,
  kscr: A0,
  lAarr: S0,
  Lacute: O0,
  lacute: D0,
  laemptyv: I0,
  lagran: N0,
  Lambda: R0,
  lambda: B0,
  lang: H0,
  Lang: P0,
  langd: _0,
  langle: q0,
  lap: $0,
  Laplacetrf: F0,
  laquo: U0,
  larrb: V0,
  larrbfs: j0,
  larr: z0,
  Larr: W0,
  lArr: G0,
  larrfs: X0,
  larrhk: Q0,
  larrlp: K0,
  larrpl: Y0,
  larrsim: Z0,
  larrtl: J0,
  latail: eM,
  lAtail: tM,
  lat: rM,
  late: nM,
  lates: aM,
  lbarr: iM,
  lBarr: oM,
  lbbrk: sM,
  lbrace: lM,
  lbrack: uM,
  lbrke: cM,
  lbrksld: vM,
  lbrkslu: fM,
  Lcaron: dM,
  lcaron: pM,
  Lcedil: hM,
  lcedil: mM,
  lceil: gM,
  lcub: yM,
  Lcy: bM,
  lcy: wM,
  ldca: CM,
  ldquo: TM,
  ldquor: kM,
  ldrdhar: EM,
  ldrushar: xM,
  ldsh: LM,
  le: MM,
  lE: AM,
  LeftAngleBracket: SM,
  LeftArrowBar: OM,
  leftarrow: DM,
  LeftArrow: IM,
  Leftarrow: NM,
  LeftArrowRightArrow: RM,
  leftarrowtail: BM,
  LeftCeiling: HM,
  LeftDoubleBracket: PM,
  LeftDownTeeVector: _M,
  LeftDownVectorBar: qM,
  LeftDownVector: $M,
  LeftFloor: FM,
  leftharpoondown: UM,
  leftharpoonup: VM,
  leftleftarrows: jM,
  leftrightarrow: zM,
  LeftRightArrow: WM,
  Leftrightarrow: GM,
  leftrightarrows: XM,
  leftrightharpoons: QM,
  leftrightsquigarrow: KM,
  LeftRightVector: YM,
  LeftTeeArrow: ZM,
  LeftTee: JM,
  LeftTeeVector: eA,
  leftthreetimes: tA,
  LeftTriangleBar: rA,
  LeftTriangle: nA,
  LeftTriangleEqual: aA,
  LeftUpDownVector: iA,
  LeftUpTeeVector: oA,
  LeftUpVectorBar: sA,
  LeftUpVector: lA,
  LeftVectorBar: uA,
  LeftVector: cA,
  lEg: vA,
  leg: fA,
  leq: dA,
  leqq: pA,
  leqslant: hA,
  lescc: mA,
  les: gA,
  lesdot: yA,
  lesdoto: bA,
  lesdotor: wA,
  lesg: CA,
  lesges: TA,
  lessapprox: kA,
  lessdot: EA,
  lesseqgtr: xA,
  lesseqqgtr: LA,
  LessEqualGreater: MA,
  LessFullEqual: AA,
  LessGreater: SA,
  lessgtr: OA,
  LessLess: DA,
  lesssim: IA,
  LessSlantEqual: NA,
  LessTilde: RA,
  lfisht: BA,
  lfloor: HA,
  Lfr: PA,
  lfr: _A,
  lg: qA,
  lgE: $A,
  lHar: FA,
  lhard: UA,
  lharu: VA,
  lharul: jA,
  lhblk: zA,
  LJcy: WA,
  ljcy: GA,
  llarr: XA,
  ll: QA,
  Ll: KA,
  llcorner: YA,
  Lleftarrow: ZA,
  llhard: JA,
  lltri: eS,
  Lmidot: tS,
  lmidot: rS,
  lmoustache: nS,
  lmoust: aS,
  lnap: iS,
  lnapprox: oS,
  lne: sS,
  lnE: lS,
  lneq: uS,
  lneqq: cS,
  lnsim: vS,
  loang: fS,
  loarr: dS,
  lobrk: pS,
  longleftarrow: hS,
  LongLeftArrow: mS,
  Longleftarrow: gS,
  longleftrightarrow: yS,
  LongLeftRightArrow: bS,
  Longleftrightarrow: wS,
  longmapsto: CS,
  longrightarrow: TS,
  LongRightArrow: kS,
  Longrightarrow: ES,
  looparrowleft: xS,
  looparrowright: LS,
  lopar: MS,
  Lopf: AS,
  lopf: SS,
  loplus: OS,
  lotimes: DS,
  lowast: IS,
  lowbar: NS,
  LowerLeftArrow: RS,
  LowerRightArrow: BS,
  loz: HS,
  lozenge: PS,
  lozf: _S,
  lpar: qS,
  lparlt: $S,
  lrarr: FS,
  lrcorner: US,
  lrhar: VS,
  lrhard: jS,
  lrm: zS,
  lrtri: WS,
  lsaquo: GS,
  lscr: XS,
  Lscr: QS,
  lsh: KS,
  Lsh: YS,
  lsim: ZS,
  lsime: JS,
  lsimg: eO,
  lsqb: tO,
  lsquo: rO,
  lsquor: nO,
  Lstrok: aO,
  lstrok: iO,
  ltcc: oO,
  ltcir: sO,
  lt: lO,
  LT: uO,
  Lt: cO,
  ltdot: vO,
  lthree: fO,
  ltimes: dO,
  ltlarr: pO,
  ltquest: hO,
  ltri: mO,
  ltrie: gO,
  ltrif: yO,
  ltrPar: bO,
  lurdshar: wO,
  luruhar: CO,
  lvertneqq: TO,
  lvnE: kO,
  macr: EO,
  male: xO,
  malt: LO,
  maltese: MO,
  Map: "⤅",
  map: AO,
  mapsto: SO,
  mapstodown: OO,
  mapstoleft: DO,
  mapstoup: IO,
  marker: NO,
  mcomma: RO,
  Mcy: BO,
  mcy: HO,
  mdash: PO,
  mDDot: _O,
  measuredangle: qO,
  MediumSpace: $O,
  Mellintrf: FO,
  Mfr: UO,
  mfr: VO,
  mho: jO,
  micro: zO,
  midast: WO,
  midcir: GO,
  mid: XO,
  middot: QO,
  minusb: KO,
  minus: YO,
  minusd: ZO,
  minusdu: JO,
  MinusPlus: eD,
  mlcp: tD,
  mldr: rD,
  mnplus: nD,
  models: aD,
  Mopf: iD,
  mopf: oD,
  mp: sD,
  mscr: lD,
  Mscr: uD,
  mstpos: cD,
  Mu: vD,
  mu: fD,
  multimap: dD,
  mumap: pD,
  nabla: hD,
  Nacute: mD,
  nacute: gD,
  nang: yD,
  nap: bD,
  napE: wD,
  napid: CD,
  napos: TD,
  napprox: kD,
  natural: ED,
  naturals: xD,
  natur: LD,
  nbsp: MD,
  nbump: AD,
  nbumpe: SD,
  ncap: OD,
  Ncaron: DD,
  ncaron: ID,
  Ncedil: ND,
  ncedil: RD,
  ncong: BD,
  ncongdot: HD,
  ncup: PD,
  Ncy: _D,
  ncy: qD,
  ndash: $D,
  nearhk: FD,
  nearr: UD,
  neArr: VD,
  nearrow: jD,
  ne: zD,
  nedot: WD,
  NegativeMediumSpace: GD,
  NegativeThickSpace: XD,
  NegativeThinSpace: QD,
  NegativeVeryThinSpace: KD,
  nequiv: YD,
  nesear: ZD,
  nesim: JD,
  NestedGreaterGreater: eI,
  NestedLessLess: tI,
  NewLine: rI,
  nexist: nI,
  nexists: aI,
  Nfr: iI,
  nfr: oI,
  ngE: sI,
  nge: lI,
  ngeq: uI,
  ngeqq: cI,
  ngeqslant: vI,
  nges: fI,
  nGg: dI,
  ngsim: pI,
  nGt: hI,
  ngt: mI,
  ngtr: gI,
  nGtv: yI,
  nharr: bI,
  nhArr: wI,
  nhpar: CI,
  ni: TI,
  nis: kI,
  nisd: EI,
  niv: xI,
  NJcy: LI,
  njcy: MI,
  nlarr: AI,
  nlArr: SI,
  nldr: OI,
  nlE: DI,
  nle: II,
  nleftarrow: NI,
  nLeftarrow: RI,
  nleftrightarrow: BI,
  nLeftrightarrow: HI,
  nleq: PI,
  nleqq: _I,
  nleqslant: qI,
  nles: $I,
  nless: FI,
  nLl: UI,
  nlsim: VI,
  nLt: jI,
  nlt: zI,
  nltri: WI,
  nltrie: GI,
  nLtv: XI,
  nmid: QI,
  NoBreak: KI,
  NonBreakingSpace: YI,
  nopf: ZI,
  Nopf: JI,
  Not: eN,
  not: tN,
  NotCongruent: rN,
  NotCupCap: nN,
  NotDoubleVerticalBar: aN,
  NotElement: iN,
  NotEqual: oN,
  NotEqualTilde: sN,
  NotExists: lN,
  NotGreater: uN,
  NotGreaterEqual: cN,
  NotGreaterFullEqual: vN,
  NotGreaterGreater: fN,
  NotGreaterLess: dN,
  NotGreaterSlantEqual: pN,
  NotGreaterTilde: hN,
  NotHumpDownHump: mN,
  NotHumpEqual: gN,
  notin: yN,
  notindot: bN,
  notinE: wN,
  notinva: CN,
  notinvb: TN,
  notinvc: kN,
  NotLeftTriangleBar: EN,
  NotLeftTriangle: xN,
  NotLeftTriangleEqual: LN,
  NotLess: MN,
  NotLessEqual: AN,
  NotLessGreater: SN,
  NotLessLess: ON,
  NotLessSlantEqual: DN,
  NotLessTilde: IN,
  NotNestedGreaterGreater: NN,
  NotNestedLessLess: RN,
  notni: BN,
  notniva: HN,
  notnivb: PN,
  notnivc: _N,
  NotPrecedes: qN,
  NotPrecedesEqual: $N,
  NotPrecedesSlantEqual: FN,
  NotReverseElement: UN,
  NotRightTriangleBar: VN,
  NotRightTriangle: jN,
  NotRightTriangleEqual: zN,
  NotSquareSubset: WN,
  NotSquareSubsetEqual: GN,
  NotSquareSuperset: XN,
  NotSquareSupersetEqual: QN,
  NotSubset: KN,
  NotSubsetEqual: YN,
  NotSucceeds: ZN,
  NotSucceedsEqual: JN,
  NotSucceedsSlantEqual: eR,
  NotSucceedsTilde: tR,
  NotSuperset: rR,
  NotSupersetEqual: nR,
  NotTilde: aR,
  NotTildeEqual: iR,
  NotTildeFullEqual: oR,
  NotTildeTilde: sR,
  NotVerticalBar: lR,
  nparallel: uR,
  npar: cR,
  nparsl: vR,
  npart: fR,
  npolint: dR,
  npr: pR,
  nprcue: hR,
  nprec: mR,
  npreceq: gR,
  npre: yR,
  nrarrc: bR,
  nrarr: wR,
  nrArr: CR,
  nrarrw: TR,
  nrightarrow: kR,
  nRightarrow: ER,
  nrtri: xR,
  nrtrie: LR,
  nsc: MR,
  nsccue: AR,
  nsce: SR,
  Nscr: OR,
  nscr: DR,
  nshortmid: IR,
  nshortparallel: NR,
  nsim: RR,
  nsime: BR,
  nsimeq: HR,
  nsmid: PR,
  nspar: _R,
  nsqsube: qR,
  nsqsupe: $R,
  nsub: FR,
  nsubE: UR,
  nsube: VR,
  nsubset: jR,
  nsubseteq: zR,
  nsubseteqq: WR,
  nsucc: GR,
  nsucceq: XR,
  nsup: QR,
  nsupE: KR,
  nsupe: YR,
  nsupset: ZR,
  nsupseteq: JR,
  nsupseteqq: eB,
  ntgl: tB,
  Ntilde: rB,
  ntilde: nB,
  ntlg: aB,
  ntriangleleft: iB,
  ntrianglelefteq: oB,
  ntriangleright: sB,
  ntrianglerighteq: lB,
  Nu: uB,
  nu: cB,
  num: vB,
  numero: fB,
  numsp: dB,
  nvap: pB,
  nvdash: hB,
  nvDash: mB,
  nVdash: gB,
  nVDash: yB,
  nvge: bB,
  nvgt: wB,
  nvHarr: CB,
  nvinfin: TB,
  nvlArr: kB,
  nvle: EB,
  nvlt: xB,
  nvltrie: LB,
  nvrArr: MB,
  nvrtrie: AB,
  nvsim: SB,
  nwarhk: OB,
  nwarr: DB,
  nwArr: IB,
  nwarrow: NB,
  nwnear: RB,
  Oacute: BB,
  oacute: HB,
  oast: PB,
  Ocirc: _B,
  ocirc: qB,
  ocir: $B,
  Ocy: FB,
  ocy: UB,
  odash: VB,
  Odblac: jB,
  odblac: zB,
  odiv: WB,
  odot: GB,
  odsold: XB,
  OElig: QB,
  oelig: KB,
  ofcir: YB,
  Ofr: ZB,
  ofr: JB,
  ogon: eH,
  Ograve: tH,
  ograve: rH,
  ogt: nH,
  ohbar: aH,
  ohm: iH,
  oint: oH,
  olarr: sH,
  olcir: lH,
  olcross: uH,
  oline: cH,
  olt: vH,
  Omacr: fH,
  omacr: dH,
  Omega: pH,
  omega: hH,
  Omicron: mH,
  omicron: gH,
  omid: yH,
  ominus: bH,
  Oopf: wH,
  oopf: CH,
  opar: TH,
  OpenCurlyDoubleQuote: kH,
  OpenCurlyQuote: EH,
  operp: xH,
  oplus: LH,
  orarr: MH,
  Or: AH,
  or: SH,
  ord: OH,
  order: DH,
  orderof: IH,
  ordf: NH,
  ordm: RH,
  origof: BH,
  oror: HH,
  orslope: PH,
  orv: _H,
  oS: qH,
  Oscr: $H,
  oscr: FH,
  Oslash: UH,
  oslash: VH,
  osol: jH,
  Otilde: zH,
  otilde: WH,
  otimesas: GH,
  Otimes: XH,
  otimes: QH,
  Ouml: KH,
  ouml: YH,
  ovbar: ZH,
  OverBar: JH,
  OverBrace: eP,
  OverBracket: tP,
  OverParenthesis: rP,
  para: nP,
  parallel: aP,
  par: iP,
  parsim: oP,
  parsl: sP,
  part: lP,
  PartialD: uP,
  Pcy: cP,
  pcy: vP,
  percnt: fP,
  period: dP,
  permil: pP,
  perp: hP,
  pertenk: mP,
  Pfr: gP,
  pfr: yP,
  Phi: bP,
  phi: wP,
  phiv: CP,
  phmmat: TP,
  phone: kP,
  Pi: EP,
  pi: xP,
  pitchfork: LP,
  piv: MP,
  planck: AP,
  planckh: SP,
  plankv: OP,
  plusacir: DP,
  plusb: IP,
  pluscir: NP,
  plus: RP,
  plusdo: BP,
  plusdu: HP,
  pluse: PP,
  PlusMinus: _P,
  plusmn: qP,
  plussim: $P,
  plustwo: FP,
  pm: UP,
  Poincareplane: VP,
  pointint: jP,
  popf: zP,
  Popf: WP,
  pound: GP,
  prap: XP,
  Pr: QP,
  pr: KP,
  prcue: YP,
  precapprox: ZP,
  prec: JP,
  preccurlyeq: e_,
  Precedes: t_,
  PrecedesEqual: r_,
  PrecedesSlantEqual: n_,
  PrecedesTilde: a_,
  preceq: i_,
  precnapprox: o_,
  precneqq: s_,
  precnsim: l_,
  pre: u_,
  prE: c_,
  precsim: v_,
  prime: f_,
  Prime: d_,
  primes: p_,
  prnap: h_,
  prnE: m_,
  prnsim: g_,
  prod: y_,
  Product: b_,
  profalar: w_,
  profline: C_,
  profsurf: T_,
  prop: k_,
  Proportional: E_,
  Proportion: x_,
  propto: L_,
  prsim: M_,
  prurel: A_,
  Pscr: S_,
  pscr: O_,
  Psi: D_,
  psi: I_,
  puncsp: N_,
  Qfr: R_,
  qfr: B_,
  qint: H_,
  qopf: P_,
  Qopf: __,
  qprime: q_,
  Qscr: $_,
  qscr: F_,
  quaternions: U_,
  quatint: V_,
  quest: j_,
  questeq: z_,
  quot: W_,
  QUOT: G_,
  rAarr: X_,
  race: Q_,
  Racute: K_,
  racute: Y_,
  radic: Z_,
  raemptyv: J_,
  rang: eq,
  Rang: tq,
  rangd: rq,
  range: nq,
  rangle: aq,
  raquo: iq,
  rarrap: oq,
  rarrb: sq,
  rarrbfs: lq,
  rarrc: uq,
  rarr: cq,
  Rarr: vq,
  rArr: fq,
  rarrfs: dq,
  rarrhk: pq,
  rarrlp: hq,
  rarrpl: mq,
  rarrsim: gq,
  Rarrtl: yq,
  rarrtl: bq,
  rarrw: wq,
  ratail: Cq,
  rAtail: Tq,
  ratio: kq,
  rationals: Eq,
  rbarr: xq,
  rBarr: Lq,
  RBarr: Mq,
  rbbrk: Aq,
  rbrace: Sq,
  rbrack: Oq,
  rbrke: Dq,
  rbrksld: Iq,
  rbrkslu: Nq,
  Rcaron: Rq,
  rcaron: Bq,
  Rcedil: Hq,
  rcedil: Pq,
  rceil: _q,
  rcub: qq,
  Rcy: $q,
  rcy: Fq,
  rdca: Uq,
  rdldhar: Vq,
  rdquo: jq,
  rdquor: zq,
  rdsh: Wq,
  real: Gq,
  realine: Xq,
  realpart: Qq,
  reals: Kq,
  Re: Yq,
  rect: Zq,
  reg: Jq,
  REG: e$,
  ReverseElement: t$,
  ReverseEquilibrium: r$,
  ReverseUpEquilibrium: n$,
  rfisht: a$,
  rfloor: i$,
  rfr: o$,
  Rfr: s$,
  rHar: l$,
  rhard: u$,
  rharu: c$,
  rharul: v$,
  Rho: f$,
  rho: d$,
  rhov: p$,
  RightAngleBracket: h$,
  RightArrowBar: m$,
  rightarrow: g$,
  RightArrow: y$,
  Rightarrow: b$,
  RightArrowLeftArrow: w$,
  rightarrowtail: C$,
  RightCeiling: T$,
  RightDoubleBracket: k$,
  RightDownTeeVector: E$,
  RightDownVectorBar: x$,
  RightDownVector: L$,
  RightFloor: M$,
  rightharpoondown: A$,
  rightharpoonup: S$,
  rightleftarrows: O$,
  rightleftharpoons: D$,
  rightrightarrows: I$,
  rightsquigarrow: N$,
  RightTeeArrow: R$,
  RightTee: B$,
  RightTeeVector: H$,
  rightthreetimes: P$,
  RightTriangleBar: _$,
  RightTriangle: q$,
  RightTriangleEqual: $$,
  RightUpDownVector: F$,
  RightUpTeeVector: U$,
  RightUpVectorBar: V$,
  RightUpVector: j$,
  RightVectorBar: z$,
  RightVector: W$,
  ring: G$,
  risingdotseq: X$,
  rlarr: Q$,
  rlhar: K$,
  rlm: Y$,
  rmoustache: Z$,
  rmoust: J$,
  rnmid: eF,
  roang: tF,
  roarr: rF,
  robrk: nF,
  ropar: aF,
  ropf: iF,
  Ropf: oF,
  roplus: sF,
  rotimes: lF,
  RoundImplies: uF,
  rpar: cF,
  rpargt: vF,
  rppolint: fF,
  rrarr: dF,
  Rrightarrow: pF,
  rsaquo: hF,
  rscr: mF,
  Rscr: gF,
  rsh: yF,
  Rsh: bF,
  rsqb: wF,
  rsquo: CF,
  rsquor: TF,
  rthree: kF,
  rtimes: EF,
  rtri: xF,
  rtrie: LF,
  rtrif: MF,
  rtriltri: AF,
  RuleDelayed: SF,
  ruluhar: OF,
  rx: DF,
  Sacute: IF,
  sacute: NF,
  sbquo: RF,
  scap: BF,
  Scaron: HF,
  scaron: PF,
  Sc: _F,
  sc: qF,
  sccue: $F,
  sce: FF,
  scE: UF,
  Scedil: VF,
  scedil: jF,
  Scirc: zF,
  scirc: WF,
  scnap: GF,
  scnE: XF,
  scnsim: QF,
  scpolint: KF,
  scsim: YF,
  Scy: ZF,
  scy: JF,
  sdotb: eU,
  sdot: tU,
  sdote: rU,
  searhk: nU,
  searr: aU,
  seArr: iU,
  searrow: oU,
  sect: sU,
  semi: lU,
  seswar: uU,
  setminus: cU,
  setmn: vU,
  sext: fU,
  Sfr: dU,
  sfr: pU,
  sfrown: hU,
  sharp: mU,
  SHCHcy: gU,
  shchcy: yU,
  SHcy: bU,
  shcy: wU,
  ShortDownArrow: CU,
  ShortLeftArrow: TU,
  shortmid: kU,
  shortparallel: EU,
  ShortRightArrow: xU,
  ShortUpArrow: LU,
  shy: MU,
  Sigma: AU,
  sigma: SU,
  sigmaf: OU,
  sigmav: DU,
  sim: IU,
  simdot: NU,
  sime: RU,
  simeq: BU,
  simg: HU,
  simgE: PU,
  siml: _U,
  simlE: qU,
  simne: $U,
  simplus: FU,
  simrarr: UU,
  slarr: VU,
  SmallCircle: jU,
  smallsetminus: zU,
  smashp: WU,
  smeparsl: GU,
  smid: XU,
  smile: QU,
  smt: KU,
  smte: YU,
  smtes: ZU,
  SOFTcy: JU,
  softcy: e2,
  solbar: t2,
  solb: r2,
  sol: n2,
  Sopf: a2,
  sopf: i2,
  spades: o2,
  spadesuit: s2,
  spar: l2,
  sqcap: u2,
  sqcaps: c2,
  sqcup: v2,
  sqcups: f2,
  Sqrt: d2,
  sqsub: p2,
  sqsube: h2,
  sqsubset: m2,
  sqsubseteq: g2,
  sqsup: y2,
  sqsupe: b2,
  sqsupset: w2,
  sqsupseteq: C2,
  square: T2,
  Square: k2,
  SquareIntersection: E2,
  SquareSubset: x2,
  SquareSubsetEqual: L2,
  SquareSuperset: M2,
  SquareSupersetEqual: A2,
  SquareUnion: S2,
  squarf: O2,
  squ: D2,
  squf: I2,
  srarr: N2,
  Sscr: R2,
  sscr: B2,
  ssetmn: H2,
  ssmile: P2,
  sstarf: _2,
  Star: q2,
  star: $2,
  starf: F2,
  straightepsilon: U2,
  straightphi: V2,
  strns: j2,
  sub: z2,
  Sub: W2,
  subdot: G2,
  subE: X2,
  sube: Q2,
  subedot: K2,
  submult: Y2,
  subnE: Z2,
  subne: J2,
  subplus: eV,
  subrarr: tV,
  subset: rV,
  Subset: nV,
  subseteq: aV,
  subseteqq: iV,
  SubsetEqual: oV,
  subsetneq: sV,
  subsetneqq: lV,
  subsim: uV,
  subsub: cV,
  subsup: vV,
  succapprox: fV,
  succ: dV,
  succcurlyeq: pV,
  Succeeds: hV,
  SucceedsEqual: mV,
  SucceedsSlantEqual: gV,
  SucceedsTilde: yV,
  succeq: bV,
  succnapprox: wV,
  succneqq: CV,
  succnsim: TV,
  succsim: kV,
  SuchThat: EV,
  sum: xV,
  Sum: LV,
  sung: MV,
  sup1: AV,
  sup2: SV,
  sup3: OV,
  sup: DV,
  Sup: IV,
  supdot: NV,
  supdsub: RV,
  supE: BV,
  supe: HV,
  supedot: PV,
  Superset: _V,
  SupersetEqual: qV,
  suphsol: $V,
  suphsub: FV,
  suplarr: UV,
  supmult: VV,
  supnE: jV,
  supne: zV,
  supplus: WV,
  supset: GV,
  Supset: XV,
  supseteq: QV,
  supseteqq: KV,
  supsetneq: YV,
  supsetneqq: ZV,
  supsim: JV,
  supsub: ej,
  supsup: tj,
  swarhk: rj,
  swarr: nj,
  swArr: aj,
  swarrow: ij,
  swnwar: oj,
  szlig: sj,
  Tab: lj,
  target: uj,
  Tau: cj,
  tau: vj,
  tbrk: fj,
  Tcaron: dj,
  tcaron: pj,
  Tcedil: hj,
  tcedil: mj,
  Tcy: gj,
  tcy: yj,
  tdot: bj,
  telrec: wj,
  Tfr: Cj,
  tfr: Tj,
  there4: kj,
  therefore: Ej,
  Therefore: xj,
  Theta: Lj,
  theta: Mj,
  thetasym: Aj,
  thetav: Sj,
  thickapprox: Oj,
  thicksim: Dj,
  ThickSpace: Ij,
  ThinSpace: Nj,
  thinsp: Rj,
  thkap: Bj,
  thksim: Hj,
  THORN: Pj,
  thorn: _j,
  tilde: qj,
  Tilde: $j,
  TildeEqual: Fj,
  TildeFullEqual: Uj,
  TildeTilde: Vj,
  timesbar: jj,
  timesb: zj,
  times: Wj,
  timesd: Gj,
  tint: Xj,
  toea: Qj,
  topbot: Kj,
  topcir: Yj,
  top: Zj,
  Topf: Jj,
  topf: ez,
  topfork: tz,
  tosa: rz,
  tprime: nz,
  trade: az,
  TRADE: iz,
  triangle: oz,
  triangledown: sz,
  triangleleft: lz,
  trianglelefteq: uz,
  triangleq: cz,
  triangleright: vz,
  trianglerighteq: fz,
  tridot: dz,
  trie: pz,
  triminus: hz,
  TripleDot: mz,
  triplus: gz,
  trisb: yz,
  tritime: bz,
  trpezium: wz,
  Tscr: Cz,
  tscr: Tz,
  TScy: kz,
  tscy: Ez,
  TSHcy: xz,
  tshcy: Lz,
  Tstrok: Mz,
  tstrok: Az,
  twixt: Sz,
  twoheadleftarrow: Oz,
  twoheadrightarrow: Dz,
  Uacute: Iz,
  uacute: Nz,
  uarr: Rz,
  Uarr: Bz,
  uArr: Hz,
  Uarrocir: Pz,
  Ubrcy: _z,
  ubrcy: qz,
  Ubreve: $z,
  ubreve: Fz,
  Ucirc: Uz,
  ucirc: Vz,
  Ucy: jz,
  ucy: zz,
  udarr: Wz,
  Udblac: Gz,
  udblac: Xz,
  udhar: Qz,
  ufisht: Kz,
  Ufr: Yz,
  ufr: Zz,
  Ugrave: Jz,
  ugrave: eW,
  uHar: tW,
  uharl: rW,
  uharr: nW,
  uhblk: aW,
  ulcorn: iW,
  ulcorner: oW,
  ulcrop: sW,
  ultri: lW,
  Umacr: uW,
  umacr: cW,
  uml: vW,
  UnderBar: fW,
  UnderBrace: dW,
  UnderBracket: pW,
  UnderParenthesis: hW,
  Union: mW,
  UnionPlus: gW,
  Uogon: yW,
  uogon: bW,
  Uopf: wW,
  uopf: CW,
  UpArrowBar: TW,
  uparrow: kW,
  UpArrow: EW,
  Uparrow: xW,
  UpArrowDownArrow: LW,
  updownarrow: MW,
  UpDownArrow: AW,
  Updownarrow: SW,
  UpEquilibrium: OW,
  upharpoonleft: DW,
  upharpoonright: IW,
  uplus: NW,
  UpperLeftArrow: RW,
  UpperRightArrow: BW,
  upsi: HW,
  Upsi: PW,
  upsih: _W,
  Upsilon: qW,
  upsilon: $W,
  UpTeeArrow: FW,
  UpTee: UW,
  upuparrows: VW,
  urcorn: jW,
  urcorner: zW,
  urcrop: WW,
  Uring: GW,
  uring: XW,
  urtri: QW,
  Uscr: KW,
  uscr: YW,
  utdot: ZW,
  Utilde: JW,
  utilde: e3,
  utri: t3,
  utrif: r3,
  uuarr: n3,
  Uuml: a3,
  uuml: i3,
  uwangle: o3,
  vangrt: s3,
  varepsilon: l3,
  varkappa: u3,
  varnothing: c3,
  varphi: v3,
  varpi: f3,
  varpropto: d3,
  varr: p3,
  vArr: h3,
  varrho: m3,
  varsigma: g3,
  varsubsetneq: y3,
  varsubsetneqq: b3,
  varsupsetneq: w3,
  varsupsetneqq: C3,
  vartheta: T3,
  vartriangleleft: k3,
  vartriangleright: E3,
  vBar: x3,
  Vbar: L3,
  vBarv: M3,
  Vcy: A3,
  vcy: S3,
  vdash: O3,
  vDash: D3,
  Vdash: I3,
  VDash: N3,
  Vdashl: R3,
  veebar: B3,
  vee: H3,
  Vee: P3,
  veeeq: _3,
  vellip: q3,
  verbar: $3,
  Verbar: F3,
  vert: U3,
  Vert: V3,
  VerticalBar: j3,
  VerticalLine: z3,
  VerticalSeparator: W3,
  VerticalTilde: G3,
  VeryThinSpace: X3,
  Vfr: Q3,
  vfr: K3,
  vltri: Y3,
  vnsub: Z3,
  vnsup: J3,
  Vopf: eG,
  vopf: tG,
  vprop: rG,
  vrtri: nG,
  Vscr: aG,
  vscr: iG,
  vsubnE: oG,
  vsubne: sG,
  vsupnE: lG,
  vsupne: uG,
  Vvdash: cG,
  vzigzag: vG,
  Wcirc: fG,
  wcirc: dG,
  wedbar: pG,
  wedge: hG,
  Wedge: mG,
  wedgeq: gG,
  weierp: yG,
  Wfr: bG,
  wfr: wG,
  Wopf: CG,
  wopf: TG,
  wp: kG,
  wr: EG,
  wreath: xG,
  Wscr: LG,
  wscr: MG,
  xcap: AG,
  xcirc: SG,
  xcup: OG,
  xdtri: DG,
  Xfr: IG,
  xfr: NG,
  xharr: RG,
  xhArr: BG,
  Xi: HG,
  xi: PG,
  xlarr: _G,
  xlArr: qG,
  xmap: $G,
  xnis: FG,
  xodot: UG,
  Xopf: VG,
  xopf: jG,
  xoplus: zG,
  xotime: WG,
  xrarr: GG,
  xrArr: XG,
  Xscr: QG,
  xscr: KG,
  xsqcup: YG,
  xuplus: ZG,
  xutri: JG,
  xvee: e4,
  xwedge: t4,
  Yacute: r4,
  yacute: n4,
  YAcy: a4,
  yacy: i4,
  Ycirc: o4,
  ycirc: s4,
  Ycy: l4,
  ycy: u4,
  yen: c4,
  Yfr: v4,
  yfr: f4,
  YIcy: d4,
  yicy: p4,
  Yopf: h4,
  yopf: m4,
  Yscr: g4,
  yscr: y4,
  YUcy: b4,
  yucy: w4,
  yuml: C4,
  Yuml: T4,
  Zacute: k4,
  zacute: E4,
  Zcaron: x4,
  zcaron: L4,
  Zcy: M4,
  zcy: A4,
  Zdot: S4,
  zdot: O4,
  zeetrf: D4,
  ZeroWidthSpace: I4,
  Zeta: N4,
  zeta: R4,
  zfr: B4,
  Zfr: H4,
  ZHcy: P4,
  zhcy: _4,
  zigrarr: q4,
  zopf: $4,
  Zopf: F4,
  Zscr: U4,
  zscr: V4,
  zwj: j4,
  zwnj: z4
}, W4 = "Á", G4 = "á", X4 = "Â", Q4 = "â", K4 = "´", Y4 = "Æ", Z4 = "æ", J4 = "À", e8 = "à", t8 = "&", r8 = "&", n8 = "Å", a8 = "å", i8 = "Ã", o8 = "ã", s8 = "Ä", l8 = "ä", u8 = "¦", c8 = "Ç", v8 = "ç", f8 = "¸", d8 = "¢", p8 = "©", h8 = "©", m8 = "¤", g8 = "°", y8 = "÷", b8 = "É", w8 = "é", C8 = "Ê", T8 = "ê", k8 = "È", E8 = "è", x8 = "Ð", L8 = "ð", M8 = "Ë", A8 = "ë", S8 = "½", O8 = "¼", D8 = "¾", I8 = ">", N8 = ">", R8 = "Í", B8 = "í", H8 = "Î", P8 = "î", _8 = "¡", q8 = "Ì", $8 = "ì", F8 = "¿", U8 = "Ï", V8 = "ï", j8 = "«", z8 = "<", W8 = "<", G8 = "¯", X8 = "µ", Q8 = "·", K8 = " ", Y8 = "¬", Z8 = "Ñ", J8 = "ñ", e5 = "Ó", t5 = "ó", r5 = "Ô", n5 = "ô", a5 = "Ò", i5 = "ò", o5 = "ª", s5 = "º", l5 = "Ø", u5 = "ø", c5 = "Õ", v5 = "õ", f5 = "Ö", d5 = "ö", p5 = "¶", h5 = "±", m5 = "£", g5 = '"', y5 = '"', b5 = "»", w5 = "®", C5 = "®", T5 = "§", k5 = "­", E5 = "¹", x5 = "²", L5 = "³", M5 = "ß", A5 = "Þ", S5 = "þ", O5 = "×", D5 = "Ú", I5 = "ú", N5 = "Û", R5 = "û", B5 = "Ù", H5 = "ù", P5 = "¨", _5 = "Ü", q5 = "ü", $5 = "Ý", F5 = "ý", U5 = "¥", V5 = "ÿ", j5 = {
  Aacute: W4,
  aacute: G4,
  Acirc: X4,
  acirc: Q4,
  acute: K4,
  AElig: Y4,
  aelig: Z4,
  Agrave: J4,
  agrave: e8,
  amp: t8,
  AMP: r8,
  Aring: n8,
  aring: a8,
  Atilde: i8,
  atilde: o8,
  Auml: s8,
  auml: l8,
  brvbar: u8,
  Ccedil: c8,
  ccedil: v8,
  cedil: f8,
  cent: d8,
  copy: p8,
  COPY: h8,
  curren: m8,
  deg: g8,
  divide: y8,
  Eacute: b8,
  eacute: w8,
  Ecirc: C8,
  ecirc: T8,
  Egrave: k8,
  egrave: E8,
  ETH: x8,
  eth: L8,
  Euml: M8,
  euml: A8,
  frac12: S8,
  frac14: O8,
  frac34: D8,
  gt: I8,
  GT: N8,
  Iacute: R8,
  iacute: B8,
  Icirc: H8,
  icirc: P8,
  iexcl: _8,
  Igrave: q8,
  igrave: $8,
  iquest: F8,
  Iuml: U8,
  iuml: V8,
  laquo: j8,
  lt: z8,
  LT: W8,
  macr: G8,
  micro: X8,
  middot: Q8,
  nbsp: K8,
  not: Y8,
  Ntilde: Z8,
  ntilde: J8,
  Oacute: e5,
  oacute: t5,
  Ocirc: r5,
  ocirc: n5,
  Ograve: a5,
  ograve: i5,
  ordf: o5,
  ordm: s5,
  Oslash: l5,
  oslash: u5,
  Otilde: c5,
  otilde: v5,
  Ouml: f5,
  ouml: d5,
  para: p5,
  plusmn: h5,
  pound: m5,
  quot: g5,
  QUOT: y5,
  raquo: b5,
  reg: w5,
  REG: C5,
  sect: T5,
  shy: k5,
  sup1: E5,
  sup2: x5,
  sup3: L5,
  szlig: M5,
  THORN: A5,
  thorn: S5,
  times: O5,
  Uacute: D5,
  uacute: I5,
  Ucirc: N5,
  ucirc: R5,
  Ugrave: B5,
  ugrave: H5,
  uml: P5,
  Uuml: _5,
  uuml: q5,
  Yacute: $5,
  yacute: F5,
  yen: U5,
  yuml: V5
}, z5 = "&", W5 = "'", G5 = ">", X5 = "<", Q5 = '"', yl = {
  amp: z5,
  apos: W5,
  gt: G5,
  lt: X5,
  quot: Q5
}, Ha = {}, K5 = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, Y5 = Lt && Lt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ha, "__esModule", { value: !0 });
var Fi = Y5(K5), Z5 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.fromCodePoint || function(t) {
    var e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  }
);
function J5(t) {
  return t >= 55296 && t <= 57343 || t > 1114111 ? "�" : (t in Fi.default && (t = Fi.default[t]), Z5(t));
}
Ha.default = J5;
var Xr = Lt && Lt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(qe, "__esModule", { value: !0 });
qe.decodeHTML = qe.decodeHTMLStrict = qe.decodeXML = void 0;
var Gn = Xr(gl), e9 = Xr(j5), t9 = Xr(yl), Ui = Xr(Ha), r9 = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
qe.decodeXML = bl(t9.default);
qe.decodeHTMLStrict = bl(Gn.default);
function bl(t) {
  var e = wl(t);
  return function(r) {
    return String(r).replace(r9, e);
  };
}
var Vi = function(t, e) {
  return t < e ? 1 : -1;
};
qe.decodeHTML = (function() {
  for (var t = Object.keys(e9.default).sort(Vi), e = Object.keys(Gn.default).sort(Vi), r = 0, n = 0; r < e.length; r++)
    t[n] === e[r] ? (e[r] += ";?", n++) : e[r] += ";";
  var a = new RegExp("&(?:" + e.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), i = wl(Gn.default);
  function o(s) {
    return s.substr(-1) !== ";" && (s += ";"), i(s);
  }
  return function(s) {
    return String(s).replace(a, o);
  };
})();
function wl(t) {
  return function(r) {
    if (r.charAt(1) === "#") {
      var n = r.charAt(2);
      return n === "X" || n === "x" ? Ui.default(parseInt(r.substr(3), 16)) : Ui.default(parseInt(r.substr(2), 10));
    }
    return t[r.slice(1, -1)] || r;
  };
}
var fe = {}, Cl = Lt && Lt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(fe, "__esModule", { value: !0 });
fe.escapeUTF8 = fe.escape = fe.encodeNonAsciiHTML = fe.encodeHTML = fe.encodeXML = void 0;
var n9 = Cl(yl), Tl = El(n9.default), kl = xl(Tl);
fe.encodeXML = Al(Tl);
var a9 = Cl(gl), Pa = El(a9.default), i9 = xl(Pa);
fe.encodeHTML = s9(Pa, i9);
fe.encodeNonAsciiHTML = Al(Pa);
function El(t) {
  return Object.keys(t).sort().reduce(function(e, r) {
    return e[t[r]] = "&" + r + ";", e;
  }, {});
}
function xl(t) {
  for (var e = [], r = [], n = 0, a = Object.keys(t); n < a.length; n++) {
    var i = a[n];
    i.length === 1 ? e.push("\\" + i) : r.push(i);
  }
  e.sort();
  for (var o = 0; o < e.length - 1; o++) {
    for (var s = o; s < e.length - 1 && e[s].charCodeAt(1) + 1 === e[s + 1].charCodeAt(1); )
      s += 1;
    var l = 1 + s - o;
    l < 3 || e.splice(o, l, e[o] + "-" + e[s]);
  }
  return r.unshift("[" + e.join("") + "]"), new RegExp(r.join("|"), "g");
}
var Ll = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, o9 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    function(t) {
      return t.codePointAt(0);
    }
  ) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(t) {
      return (t.charCodeAt(0) - 55296) * 1024 + t.charCodeAt(1) - 56320 + 65536;
    }
  )
);
function Qr(t) {
  return "&#x" + (t.length > 1 ? o9(t) : t.charCodeAt(0)).toString(16).toUpperCase() + ";";
}
function s9(t, e) {
  return function(r) {
    return r.replace(e, function(n) {
      return t[n];
    }).replace(Ll, Qr);
  };
}
var Ml = new RegExp(kl.source + "|" + Ll.source, "g");
function l9(t) {
  return t.replace(Ml, Qr);
}
fe.escape = l9;
function u9(t) {
  return t.replace(kl, Qr);
}
fe.escapeUTF8 = u9;
function Al(t) {
  return function(e) {
    return e.replace(Ml, function(r) {
      return t[r] || Qr(r);
    });
  };
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.encodeHTML5 = t.encodeHTML4 = t.escapeUTF8 = t.escape = t.encodeNonAsciiHTML = t.encodeHTML = t.encodeXML = t.encode = t.decodeStrict = t.decode = void 0;
  var e = qe, r = fe;
  function n(l, u) {
    return (!u || u <= 0 ? e.decodeXML : e.decodeHTML)(l);
  }
  t.decode = n;
  function a(l, u) {
    return (!u || u <= 0 ? e.decodeXML : e.decodeHTMLStrict)(l);
  }
  t.decodeStrict = a;
  function i(l, u) {
    return (!u || u <= 0 ? r.encodeXML : r.encodeHTML)(l);
  }
  t.encode = i;
  var o = fe;
  Object.defineProperty(t, "encodeXML", { enumerable: !0, get: function() {
    return o.encodeXML;
  } }), Object.defineProperty(t, "encodeHTML", { enumerable: !0, get: function() {
    return o.encodeHTML;
  } }), Object.defineProperty(t, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return o.encodeNonAsciiHTML;
  } }), Object.defineProperty(t, "escape", { enumerable: !0, get: function() {
    return o.escape;
  } }), Object.defineProperty(t, "escapeUTF8", { enumerable: !0, get: function() {
    return o.escapeUTF8;
  } }), Object.defineProperty(t, "encodeHTML4", { enumerable: !0, get: function() {
    return o.encodeHTML;
  } }), Object.defineProperty(t, "encodeHTML5", { enumerable: !0, get: function() {
    return o.encodeHTML;
  } });
  var s = qe;
  Object.defineProperty(t, "decodeXML", { enumerable: !0, get: function() {
    return s.decodeXML;
  } }), Object.defineProperty(t, "decodeHTML", { enumerable: !0, get: function() {
    return s.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return s.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTML4", { enumerable: !0, get: function() {
    return s.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML5", { enumerable: !0, get: function() {
    return s.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return s.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return s.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeXMLStrict", { enumerable: !0, get: function() {
    return s.decodeXML;
  } });
})(Ba);
var Sl = "&(?:#x[a-f0-9]{1,6}|#[0-9]{1,7}|[a-z][a-z0-9]{1,31});", c9 = 92, v9 = /[\\&]/, _a = "[!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]", f9 = new RegExp("\\\\" + _a + "|" + Sl, "gi"), d9 = '[&<>"]', ji = new RegExp(d9, "g"), p9 = function(t) {
  return t.charCodeAt(0) === c9 ? t.charAt(1) : Ba.decodeHTML(t);
};
function jt(t) {
  return v9.test(t) ? t.replace(f9, p9) : t;
}
function or(t) {
  try {
    return Ad(t);
  } catch {
    return t;
  }
}
function h9(t) {
  switch (t) {
    case "&":
      return "&amp;";
    case "<":
      return "&lt;";
    case ">":
      return "&gt;";
    case '"':
      return "&quot;";
    default:
      return t;
  }
}
function yt(t) {
  return ji.test(t) ? t.replace(ji, h9) : t;
}
function Xn(t, e) {
  for (var r = [], n = 0; n < e; n++)
    r.push(t);
  return r.join("");
}
function zi(t) {
  return t ? !/[^ \t]+/.test(t) : !0;
}
var m9 = (
  /** @class */
  (function() {
    function t(e) {
      this.current = e, this.root = e, this.entering = !0;
    }
    return t.prototype.next = function() {
      var e = this.current, r = this.entering;
      if (e === null)
        return null;
      var n = qa(e);
      return r && n ? e.firstChild ? (this.current = e.firstChild, this.entering = !0) : this.entering = !1 : e === this.root ? this.current = null : e.next === null ? (this.current = e.parent, this.entering = !1) : (this.current = e.next, this.entering = !0), { entering: r, node: e };
    }, t.prototype.resumeAt = function(e, r) {
      this.current = e, this.entering = r === !0;
    }, t;
  })()
);
function qa(t) {
  switch (t.type) {
    case "document":
    case "blockQuote":
    case "list":
    case "item":
    case "paragraph":
    case "heading":
    case "emph":
    case "strong":
    case "strike":
    case "link":
    case "image":
    case "table":
    case "tableHead":
    case "tableBody":
    case "tableRow":
    case "tableCell":
    case "tableDelimRow":
    case "customInline":
      return !0;
    default:
      return !1;
  }
}
var g9 = 1, Kr = {};
function y9(t) {
  return Kr[t];
}
function Qn(t) {
  delete Kr[t];
}
function b9() {
  Kr = {};
}
var Yt = (
  /** @class */
  (function() {
    function t(e, r) {
      this.parent = null, this.prev = null, this.next = null, this.firstChild = null, this.lastChild = null, this.literal = null, e === "document" ? this.id = -1 : this.id = g9++, this.type = e, this.sourcepos = r, Kr[this.id] = this;
    }
    return t.prototype.isContainer = function() {
      return qa(this);
    }, t.prototype.unlink = function() {
      this.prev ? this.prev.next = this.next : this.parent && (this.parent.firstChild = this.next), this.next ? this.next.prev = this.prev : this.parent && (this.parent.lastChild = this.prev), this.parent = null, this.next = null, this.prev = null;
    }, t.prototype.replaceWith = function(e) {
      this.insertBefore(e), this.unlink();
    }, t.prototype.insertAfter = function(e) {
      e.unlink(), e.next = this.next, e.next && (e.next.prev = e), e.prev = this, this.next = e, this.parent && (e.parent = this.parent, e.next || (e.parent.lastChild = e));
    }, t.prototype.insertBefore = function(e) {
      e.unlink(), e.prev = this.prev, e.prev && (e.prev.next = e), e.next = this, this.prev = e, e.parent = this.parent, e.prev || (e.parent.firstChild = e);
    }, t.prototype.appendChild = function(e) {
      e.unlink(), e.parent = this, this.lastChild ? (this.lastChild.next = e, e.prev = this.lastChild, this.lastChild = e) : (this.firstChild = e, this.lastChild = e);
    }, t.prototype.prependChild = function(e) {
      e.unlink(), e.parent = this, this.firstChild ? (this.firstChild.prev = e, e.next = this.firstChild, this.firstChild = e) : (this.firstChild = e, this.lastChild = e);
    }, t.prototype.walker = function() {
      return new m9(this);
    }, t;
  })()
), Ue = (
  /** @class */
  (function(t) {
    me(e, t);
    function e(r, n) {
      var a = t.call(this, r, n) || this;
      return a.open = !0, a.lineOffsets = null, a.stringContent = null, a.lastLineBlank = !1, a.lastLineChecked = !1, a.type = r, a;
    }
    return e;
  })(Yt)
), w9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.listData = null, r;
    }
    return e;
  })(Ue)
), C9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.level = 0, r.headingType = "atx", r;
    }
    return e;
  })(Ue)
), T9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.isFenced = !1, r.fenceChar = null, r.fenceLength = 0, r.fenceOffset = -1, r.info = null, r.infoPadding = 0, r;
    }
    return e;
  })(Ue)
), k9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.columns = [], r;
    }
    return e;
  })(Ue)
), E9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.startIdx = 0, r.endIdx = 0, r.paddingLeft = 0, r.paddingRight = 0, r.ignored = !1, r;
    }
    return e;
  })(Ue)
), x9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.title = "", r.dest = "", r.label = "", r;
    }
    return e;
  })(Ue)
), L9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.syntaxLength = 0, r.offset = -1, r.info = "", r;
    }
    return e;
  })(Ue)
), M9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.htmlBlockType = -1, r;
    }
    return e;
  })(Ue)
), A9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.destination = null, r.title = null, r.extendedAutolink = !1, r;
    }
    return e;
  })(Yt)
), S9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.tickCount = 0, r;
    }
    return e;
  })(Yt)
), O9 = (
  /** @class */
  (function(t) {
    me(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.info = "", r;
    }
    return e;
  })(Yt)
);
function j(t, e) {
  switch (t) {
    case "heading":
      return new C9(t, e);
    case "list":
    case "item":
      return new w9(t, e);
    case "link":
    case "image":
      return new A9(t, e);
    case "codeBlock":
      return new T9(t, e);
    case "htmlBlock":
      return new M9(t, e);
    case "table":
      return new k9(t, e);
    case "tableCell":
      return new E9(t, e);
    case "document":
    case "paragraph":
    case "blockQuote":
    case "thematicBreak":
    case "tableRow":
    case "tableBody":
    case "tableHead":
    case "frontMatter":
      return new Ue(t, e);
    case "code":
      return new S9(t, e);
    case "refDef":
      return new x9(t, e);
    case "customBlock":
      return new L9(t, e);
    case "customInline":
      return new O9(t, e);
    default:
      return new Yt(t, e);
  }
}
function Ol(t) {
  return t.type === "codeBlock";
}
function D9(t) {
  return t.type === "htmlBlock";
}
function I9(t) {
  return t.type === "heading";
}
function Wi(t) {
  return t.type === "list";
}
function N9(t) {
  return t.type === "table";
}
function ht(t) {
  return t.type === "refDef";
}
function Dl(t) {
  return t.type === "customBlock";
}
function R9(t) {
  return t.type === "customInline";
}
function W(t, e) {
  var r = j("text", e);
  return r.literal = t, r;
}
var Il = "[A-Za-z][A-Za-z0-9-]*", B9 = "[a-zA-Z_:][a-zA-Z0-9:._-]*", H9 = "[^\"'=<>`\\x00-\\x20]+", P9 = "'[^']*'", _9 = '"[^"]*"', q9 = "(?:" + H9 + "|" + P9 + "|" + _9 + ")", $9 = "(?:\\s*=\\s*" + q9 + ")", F9 = "(?:\\s+" + B9 + $9 + "?)", Nl = "<" + Il + F9 + "*\\s*/?>", Rl = "</" + Il + "\\s*[>]", U9 = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->", V9 = "[<][?].*?[?][>]", j9 = "<![A-Z]+\\s+[^>]*>", z9 = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", W9 = "(?:" + Nl + "|" + Rl + "|" + U9 + "|" + V9 + "|" + j9 + "|" + z9 + ")", G9 = new RegExp("^" + W9, "i");
/*! http://mths.be/fromcodepoint v0.2.1 by @mathias */
var Kn;
if (String.fromCodePoint)
  Kn = function(t) {
    try {
      return String.fromCodePoint(t);
    } catch (e) {
      if (e instanceof RangeError)
        return "�";
      throw e;
    }
  };
else {
  var X9 = String.fromCharCode, Q9 = Math.floor;
  Kn = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    var r = 16384, n = [], a, i, o = -1, s = t.length;
    if (!s)
      return "";
    for (var l = ""; ++o < s; ) {
      var u = Number(t[o]);
      if (!isFinite(u) || // `NaN`, `+Infinity`, or `-Infinity`
      u < 0 || // not a valid Unicode code point
      u > 1114111 || // not a valid Unicode code point
      Q9(u) !== u)
        return "�";
      u <= 65535 ? n.push(u) : (u -= 65536, a = (u >> 10) + 55296, i = u % 1024 + 56320, n.push(a, i)), (o + 1 === s || n.length > r) && (l += X9.apply(void 0, n), n.length = 0);
    }
    return l;
  };
}
var wn = Kn, K9 = "(?:[w-]+.)*[A-Za-z0-9-]+.[A-Za-z0-9-]+", Y9 = "[^<\\s]*[^<?!.,:*_?~\\s]", Z9 = "[\\w.+-]+@(?:[\\w-]+\\.)+[\\w-]+";
function J9(t) {
  var e = /\)+$/.exec(t);
  if (e) {
    for (var r = 0, n = 0, a = t; n < a.length; n++) {
      var i = a[n];
      i === "(" ? r < 0 ? r = 1 : r += 1 : i === ")" && (r -= 1);
    }
    if (r < 0) {
      var o = Math.min(-r, e[0].length);
      return t.substring(0, t.length - o);
    }
  }
  return t;
}
function e6(t) {
  return t.replace(/&[A-Za-z0-9]+;$/, "");
}
function t6(t) {
  for (var e = new RegExp(Z9, "g"), r = [], n; n = e.exec(t); ) {
    var a = n[0];
    /[_-]+$/.test(a) || r.push({
      text: a,
      range: [n.index, n.index + a.length - 1],
      url: "mailto:" + a
    });
  }
  return r;
}
function r6(t) {
  for (var e = new RegExp("(www|https?://)." + K9 + Y9, "g"), r = [], n; n = e.exec(t); ) {
    var a = e6(J9(n[0])), i = n[1] === "www" ? "http://" : "";
    r.push({
      text: a,
      range: [n.index, n.index + a.length - 1],
      url: "" + i + a
    });
  }
  return r;
}
function n6(t) {
  return Wn(Wn([], r6(t)), t6(t)).sort(function(e, r) {
    return e.range[0] - r.range[0];
  });
}
function a6(t, e) {
  typeof e == "boolean" && (e = n6);
  for (var r, n = function() {
    var a = r.entering, i = r.node;
    if (a && i.type === "text" && i.parent.type !== "link") {
      var o = i.literal, s = e(o);
      if (!s || !s.length)
        return "continue";
      for (var l = 0, u = i.sourcepos[0], c = u[0], v = u[1], f = function(I, _) {
        return [
          [c, v + I],
          [c, v + _]
        ];
      }, d = [], p = 0, h = s; p < h.length; p++) {
        var m = h[p], y = m.range, w = m.url, C = m.text;
        y[0] > l && d.push(W(o.substring(l, y[0]), f(l, y[0] - 1)));
        var T = j("link", f.apply(void 0, y));
        T.appendChild(W(C, f.apply(void 0, y))), T.destination = w, T.extendedAutolink = !0, d.push(T), l = y[1] + 1;
      }
      l < o.length && d.push(W(o.substring(l), f(l, o.length - 1)));
      for (var k = 0, M = d; k < M.length; k++) {
        var O = M[k];
        i.insertBefore(O);
      }
      i.unlink();
    }
  }; r = t.next(); )
    n();
}
function Ir(t) {
  return t[t.length - 1];
}
function Gi(t) {
  return t.slice(1, t.length - 1).trim().replace(/[ \t\r\n]+/, " ").toLowerCase().toUpperCase();
}
function sr(t, e) {
  Object.keys(t).forEach(function(r) {
    e(r, t[r]);
  });
}
function i6(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  var n = J({}, t);
  return e.forEach(function(a) {
    delete n[a];
  }), n;
}
function mt(t) {
  return !Object.keys(t).length;
}
function o6(t) {
  Object.keys(t).forEach(function(e) {
    delete t[e];
  });
}
var Yn = 10, Cn = 42, lr = 95, s6 = 96, Xi = 91, l6 = 93, ur = 126, Qi = 60, u6 = 33, Ki = 92, c6 = 38, Yi = 40, Tn = 41, v6 = 58, Qe = 39, Ke = 34, Ye = 36, kn = "\\\\" + _a, Zi = new RegExp(/[!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/), f6 = new RegExp('^(?:"(' + kn + '|[^"\\x00])*"|' + ("'(" + kn + "|[^'\\x00])*'") + "|" + ("\\((" + kn + "|[^()\\x00])*\\))")), d6 = /^(?:<(?:[^<>\n\\\x00]|\\.)*>)/, Ji = new RegExp("^" + _a), p6 = new RegExp("^" + Sl, "i"), h6 = /`+/, m6 = /^`+/, g6 = /\.\.\./g, y6 = /--+/g, b6 = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/, w6 = /^<[A-Za-z][A-Za-z0-9.+-]{1,31}:[^<>\x00-\x20]*>/i, C6 = /^ *(?:\n *)?/, En = /^[ \t\n\x0b\x0c\x0d]/, eo = /^\s/, T6 = / *$/, k6 = /^ */, to = /^ *(?:\n|$)/, E6 = /^\[(?:[^\\\[\]]|\\.){0,1000}\]/, x6 = /^[^\n`\[\]\\!<&*_'"~$]+/m, L6 = (
  /** @class */
  (function() {
    function t(e) {
      this.subject = "", this.delimiters = null, this.brackets = null, this.pos = 0, this.lineStartNum = 0, this.lineIdx = 0, this.lineOffsets = [0], this.linePosOffset = 0, this.refMap = {}, this.refLinkCandidateMap = {}, this.refDefCandidateMap = {}, this.options = e;
    }
    return t.prototype.sourcepos = function(e, r) {
      var n = this.linePosOffset + this.lineOffsets[this.lineIdx], a = this.lineStartNum + this.lineIdx, i = [a, e + n];
      return typeof r == "number" ? [i, [a, r + n]] : i;
    }, t.prototype.nextLine = function() {
      this.lineIdx += 1, this.linePosOffset = -this.pos;
    }, t.prototype.match = function(e) {
      var r = e.exec(this.subject.slice(this.pos));
      return r === null ? null : (this.pos += r.index + r[0].length, r[0]);
    }, t.prototype.peek = function() {
      return this.pos < this.subject.length ? this.subject.charCodeAt(this.pos) : -1;
    }, t.prototype.spnl = function() {
      return this.match(C6), !0;
    }, t.prototype.parseBackticks = function(e) {
      var r = this.pos + 1, n = this.match(m6);
      if (n === null)
        return !1;
      for (var a = this.pos, i; (i = this.match(h6)) !== null; )
        if (i === n) {
          var o = this.subject.slice(a, this.pos - n.length), s = this.sourcepos(r, this.pos), l = o.split(`
`);
          if (l.length > 1) {
            var u = Ir(l);
            this.lineIdx += l.length - 1, this.linePosOffset = -(this.pos - u.length - n.length), s[1] = this.sourcepos(this.pos), o = l.join(" ");
          }
          var c = j("code", s);
          return o.length > 0 && o.match(/[^ ]/) !== null && o[0] == " " && o[o.length - 1] == " " ? c.literal = o.slice(1, o.length - 1) : c.literal = o, c.tickCount = n.length, e.appendChild(c), !0;
        }
      return this.pos = a, e.appendChild(W(n, this.sourcepos(r, this.pos - 1))), !0;
    }, t.prototype.parseBackslash = function(e) {
      var r = this.subject, n;
      this.pos += 1;
      var a = this.pos;
      return this.peek() === Yn ? (this.pos += 1, n = j("linebreak", this.sourcepos(this.pos - 1, this.pos)), e.appendChild(n), this.nextLine()) : Ji.test(r.charAt(this.pos)) ? (e.appendChild(W(r.charAt(this.pos), this.sourcepos(a, this.pos))), this.pos += 1) : e.appendChild(W("\\", this.sourcepos(a, a))), !0;
    }, t.prototype.parseAutolink = function(e) {
      var r, n, a, i = this.pos + 1;
      return (r = this.match(b6)) ? (n = r.slice(1, r.length - 1), a = j("link", this.sourcepos(i, this.pos)), a.destination = or("mailto:" + n), a.title = "", a.appendChild(W(n, this.sourcepos(i + 1, this.pos - 1))), e.appendChild(a), !0) : (r = this.match(w6)) ? (n = r.slice(1, r.length - 1), a = j("link", this.sourcepos(i, this.pos)), a.destination = or(n), a.title = "", a.appendChild(W(n, this.sourcepos(i + 1, this.pos - 1))), e.appendChild(a), !0) : !1;
    }, t.prototype.parseHtmlTag = function(e) {
      var r = this.pos + 1, n = this.match(G9);
      if (n === null)
        return !1;
      var a = j("htmlInline", this.sourcepos(r, this.pos));
      return a.literal = n, e.appendChild(a), !0;
    }, t.prototype.scanDelims = function(e) {
      var r = 0, n = this.pos;
      if (e === Qe || e === Ke)
        r++, this.pos++;
      else
        for (; this.peek() === e; )
          r++, this.pos++;
      if (r === 0 || r < 2 && (e === ur || e === Ye))
        return this.pos = n, null;
      var a = n === 0 ? `
` : this.subject.charAt(n - 1), i = this.peek(), o;
      i === -1 ? o = `
` : o = wn(i);
      var s = eo.test(o), l = Zi.test(o), u = eo.test(a), c = Zi.test(a), v = !s && (!l || u || c), f = !u && (!c || s || l), d, p;
      return e === lr ? (d = v && (!f || c), p = f && (!v || l)) : e === Qe || e === Ke ? (d = v && !f, p = f) : e === Ye ? (d = !s, p = !u) : (d = v, p = f), this.pos = n, { numdelims: r, canOpen: d, canClose: p };
    }, t.prototype.handleDelim = function(e, r) {
      var n = this.scanDelims(e);
      if (!n)
        return !1;
      var a = n.numdelims, i = this.pos + 1, o;
      this.pos += a, e === Qe ? o = "’" : e === Ke ? o = "“" : o = this.subject.slice(i - 1, this.pos);
      var s = W(o, this.sourcepos(i, this.pos));
      return r.appendChild(s), (n.canOpen || n.canClose) && (this.options.smart || e !== Qe && e !== Ke) && (this.delimiters = {
        cc: e,
        numdelims: a,
        origdelims: a,
        node: s,
        previous: this.delimiters,
        next: null,
        canOpen: n.canOpen,
        canClose: n.canClose
      }, this.delimiters.previous && (this.delimiters.previous.next = this.delimiters)), !0;
    }, t.prototype.removeDelimiter = function(e) {
      e.previous !== null && (e.previous.next = e.next), e.next === null ? this.delimiters = e.previous : e.next.previous = e.previous;
    }, t.prototype.removeDelimitersBetween = function(e, r) {
      e.next !== r && (e.next = r, r.previous = e);
    }, t.prototype.processEmphasis = function(e) {
      var r, n, a, i, o, s, l, u = !1, c = (r = {}, r[lr] = [e, e, e], r[Cn] = [e, e, e], r[Qe] = [e], r[Ke] = [e], r[ur] = [e], r[Ye] = [e], r);
      for (a = this.delimiters; a !== null && a.previous !== e; )
        a = a.previous;
      for (; a !== null; ) {
        var v = a.cc, f = v === lr || v === Cn;
        if (!a.canClose)
          a = a.next;
        else {
          for (n = a.previous, l = !1; n !== null && n !== e && n !== c[v][f ? a.origdelims % 3 : 0]; ) {
            if (u = f && (a.canOpen || n.canClose) && a.origdelims % 3 !== 0 && (n.origdelims + a.origdelims) % 3 === 0, n.cc === a.cc && n.canOpen && !u) {
              l = !0;
              break;
            }
            n = n.previous;
          }
          if (i = a, f || v === ur || v === Ye) {
            if (!l)
              a = a.next;
            else if (n) {
              var d = a.numdelims >= 2 && n.numdelims >= 2 ? 2 : 1, p = f ? 0 : 1;
              o = n.node, s = a.node;
              var h = f ? d === 1 ? "emph" : "strong" : "strike";
              v === Ye && (h = "customInline");
              var m = j(h), y = o.sourcepos[1], w = s.sourcepos[0];
              m.sourcepos = [
                [y[0], y[1] - d + 1],
                [w[0], w[1] + d - 1]
              ], o.sourcepos[1][1] -= d, s.sourcepos[0][1] += d, o.literal = o.literal.slice(d), s.literal = s.literal.slice(d), n.numdelims -= d, a.numdelims -= d;
              for (var C = o.next, T = void 0; C && C !== s; )
                T = C.next, C.unlink(), m.appendChild(C), C = T;
              if (v === Ye) {
                var k = m.firstChild, M = k.literal || "", O = M.split(/\s/)[0];
                m.info = O, M.length <= O.length ? k.unlink() : (k.sourcepos[0][1] += O.length, k.literal = M.replace(O + " ", ""));
              }
              if (o.insertAfter(m), this.removeDelimitersBetween(n, a), n.numdelims <= p && (n.numdelims === 0 && o.unlink(), this.removeDelimiter(n)), a.numdelims <= p) {
                a.numdelims === 0 && s.unlink();
                var I = a.next;
                this.removeDelimiter(a), a = I;
              }
            }
          } else v === Qe ? (a.node.literal = "’", l && (n.node.literal = "‘"), a = a.next) : v === Ke && (a.node.literal = "”", l && (n.node.literal = "“"), a = a.next);
          l || (c[v][f ? i.origdelims % 3 : 0] = i.previous, i.canOpen || this.removeDelimiter(i));
        }
      }
      for (; this.delimiters !== null && this.delimiters !== e; )
        this.removeDelimiter(this.delimiters);
    }, t.prototype.parseLinkTitle = function() {
      var e = this.match(f6);
      return e === null ? null : jt(e.substr(1, e.length - 2));
    }, t.prototype.parseLinkDestination = function() {
      var e = this.match(d6);
      if (e === null) {
        if (this.peek() === Qi)
          return null;
        for (var r = this.pos, n = 0, a = void 0; (a = this.peek()) !== -1; )
          if (a === Ki && Ji.test(this.subject.charAt(this.pos + 1)))
            this.pos += 1, this.peek() !== -1 && (this.pos += 1);
          else if (a === Yi)
            this.pos += 1, n += 1;
          else if (a === Tn) {
            if (n < 1)
              break;
            this.pos += 1, n -= 1;
          } else {
            if (En.exec(wn(a)) !== null)
              break;
            this.pos += 1;
          }
        return this.pos === r && a !== Tn || n !== 0 ? null : (e = this.subject.substr(r, this.pos - r), or(jt(e)));
      }
      return or(jt(e.substr(1, e.length - 2)));
    }, t.prototype.parseLinkLabel = function() {
      var e = this.match(E6);
      return e === null || e.length > 1001 ? 0 : e.length;
    }, t.prototype.parseOpenBracket = function(e) {
      var r = this.pos;
      this.pos += 1;
      var n = W("[", this.sourcepos(this.pos, this.pos));
      return e.appendChild(n), this.addBracket(n, r, !1), !0;
    }, t.prototype.parseBang = function(e) {
      var r = this.pos;
      if (this.pos += 1, this.peek() === Xi) {
        this.pos += 1;
        var n = W("![", this.sourcepos(this.pos - 1, this.pos));
        e.appendChild(n), this.addBracket(n, r + 1, !0);
      } else {
        var n = W("!", this.sourcepos(this.pos, this.pos));
        e.appendChild(n);
      }
      return !0;
    }, t.prototype.parseCloseBracket = function(e) {
      var r = null, n = null, a = !1;
      this.pos += 1;
      var i = this.pos, o = this.brackets;
      if (o === null)
        return e.appendChild(W("]", this.sourcepos(i, i))), !0;
      if (!o.active)
        return e.appendChild(W("]", this.sourcepos(i, i))), this.removeBracket(), !0;
      var s = o.image, l = this.pos;
      this.peek() === Yi && (this.pos++, this.spnl() && (r = this.parseLinkDestination()) !== null && this.spnl() && // make sure there's a space before the title:
      (En.test(this.subject.charAt(this.pos - 1)) && (n = this.parseLinkTitle()) || !0) && this.spnl() && this.peek() === Tn ? (this.pos += 1, a = !0) : this.pos = l);
      var u = "";
      if (!a) {
        var c = this.pos, v = this.parseLinkLabel();
        if (v > 2 ? u = this.subject.slice(c, c + v) : o.bracketAfter || (u = this.subject.slice(o.index, i)), v === 0 && (this.pos = l), u) {
          u = Gi(u);
          var f = this.refMap[u];
          f && (r = f.destination, n = f.title, a = !0);
        }
      }
      if (a) {
        var d = j(s ? "image" : "link");
        d.destination = r, d.title = n || "", d.sourcepos = [o.startpos, this.sourcepos(this.pos)];
        for (var p = o.node.next, h = void 0; p; )
          h = p.next, p.unlink(), d.appendChild(p), p = h;
        if (e.appendChild(d), this.processEmphasis(o.previousDelimiter), this.removeBracket(), o.node.unlink(), !s)
          for (o = this.brackets; o !== null; )
            o.image || (o.active = !1), o = o.previous;
        return this.options.referenceDefinition && (this.refLinkCandidateMap[e.id] = { node: e, refLabel: u }), !0;
      }
      return this.removeBracket(), this.pos = i, e.appendChild(W("]", this.sourcepos(i, i))), this.options.referenceDefinition && (this.refLinkCandidateMap[e.id] = { node: e, refLabel: u }), !0;
    }, t.prototype.addBracket = function(e, r, n) {
      this.brackets !== null && (this.brackets.bracketAfter = !0), this.brackets = {
        node: e,
        startpos: this.sourcepos(r + (n ? 0 : 1)),
        previous: this.brackets,
        previousDelimiter: this.delimiters,
        index: r,
        image: n,
        active: !0
      };
    }, t.prototype.removeBracket = function() {
      this.brackets && (this.brackets = this.brackets.previous);
    }, t.prototype.parseEntity = function(e) {
      var r, n = this.pos + 1;
      return (r = this.match(p6)) ? (e.appendChild(W(Ba.decodeHTML(r), this.sourcepos(n, this.pos))), !0) : !1;
    }, t.prototype.parseString = function(e) {
      var r, n = this.pos + 1;
      if (r = this.match(x6)) {
        if (this.options.smart) {
          var a = r.replace(g6, "…").replace(y6, function(o) {
            var s = 0, l = 0;
            return o.length % 3 === 0 ? l = o.length / 3 : o.length % 2 === 0 ? s = o.length / 2 : o.length % 3 === 2 ? (s = 1, l = (o.length - 2) / 3) : (s = 2, l = (o.length - 4) / 3), Xn("—", l) + Xn("–", s);
          });
          e.appendChild(W(a, this.sourcepos(n, this.pos)));
        } else {
          var i = W(r, this.sourcepos(n, this.pos));
          e.appendChild(i);
        }
        return !0;
      }
      return !1;
    }, t.prototype.parseNewline = function(e) {
      this.pos += 1;
      var r = e.lastChild;
      if (r && r.type === "text" && r.literal[r.literal.length - 1] === " ") {
        var n = r.literal[r.literal.length - 2] === " ", a = r.literal.length;
        r.literal = r.literal.replace(T6, "");
        var i = a - r.literal.length;
        r.sourcepos[1][1] -= i, e.appendChild(j(n ? "linebreak" : "softbreak", this.sourcepos(this.pos - i, this.pos)));
      } else
        e.appendChild(j("softbreak", this.sourcepos(this.pos, this.pos)));
      return this.nextLine(), this.match(k6), !0;
    }, t.prototype.parseReference = function(e, r) {
      if (!this.options.referenceDefinition)
        return 0;
      this.subject = e.stringContent, this.pos = 0;
      var n = null, a = this.pos, i = this.parseLinkLabel();
      if (i === 0)
        return 0;
      var o = this.subject.substr(0, i);
      if (this.peek() === v6)
        this.pos++;
      else
        return this.pos = a, 0;
      this.spnl();
      var s = this.parseLinkDestination();
      if (s === null)
        return this.pos = a, 0;
      var l = this.pos;
      this.spnl(), this.pos !== l && (n = this.parseLinkTitle()), n === null && (n = "", this.pos = l);
      var u = !0;
      if (this.match(to) === null && (n === "" ? u = !1 : (n = "", this.pos = l, u = this.match(to) !== null)), !u)
        return this.pos = a, 0;
      var c = Gi(o);
      if (c === "")
        return this.pos = a, 0;
      var v = this.getReferenceDefSourcepos(e);
      e.sourcepos[0][0] = v[1][0] + 1;
      var f = j("refDef", v);
      return f.title = n, f.dest = s, f.label = c, e.insertBefore(f), r[c] ? this.refDefCandidateMap[f.id] = f : r[c] = ea(f), this.pos - a;
    }, t.prototype.mergeTextNodes = function(e) {
      for (var r, n = []; r = e.next(); ) {
        var a = r.entering, i = r.node;
        if (a && i.type === "text")
          n.push(i);
        else if (n.length === 1)
          n = [];
        else if (n.length > 1) {
          var o = n[0], s = n[n.length - 1];
          o.sourcepos && s.sourcepos && (o.sourcepos[1] = s.sourcepos[1]), o.next = s.next, o.next && (o.next.prev = o);
          for (var l = 1; l < n.length; l += 1)
            o.literal += n[l].literal, n[l].unlink();
          n = [];
        }
      }
    }, t.prototype.getReferenceDefSourcepos = function(e) {
      for (var r = e.stringContent.split(/\n|\r\n/), n = !1, a = 0, i = { line: 0, ch: 0 }, o = 0; o < r.length; o += 1) {
        var s = r[o];
        if (En.test(s))
          break;
        if (/\:/.test(s) && a === 0) {
          if (n)
            break;
          var l = s.indexOf(":") === s.length - 1 ? o + 1 : o;
          i = { line: l, ch: r[l].length }, n = !0;
        }
        var u = s.match(/'|"/g);
        if (u && (a += u.length), a === 2) {
          i = { line: o, ch: s.length };
          break;
        }
      }
      return [
        [e.sourcepos[0][0], e.sourcepos[0][1]],
        [e.sourcepos[0][0] + i.line, i.ch]
      ];
    }, t.prototype.parseInline = function(e) {
      var r, n = !1, a = this.peek();
      if (a === -1)
        return !1;
      switch (a) {
        case Yn:
          n = this.parseNewline(e);
          break;
        case Ki:
          n = this.parseBackslash(e);
          break;
        case s6:
          n = this.parseBackticks(e);
          break;
        case Cn:
        case lr:
        case ur:
        case Ye:
          n = this.handleDelim(a, e);
          break;
        case Qe:
        case Ke:
          n = !!(!((r = this.options) === null || r === void 0) && r.smart) && this.handleDelim(a, e);
          break;
        case Xi:
          n = this.parseOpenBracket(e);
          break;
        case u6:
          n = this.parseBang(e);
          break;
        case l6:
          n = this.parseCloseBracket(e);
          break;
        case Qi:
          n = this.parseAutolink(e) || this.parseHtmlTag(e);
          break;
        case c6:
          e.disabledEntityParse || (n = this.parseEntity(e));
          break;
        default:
          n = this.parseString(e);
          break;
      }
      return n || (this.pos += 1, e.appendChild(W(wn(a), this.sourcepos(this.pos, this.pos + 1)))), !0;
    }, t.prototype.parse = function(e) {
      for (this.subject = e.stringContent.trim(), this.pos = 0, this.delimiters = null, this.brackets = null, this.lineOffsets = e.lineOffsets || [0], this.lineIdx = 0, this.linePosOffset = 0, this.lineStartNum = e.sourcepos[0][0], I9(e) && (this.lineOffsets[0] += e.level + 1); this.parseInline(e); )
        ;
      e.stringContent = null, this.processEmphasis(null), this.mergeTextNodes(e.walker());
      var r = this.options, n = r.extendedAutolinks, a = r.customParser;
      if (n && a6(e.walker(), n), a && e.firstChild)
        for (var i, o = e.firstChild.walker(); i = o.next(); ) {
          var s = i.node, l = i.entering;
          a[s.type] && a[s.type](s, { entering: l, options: this.options });
        }
    }, t;
  })()
), M6 = /^\[([ \txX])\][ \t]+/;
function A6(t, e) {
  if (e.firstChild && e.firstChild.type === "paragraph") {
    var r = e.firstChild, n = r.stringContent.match(M6);
    if (n) {
      var a = n[0].length;
      r.stringContent = r.stringContent.substring(a - 1), r.sourcepos[0][1] += a, r.lineOffsets[0] += a, e.listData.task = !0, e.listData.checked = /[xX]/.test(n[1]);
    }
  }
}
var S6 = {
  continue: function() {
    return 0;
  },
  finalize: function() {
  },
  canContain: function(t) {
    return t === "tableHead" || t === "tableBody";
  },
  acceptsLines: !1
}, O6 = {
  continue: function() {
    return 0;
  },
  finalize: function() {
  },
  canContain: function(t) {
    return t === "tableRow";
  },
  acceptsLines: !1
}, D6 = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function(t) {
    return t === "tableRow" || t === "tableDelimRow";
  },
  acceptsLines: !1
}, I6 = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function(t) {
    return t === "tableDelimCell";
  },
  acceptsLines: !1
}, N6 = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !1
}, R6 = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function(t) {
    return t === "tableCell";
  },
  acceptsLines: !1
}, B6 = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !1
}, Nr = 4, Bl = 9, Hl = 62, H6 = 60, Pl = 32, _l = 91, ql = /[^ \t\f\v\r\n]/, P6 = /^(?:`{3,}|~{3,})(?= *$)/;
function ro(t) {
  for (var e = t; e; ) {
    if (e.lastLineBlank)
      return !0;
    var r = e.type;
    if (!e.lastLineChecked && (r === "list" || r === "item"))
      e.lastLineChecked = !0, e = e.lastChild;
    else {
      e.lastLineChecked = !0;
      break;
    }
  }
  return !1;
}
function de(t, e) {
  return e < t.length ? t.charCodeAt(e) : -1;
}
function $l(t) {
  return !ql.test(t);
}
function Mt(t) {
  return t === Pl || t === Bl;
}
var _6 = /^\$\$$/, q6 = {
  continue: function(t, e) {
    var r = t.currentLine, n = r.match(_6);
    if (n)
      return t.lastLineLength = n[0].length, t.finalize(e, t.lineNumber), 2;
    for (var a = e.offset; a > 0 && Mt(de(r, t.offset)); )
      t.advanceOffset(1, !0), a--;
    return 0;
  },
  finalize: function(t, e) {
    if (e.stringContent !== null) {
      var r = e.stringContent, n = r.indexOf(`
`), a = r.slice(0, n), i = r.slice(n + 1), o = a.match(/^(\s*)(.*)/);
      e.info = jt(o[2].trim()), e.literal = i, e.stringContent = null;
    }
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !0
}, Fl = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !0
}, $6 = {
  continue: function() {
    return 0;
  },
  finalize: function() {
  },
  canContain: function(t) {
    return t !== "item";
  },
  acceptsLines: !1
}, F6 = {
  continue: function() {
    return 0;
  },
  finalize: function(t, e) {
    for (var r = e.firstChild; r; ) {
      if (ro(r) && r.next) {
        e.listData.tight = !1;
        break;
      }
      for (var n = r.firstChild; n; ) {
        if (ro(n) && (r.next || n.next)) {
          e.listData.tight = !1;
          break;
        }
        n = n.next;
      }
      r = r.next;
    }
  },
  canContain: function(t) {
    return t === "item";
  },
  acceptsLines: !1
}, U6 = {
  continue: function(t) {
    var e = t.currentLine;
    if (!t.indented && de(e, t.nextNonspace) === Hl)
      t.advanceNextNonspace(), t.advanceOffset(1, !1), Mt(de(e, t.offset)) && t.advanceOffset(1, !0);
    else
      return 1;
    return 0;
  },
  finalize: function() {
  },
  canContain: function(t) {
    return t !== "item";
  },
  acceptsLines: !1
}, V6 = {
  continue: function(t, e) {
    if (t.blank) {
      if (e.firstChild === null)
        return 1;
      t.advanceNextNonspace();
    } else if (t.indent >= e.listData.markerOffset + e.listData.padding)
      t.advanceOffset(e.listData.markerOffset + e.listData.padding, !0);
    else
      return 1;
    return 0;
  },
  finalize: A6,
  canContain: function(t) {
    return t !== "item";
  },
  acceptsLines: !1
}, j6 = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !1
}, z6 = {
  continue: function() {
    return 1;
  },
  finalize: function() {
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !1
}, W6 = {
  continue: function(t, e) {
    var r = t.currentLine, n = t.indent;
    if (e.isFenced) {
      var a = n <= 3 && r.charAt(t.nextNonspace) === e.fenceChar && r.slice(t.nextNonspace).match(P6);
      if (a && a[0].length >= e.fenceLength)
        return t.lastLineLength = t.offset + n + a[0].length, t.finalize(e, t.lineNumber), 2;
      for (var i = e.fenceOffset; i > 0 && Mt(de(r, t.offset)); )
        t.advanceOffset(1, !0), i--;
    } else if (n >= Nr)
      t.advanceOffset(Nr, !0);
    else if (t.blank)
      t.advanceNextNonspace();
    else
      return 1;
    return 0;
  },
  finalize: function(t, e) {
    var r;
    if (e.stringContent !== null) {
      if (e.isFenced) {
        var n = e.stringContent, a = n.indexOf(`
`), i = n.slice(0, a), o = n.slice(a + 1), s = i.match(/^(\s*)(.*)/);
        e.infoPadding = s[1].length, e.info = jt(s[2].trim()), e.literal = o;
      } else
        e.literal = (r = e.stringContent) === null || r === void 0 ? void 0 : r.replace(/(\n *)+$/, `
`);
      e.stringContent = null;
    }
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !0
}, G6 = {
  continue: function(t, e) {
    return t.blank && (e.htmlBlockType === 6 || e.htmlBlockType === 7) ? 1 : 0;
  },
  finalize: function(t, e) {
    var r;
    e.literal = ((r = e.stringContent) === null || r === void 0 ? void 0 : r.replace(/(\n *)+$/, "")) || null, e.stringContent = null;
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !0
}, X6 = {
  continue: function(t) {
    return t.blank ? 1 : 0;
  },
  finalize: function(t, e) {
    if (e.stringContent !== null) {
      for (var r, n = !1; de(e.stringContent, 0) === _l && (r = t.inlineParser.parseReference(e, t.refMap)); )
        e.stringContent = e.stringContent.slice(r), n = !0;
      n && $l(e.stringContent) && e.unlink();
    }
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !0
}, Q6 = Fl, K6 = Fl, gt = {
  document: $6,
  list: F6,
  blockQuote: U6,
  item: V6,
  heading: j6,
  thematicBreak: z6,
  codeBlock: W6,
  htmlBlock: G6,
  paragraph: X6,
  table: S6,
  tableBody: O6,
  tableHead: D6,
  tableRow: R6,
  tableCell: B6,
  tableDelimRow: I6,
  tableDelimCell: N6,
  refDef: Q6,
  customBlock: q6,
  frontMatter: K6
};
function Zn(t) {
  for (var e = 0, r = 0, n = [], a = 0; a < t.length; a += 1)
    if (t[a] === "|" && t[a - 1] !== "\\") {
      var i = t.substring(e, a);
      e === 0 && zi(i) ? r = a + 1 : n.push(i), e = a + 1;
    }
  if (e < t.length) {
    var i = t.substring(e, t.length);
    zi(i) || n.push(i);
  }
  return [r, n];
}
function Jn(t, e, r, n) {
  for (var a = [], i = 0, o = e; i < o.length; i++) {
    var s = o[i], l = s.match(/^[ \t]+/), u = l ? l[0].length : 0, c = void 0, v = void 0;
    if (u === s.length)
      u = 0, c = 0, v = "";
    else {
      var f = s.match(/[ \t]+$/);
      c = f ? f[0].length : 0, v = s.slice(u, s.length - c);
    }
    var d = n + u, p = j(t, [
      [r, n],
      [r, n + s.length - 1]
    ]);
    p.stringContent = v.replace(/\\\|/g, "|"), p.startIdx = a.length, p.endIdx = a.length, p.lineOffsets = [d - 1], p.paddingLeft = u, p.paddingRight = c, a.push(p), n += s.length + 1;
  }
  return a;
}
function Y6(t) {
  var e = null, r = t.stringContent, n = r[0], a = r[r.length - 1];
  return a === ":" ? e = n === ":" ? "center" : "right" : n === ":" && (e = "left"), { align: e };
}
var Z6 = function(t, e) {
  var r = e.stringContent;
  if (e.type === "paragraph" && !t.indented && !t.blank) {
    var n = r.length - 1, a = r.lastIndexOf(`
`, n - 1) + 1, i = r.slice(a, n), o = t.currentLine.slice(t.nextNonspace), s = Zn(i), l = s[0], u = s[1], c = Zn(o), v = c[0], f = c[1], d = /^[ \t]*:?-+:?[ \t]*$/;
    if (
      // not checking if the number of header cells and delimiter cells are the same
      // to consider the case of merged-column (via plugin)
      !u.length || !f.length || f.some(function(I) {
        return !d.test(I);
      }) || // to prevent to regard setTextHeading as tabel delim cell with 'disallowDeepHeading' option
      f.length === 1 && o.indexOf("|") !== 0
    )
      return 0;
    var p = e.lineOffsets, h = t.lineNumber - 1, m = Ir(p) + 1, y = j("table", [
      [h, m],
      [t.lineNumber, t.offset]
    ]);
    if (y.columns = f.map(function() {
      return { align: null };
    }), e.insertAfter(y), p.length === 1)
      e.unlink();
    else {
      e.stringContent = r.slice(0, a);
      var w = r.lastIndexOf(`
`, a - 2) + 1, C = a - w - 1;
      t.lastLineLength = p[p.length - 2] + C, t.finalize(e, h - 1);
    }
    t.advanceOffset(t.currentLine.length - t.offset, !1);
    var T = j("tableHead", [
      [h, m],
      [t.lineNumber, t.offset]
    ]);
    y.appendChild(T);
    var k = j("tableRow", [
      [h, m],
      [h, m + i.length - 1]
    ]), M = j("tableDelimRow", [
      [t.lineNumber, t.nextNonspace + 1],
      [t.lineNumber, t.offset]
    ]);
    T.appendChild(k), T.appendChild(M), Jn("tableCell", u, h, m + l).forEach(function(I) {
      k.appendChild(I);
    });
    var O = Jn("tableDelimCell", f, t.lineNumber, t.nextNonspace + 1 + v);
    return O.forEach(function(I) {
      M.appendChild(I);
    }), y.columns = O.map(Y6), t.tip = y, 2;
  }
  return 0;
}, J6 = function(t, e) {
  if (e.type !== "table" && e.type !== "tableBody" || !t.blank && t.currentLine.indexOf("|") === -1)
    return 0;
  if (t.advanceOffset(t.currentLine.length - t.offset, !1), t.blank) {
    var r = e;
    return e.type === "tableBody" && (r = e.parent, t.finalize(e, t.lineNumber - 1)), t.finalize(r, t.lineNumber - 1), 0;
  }
  var n = e;
  e.type === "table" && (n = t.addChild("tableBody", t.nextNonspace), n.stringContent = null);
  var a = j("tableRow", [
    [t.lineNumber, t.nextNonspace + 1],
    [t.lineNumber, t.currentLine.length]
  ]);
  n.appendChild(a);
  var i = n.parent, o = t.currentLine.slice(t.nextNonspace), s = Zn(o), l = s[0], u = s[1];
  return Jn("tableCell", u, t.lineNumber, t.nextNonspace + 1 + l).forEach(function(c, v) {
    v >= i.columns.length && (c.ignored = !0), a.appendChild(c);
  }), 2;
}, eX = /^(\$\$)(\s*[a-zA-Z])+/, tX = /^(\$\$)(\s*[a-zA-Z])+.*(\$\$)/, rX = function(t) {
  var e;
  if (!t.indented && !tX.test(t.currentLine) && (e = t.currentLine.match(eX))) {
    var r = e[1].length;
    t.closeUnmatchedBlocks();
    var n = t.addChild("customBlock", t.nextNonspace);
    return n.syntaxLength = r, n.offset = t.indent, t.advanceNextNonspace(), t.advanceOffset(r, !1), 2;
  }
  return 0;
}, nX = /^`{3,}(?!.*`)|^~{3,}/, aX = [
  /./,
  /^<(?:script|pre|style)(?:\s|>|$)/i,
  /^<!--/,
  /^<[?]/,
  /^<![A-Z]/,
  /^<!\[CDATA\[/,
  /^<[/]?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[123456]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|[/]?[>]|$)/i,
  new RegExp("^(?:" + Nl + "|" + Rl + ")\\s*$", "i")
], iX = /^(?:=+|-+)[ \t]*$/, oX = /^#{1,6}(?:[ \t]+|$)/, sX = /^(?:(?:\*[ \t]*){3,}|(?:_[ \t]*){3,}|(?:-[ \t]*){3,})[ \t]*$/, Ul = /^[*+-]/, Vl = /^(\d{1,9})([.)])/;
function lX(t, e) {
  var r = t.currentLine.slice(t.nextNonspace), n, a, i = {
    type: "bullet",
    tight: !0,
    bulletChar: "",
    start: 0,
    delimiter: "",
    padding: 0,
    markerOffset: t.indent,
    // GFM: Task List Item
    task: !1,
    checked: !1
  };
  if (t.indent >= 4)
    return null;
  if (n = r.match(Ul))
    i.type = "bullet", i.bulletChar = n[0][0];
  else if ((n = r.match(Vl)) && (e.type !== "paragraph" || n[1] === "1"))
    i.type = "ordered", i.start = parseInt(n[1], 10), i.delimiter = n[2];
  else
    return null;
  if (a = de(t.currentLine, t.nextNonspace + n[0].length), !(a === -1 || a === Bl || a === Pl) || e.type === "paragraph" && !t.currentLine.slice(t.nextNonspace + n[0].length).match(ql))
    return null;
  t.advanceNextNonspace(), t.advanceOffset(n[0].length, !0);
  var o = t.column, s = t.offset;
  do
    t.advanceOffset(1, !0), a = de(t.currentLine, t.offset);
  while (t.column - o < 5 && Mt(a));
  var l = de(t.currentLine, t.offset) === -1, u = t.column - o;
  return u >= 5 || u < 1 || l ? (i.padding = n[0].length + 1, t.column = o, t.offset = s, Mt(de(t.currentLine, t.offset)) && t.advanceOffset(1, !0)) : i.padding = n[0].length + u, i;
}
function uX(t, e) {
  return t.type === e.type && t.delimiter === e.delimiter && t.bulletChar === e.bulletChar;
}
function jl(t, e) {
  return t.options.disallowDeepHeading && (e.type === "blockQuote" || e.type === "item");
}
var cX = function(t) {
  return !t.indented && de(t.currentLine, t.nextNonspace) === Hl ? (t.advanceNextNonspace(), t.advanceOffset(1, !1), Mt(de(t.currentLine, t.offset)) && t.advanceOffset(1, !0), t.closeUnmatchedBlocks(), t.addChild("blockQuote", t.nextNonspace), 1) : 0;
}, vX = function(t, e) {
  var r;
  if (!t.indented && // The nested Heading is disallowed in list and blockquote with 'disallowDeepHeading' option
  !jl(t, e) && (r = t.currentLine.slice(t.nextNonspace).match(oX))) {
    t.advanceNextNonspace(), t.advanceOffset(r[0].length, !1), t.closeUnmatchedBlocks();
    var n = t.addChild("heading", t.nextNonspace);
    return n.level = r[0].trim().length, n.headingType = "atx", n.stringContent = t.currentLine.slice(t.offset).replace(/^[ \t]*#+[ \t]*$/, "").replace(/[ \t]+#+[ \t]*$/, ""), t.advanceOffset(t.currentLine.length - t.offset), 2;
  }
  return 0;
}, fX = function(t) {
  var e;
  if (!t.indented && (e = t.currentLine.slice(t.nextNonspace).match(nX))) {
    var r = e[0].length;
    t.closeUnmatchedBlocks();
    var n = t.addChild("codeBlock", t.nextNonspace);
    return n.isFenced = !0, n.fenceLength = r, n.fenceChar = e[0][0], n.fenceOffset = t.indent, t.advanceNextNonspace(), t.advanceOffset(r, !1), 2;
  }
  return 0;
}, dX = function(t, e) {
  if (!t.indented && de(t.currentLine, t.nextNonspace) === H6) {
    var r = t.currentLine.slice(t.nextNonspace), n = t.options.disallowedHtmlBlockTags, a = void 0;
    for (a = 1; a <= 7; a++) {
      var i = r.match(aX[a]);
      if (i) {
        if (a === 7) {
          if (e.type === "paragraph")
            return 0;
          if (n.length > 0) {
            var o = new RegExp("</?(?:" + n.join("|") + ")", "i");
            if (o.test(i[0]))
              return 0;
          }
        }
        t.closeUnmatchedBlocks();
        var s = t.addChild("htmlBlock", t.offset);
        return s.htmlBlockType = a, 2;
      }
    }
  }
  return 0;
}, pX = function(t, e) {
  var r;
  if (e.stringContent !== null && !t.indented && e.type === "paragraph" && // The nested Heading is disallowed in list and blockquote with 'disallowDeepHeading' option
  !jl(t, e.parent) && (r = t.currentLine.slice(t.nextNonspace).match(iX))) {
    t.closeUnmatchedBlocks();
    for (var n = void 0; de(e.stringContent, 0) === _l && (n = t.inlineParser.parseReference(e, t.refMap)); )
      e.stringContent = e.stringContent.slice(n);
    if (e.stringContent.length > 0) {
      var a = j("heading", e.sourcepos);
      return a.level = r[0][0] === "=" ? 1 : 2, a.headingType = "setext", a.stringContent = e.stringContent, e.insertAfter(a), e.unlink(), t.tip = a, t.advanceOffset(t.currentLine.length - t.offset, !1), 2;
    }
    return 0;
  }
  return 0;
}, hX = function(t) {
  return !t.indented && sX.test(t.currentLine.slice(t.nextNonspace)) ? (t.closeUnmatchedBlocks(), t.addChild("thematicBreak", t.nextNonspace), t.advanceOffset(t.currentLine.length - t.offset, !1), 2) : 0;
}, mX = function(t, e) {
  var r, n = e;
  return (!t.indented || e.type === "list") && (r = lX(t, n)) ? (t.closeUnmatchedBlocks(), (t.tip.type !== "list" || !uX(n.listData, r)) && (n = t.addChild("list", t.nextNonspace), n.listData = r), n = t.addChild("item", t.nextNonspace), n.listData = r, 1) : 0;
}, gX = function(t) {
  return t.indented && t.tip.type !== "paragraph" && !t.blank ? (t.advanceOffset(Nr, !0), t.closeUnmatchedBlocks(), t.addChild("codeBlock", t.offset), 2) : 0;
}, xn = [
  cX,
  vX,
  fX,
  dX,
  pX,
  hX,
  mX,
  gX,
  Z6,
  J6,
  rX
], zl = /^(-{3}|\+{3}|;{3})$/, yX = function(t, e) {
  var r = t.currentLine, n = t.lineNumber, a = t.indented;
  if (n === 1 && !a && e.type === "document" && zl.test(r)) {
    t.closeUnmatchedBlocks();
    var i = t.addChild("frontMatter", t.nextNonspace);
    return i.stringContent = r, t.advanceNextNonspace(), t.advanceOffset(r.length, !1), 2;
  }
  return 0;
}, bX = {
  continue: function(t, e) {
    var r = t.currentLine, n = r.match(zl);
    return e.type === "frontMatter" && n ? (e.stringContent += r, t.lastLineLength = n[0].length, t.finalize(e, t.lineNumber), 2) : 0;
  },
  finalize: function(t, e) {
    e.stringContent !== null && (e.literal = e.stringContent, e.stringContent = null);
  },
  canContain: function() {
    return !1;
  },
  acceptsLines: !0
}, wX = [
  /./,
  /<\/(?:script|pre|style)>/i,
  /-->/,
  /\?>/,
  />/,
  /\]\]>/
], CX = /^[#`~*+_=<>0-9-;$]/, TX = /\r\n|\n|\r/;
function Ln() {
  return j("document", [
    [1, 1],
    [0, 0]
  ]);
}
var kX = {
  smart: !1,
  tagFilter: !1,
  extendedAutolinks: !1,
  disallowedHtmlBlockTags: [],
  referenceDefinition: !1,
  disallowDeepHeading: !1,
  customParser: null,
  frontMatter: !1
}, EX = (
  /** @class */
  (function() {
    function t(e) {
      this.options = J(J({}, kX), e), this.doc = Ln(), this.tip = this.doc, this.oldtip = this.doc, this.lineNumber = 0, this.offset = 0, this.column = 0, this.nextNonspace = 0, this.nextNonspaceColumn = 0, this.indent = 0, this.currentLine = "", this.indented = !1, this.blank = !1, this.partiallyConsumedTab = !1, this.allClosed = !0, this.lastMatchedContainer = this.doc, this.refMap = {}, this.refLinkCandidateMap = {}, this.refDefCandidateMap = {}, this.lastLineLength = 0, this.lines = [], this.options.frontMatter && (gt.frontMatter = bX, xn.unshift(yX)), this.inlineParser = new L6(this.options);
    }
    return t.prototype.advanceOffset = function(e, r) {
      r === void 0 && (r = !1);
      for (var n = this.currentLine, a, i, o; e > 0 && (o = n[this.offset]); )
        o === "	" ? (a = 4 - this.column % 4, r ? (this.partiallyConsumedTab = a > e, i = a > e ? e : a, this.column += i, this.offset += this.partiallyConsumedTab ? 0 : 1, e -= i) : (this.partiallyConsumedTab = !1, this.column += a, this.offset += 1, e -= 1)) : (this.partiallyConsumedTab = !1, this.offset += 1, this.column += 1, e -= 1);
    }, t.prototype.advanceNextNonspace = function() {
      this.offset = this.nextNonspace, this.column = this.nextNonspaceColumn, this.partiallyConsumedTab = !1;
    }, t.prototype.findNextNonspace = function() {
      for (var e = this.currentLine, r = this.offset, n = this.column, a; (a = e.charAt(r)) !== ""; )
        if (a === " ")
          r++, n++;
        else if (a === "	")
          r++, n += 4 - n % 4;
        else
          break;
      this.blank = a === `
` || a === "\r" || a === "", this.nextNonspace = r, this.nextNonspaceColumn = n, this.indent = this.nextNonspaceColumn - this.column, this.indented = this.indent >= Nr;
    }, t.prototype.addLine = function() {
      if (this.partiallyConsumedTab) {
        this.offset += 1;
        var e = 4 - this.column % 4;
        this.tip.stringContent += Xn(" ", e);
      }
      this.tip.lineOffsets ? this.tip.lineOffsets.push(this.offset) : this.tip.lineOffsets = [this.offset], this.tip.stringContent += this.currentLine.slice(this.offset) + `
`;
    }, t.prototype.addChild = function(e, r) {
      for (; !gt[this.tip.type].canContain(e); )
        this.finalize(this.tip, this.lineNumber - 1);
      var n = r + 1, a = j(e, [
        [this.lineNumber, n],
        [0, 0]
      ]);
      return a.stringContent = "", this.tip.appendChild(a), this.tip = a, a;
    }, t.prototype.closeUnmatchedBlocks = function() {
      if (!this.allClosed) {
        for (; this.oldtip !== this.lastMatchedContainer; ) {
          var e = this.oldtip.parent;
          this.finalize(this.oldtip, this.lineNumber - 1), this.oldtip = e;
        }
        this.allClosed = !0;
      }
    }, t.prototype.finalize = function(e, r) {
      var n = e.parent;
      e.open = !1, e.sourcepos[1] = [r, this.lastLineLength], gt[e.type].finalize(this, e), this.tip = n;
    }, t.prototype.processInlines = function(e) {
      var r, n = this.options.customParser, a = e.walker();
      for (this.inlineParser.refMap = this.refMap, this.inlineParser.refLinkCandidateMap = this.refLinkCandidateMap, this.inlineParser.refDefCandidateMap = this.refDefCandidateMap, this.inlineParser.options = this.options; r = a.next(); ) {
        var i = r.node, o = r.entering, s = i.type;
        n && n[s] && n[s](i, { entering: o, options: this.options }), !o && (s === "paragraph" || s === "heading" || s === "tableCell" && !i.ignored) && this.inlineParser.parse(i);
      }
    }, t.prototype.incorporateLine = function(e) {
      var r = this.doc;
      this.oldtip = this.tip, this.offset = 0, this.column = 0, this.blank = !1, this.partiallyConsumedTab = !1, this.lineNumber += 1, e.indexOf("\0") !== -1 && (e = e.replace(/\0/g, "�")), this.currentLine = e;
      for (var n = !0, a; (a = r.lastChild) && a.open; ) {
        switch (r = a, this.findNextNonspace(), gt[r.type].continue(this, r)) {
          case 0:
            break;
          case 1:
            n = !1;
            break;
          case 2:
            this.lastLineLength = e.length;
            return;
          default:
            throw new Error("continue returned illegal value, must be 0, 1, or 2");
        }
        if (!n) {
          r = r.parent;
          break;
        }
      }
      this.allClosed = r === this.oldtip, this.lastMatchedContainer = r;
      for (var i = r.type !== "paragraph" && gt[r.type].acceptsLines, o = xn.length; !i; ) {
        if (this.findNextNonspace(), r.type !== "table" && r.type !== "tableBody" && r.type !== "paragraph" && !this.indented && !CX.test(e.slice(this.nextNonspace))) {
          this.advanceNextNonspace();
          break;
        }
        for (var s = 0; s < o; ) {
          var l = xn[s](this, r);
          if (l === 1) {
            r = this.tip;
            break;
          } else if (l === 2) {
            r = this.tip, i = !0;
            break;
          } else
            s++;
        }
        if (s === o) {
          this.advanceNextNonspace();
          break;
        }
      }
      if (!this.allClosed && !this.blank && this.tip.type === "paragraph")
        this.addLine();
      else {
        this.closeUnmatchedBlocks(), this.blank && r.lastChild && (r.lastChild.lastLineBlank = !0);
        for (var u = r.type, c = this.blank && !(u === "blockQuote" || Ol(r) && r.isFenced || u === "item" && !r.firstChild && r.sourcepos[0][0] === this.lineNumber), v = r; v; )
          v.lastLineBlank = c, v = v.parent;
        gt[u].acceptsLines ? (this.addLine(), D9(r) && r.htmlBlockType >= 1 && r.htmlBlockType <= 5 && wX[r.htmlBlockType].test(this.currentLine.slice(this.offset)) && (this.lastLineLength = e.length, this.finalize(r, this.lineNumber))) : this.offset < e.length && !this.blank && (r = this.addChild("paragraph", this.offset), this.advanceNextNonspace(), this.addLine());
      }
      this.lastLineLength = e.length;
    }, t.prototype.parse = function(e, r) {
      this.doc = Ln(), this.tip = this.doc, this.lineNumber = 0, this.lastLineLength = 0, this.offset = 0, this.column = 0, this.lastMatchedContainer = this.doc, this.currentLine = "";
      var n = e.split(TX), a = n.length;
      this.lines = r || n, this.options.referenceDefinition && this.clearRefMaps(), e.charCodeAt(e.length - 1) === Yn && (a -= 1);
      for (var i = 0; i < a; i++)
        this.incorporateLine(n[i]);
      for (; this.tip; )
        this.finalize(this.tip, a);
      return this.processInlines(this.doc), this.doc;
    }, t.prototype.partialParseStart = function(e, r) {
      this.doc = Ln(), this.tip = this.doc, this.lineNumber = e - 1, this.lastLineLength = 0, this.offset = 0, this.column = 0, this.lastMatchedContainer = this.doc, this.currentLine = "";
      for (var n = r.length, a = 0; a < n; a++)
        this.incorporateLine(r[a]);
      return this.doc;
    }, t.prototype.partialParseExtends = function(e) {
      for (var r = 0; r < e.length; r++)
        this.incorporateLine(e[r]);
    }, t.prototype.partialParseFinish = function() {
      for (; this.tip; )
        this.finalize(this.tip, this.lineNumber);
      this.processInlines(this.doc);
    }, t.prototype.setRefMaps = function(e, r, n) {
      this.refMap = e, this.refLinkCandidateMap = r, this.refDefCandidateMap = n;
    }, t.prototype.clearRefMaps = function() {
      [this.refMap, this.refLinkCandidateMap, this.refDefCandidateMap].forEach(function(e) {
        o6(e);
      });
    }, t;
  })()
);
function no(t, e) {
  return t[0] < e[0] ? 1 : t[0] > e[0] ? -1 : t[1] < e[1] ? 1 : t[1] > e[1] ? -1 : 0;
}
function xX(t, e) {
  var r = t[0], n = t[1];
  return no(n, e) === 1 ? 1 : no(r, e) === -1 ? -1 : 0;
}
function LX(t, e) {
  if (!(t.parent !== e.parent || t === e)) {
    for (var r = t.next; r && r !== e; ) {
      for (var n = r.next, a = 0, i = ["parent", "prev", "next"]; a < i.length; a++) {
        var o = i[a];
        r[o] && (Qn(r[o].id), r[o] = null);
      }
      r = n;
    }
    t.next = e.next, e.next ? e.next.prev = t : t.parent.lastChild = t;
  }
}
function MX(t) {
  for (var e = [], r = t.firstChild; r; )
    e.push(r), r = r.next;
  return e;
}
function ao(t, e) {
  for (var r = 0, n = e; r < n.length; r++) {
    var a = n[r];
    t.insertBefore(a);
  }
}
function AX(t, e) {
  for (var r = e.length - 1; r >= 0; r -= 1)
    t.prependChild(e[r]);
}
function SX(t, e) {
  if (!(!t || !t.parent || e === 0)) {
    var r = t.parent.walker();
    r.resumeAt(t, !0);
    for (var n; n = r.next(); ) {
      var a = n.node, i = n.entering;
      i && (a.sourcepos[0][0] += e, a.sourcepos[1][0] += e);
    }
  }
}
function Wl(t, e) {
  var r = t[0], n = t[1];
  return n[0] < e ? 1 : r[0] > e ? -1 : 0;
}
function cr(t, e) {
  for (var r = t.firstChild; r; ) {
    var n = Wl(r.sourcepos, e);
    if (n === 0)
      return r;
    if (n === -1)
      return r.prev || r;
    r = r.next;
  }
  return t.lastChild;
}
function OX(t) {
  for (; t.lastChild; )
    t = t.lastChild;
  return t;
}
function DX(t) {
  for (; t.parent && t.parent.type !== "document" && t.parent.sourcepos[0][0] === t.sourcepos[0][0]; )
    t = t.parent;
  return t;
}
function IX(t, e) {
  for (var r = t.firstChild, n = null; r; ) {
    var a = Wl(r.sourcepos, e);
    if (a === 0) {
      if (r.sourcepos[0][0] === e || !r.firstChild)
        return r;
      n = r, r = r.firstChild;
    } else {
      if (a === -1)
        break;
      n = r, r = r.next;
    }
  }
  return n ? DX(OX(n)) : null;
}
function NX(t, e) {
  for (var r = t, n = null; r; ) {
    var a = xX(r.sourcepos, e);
    if (a === 0)
      if (r.firstChild)
        n = r, r = r.firstChild;
      else
        return r;
    else {
      if (a === -1)
        return n;
      if (r.next)
        r = r.next;
      else
        return n;
    }
  }
  return r;
}
function Gl(t) {
  return y9(t) || null;
}
function Mn(t, e, r) {
  if (r === void 0 && (r = null), e)
    for (var n = e.walker(); e && e !== r; ) {
      t(e);
      var a = n.next();
      if (a)
        e = a.node;
      else
        break;
    }
}
function RX(t) {
  var e = Gl(t);
  if (!e)
    return !0;
  for (; e && e.type !== "document"; ) {
    if (!e.parent && !e.prev && !e.next)
      return !0;
    e = e.parent;
  }
  return !1;
}
var io = /\r\n|\n|\r/;
function BX(t) {
  var e = t.match(/^[ \t]+/);
  if (e && (e[0].length >= 2 || /\t/.test(e[0])))
    return !0;
  var r = e ? t.slice(e.length) : t;
  return Ul.test(r) || Vl.test(r);
}
function HX(t) {
  return !$l(t) && t.indexOf("|") !== -1;
}
function ea(t) {
  var e = t.id, r = t.title, n = t.sourcepos, a = t.dest;
  return {
    id: e,
    title: r,
    sourcepos: n,
    unlinked: !1,
    destination: a
  };
}
var Xl = (
  /** @class */
  (function() {
    function t(e, r) {
      this.refMap = {}, this.refLinkCandidateMap = {}, this.refDefCandidateMap = {}, this.referenceDefinition = !!r?.referenceDefinition, this.parser = new EX(r), this.parser.setRefMaps(this.refMap, this.refLinkCandidateMap, this.refDefCandidateMap), this.eventHandlerMap = { change: [] }, e = e || "", this.lineTexts = e.split(io), this.root = this.parser.parse(e, this.lineTexts);
    }
    return t.prototype.updateLineTexts = function(e, r, n) {
      var a, i = e[0], o = e[1], s = r[0], l = r[1], u = n.split(io), c = u.length, v = this.lineTexts[i - 1], f = this.lineTexts[s - 1];
      u[0] = v.slice(0, o - 1) + u[0], u[c - 1] = u[c - 1] + f.slice(l - 1);
      var d = s - i + 1;
      return (a = this.lineTexts).splice.apply(a, Wn([i - 1, d], u)), c - d;
    }, t.prototype.updateRootNodeState = function() {
      if (this.lineTexts.length === 1 && this.lineTexts[0] === "") {
        this.root.lastLineBlank = !0, this.root.sourcepos = [
          [1, 1],
          [1, 0]
        ];
        return;
      }
      this.root.lastChild && (this.root.lastLineBlank = this.root.lastChild.lastLineBlank);
      for (var e = this.lineTexts, r = e.length - 1; e[r] === ""; )
        r -= 1;
      e.length - 2 > r && (r += 1), this.root.sourcepos[1] = [r + 1, e[r].length];
    }, t.prototype.replaceRangeNodes = function(e, r, n) {
      e ? (ao(e, n), LX(e, r), [e.id, r.id].forEach(function(a) {
        return Qn(a);
      }), e.unlink()) : r ? (ao(r, n), Qn(r.id), r.unlink()) : AX(this.root, n);
    }, t.prototype.getNodeRange = function(e, r) {
      var n = cr(this.root, e[0]), a = cr(this.root, r[0]);
      return a && a.next && r[0] + 1 === a.next.sourcepos[0][0] && (a = a.next), [n, a];
    }, t.prototype.trigger = function(e, r) {
      this.eventHandlerMap[e].forEach(function(n) {
        n(r);
      });
    }, t.prototype.extendEndLine = function(e) {
      for (; this.lineTexts[e] === ""; )
        e += 1;
      return e;
    }, t.prototype.parseRange = function(e, r, n, a) {
      e && e.prev && (Wi(e.prev) && BX(this.lineTexts[n - 1]) || N9(e.prev) && HX(this.lineTexts[n - 1])) && (e = e.prev, n = e.sourcepos[0][0]);
      for (var i = this.lineTexts.slice(n - 1, a), o = this.parser.partialParseStart(n, i), s = r ? r.next : this.root.firstChild, l = o.lastChild, u = l && Ol(l) && l.open, c = l && Dl(l) && l.open, v = l && Wi(l); (u || c) && s || v && s && (s.type === "list" || s.sourcepos[0][1] >= 2); ) {
        var f = this.extendEndLine(s.sourcepos[1][0]);
        this.parser.partialParseExtends(this.lineTexts.slice(a, f)), e || (e = r), r = s, a = f, s = s.next;
      }
      this.parser.partialParseFinish();
      var d = MX(o);
      return { newNodes: d, extStartNode: e, extEndNode: r };
    }, t.prototype.getRemovedNodeRange = function(e, r) {
      return !e || e && ht(e) || r && ht(r) ? null : {
        id: [e.id, r.id],
        line: [e.sourcepos[0][0] - 1, r.sourcepos[1][0] - 1]
      };
    }, t.prototype.markDeletedRefMap = function(e, r) {
      var n = this;
      if (!mt(this.refMap)) {
        var a = function(i) {
          if (ht(i)) {
            var o = n.refMap[i.label];
            o && i.id === o.id && (o.unlinked = !0);
          }
        };
        e && Mn(a, e.parent, r), r && Mn(a, r);
      }
    }, t.prototype.replaceWithNewRefDefState = function(e) {
      var r = this;
      if (!mt(this.refMap)) {
        var n = function(a) {
          if (ht(a)) {
            var i = a.label, o = r.refMap[i];
            (!o || o.unlinked) && (r.refMap[i] = ea(a));
          }
        };
        e.forEach(function(a) {
          Mn(n, a);
        });
      }
    }, t.prototype.replaceWithRefDefCandidate = function() {
      var e = this;
      mt(this.refDefCandidateMap) || sr(this.refDefCandidateMap, function(r, n) {
        var a = n.label, i = n.sourcepos, o = e.refMap[a];
        (!o || o.unlinked || o.sourcepos[0][0] > i[0][0]) && (e.refMap[a] = ea(n));
      });
    }, t.prototype.getRangeWithRefDef = function(e, r, n, a, i) {
      if (this.referenceDefinition && !mt(this.refMap)) {
        var o = cr(this.root, e - 1), s = cr(this.root, r + 1);
        o && ht(o) && o !== n && o !== a && (n = o, e = n.sourcepos[0][0]), s && ht(s) && s !== n && s !== a && (a = s, r = this.extendEndLine(a.sourcepos[1][0] + i));
      }
      return [n, a, e, r];
    }, t.prototype.parse = function(e, r, n) {
      n === void 0 && (n = 0);
      var a = this.getNodeRange(e, r), i = a[0], o = a[1], s = i ? Math.min(i.sourcepos[0][0], e[0]) : e[0], l = this.extendEndLine((o ? Math.max(o.sourcepos[1][0], r[0]) : r[0]) + n), u = this.parseRange.apply(this, this.getRangeWithRefDef(s, l, i, o, n)), c = u.newNodes, v = u.extStartNode, f = u.extEndNode, d = this.getRemovedNodeRange(v, f), p = f ? f.next : this.root.firstChild;
      return this.referenceDefinition ? (this.markDeletedRefMap(v, f), this.replaceRangeNodes(v, f, c), this.replaceWithNewRefDefState(c)) : this.replaceRangeNodes(v, f, c), { nodes: c, removedNodeRange: d, nextNode: p };
    }, t.prototype.parseRefLink = function() {
      var e = this, r = [];
      return mt(this.refMap) || sr(this.refMap, function(n, a) {
        a.unlinked && delete e.refMap[n], sr(e.refLinkCandidateMap, function(i, o) {
          var s = o.node, l = o.refLabel;
          l === n && r.push(e.parse(s.sourcepos[0], s.sourcepos[1]));
        });
      }), r;
    }, t.prototype.removeUnlinkedCandidate = function() {
      mt(this.refDefCandidateMap) || [this.refLinkCandidateMap, this.refDefCandidateMap].forEach(function(e) {
        sr(e, function(r) {
          RX(r) && delete e[r];
        });
      });
    }, t.prototype.editMarkdown = function(e, r, n) {
      var a = this.updateLineTexts(e, r, n), i = this.parse(e, r, a), o = i6(i, "nextNode");
      SX(i.nextNode, a), this.updateRootNodeState();
      var s = [o];
      return this.referenceDefinition && (this.removeUnlinkedCandidate(), this.replaceWithRefDefCandidate(), s = s.concat(this.parseRefLink())), this.trigger("change", s), s;
    }, t.prototype.getLineTexts = function() {
      return this.lineTexts;
    }, t.prototype.getRootNode = function() {
      return this.root;
    }, t.prototype.findNodeAtPosition = function(e) {
      var r = NX(this.root, e);
      return !r || r === this.root ? null : r;
    }, t.prototype.findFirstNodeAtLine = function(e) {
      return IX(this.root, e);
    }, t.prototype.on = function(e, r) {
      this.eventHandlerMap[e].push(r);
    }, t.prototype.off = function(e, r) {
      var n = this.eventHandlerMap[e], a = n.indexOf(r);
      n.splice(a, 1);
    }, t.prototype.findNodeById = function(e) {
      return Gl(e);
    }, t.prototype.removeAllNode = function() {
      b9();
    }, t;
  })()
), PX = [
  "title",
  "textarea",
  "style",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "script",
  "plaintext"
], oo = new RegExp("<(/?(?:" + PX.join("|") + ")[^>]*>)", "ig");
function so(t) {
  return oo.test(t) ? t.replace(oo, function(e, r) {
    return "&lt;" + r;
  }) : t;
}
var lo = {
  heading: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "h" + t.level,
      outerNewLine: !0
    };
  },
  text: function(t) {
    return {
      type: "text",
      content: t.literal
    };
  },
  softbreak: function(t, e) {
    var r = e.options;
    return {
      type: "html",
      content: r.softbreak
    };
  },
  linebreak: function() {
    return {
      type: "html",
      content: `<br />
`
    };
  },
  emph: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "em"
    };
  },
  strong: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "strong"
    };
  },
  paragraph: function(t, e) {
    var r, n = e.entering, a = (r = t.parent) === null || r === void 0 ? void 0 : r.parent;
    return a && a.type === "list" && a.listData.tight ? null : {
      type: n ? "openTag" : "closeTag",
      tagName: "p",
      outerNewLine: !0
    };
  },
  thematicBreak: function() {
    return {
      type: "openTag",
      tagName: "hr",
      outerNewLine: !0,
      selfClose: !0
    };
  },
  blockQuote: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "blockquote",
      outerNewLine: !0,
      innerNewLine: !0
    };
  },
  list: function(t, e) {
    var r = e.entering, n = t.listData, a = n.type, i = n.start, o = a === "bullet" ? "ul" : "ol", s = {};
    return o === "ol" && i !== null && i !== 1 && (s.start = i.toString()), {
      type: r ? "openTag" : "closeTag",
      tagName: o,
      attributes: s,
      outerNewLine: !0
    };
  },
  item: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "li",
      outerNewLine: !0
    };
  },
  htmlInline: function(t, e) {
    var r = e.options, n = r.tagFilter ? so(t.literal) : t.literal;
    return { type: "html", content: n };
  },
  htmlBlock: function(t, e) {
    var r = e.options, n = r.tagFilter ? so(t.literal) : t.literal;
    return r.nodeId ? [
      { type: "openTag", tagName: "div", outerNewLine: !0 },
      { type: "html", content: n },
      { type: "closeTag", tagName: "div", outerNewLine: !0 }
    ] : { type: "html", content: n, outerNewLine: !0 };
  },
  code: function(t) {
    return [
      { type: "openTag", tagName: "code" },
      { type: "text", content: t.literal },
      { type: "closeTag", tagName: "code" }
    ];
  },
  codeBlock: function(t) {
    var e = t.info, r = e ? e.split(/\s+/) : [], n = [];
    return r.length > 0 && r[0].length > 0 && n.push("language-" + yt(r[0])), [
      { type: "openTag", tagName: "pre", outerNewLine: !0 },
      { type: "openTag", tagName: "code", classNames: n },
      { type: "text", content: t.literal },
      { type: "closeTag", tagName: "code" },
      { type: "closeTag", tagName: "pre", outerNewLine: !0 }
    ];
  },
  link: function(t, e) {
    var r = e.entering;
    if (r) {
      var n = t, a = n.title, i = n.destination;
      return {
        type: "openTag",
        tagName: "a",
        attributes: J({ href: yt(i) }, a && { title: yt(a) })
      };
    }
    return { type: "closeTag", tagName: "a" };
  },
  image: function(t, e) {
    var r = e.getChildrenText, n = e.skipChildren, a = t, i = a.title, o = a.destination;
    return n(), {
      type: "openTag",
      tagName: "img",
      selfClose: !0,
      attributes: J({ src: yt(o), alt: r(t) }, i && { title: yt(i) })
    };
  },
  customBlock: function(t, e, r) {
    var n = t.info.trim().toLowerCase(), a = r[n];
    if (a)
      try {
        return a(t, e);
      } catch (i) {
        console.warn("[@toast-ui/editor] - The error occurred when " + n + " block node was parsed in markdown renderer: " + i);
      }
    return [
      { type: "openTag", tagName: "div", outerNewLine: !0 },
      { type: "text", content: t.literal },
      { type: "closeTag", tagName: "div", outerNewLine: !0 }
    ];
  },
  frontMatter: function(t) {
    return [
      {
        type: "openTag",
        tagName: "div",
        outerNewLine: !0,
        // Because front matter is metadata, it should not be render.
        attributes: { style: "white-space: pre; display: none;" }
      },
      { type: "text", content: t.literal },
      { type: "closeTag", tagName: "div", outerNewLine: !0 }
    ];
  },
  customInline: function(t, e, r) {
    var n = t, a = n.info, i = n.firstChild, o = a.trim().toLowerCase(), s = r[o], l = e.entering;
    if (s)
      try {
        return s(t, e);
      } catch (u) {
        console.warn("[@toast-ui/editor] - The error occurred when " + o + " inline node was parsed in markdown renderer: " + u);
      }
    return l ? [
      { type: "openTag", tagName: "span" },
      { type: "text", content: "$$" + a + (i ? " " : "") }
    ] : [
      { type: "text", content: "$$" },
      { type: "closeTag", tagName: "span" }
    ];
  }
}, uo = {
  strike: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "del"
    };
  },
  item: function(t, e) {
    var r = e.entering, n = t.listData, a = n.checked, i = n.task;
    if (r) {
      var o = {
        type: "openTag",
        tagName: "li",
        outerNewLine: !0
      };
      return i ? [
        o,
        {
          type: "openTag",
          tagName: "input",
          selfClose: !0,
          attributes: J(J({}, a && { checked: "" }), { disabled: "", type: "checkbox" })
        },
        {
          type: "text",
          content: " "
        }
      ] : o;
    }
    return {
      type: "closeTag",
      tagName: "li",
      outerNewLine: !0
    };
  },
  table: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "table",
      outerNewLine: !0
    };
  },
  tableHead: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "thead",
      outerNewLine: !0
    };
  },
  tableBody: function(t, e) {
    var r = e.entering;
    return {
      type: r ? "openTag" : "closeTag",
      tagName: "tbody",
      outerNewLine: !0
    };
  },
  tableRow: function(t, e) {
    var r = e.entering;
    if (r)
      return {
        type: "openTag",
        tagName: "tr",
        outerNewLine: !0
      };
    var n = [];
    if (t.lastChild)
      for (var a = t.parent.parent.columns.length, i = t.lastChild.endIdx, o = i + 1; o < a; o += 1)
        n.push({
          type: "openTag",
          tagName: "td",
          outerNewLine: !0
        }, {
          type: "closeTag",
          tagName: "td",
          outerNewLine: !0
        });
    return n.push({
      type: "closeTag",
      tagName: "tr",
      outerNewLine: !0
    }), n;
  },
  tableCell: function(t, e) {
    var r = e.entering;
    if (t.ignored)
      return {
        type: "text",
        content: ""
      };
    var n = t.parent.parent, a = n.type === "tableHead" ? "th" : "td", i = n.parent, o = i.columns[t.startIdx], s = o?.align ? { align: o.align } : null;
    return r ? J({ type: "openTag", tagName: a, outerNewLine: !0 }, s && { attributes: s }) : {
      type: "closeTag",
      tagName: a,
      outerNewLine: !0
    };
  }
}, _X = {
  softbreak: `
`,
  gfm: !1,
  tagFilter: !1,
  nodeId: !1
};
function qX(t) {
  for (var e = [], r = t.walker(), n = null; n = r.next(); ) {
    var a = n.node;
    a.type === "text" && e.push(a.literal);
  }
  return e.join("");
}
var $a = (
  /** @class */
  (function() {
    function t(e) {
      this.buffer = [], this.options = J(J({}, _X), e), this.convertors = this.createConvertors(), delete this.options.convertors;
    }
    return t.prototype.createConvertors = function() {
      var e = J({}, lo);
      if (this.options.gfm && (e = J(J({}, e), uo)), this.options.convertors) {
        var r = this.options.convertors, n = Object.keys(r), a = J(J({}, lo), uo);
        n.forEach(function(i) {
          var o = e[i], s = r[i], l = Object.keys(a).indexOf(i) === -1 ? i.toLowerCase() : i;
          o ? e[l] = function(u, c, v) {
            return c.origin = function() {
              return o(u, c, v);
            }, s(u, c);
          } : e[l] = s;
        });
      }
      return e;
    }, t.prototype.getConvertors = function() {
      return this.convertors;
    }, t.prototype.getOptions = function() {
      return this.options;
    }, t.prototype.render = function(e) {
      var r = this;
      this.buffer = [];
      for (var n = e.walker(), a = null, i = function() {
        var s = a.node, l = a.entering, u = o.convertors[s.type];
        if (!u)
          return "continue";
        var c = !1, v = {
          entering: l,
          leaf: !qa(s),
          options: o.options,
          getChildrenText: qX,
          skipChildren: function() {
            c = !0;
          }
        }, f = Dl(s) || R9(s) ? u(s, v, o.convertors) : u(s, v);
        if (f) {
          var d = Array.isArray(f) ? f : [f];
          d.forEach(function(p, h) {
            p.type === "openTag" && r.options.nodeId && h === 0 && (p.attributes || (p.attributes = {}), p.attributes["data-nodeid"] = String(s.id)), r.renderHTMLNode(p);
          }), c && (n.resumeAt(s, !1), n.next());
        }
      }, o = this; a = n.next(); )
        i();
      return this.addNewLine(), this.buffer.join("");
    }, t.prototype.renderHTMLNode = function(e) {
      switch (e.type) {
        case "openTag":
        case "closeTag":
          this.renderElementNode(e);
          break;
        case "text":
          this.renderTextNode(e);
          break;
        case "html":
          this.renderRawHtmlNode(e);
          break;
      }
    }, t.prototype.generateOpenTagString = function(e) {
      var r = this, n = e.tagName, a = e.classNames, i = e.attributes;
      this.buffer.push("<" + n), a && a.length > 0 && this.buffer.push(' class="' + a.join(" ") + '"'), i && Object.keys(i).forEach(function(o) {
        var s = i[o];
        r.buffer.push(" " + o + '="' + s + '"');
      }), e.selfClose && this.buffer.push(" /"), this.buffer.push(">");
    }, t.prototype.generateCloseTagString = function(e) {
      var r = e.tagName;
      this.buffer.push("</" + r + ">");
    }, t.prototype.addNewLine = function() {
      this.buffer.length && Ir(Ir(this.buffer)) !== `
` && this.buffer.push(`
`);
    }, t.prototype.addOuterNewLine = function(e) {
      e.outerNewLine && this.addNewLine();
    }, t.prototype.addInnerNewLine = function(e) {
      e.innerNewLine && this.addNewLine();
    }, t.prototype.renderTextNode = function(e) {
      this.buffer.push(yt(e.content));
    }, t.prototype.renderRawHtmlNode = function(e) {
      this.addOuterNewLine(e), this.buffer.push(e.content), this.addOuterNewLine(e);
    }, t.prototype.renderElementNode = function(e) {
      e.type === "openTag" ? (this.addOuterNewLine(e), this.generateOpenTagString(e), e.selfClose ? this.addOuterNewLine(e) : this.addInnerNewLine(e)) : (this.addInnerNewLine(e), this.generateCloseTagString(e), this.addOuterNewLine(e));
    }, t;
  })()
);
/*! @license DOMPurify 2.3.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.3/LICENSE */
function $X(t) {
  if (Array.isArray(t)) {
    for (var e = 0, r = Array(t.length); e < t.length; e++)
      r[e] = t[e];
    return r;
  } else
    return Array.from(t);
}
var FX = Object.hasOwnProperty, co = Object.setPrototypeOf, UX = Object.isFrozen, VX = Object.getPrototypeOf, jX = Object.getOwnPropertyDescriptor, ue = Object.freeze, $e = Object.seal, zX = Object.create, Ql = typeof Reflect < "u" && Reflect, Rr = Ql.apply, ta = Ql.construct;
Rr || (Rr = function(e, r, n) {
  return e.apply(r, n);
});
ue || (ue = function(e) {
  return e;
});
$e || ($e = function(e) {
  return e;
});
ta || (ta = function(e, r) {
  return new (Function.prototype.bind.apply(e, [null].concat($X(r))))();
});
var WX = ke(Array.prototype.forEach), vo = ke(Array.prototype.pop), Pt = ke(Array.prototype.push), gr = ke(String.prototype.toLowerCase), fo = ke(String.prototype.match), je = ke(String.prototype.replace), GX = ke(String.prototype.indexOf), XX = ke(String.prototype.trim), Be = ke(RegExp.prototype.test), po = QX(TypeError);
function ke(t) {
  return function(e) {
    for (var r = arguments.length, n = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    return Rr(t, e, n);
  };
}
function QX(t) {
  return function() {
    for (var e = arguments.length, r = Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return ta(t, r);
  };
}
function N(t, e) {
  co && co(t, null);
  for (var r = e.length; r--; ) {
    var n = e[r];
    if (typeof n == "string") {
      var a = gr(n);
      a !== n && (UX(e) || (e[r] = a), n = a);
    }
    t[n] = !0;
  }
  return t;
}
function Ze(t) {
  var e = zX(null), r = void 0;
  for (r in t)
    Rr(FX, t, [r]) && (e[r] = t[r]);
  return e;
}
function vr(t, e) {
  for (; t !== null; ) {
    var r = jX(t, e);
    if (r) {
      if (r.get)
        return ke(r.get);
      if (typeof r.value == "function")
        return ke(r.value);
    }
    t = VX(t);
  }
  function n(a) {
    return console.warn("fallback value for", a), null;
  }
  return n;
}
var ho = ue(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), An = ue(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Sn = ue(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), KX = ue(["animate", "color-profile", "cursor", "discard", "fedropshadow", "feimage", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), On = ue(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]), YX = ue(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), mo = ue(["#text"]), go = ue(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), Dn = ue(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), yo = ue(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), fr = ue(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ZX = $e(/\{\{[\s\S]*|[\s\S]*\}\}/gm), JX = $e(/<%[\s\S]*|[\s\S]*%>/gm), eQ = $e(/^data-[\-\w.\u00B7-\uFFFF]/), tQ = $e(/^aria-[\-\w]+$/), rQ = $e(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), nQ = $e(/^(?:\w+script|data):/i), aQ = $e(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
  return typeof t;
} : function(t) {
  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
};
function Le(t) {
  if (Array.isArray(t)) {
    for (var e = 0, r = Array(t.length); e < t.length; e++)
      r[e] = t[e];
    return r;
  } else
    return Array.from(t);
}
var iQ = function() {
  return typeof window > "u" ? null : window;
}, oQ = function(e, r) {
  if ((typeof e > "u" ? "undefined" : Vt(e)) !== "object" || typeof e.createPolicy != "function")
    return null;
  var n = null, a = "data-tt-policy-suffix";
  r.currentScript && r.currentScript.hasAttribute(a) && (n = r.currentScript.getAttribute(a));
  var i = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(i, {
      createHTML: function(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
};
function Kl() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : iQ(), e = function(g) {
    return Kl(g);
  };
  if (e.version = "2.3.3", e.removed = [], !t || !t.document || t.document.nodeType !== 9)
    return e.isSupported = !1, e;
  var r = t.document, n = t.document, a = t.DocumentFragment, i = t.HTMLTemplateElement, o = t.Node, s = t.Element, l = t.NodeFilter, u = t.NamedNodeMap, c = u === void 0 ? t.NamedNodeMap || t.MozNamedAttrMap : u, v = t.Text, f = t.Comment, d = t.DOMParser, p = t.trustedTypes, h = s.prototype, m = vr(h, "cloneNode"), y = vr(h, "nextSibling"), w = vr(h, "childNodes"), C = vr(h, "parentNode");
  if (typeof i == "function") {
    var T = n.createElement("template");
    T.content && T.content.ownerDocument && (n = T.content.ownerDocument);
  }
  var k = oQ(p, r), M = k && er ? k.createHTML("") : "", O = n, I = O.implementation, _ = O.createNodeIterator, V = O.createDocumentFragment, Y = O.getElementsByTagName, pe = r.importNode, Zt = {};
  try {
    Zt = Ze(n).documentMode ? n.documentMode : {};
  } catch {
  }
  var xe = {};
  e.isSupported = typeof C == "function" && I && typeof I.createHTMLDocument < "u" && Zt !== 9;
  var Jr = ZX, en = JX, Hu = eQ, Pu = tQ, _u = nQ, Ga = aQ, tn = rQ, re = null, Xa = N({}, [].concat(Le(ho), Le(An), Le(Sn), Le(On), Le(mo))), ne = null, Qa = N({}, [].concat(Le(go), Le(Dn), Le(yo), Le(fr))), rn = null, nn = null, Ka = !0, an = !0, Ya = !1, st = !1, lt = !1, on = !1, sn = !1, ut = !1, Jt = !1, Za = !0, er = !1, Ja = !0, ln = !0, Rt = !1, ct = {}, vt = null, ei = N({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]), ti = null, ri = N({}, ["audio", "video", "img", "source", "image", "track"]), un = null, ni = N({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), cn = "http://www.w3.org/1998/Math/MathML", vn = "http://www.w3.org/2000/svg", Ve = "http://www.w3.org/1999/xhtml", tr = Ve, fn = !1, ft = void 0, qu = ["application/xhtml+xml", "text/html"], $u = "text/html", dt = void 0, pt = null, Fu = n.createElement("form"), dn = function(g) {
    pt && pt === g || ((!g || (typeof g > "u" ? "undefined" : Vt(g)) !== "object") && (g = {}), g = Ze(g), re = "ALLOWED_TAGS" in g ? N({}, g.ALLOWED_TAGS) : Xa, ne = "ALLOWED_ATTR" in g ? N({}, g.ALLOWED_ATTR) : Qa, un = "ADD_URI_SAFE_ATTR" in g ? N(Ze(ni), g.ADD_URI_SAFE_ATTR) : ni, ti = "ADD_DATA_URI_TAGS" in g ? N(Ze(ri), g.ADD_DATA_URI_TAGS) : ri, vt = "FORBID_CONTENTS" in g ? N({}, g.FORBID_CONTENTS) : ei, rn = "FORBID_TAGS" in g ? N({}, g.FORBID_TAGS) : {}, nn = "FORBID_ATTR" in g ? N({}, g.FORBID_ATTR) : {}, ct = "USE_PROFILES" in g ? g.USE_PROFILES : !1, Ka = g.ALLOW_ARIA_ATTR !== !1, an = g.ALLOW_DATA_ATTR !== !1, Ya = g.ALLOW_UNKNOWN_PROTOCOLS || !1, st = g.SAFE_FOR_TEMPLATES || !1, lt = g.WHOLE_DOCUMENT || !1, ut = g.RETURN_DOM || !1, Jt = g.RETURN_DOM_FRAGMENT || !1, Za = g.RETURN_DOM_IMPORT !== !1, er = g.RETURN_TRUSTED_TYPE || !1, sn = g.FORCE_BODY || !1, Ja = g.SANITIZE_DOM !== !1, ln = g.KEEP_CONTENT !== !1, Rt = g.IN_PLACE || !1, tn = g.ALLOWED_URI_REGEXP || tn, tr = g.NAMESPACE || Ve, ft = // eslint-disable-next-line unicorn/prefer-includes
    qu.indexOf(g.PARSER_MEDIA_TYPE) === -1 ? ft = $u : ft = g.PARSER_MEDIA_TYPE, dt = ft === "application/xhtml+xml" ? function(E) {
      return E;
    } : gr, st && (an = !1), Jt && (ut = !0), ct && (re = N({}, [].concat(Le(mo))), ne = [], ct.html === !0 && (N(re, ho), N(ne, go)), ct.svg === !0 && (N(re, An), N(ne, Dn), N(ne, fr)), ct.svgFilters === !0 && (N(re, Sn), N(ne, Dn), N(ne, fr)), ct.mathMl === !0 && (N(re, On), N(ne, yo), N(ne, fr))), g.ADD_TAGS && (re === Xa && (re = Ze(re)), N(re, g.ADD_TAGS)), g.ADD_ATTR && (ne === Qa && (ne = Ze(ne)), N(ne, g.ADD_ATTR)), g.ADD_URI_SAFE_ATTR && N(un, g.ADD_URI_SAFE_ATTR), g.FORBID_CONTENTS && (vt === ei && (vt = Ze(vt)), N(vt, g.FORBID_CONTENTS)), ln && (re["#text"] = !0), lt && N(re, ["html", "head", "body"]), re.table && (N(re, ["tbody"]), delete rn.tbody), ue && ue(g), pt = g);
  }, ai = N({}, ["mi", "mo", "mn", "ms", "mtext"]), ii = N({}, ["foreignobject", "desc", "title", "annotation-xml"]), rr = N({}, An);
  N(rr, Sn), N(rr, KX);
  var pn = N({}, On);
  N(pn, YX);
  var Uu = function(g) {
    var E = C(g);
    (!E || !E.tagName) && (E = {
      namespaceURI: Ve,
      tagName: "template"
    });
    var A = gr(g.tagName), P = gr(E.tagName);
    if (g.namespaceURI === vn)
      return E.namespaceURI === Ve ? A === "svg" : E.namespaceURI === cn ? A === "svg" && (P === "annotation-xml" || ai[P]) : !!rr[A];
    if (g.namespaceURI === cn)
      return E.namespaceURI === Ve ? A === "math" : E.namespaceURI === vn ? A === "math" && ii[P] : !!pn[A];
    if (g.namespaceURI === Ve) {
      if (E.namespaceURI === vn && !ii[P] || E.namespaceURI === cn && !ai[P])
        return !1;
      var ae = N({}, ["title", "style", "font", "a", "script"]);
      return !pn[A] && (ae[A] || !rr[A]);
    }
    return !1;
  }, Ie = function(g) {
    Pt(e.removed, { element: g });
    try {
      g.parentNode.removeChild(g);
    } catch {
      try {
        g.outerHTML = M;
      } catch {
        g.remove();
      }
    }
  }, oi = function(g, E) {
    try {
      Pt(e.removed, {
        attribute: E.getAttributeNode(g),
        from: E
      });
    } catch {
      Pt(e.removed, {
        attribute: null,
        from: E
      });
    }
    if (E.removeAttribute(g), g === "is" && !ne[g])
      if (ut || Jt)
        try {
          Ie(E);
        } catch {
        }
      else
        try {
          E.setAttribute(g, "");
        } catch {
        }
  }, si = function(g) {
    var E = void 0, A = void 0;
    if (sn)
      g = "<remove></remove>" + g;
    else {
      var P = fo(g, /^[\r\n\t ]+/);
      A = P && P[0];
    }
    ft === "application/xhtml+xml" && (g = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + g + "</body></html>");
    var ae = k ? k.createHTML(g) : g;
    if (tr === Ve)
      try {
        E = new d().parseFromString(ae, ft);
      } catch {
      }
    if (!E || !E.documentElement) {
      E = I.createDocument(tr, "template", null);
      try {
        E.documentElement.innerHTML = fn ? "" : ae;
      } catch {
      }
    }
    var ie = E.body || E.documentElement;
    return g && A && ie.insertBefore(n.createTextNode(A), ie.childNodes[0] || null), tr === Ve ? Y.call(E, lt ? "html" : "body")[0] : lt ? E.documentElement : ie;
  }, li = function(g) {
    return _.call(g.ownerDocument || g, g, l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT, null, !1);
  }, Vu = function(g) {
    return g instanceof v || g instanceof f ? !1 : typeof g.nodeName != "string" || typeof g.textContent != "string" || typeof g.removeChild != "function" || !(g.attributes instanceof c) || typeof g.removeAttribute != "function" || typeof g.setAttribute != "function" || typeof g.namespaceURI != "string" || typeof g.insertBefore != "function";
  }, Bt = function(g) {
    return (typeof o > "u" ? "undefined" : Vt(o)) === "object" ? g instanceof o : g && (typeof g > "u" ? "undefined" : Vt(g)) === "object" && typeof g.nodeType == "number" && typeof g.nodeName == "string";
  }, Ne = function(g, E, A) {
    xe[g] && WX(xe[g], function(P) {
      P.call(e, E, A, pt);
    });
  }, ui = function(g) {
    var E = void 0;
    if (Ne("beforeSanitizeElements", g, null), Vu(g) || fo(g.nodeName, /[\u0080-\uFFFF]/))
      return Ie(g), !0;
    var A = dt(g.nodeName);
    if (Ne("uponSanitizeElement", g, {
      tagName: A,
      allowedTags: re
    }), !Bt(g.firstElementChild) && (!Bt(g.content) || !Bt(g.content.firstElementChild)) && Be(/<[/\w]/g, g.innerHTML) && Be(/<[/\w]/g, g.textContent) || A === "select" && Be(/<template/i, g.innerHTML))
      return Ie(g), !0;
    if (!re[A] || rn[A]) {
      if (ln && !vt[A]) {
        var P = C(g) || g.parentNode, ae = w(g) || g.childNodes;
        if (ae && P)
          for (var ie = ae.length, oe = ie - 1; oe >= 0; --oe)
            P.insertBefore(m(ae[oe], !0), y(g));
      }
      return Ie(g), !0;
    }
    return g instanceof s && !Uu(g) || (A === "noscript" || A === "noembed") && Be(/<\/no(script|embed)/i, g.innerHTML) ? (Ie(g), !0) : (st && g.nodeType === 3 && (E = g.textContent, E = je(E, Jr, " "), E = je(E, en, " "), g.textContent !== E && (Pt(e.removed, { element: g.cloneNode() }), g.textContent = E)), Ne("afterSanitizeElements", g, null), !1);
  }, ci = function(g, E, A) {
    if (Ja && (E === "id" || E === "name") && (A in n || A in Fu))
      return !1;
    if (!(an && !nn[E] && Be(Hu, E))) {
      if (!(Ka && Be(Pu, E))) {
        if (!ne[E] || nn[E])
          return !1;
        if (!un[E]) {
          if (!Be(tn, je(A, Ga, ""))) {
            if (!((E === "src" || E === "xlink:href" || E === "href") && g !== "script" && GX(A, "data:") === 0 && ti[g])) {
              if (!(Ya && !Be(_u, je(A, Ga, "")))) {
                if (A) return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, vi = function(g) {
    var E = void 0, A = void 0, P = void 0, ae = void 0;
    Ne("beforeSanitizeAttributes", g, null);
    var ie = g.attributes;
    if (ie) {
      var oe = {
        attrName: "",
        attrValue: "",
        keepAttr: !0,
        allowedAttributes: ne
      };
      for (ae = ie.length; ae--; ) {
        E = ie[ae];
        var Re = E, Ht = Re.name, fi = Re.namespaceURI;
        if (A = XX(E.value), P = dt(Ht), oe.attrName = P, oe.attrValue = A, oe.keepAttr = !0, oe.forceKeepAttr = void 0, Ne("uponSanitizeAttribute", g, oe), A = oe.attrValue, !oe.forceKeepAttr && (oi(Ht, g), !!oe.keepAttr)) {
          if (Be(/\/>/i, A)) {
            oi(Ht, g);
            continue;
          }
          st && (A = je(A, Jr, " "), A = je(A, en, " "));
          var zu = dt(g.nodeName);
          if (ci(zu, P, A))
            try {
              fi ? g.setAttributeNS(fi, Ht, A) : g.setAttribute(Ht, A), vo(e.removed);
            } catch {
            }
        }
      }
      Ne("afterSanitizeAttributes", g, null);
    }
  }, ju = function S(g) {
    var E = void 0, A = li(g);
    for (Ne("beforeSanitizeShadowDOM", g, null); E = A.nextNode(); )
      Ne("uponSanitizeShadowNode", E, null), !ui(E) && (E.content instanceof a && S(E.content), vi(E));
    Ne("afterSanitizeShadowDOM", g, null);
  };
  return e.sanitize = function(S, g) {
    var E = void 0, A = void 0, P = void 0, ae = void 0, ie = void 0;
    if (fn = !S, fn && (S = "<!-->"), typeof S != "string" && !Bt(S)) {
      if (typeof S.toString != "function")
        throw po("toString is not a function");
      if (S = S.toString(), typeof S != "string")
        throw po("dirty is not a string, aborting");
    }
    if (!e.isSupported) {
      if (Vt(t.toStaticHTML) === "object" || typeof t.toStaticHTML == "function") {
        if (typeof S == "string")
          return t.toStaticHTML(S);
        if (Bt(S))
          return t.toStaticHTML(S.outerHTML);
      }
      return S;
    }
    if (on || dn(g), e.removed = [], typeof S == "string" && (Rt = !1), !Rt) if (S instanceof o)
      E = si("<!---->"), A = E.ownerDocument.importNode(S, !0), A.nodeType === 1 && A.nodeName === "BODY" || A.nodeName === "HTML" ? E = A : E.appendChild(A);
    else {
      if (!ut && !st && !lt && // eslint-disable-next-line unicorn/prefer-includes
      S.indexOf("<") === -1)
        return k && er ? k.createHTML(S) : S;
      if (E = si(S), !E)
        return ut ? null : M;
    }
    E && sn && Ie(E.firstChild);
    for (var oe = li(Rt ? S : E); P = oe.nextNode(); )
      P.nodeType === 3 && P === ae || ui(P) || (P.content instanceof a && ju(P.content), vi(P), ae = P);
    if (ae = null, Rt)
      return S;
    if (ut) {
      if (Jt)
        for (ie = V.call(E.ownerDocument); E.firstChild; )
          ie.appendChild(E.firstChild);
      else
        ie = E;
      return Za && (ie = pe.call(r, ie, !0)), ie;
    }
    var Re = lt ? E.outerHTML : E.innerHTML;
    return st && (Re = je(Re, Jr, " "), Re = je(Re, en, " ")), k && er ? k.createHTML(Re) : Re;
  }, e.setConfig = function(S) {
    dn(S), on = !0;
  }, e.clearConfig = function() {
    pt = null, on = !1;
  }, e.isValidAttribute = function(S, g, E) {
    pt || dn({});
    var A = dt(S), P = dt(g);
    return ci(A, P, E);
  }, e.addHook = function(S, g) {
    typeof g == "function" && (xe[S] = xe[S] || [], Pt(xe[S], g));
  }, e.removeHook = function(S) {
    xe[S] && vo(xe[S]);
  }, e.removeHooks = function(S) {
    xe[S] && (xe[S] = []);
  }, e.removeAllHooks = function() {
    xe = {};
  }, e;
}
var sQ = Kl(), lQ = ["iframe", "embed"], Yl = [];
function Zl(t) {
  te(lQ, t) && Yl.push(t.toLowerCase());
}
function ot(t, e) {
  return sQ.sanitize(t, b({ ADD_TAGS: Yl, ADD_ATTR: ["rel", "target", "hreflang", "type"], FORBID_TAGS: [
    "input",
    "script",
    "textarea",
    "form",
    "button",
    "select",
    "meta",
    "style",
    "link",
    "title",
    "object",
    "base"
  ] }, e));
}
function Jl(t, e) {
  return t.literal.replace(new RegExp("(<\\s*" + e + "[^>]*>)|(</" + e + "\\s*[>])", "ig"), "").trim();
}
function ra(t) {
  t = t.match(Et)[0];
  var e = t.match(new RegExp(Xs, "g"));
  return e ? e.reduce(function(r, n) {
    var a = n.trim().split("="), i = a[0], o = a.slice(1);
    return o.length && (r[i] = o.join("=").replace(/'|"/g, "").trim()), r;
  }, {}) : {};
}
function na(t) {
  return De(t.attributes).reduce(function(e, r) {
    return e[r.nodeName] = r.nodeValue, e;
  }, {});
}
function bo(t, e, r, n) {
  var a = n.getToDOMNode(e)(t), i = r(a.outerHTML), o = document.createElement("div");
  o.innerHTML = i, a = o.firstChild;
  var s = na(a);
  return { dom: a, htmlAttrs: s };
}
var uQ = {
  htmlBlock: function(t, e, r) {
    return {
      atom: !0,
      content: "block+",
      group: "block",
      attrs: {
        htmlAttrs: { default: {} },
        childrenHTML: { default: "" },
        htmlBlock: { default: !0 }
      },
      parseDOM: [
        {
          tag: t,
          getAttrs: function(n) {
            return {
              htmlAttrs: na(n),
              childrenHTML: n.innerHTML
            };
          }
        }
      ],
      toDOM: function(n) {
        var a = bo(n, t, e, r), i = a.dom, o = a.htmlAttrs;
        return o.class = o.class ? o.class + " html-block" : "html-block", ce([t, o], De(i.childNodes));
      }
    };
  },
  htmlInline: function(t, e, r) {
    return {
      attrs: {
        htmlAttrs: { default: {} },
        htmlInline: { default: !0 }
      },
      parseDOM: [
        {
          tag: t,
          getAttrs: function(n) {
            return {
              htmlAttrs: na(n)
            };
          }
        }
      ],
      toDOM: function(n) {
        var a = bo(n, t, e, r).htmlAttrs;
        return [t, a, 0];
      }
    };
  }
};
function cQ(t, e, r) {
  var n = { nodes: {}, marks: {} };
  return ["htmlBlock", "htmlInline"].forEach(function(a) {
    t[a] && Object.keys(t[a]).forEach(function(i) {
      var o = a === "htmlBlock" ? "nodes" : "marks";
      Zl(i), n[o][i] = uQ[a](i, e, r);
    });
  }), n;
}
var vQ = /^\s*<\s*\//, fQ = {
  paragraph: function(t, e) {
    var r = e.entering, n = e.origin, a = e.options;
    return a.nodeId ? {
      type: r ? "openTag" : "closeTag",
      outerNewLine: !0,
      tagName: "p"
    } : n();
  },
  softbreak: function(t) {
    var e = t.prev && t.prev.type === "htmlInline", r = e && /<br ?\/?>/.test(t.prev.literal), n = r ? `
` : `<br>
`;
    return { type: "html", content: n };
  },
  item: function(t, e) {
    var r = e.entering;
    if (r) {
      var n = {}, a = [];
      return t.listData.task && (n["data-task"] = "", a.push("task-list-item"), t.listData.checked && (a.push("checked"), n["data-task-checked"] = "")), {
        type: "openTag",
        tagName: "li",
        classNames: a,
        attributes: n,
        outerNewLine: !0
      };
    }
    return {
      type: "closeTag",
      tagName: "li",
      outerNewLine: !0
    };
  },
  code: function(t) {
    var e = { "data-backticks": String(t.tickCount) };
    return [
      { type: "openTag", tagName: "code", attributes: e },
      { type: "text", content: t.literal },
      { type: "closeTag", tagName: "code" }
    ];
  },
  codeBlock: function(t) {
    var e = t, r = e.fenceLength, n = e.info, a = n ? n.split(/\s+/) : [], i = [], o = {};
    if (r > 3 && (o["data-backticks"] = r), a.length > 0 && a[0].length > 0) {
      var s = a[0];
      i.push("lang-" + s), o["data-language"] = s;
    }
    return [
      { type: "openTag", tagName: "pre", classNames: i },
      { type: "openTag", tagName: "code", attributes: o },
      { type: "text", content: t.literal },
      { type: "closeTag", tagName: "code" },
      { type: "closeTag", tagName: "pre" }
    ];
  },
  customInline: function(t, e) {
    var r = e.origin, n = e.entering, a = e.skipChildren, i = t.info;
    if (i.indexOf("widget") !== -1 && n) {
      a();
      var o = js(t), s = Vs(i, o).outerHTML;
      return [
        { type: "openTag", tagName: "span", classNames: ["tui-widget"] },
        { type: "html", content: s },
        { type: "closeTag", tagName: "span" }
      ];
    }
    return r();
  }
};
function Fa(t, e) {
  var r = b({}, fQ);
  return t && (r.link = function(n, a) {
    var i = a.entering, o = a.origin, s = o();
    return i && (s.attributes = b(b({}, s.attributes), t)), s;
  }), e && Object.keys(e).forEach(function(n) {
    var a = r[n], i = e[n];
    a && he(i) ? r[n] = function(o, s) {
      var l = b({}, s);
      return l.origin = function() {
        return a(o, s);
      }, i(o, l);
    } : te(["htmlBlock", "htmlInline"], n) && !he(i) ? r[n] = function(o, s) {
      var l = o.literal.match(Et);
      if (l) {
        var u = l[0], c = l[1], v = l[3], f = (c || v).toLowerCase(), d = i[f], p = Jl(o, f);
        if (d) {
          var h = b({}, o);
          return h.attrs = ra(u), h.childrenHTML = p, h.type = f, s.entering = !vQ.test(o.literal), d(h, s);
        }
      }
      return s.origin();
    } : r[n] = i;
  }), r;
}
var dQ = ["list", "item", "blockQuote"], pQ = ["UL", "OL", "BLOCKQUOTE"];
function hQ(t, e) {
  var r, n = t.child(e);
  return !n.childCount || n.childCount === 1 && !(!((r = n.firstChild.text) === null || r === void 0) && r.trim());
}
function wo(t, e, r) {
  var n = Kt(e) - 1, a = Fr(e) - 1, i = r[n].getBoundingClientRect(), o = r[a].offsetTop - r[n].offsetTop + r[a].clientHeight;
  return {
    height: o <= 0 ? r[n].clientHeight : o + mQ(t, r, Math.min(a + 1, t.childCount - 1)),
    rect: i
  };
}
function mQ(t, e, r) {
  for (var n = t.childCount - 1, a = 0; r <= n && hQ(t, r); )
    a += e[r].clientHeight, r += 1;
  return a;
}
function gQ(t, e) {
  for (; !t.getAttribute("data-nodeid") && t.parentElement !== e; )
    t = t.parentElement;
  return t;
}
function Br(t, e) {
  for (var r = 0; t && t !== e && (te(pQ, t.tagName) || (r += t.offsetTop), t.offsetParent !== e.offsetParent); )
    t = t.parentElement;
  return r;
}
function yQ(t, e) {
  for (var r = e, n = null; r; ) {
    var a = r.firstElementChild;
    if (!a)
      break;
    var i = eu(a, t, Br(r, e));
    n = r, r = i;
  }
  var o = r || n;
  return o === e ? null : o;
}
function eu(t, e, r) {
  return t && e > r + t.offsetTop ? eu(t.nextElementSibling, e, r) || t : null;
}
function bQ(t, e, r, n) {
  var a = Math.min((t - e) / r, 1);
  return a * n;
}
function In(t, e) {
  for (var r = t.querySelector('[data-nodeid="' + e.id + '"]'); !r || ov(e); )
    e = e.parent, r = t.querySelector('[data-nodeid="' + e.id + '"]');
  return wQ({ mdNode: e, el: r });
}
function wQ(t) {
  for (var e = t.mdNode, r = t.el; (te(dQ, e.type) || e.type === "table") && e.firstChild; )
    e = e.firstChild, r = r.firstElementChild;
  return { mdNode: e, el: r };
}
var be = {};
function CQ(t, e) {
  be[t] = be[t] || {}, be[t].height = e;
}
function TQ(t, e) {
  be[t] = be[t] || {}, be[t].offsetTop = e;
}
function kQ(t) {
  return be[t] && be[t].height;
}
function EQ(t) {
  return be[t] && be[t].offsetTop;
}
function aa(t) {
  t && (delete be[Number(t.getAttribute("data-nodeid"))], De(t.children).forEach(function(e) {
    aa(e);
  }));
}
function xQ(t, e, r) {
  var n = kQ(r), a = EQ(r), i = n || t.clientHeight, o = a || Br(t, e) || t.offsetTop;
  return n || CQ(r, i), a || TQ(r, o), { nodeHeight: i, offsetTop: o };
}
var Nn = L("md-preview-highlight");
function LQ(t, e) {
  for (var r = t.firstChild; r && r.next && !(Ur(r.next) > e + 1); )
    r = r.next;
  return r;
}
var tu = (
  /** @class */
  (function() {
    function t(e, r) {
      var n = document.createElement("div");
      this.el = n, this.eventEmitter = e, this.isViewer = !!r.isViewer, this.el.className = L("md-preview");
      var a = r.linkAttributes, i = r.customHTMLRenderer, o = r.sanitizer, s = r.highlight, l = s === void 0 ? !1 : s;
      this.renderer = new $a({
        gfm: !0,
        nodeId: !0,
        convertors: Fa(a, i)
      }), this.cursorNodeId = null, this.sanitizer = o, this.initEvent(l), this.initContentSection(), this.isViewer && (this.previewContent.style.overflowWrap = "break-word");
    }
    return t.prototype.initContentSection = function() {
      this.previewContent = Js('<div class="' + L("contents") + '"></div>'), this.isViewer || this.el.appendChild(this.previewContent);
    }, t.prototype.toggleActive = function(e) {
      La(this.el, "active", e);
    }, t.prototype.initEvent = function(e) {
      var r = this;
      this.eventEmitter.listen("updatePreview", this.update.bind(this)), !this.isViewer && (e && (this.eventEmitter.listen("changeToolbarState", function(n) {
        var a = n.mdNode, i = n.cursorPos;
        r.updateCursorNode(a, i);
      }), this.eventEmitter.listen("blur", function() {
        r.removeHighlight();
      })), ml(this.el, "scroll", function(n) {
        r.eventEmitter.emit("scroll", "preview", yQ(n.target.scrollTop, r.previewContent));
      }), this.eventEmitter.listen("changePreviewTabPreview", function() {
        return r.toggleActive(!0);
      }), this.eventEmitter.listen("changePreviewTabWrite", function() {
        return r.toggleActive(!1);
      }));
    }, t.prototype.removeHighlight = function() {
      if (this.cursorNodeId) {
        var e = this.getElementByNodeId(this.cursorNodeId);
        e && ye(e, Nn);
      }
    }, t.prototype.updateCursorNode = function(e, r) {
      e && (e = kt(e, function(o) {
        return !uv(o);
      }), e.type === "tableRow" ? e = LQ(e, r[1]) : e.type === "tableBody" && (e = null));
      var n = e ? e.id : null;
      if (this.cursorNodeId !== n) {
        var a = this.getElementByNodeId(this.cursorNodeId), i = this.getElementByNodeId(n);
        a && ye(a, Nn), i && Ae(i, Nn), this.cursorNodeId = n;
      }
    }, t.prototype.getElementByNodeId = function(e) {
      return e ? this.previewContent.querySelector('[data-nodeid="' + e + '"]') : null;
    }, t.prototype.update = function(e) {
      var r = this;
      e.forEach(function(n) {
        return r.replaceRangeNodes(n);
      }), this.eventEmitter.emit("afterPreviewRender", this);
    }, t.prototype.replaceRangeNodes = function(e) {
      var r = this, n = e.nodes, a = e.removedNodeRange, i = this.previewContent, o = this.eventEmitter.emitReduce("beforePreviewRender", this.sanitizer(n.map(function(p) {
        return r.renderer.render(p);
      }).join("")));
      if (!a)
        i.insertAdjacentHTML("afterbegin", o);
      else {
        var s = a.id, l = s[0], u = s[1], c = this.getElementByNodeId(l), v = this.getElementByNodeId(u);
        if (c) {
          c.insertAdjacentHTML("beforebegin", o);
          for (var f = c; f && f !== v; ) {
            var d = f.nextElementSibling;
            nt(f), aa(f), f = d;
          }
          f?.parentNode && (nt(f), aa(f));
        }
      }
    }, t.prototype.getRenderer = function() {
      return this.renderer;
    }, t.prototype.destroy = function() {
      hl(this.el, "scroll"), this.el = null;
    }, t.prototype.getElement = function() {
      return this.el;
    }, t.prototype.getHTML = function() {
      return Sa(this.previewContent.innerHTML);
    }, t.prototype.setHTML = function(e) {
      this.previewContent.innerHTML = e;
    }, t.prototype.setHeight = function(e) {
      Oe(this.el, { height: e + "px" });
    }, t.prototype.setMinHeight = function(e) {
      Oe(this.el, { minHeight: e + "px" });
    }, t;
  })()
);
function Pe(t, e) {
  for (var r = t.depth; r; ) {
    var n = t.node(r);
    if (e(n, r))
      return {
        node: n,
        depth: r,
        offset: r > 0 ? t.before(r) : 0
      };
    r -= 1;
  }
  return null;
}
function At(t) {
  return !!Pe(t, function(e) {
    var r = e.type;
    return r.name === "listItem" || r.name === "bulletList" || r.name === "orderedList";
  });
}
function Hr(t) {
  return !!Pe(t, function(e) {
    var r = e.type;
    return r.name === "tableHeadCell" || r.name === "tableBodyCell";
  });
}
function St(t) {
  return Pe(t, function(e) {
    var r = e.type;
    return r.name === "listItem";
  });
}
function Yr(t) {
  return {
    tag: t,
    getAttrs: function(e) {
      var r = e.getAttribute("data-raw-html");
      return b({}, r && { rawHTML: r });
    }
  };
}
function ru(t) {
  return Object.keys(t).reduce(function(e, r) {
    return r !== "rawHTML" && t[r] && (r = r === "className" ? "class" : r, e[r] = t[r]), e;
  }, {});
}
function nu(t) {
  return {
    tag: t,
    getAttrs: function(e) {
      return ["rawHTML", "colspan", "rowspan", "extended"].reduce(function(r, n) {
        var a = n === "rawHTML" ? "data-raw-html" : n, i = e.getAttribute(a);
        return i && (r[n] = te(["rawHTML", "extended"], n) ? i : Number(i)), r;
      }, {});
    }
  };
}
function K() {
  return {
    htmlAttrs: { default: null },
    classNames: { default: null }
  };
}
function z(t) {
  var e = t.htmlAttrs, r = t.classNames;
  return b(b({}, e), { class: r ? r.join(" ") : null });
}
function MQ(t, e) {
  var r = t.parent, n = t.startIndex, a = t.endIndex, i = r.contentMatchAt(n).findWrapping(e);
  if (i) {
    var o = i.length ? i[0] : e;
    return r.canReplaceWith(n, a, o) ? i : null;
  }
  return null;
}
function AQ(t, e) {
  var r = t.parent, n = t.startIndex, a = t.endIndex, i = r.child(n), o = e.contentMatch.findWrapping(i.type);
  if (o) {
    for (var s = o.length ? o[o.length - 1] : e, l = s.contentMatch, u = n; l && u < a; u += 1)
      l = l.matchType(r.child(u).type);
    if (l && l.validEnd)
      return o;
  }
  return null;
}
function SQ(t, e, r, n) {
  var a = MQ(t, r), i = AQ(e, r);
  if (a && i) {
    var o = a.map(function(l) {
      return { type: l };
    }), s = i.map(function(l) {
      return { type: l, attrs: n };
    });
    return o.concat({ type: r }).concat(s);
  }
  return null;
}
function OQ(t, e, r, n, a) {
  for (var i = e.start, o = e.end, s = e.startIndex, l = e.endIndex, u = e.parent, c = q.empty, v = r.length - 1; v >= 0; v -= 1)
    c = q.from(r[v].type.create(r[v].attrs, c));
  t.step(new Xt(i - (n ? 2 : 0), o, i, o, new Ce(c, 0, 0), r.length, !0));
  for (var f = 0, v = 0; v < r.length; v += 1)
    if (r[v].type === a) {
      f = v + 1;
      break;
    }
  for (var d = r.length - f, p = i + r.length - (n ? 2 : 0), v = s, h = l; v < h; v += 1) {
    var m = v === s;
    !m && Os(t.doc, p, d) && (t.split(p, d), p += d * 2), p += u.child(v).nodeSize;
  }
  return t;
}
function au(t, e, r, n) {
  var a = e.$from, i = e.$to, o = e.depth, s = e, l = !1;
  if (o >= 2 && a.node(o - 1).type.compatibleContent(r) && e.startIndex === 0 && a.index(o - 1)) {
    var u = t.doc.resolve(e.start - 2);
    s = new Pn(u, u, o), e.endIndex < e.parent.childCount && (e = new Pn(a, t.doc.resolve(i.end(o)), o)), l = !0;
  }
  var c = SQ(s, e, r, n);
  return c ? OQ(t, e, c, l, r) : t;
}
function iu(t, e) {
  for (var r = t.resolve(e); r.node().type.name !== "paragraph"; )
    e -= 2, r = t.resolve(e);
  return St(r);
}
function DQ(t, e) {
  var r = e.$from, n = e.$to, a = St(r), i = St(n);
  if (a && i)
    for (; i; ) {
      var o = i.offset, s = i.node, l = { task: !s.attrs.task, checked: !1 };
      if (t.setNodeMarkup(o, null, l), o === a.offset)
        break;
      i = iu(t.doc, o);
    }
  return t;
}
function IQ(t, e, r) {
  var n = e.$from, a = e.$to, i = St(n), o = St(a);
  if (i && o)
    for (; o; ) {
      var s = o.offset, l = o.node, u = o.depth;
      l.attrs.task && t.setNodeMarkup(s, null, { task: !1, checked: !1 });
      var c = t.doc.resolve(s);
      if (c.parent.type !== r) {
        var v = c.before(u - 1);
        t.setNodeMarkup(v, r);
      }
      if (s === i.offset)
        break;
      o = iu(t.doc, s);
    }
  return t;
}
function ou(t) {
  return function(e, r) {
    var n = e.selection, a = e.tr, i = n.$from, o = n.$to, s = i.blockRange(o);
    if (s) {
      var l = At(i) ? IQ(a, s, t) : au(a, s, t);
      return r(l), !0;
    }
    return !1;
  };
}
function NQ() {
  return function(t, e) {
    var r = t.selection, n = t.tr, a = t.schema, i = r.$from, o = r.$to, s = i.blockRange(o);
    if (s) {
      var l = At(i) ? DQ(n, s) : au(n, s, a.nodes.bulletList, { task: !0 });
      return e(l), !0;
    }
    return !1;
  };
}
function RQ(t) {
  return function(e, r) {
    var n = e.tr, a = e.selection, i = a.$from, o = a.$to, s = i.blockRange(o, function(h) {
      var m = h.childCount, y = h.firstChild;
      return !!m && y.type === t;
    });
    if (s && s.startIndex > 0) {
      var l = s.parent, u = l.child(s.startIndex - 1);
      if (u.type !== t)
        return !1;
      var c = u.lastChild && u.lastChild.type === l.type, v = c ? q.from(t.create()) : null, f = new Ce(q.from(t.create(null, q.from(l.type.create(null, v)))), c ? 3 : 1, 0), d = s.start, p = s.end;
      return n.step(new Xt(d - (c ? 3 : 1), p, d, p, f, 1, !0)), r(n), !0;
    }
    return !1;
  };
}
function BQ(t, e, r) {
  var n = e.$from, a = e.$to, i = e.end, o = e.depth, s = e.parent, l = a.end(o);
  return i < l && (t.step(new Xt(i - 1, l, i, l, new Ce(q.from(r.create(null, s.copy())), 1, 0), 1, !0)), e = new Pn(t.doc.resolve(n.pos), t.doc.resolve(l), o)), t.lift(e, Gu(e)), t;
}
function HQ(t, e) {
  for (var r = e.parent, n = e.end, a = e.endIndex - 1, i = e.startIndex; a > i; a -= 1)
    n -= r.child(a).nodeSize, t.delete(n - 1, n + 1);
  var o = t.doc.resolve(e.start), s = o.nodeAfter, l = e.startIndex === 0, u = e.endIndex === r.childCount, c = o.node(-1), v = o.index(-1), f = c.canReplace(v + (l ? 0 : 1), v + 1, s?.content.append(u ? q.empty : q.from(r)));
  if (s && f) {
    var d = o.pos, p = d + s.nodeSize;
    t.step(new Xt(d - (l ? 1 : 0), p + (u ? 1 : 0), d + 1, p - 1, new Ce((l ? q.empty : q.from(r.copy(q.empty))).append(u ? q.empty : q.from(r.copy(q.empty))), l ? 0 : 1, u ? 0 : 1), l ? 0 : 1));
  }
  return t;
}
function PQ(t) {
  return function(e, r) {
    var n = e.tr, a = e.selection, i = a.$from, o = a.$to, s = i.blockRange(o, function(c) {
      var v = c.childCount, f = c.firstChild;
      return !!v && f.type === t;
    });
    if (s) {
      var l = i.node(s.depth - 1).type === t, u = l ? BQ(n, s, t) : HQ(n, s);
      return r(u), !0;
    }
    return !1;
  };
}
function _Q(t) {
  return function(e, r) {
    var n = e.tr, a = e.selection, i = a.$from, o = a.$to;
    if (i.depth < 2 || !i.sameParent(o))
      return !1;
    var s = i.node(-1);
    if (s.type !== t)
      return !1;
    if (i.parent.content.size === 0 && i.node(-1).childCount === i.indexAfter(-1)) {
      if (i.depth === 2 || i.node(-3).type !== t || i.index(-2) !== i.node(-2).childCount - 1)
        return !1;
      for (var l = i.index(-1) > 0, u = q.empty, c = i.depth - (l ? 1 : 2); c >= i.depth - 3; c -= 1)
        u = q.from(i.node(c).copy(u));
      return u = u.append(q.from(t.createAndFill())), n.replace(l ? i.before() : i.before(-1), i.after(-3), new Ce(u, l ? 3 : 2, 2)), n.setSelection(It.near(n.doc.resolve(i.pos + (l ? 3 : 2)))), r(n), !0;
    }
    var v = o.pos === i.end() ? s.contentMatchAt(0).defaultType : null, f = v && [null, { type: v }];
    return n.delete(i.pos, o.pos), Os(n.doc, i.pos, 2, f) ? (n.split(i.pos, 2, f), r(n), !0) : !1;
  };
}
function qQ() {
  return function() {
    return function(t, e) {
      var r = t.selection, n = t.schema, a = r.$from, i = r.$to, o = a.blockRange(i);
      return o && At(a) ? RQ(n.nodes.listItem)(t, e) : !1;
    };
  };
}
function $Q() {
  return function() {
    return function(t, e) {
      var r = t.selection, n = t.schema, a = r.$from, i = r.$to, o = a.blockRange(i);
      return o && At(a) ? PQ(n.nodes.listItem)(t, e) : !1;
    };
  };
}
function Ua() {
  return {
    indent: qQ(),
    outdent: $Q()
  };
}
var Co = /* @__PURE__ */ new Map(), Z = (
  /** @class */
  (function() {
    function t(e, r, n, a) {
      this.table = e, this.tableRows = r, this.tableStartPos = n, this.rowInfo = a;
    }
    return t.create = function(e) {
      var r = Pe(e, function(p) {
        var h = p.type;
        return h.name === "table";
      });
      if (r) {
        var n = r.node, a = r.depth, i = r.offset, o = Co.get(n);
        if (o?.tableStartPos === i + 1)
          return o;
        var s = [], l = e.start(a), u = n.child(0), c = n.child(1), v = ia(u, l), f = ia(c, l + u.nodeSize);
        u.forEach(function(p) {
          return s.push(p);
        }), c.forEach(function(p) {
          return s.push(p);
        });
        var d = new t(n, s, l, v.concat(f));
        return Co.set(n, d), d;
      }
      return null;
    }, Object.defineProperty(t.prototype, "totalRowCount", {
      get: function() {
        return this.rowInfo.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "totalColumnCount", {
      get: function() {
        return this.rowInfo[0].length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tableStartOffset", {
      get: function() {
        return this.tableStartPos;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tableEndOffset", {
      get: function() {
        return this.tableStartPos + this.table.nodeSize - 1;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getCellInfo = function(e, r) {
      return this.rowInfo[e][r];
    }, t.prototype.posAt = function(e, r) {
      for (var n = 0, a = this.tableStartPos; ; n += 1) {
        var i = a + this.tableRows[n].nodeSize;
        if (n === e) {
          for (var o = r; o < this.totalColumnCount && this.rowInfo[n][o].offset < a; )
            o += 1;
          return o === this.totalColumnCount ? i : this.rowInfo[n][o].offset;
        }
        a = i;
      }
    }, t.prototype.getNodeAndPos = function(e, r) {
      var n = this.rowInfo[e][r];
      return {
        node: this.table.nodeAt(n.offset - this.tableStartOffset),
        pos: n.offset
      };
    }, t.prototype.extendedRowspan = function(e, r) {
      return !1;
    }, t.prototype.extendedColspan = function(e, r) {
      return !1;
    }, t.prototype.getRowspanCount = function(e, r) {
      return 0;
    }, t.prototype.getColspanCount = function(e, r) {
      return 0;
    }, t.prototype.decreaseColspanCount = function(e, r) {
      return 0;
    }, t.prototype.decreaseRowspanCount = function(e, r) {
      return 0;
    }, t.prototype.getColspanStartInfo = function(e, r) {
      return null;
    }, t.prototype.getRowspanStartInfo = function(e, r) {
      return null;
    }, t.prototype.getCellStartOffset = function(e, r) {
      var n = this.rowInfo[e][r].offset;
      return this.extendedRowspan(e, r) ? this.posAt(e, r) : n;
    }, t.prototype.getCellEndOffset = function(e, r) {
      var n = this.rowInfo[e][r], a = n.offset, i = n.nodeSize;
      return this.extendedRowspan(e, r) ? this.posAt(e, r) : a + i;
    }, t.prototype.getCellIndex = function(e) {
      for (var r = 0; r < this.totalRowCount; r += 1)
        for (var n = this.rowInfo[r], a = 0; a < this.totalColumnCount; a += 1)
          if (n[a].offset + 1 > e.pos)
            return [r, a];
      return [0, 0];
    }, t.prototype.getRectOffsets = function(e, r) {
      var n, a, i;
      r === void 0 && (r = e), e.pos > r.pos && (n = [r, e], e = n[0], r = n[1]);
      var o = this.getCellIndex(e), s = o[0], l = o[1], u = this.getCellIndex(r), c = u[0], v = u[1];
      return a = Ci(s, c), s = a[0], c = a[1], i = Ci(l, v), l = i[0], v = i[1], this.getSpannedOffsets({ startRowIdx: s, startColIdx: l, endRowIdx: c, endColIdx: v });
    }, t.prototype.getSpannedOffsets = function(e) {
      return e;
    }, t;
  })()
), ia = function(t, e) {
  var r = [];
  return t.forEach(function(n, a) {
    var i = { rowspanMap: {}, colspanMap: {}, length: 0 };
    n.forEach(function(o, s) {
      for (var l = o.nodeSize, u = 0; i[u]; )
        u += 1;
      i[u] = {
        // 2 is the sum of the front and back positions of the tag
        offset: e + a + s + 2,
        nodeSize: l
      }, i.length += 1;
    }), r.push(i);
  }), r;
};
function FQ(t, e) {
  return Ta(Z.prototype, t), ia = e, Z;
}
function UQ(t, e, r) {
  for (var n = r.startRowIdx, a = r.startColIdx, i = r.endRowIdx, o = r.endColIdx, s = [], l = n; l <= i; l += 1)
    for (var u = a; u <= o; u += 1) {
      var c = e.getCellInfo(l, u), v = c.offset, f = c.nodeSize;
      s.push(new Ku(t.resolve(v + 1), t.resolve(v + f - 1)));
    }
  return s;
}
function VQ(t, e) {
  var r = [];
  return t.childCount && r.push(t), e.childCount && r.push(e), q.from(r);
}
var Va = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r, n) {
      n === void 0 && (n = r);
      var a = this, i = r.node(0), o = Z.create(r), s = o.getRectOffsets(r, n), l = UQ(i, o, s);
      return a = t.call(this, l[0].$from, l[0].$to, l) || this, a.startCell = r, a.endCell = n, a.offsetMap = o, a.isCellSelection = !0, a.visible = !1, a;
    }
    return e.prototype.map = function(r, n) {
      var a = this.startCell.pos, i = this.endCell.pos, o = r.resolve(n.map(a)), s = r.resolve(n.map(i)), l = Z.create(o);
      if (this.offsetMap.totalColumnCount > l.totalColumnCount || this.offsetMap.totalRowCount > l.totalRowCount) {
        var u = { tableBody: 1, tableRow: 2, tableCell: 3, paragraph: 4 }, c = u[s.parent.type.name], v = s.end(s.depth - c), f = Math.min(v - 4, s.pos);
        return Dt.create(r, f);
      }
      return new e(o, s);
    }, e.prototype.eq = function(r) {
      return r instanceof e && r.startCell.pos === this.startCell.pos && r.endCell.pos === this.endCell.pos;
    }, e.prototype.content = function() {
      for (var r = this.startCell.node(-2), n = this.startCell.start(-2), a = r.child(1).firstChild, i = r.child(0).type.create(), o = r.child(1).type.create(), s = Z.create(this.startCell), l = s.getRectOffsets(this.startCell, this.endCell), u = l.startRowIdx, c = l.startColIdx, v = l.endRowIdx, f = l.endColIdx, d = !1, p = u; p <= v; p += 1) {
        for (var h = [], m = c; m <= f; m += 1) {
          var y = s.getCellInfo(p, m).offset, w = r.nodeAt(y - n);
          w && (d = w.type.name === "tableHeadCell", s.extendedRowspan(p, m) || s.extendedColspan(p, m) ? h.push(w.type.create({ extended: !0 })) : h.push(w.copy(w.content)));
        }
        var C = a.copy(q.from(h)), T = d ? i : o;
        T.content = T.content.append(q.from(C));
      }
      return new Ce(VQ(i, o), 1, 1);
    }, e.prototype.toJSON = function() {
      return JSON.stringify(this);
    }, e;
  })(It)
);
function jQ(t, e, r) {
  for (var n = e.nodes, a = n.tableRow, i = n.tableHeadCell, o = n.paragraph, s = [], l = 0; l < t; l += 1) {
    var u = r && r[l], c = o.create(null, u ? e.text(u) : []);
    s.push(i.create(null, c));
  }
  return [a.create(null, s)];
}
function su(t, e, r, n) {
  for (var a = r.nodes, i = a.tableRow, o = a.tableBodyCell, s = a.paragraph, l = [], u = 0; u < t; u += 1) {
    for (var c = [], v = 0; v < e; v += 1) {
      var f = n && n[u * e + v], d = s.create(null, f ? r.text(f) : []);
      c.push(o.create(null, d));
    }
    l.push(i.create(null, c));
  }
  return l;
}
function yr(t, e, r, n) {
  n === void 0 && (n = null);
  for (var a = r.nodes, i = a.tableHeadCell, o = a.tableBodyCell, s = a.paragraph, l = e === 0 ? i : o, u = [], c = 0; c < t; c += 1)
    u.push(l.create(n, s.create()));
  return u;
}
function lu(t, e) {
  for (; t && t !== e; ) {
    if (t.nodeName === "TD" || t.nodeName === "TH")
      return t;
    t = t.parentNode;
  }
  return null;
}
function uu(t) {
  return Pe(t, function(e) {
    var r = e.type;
    return r.name === "tableHeadCell" || r.name === "tableBodyCell";
  });
}
function Me(t) {
  if (t instanceof Dt) {
    var e = t.$anchor, r = uu(e);
    if (r) {
      var n = e.node(0).resolve(e.before(r.depth));
      return { anchor: n, head: n };
    }
  }
  var a = t, i = a.startCell, o = a.endCell;
  return { anchor: i, head: o };
}
function cu(t) {
  var e;
  if (t.size) {
    var r = t.content, n = t.openStart, a = t.openEnd;
    if (r.childCount !== 1)
      return null;
    for (; r.childCount === 1 && (n > 0 && a > 0 || ((e = r.firstChild) === null || e === void 0 ? void 0 : e.type.name) === "table"); )
      n -= 1, a -= 1, r = r.firstChild.content;
    if (r.firstChild.type.name === "tableHead" || r.firstChild.type.name === "tableBody")
      return r;
  }
  return null;
}
function wt(t) {
  var e = t.startRowIdx, r = t.startColIdx, n = t.endRowIdx, a = t.endColIdx, i = n - e + 1, o = a - r + 1;
  return { rowCount: i, columnCount: o };
}
function zQ(t, e) {
  return b(b({}, t.attrs), e);
}
var ze = new pa("cellSelection"), WQ = 2, GQ = (
  /** @class */
  (function() {
    function t(e) {
      this.view = e, this.handlers = {
        mousedown: this.handleMousedown.bind(this),
        mousemove: this.handleMousemove.bind(this),
        mouseup: this.handleMouseup.bind(this)
      }, this.startCellPos = null, this.init();
    }
    return t.prototype.init = function() {
      this.view.dom.addEventListener("mousedown", this.handlers.mousedown);
    }, t.prototype.handleMousedown = function(e) {
      var r = lu(e.target, this.view.dom);
      if (e.button === WQ) {
        e.preventDefault();
        return;
      }
      if (r) {
        var n = this.getCellPos(e);
        n && (this.startCellPos = n), this.bindEvent();
      }
    }, t.prototype.handleMousemove = function(e) {
      var r = ze.getState(this.view.state), n = this.getCellPos(e), a = this.startCellPos, i;
      r ? i = this.view.state.doc.resolve(r) : a !== n && (i = a), i && a && n && this.setCellSelection(a, n);
    }, t.prototype.handleMouseup = function() {
      this.startCellPos = null, this.unbindEvent(), ze.getState(this.view.state) !== null && this.view.dispatch(this.view.state.tr.setMeta(ze, -1));
    }, t.prototype.bindEvent = function() {
      var e = this.view.dom;
      e.addEventListener("mousemove", this.handlers.mousemove), e.addEventListener("mouseup", this.handlers.mouseup);
    }, t.prototype.unbindEvent = function() {
      var e = this.view.dom;
      e.removeEventListener("mousemove", this.handlers.mousemove), e.removeEventListener("mouseup", this.handlers.mouseup);
    }, t.prototype.getCellPos = function(e) {
      var r = e.clientX, n = e.clientY, a = this.view.posAtCoords({ left: r, top: n });
      if (a) {
        var i = this.view.state.doc, o = i.resolve(a.pos), s = uu(o);
        if (s) {
          var l = o.before(s.depth);
          return i.resolve(l);
        }
      }
      return null;
    }, t.prototype.setCellSelection = function(e, r) {
      var n = this.view.state, a = n.selection, i = n.tr, o = ze.getState(this.view.state) === null, s = new Va(e, r);
      if (o || !a.eq(s)) {
        var l = i.setSelection(s);
        o && l.setMeta(ze, r.pos), this.view.dispatch(l);
      }
    }, t.prototype.destroy = function() {
      this.view.dom.removeEventListener("mousedown", this.handlers.mousedown);
    }, t;
  })()
), XQ = L("cell-selected");
function QQ(t) {
  var e = t.selection, r = t.doc;
  if (e instanceof Va) {
    var n = [], a = e.ranges;
    return a.forEach(function(i) {
      var o = i.$from, s = i.$to;
      n.push(fa.node(o.pos - 1, s.pos + 1, { class: XQ }));
    }), va.create(r, n);
  }
  return null;
}
function KQ() {
  return new Ee({
    key: ze,
    state: {
      init: function() {
        return null;
      },
      apply: function(t, e) {
        var r = t.getMeta(ze);
        if (r)
          return r === -1 ? null : r;
        if (Tr(e) || !t.docChanged)
          return e;
        var n = t.mapping.mapResult(e), a = n.deleted, i = n.pos;
        return a ? null : i;
      }
    },
    props: {
      decorations: QQ,
      createSelectionBetween: function(t) {
        var e = t.state;
        return Tr(ze.getState(e)) ? null : e.selection;
      }
    },
    view: function(t) {
      return new GQ(t);
    }
  });
}
var vu = (
  /** @class */
  (function() {
    function t() {
      this.keys = [], this.values = [];
    }
    return t.prototype.getKeyIndex = function(e) {
      return tt(e, this.keys);
    }, t.prototype.get = function(e) {
      return this.values[this.getKeyIndex(e)];
    }, t.prototype.set = function(e, r) {
      var n = this.getKeyIndex(e);
      return n > -1 ? this.values[n] = r : (this.keys.push(e), this.values.push(r)), this;
    }, t.prototype.has = function(e) {
      return this.getKeyIndex(e) > -1;
    }, t.prototype.delete = function(e) {
      var r = this.getKeyIndex(e);
      return r > -1 ? (this.keys.splice(r, 1), this.values.splice(r, 1), !0) : !1;
    }, t.prototype.forEach = function(e, r) {
      var n = this;
      r === void 0 && (r = this), this.values.forEach(function(a, i) {
        a && n.keys[i] && e.call(r, a, n.keys[i], n);
      });
    }, t.prototype.clear = function() {
      this.keys = [], this.values = [];
    }, t;
  })()
), Rn = "en-US", YQ = (
  /** @class */
  (function() {
    function t() {
      this.code = Rn, this.langs = new vu();
    }
    return t.prototype.setCode = function(e) {
      this.code = e || Rn;
    }, t.prototype.setLanguage = function(e, r) {
      var n = this;
      e = [].concat(e), e.forEach(function(a) {
        if (!n.langs.has(a))
          n.langs.set(a, r);
        else {
          var i = n.langs.get(a);
          n.langs.set(a, ma(i, r));
        }
      });
    }, t.prototype.get = function(e, r) {
      r || (r = this.code);
      var n = this.langs.get(r);
      n || (n = this.langs.get(Rn));
      var a = n[e];
      if (!a)
        throw new Error('There is no text key "' + e + '" in ' + r);
      return a;
    }, t;
  })()
), D = new YQ(), ZQ = [
  [
    {
      action: "Add row to up",
      command: "addRowToUp",
      disableInThead: !0,
      className: "add-row-up"
    },
    {
      action: "Add row to down",
      command: "addRowToDown",
      disableInThead: !0,
      className: "add-row-down"
    },
    { action: "Remove row", command: "removeRow", disableInThead: !0, className: "remove-row" }
  ],
  [
    { action: "Add column to left", command: "addColumnToLeft", className: "add-column-left" },
    { action: "Add column to right", command: "addColumnToRight", className: "add-column-right" },
    { action: "Remove column", command: "removeColumn", className: "remove-column" }
  ],
  [
    {
      action: "Align column to left",
      command: "alignColumn",
      payload: { align: "left" },
      className: "align-column-left"
    },
    {
      action: "Align column to center",
      command: "alignColumn",
      payload: { align: "center" },
      className: "align-column-center"
    },
    {
      action: "Align column to right",
      command: "alignColumn",
      payload: { align: "right" },
      className: "align-column-right"
    }
  ],
  [{ action: "Remove table", command: "removeTable", className: "remove-table" }]
];
function JQ(t, e) {
  return ZQ.map(function(r) {
    return r.map(function(n) {
      var a = n.action, i = n.command, o = n.payload, s = n.disableInThead, l = n.className;
      return {
        label: D.get(a),
        onClick: function() {
          t.emit("command", i, o);
        },
        disabled: e && !!s,
        className: l
      };
    });
  }).concat();
}
function eK(t) {
  return new Ee({
    props: {
      handleDOMEvents: {
        contextmenu: function(e, r) {
          var n = lu(r.target, e.dom);
          if (n) {
            r.preventDefault();
            var a = r, i = a.clientX, o = a.clientY, s = e.dom.parentNode.getBoundingClientRect(), l = s.left, u = s.top, c = n.nodeName === "TH";
            return t.emit("contextmenu", {
              pos: { left: i - l + 10 + "px", top: o - u + 30 + "px" },
              menuGroups: JQ(t, c),
              tableCell: n
            }), !0;
          }
          return !1;
        }
      }
    }
  });
}
function tK() {
  return new Ee({
    props: {
      handleDOMEvents: {
        mousedown: function(t, e) {
          var r = e, n = r.clientX, a = r.clientY, i = t.posAtCoords({ left: n, top: a });
          if (i) {
            var o = t.state, s = o.doc, l = o.tr, u = s.resolve(i.pos), c = St(u), v = e.target, f = getComputedStyle(v, ":before"), d = e, p = d.offsetX, h = d.offsetY;
            if (!c || !xa(f, p, h))
              return !1;
            e.preventDefault();
            var m = u.before(c.depth), y = c.node.attrs;
            return l.setNodeMarkup(m, null, b(b({}, y), { checked: !y.checked })), t.dispatch(l), !0;
          }
          return !1;
        }
      }
    }
  });
}
var rK = ["image", "link", "customBlock", "frontMatter"], nK = ["strong", "strike", "emph", "code"], fu = ["bulletList", "orderedList", "taskList"];
function aK(t, e) {
  var r = t.type.name;
  return r === "listItem" ? t.attrs.task ? "taskList" : e.type.name : r.indexOf("table") !== -1 ? "table" : r;
}
function iK(t, e) {
  e[t] = { active: !0 }, fu.filter(function(r) {
    return r !== t;
  }).forEach(function(r) {
    e[r] && delete e[r];
  });
}
function oK(t, e, r, n) {
  nK.forEach(function(a) {
    var i = r.marks[a], o = t.marksAcross(e) || [], s = !!i.isInSet(o);
    s && (n[a] = { active: !0 });
  });
}
function sK(t, e, r) {
  var n = t.$from, a = t.$to, i = t.from, o = t.to, s = {
    indent: { active: !1, disabled: !0 },
    outdent: { active: !1, disabled: !0 }
  };
  return e.nodesBetween(i, o, function(l, u, c) {
    var v = aK(l, c);
    te(rK, v) || (te(fu, v) ? (iK(v, s), s.indent.disabled = !1, s.outdent.disabled = !1) : v === "paragraph" || v === "text" ? oK(n, a, r, s) : s[v] = { active: !0 });
  }), s;
}
function lK(t) {
  return new Ee({
    view: function() {
      return {
        update: function(e) {
          var r = e.state, n = r.selection, a = r.doc, i = r.schema;
          t.emit("changeToolbarState", {
            toolbarState: sK(n, a, i)
          });
        }
      };
    }
  });
}
var uK = (
  /** @class */
  (function() {
    function t(e, r, n, a) {
      var i = this;
      this.openEditor = function() {
        if (i.innerEditorView)
          throw new Error("The editor is already opened.");
        i.dom.draggable = !1, i.wrapper.style.display = "none", i.innerViewContainer.style.display = "block", i.innerEditorView = new da(i.innerViewContainer, {
          state: Ds.create({
            doc: i.node,
            plugins: [
              zt({
                "Mod-z": function() {
                  return pr(i.innerEditorView.state, i.innerEditorView.dispatch);
                },
                "Shift-Mod-z": function() {
                  return Ps(i.innerEditorView.state, i.innerEditorView.dispatch);
                },
                Tab: function(o, s) {
                  return s(o.tr.insertText("	")), !0;
                },
                Enter: rc,
                Escape: function() {
                  return i.cancelEditing(), !0;
                },
                "Ctrl-Enter": function() {
                  return i.saveAndFinishEditing(), !0;
                }
              }),
              Hs()
            ]
          }),
          dispatchTransaction: function(o) {
            return i.dispatchInner(o);
          },
          handleDOMEvents: {
            mousedown: function() {
              return i.editorView.hasFocus() && i.innerEditorView.focus(), !0;
            },
            blur: function() {
              return i.saveAndFinishEditing(), !0;
            }
          }
        }), i.innerEditorView.focus();
      }, this.node = e, this.editorView = r, this.getPos = n, this.toDOMAdaptor = a, this.innerEditorView = null, this.canceled = !1, this.dom = document.createElement("div"), this.dom.className = L("custom-block"), this.wrapper = document.createElement("div"), this.wrapper.className = L("custom-block-view"), this.createInnerViewContainer(), this.renderCustomBlock(), this.dom.appendChild(this.innerViewContainer), this.dom.appendChild(this.wrapper);
    }
    return t.prototype.renderToolArea = function() {
      var e = this, r = document.createElement("div"), n = document.createElement("span"), a = document.createElement("button");
      r.className = "tool", n.textContent = this.node.attrs.info, n.className = "info", a.type = "button", a.addEventListener("click", function() {
        return e.openEditor();
      }), r.appendChild(n), r.appendChild(a), this.wrapper.appendChild(r);
    }, t.prototype.renderCustomBlock = function() {
      var e = this.toDOMAdaptor.getToDOMNode(this.node.attrs.info);
      if (e) {
        for (var r = e(this.node); this.wrapper.hasChildNodes(); )
          this.wrapper.removeChild(this.wrapper.lastChild);
        r && this.wrapper.appendChild(r), this.renderToolArea();
      }
    }, t.prototype.createInnerViewContainer = function() {
      this.innerViewContainer = document.createElement("div"), this.innerViewContainer.className = L("custom-block-editor"), this.innerViewContainer.style.display = "none";
    }, t.prototype.closeEditor = function() {
      this.innerEditorView && (this.innerEditorView.destroy(), this.innerEditorView = null, this.innerViewContainer.style.display = "none"), this.wrapper.style.display = "block";
    }, t.prototype.saveAndFinishEditing = function() {
      var e = this.editorView.state.selection.to, r = this.editorView.state;
      this.editorView.dispatch(r.tr.setSelection(F(r.tr, e))), this.editorView.focus(), this.renderCustomBlock(), this.closeEditor();
    }, t.prototype.cancelEditing = function() {
      var e = ac(this.innerEditorView.state);
      for (this.canceled = !0; e--; )
        pr(this.innerEditorView.state, this.innerEditorView.dispatch), pr(this.editorView.state, this.editorView.dispatch);
      this.canceled = !1;
      var r = this.editorView.state.selection.to, n = this.editorView.state;
      this.editorView.dispatch(n.tr.setSelection(Dt.create(n.doc, r))), this.editorView.focus(), this.closeEditor();
    }, t.prototype.dispatchInner = function(e) {
      var r = this.innerEditorView.state.applyTransaction(e), n = r.state, a = r.transactions;
      if (this.innerEditorView.updateState(n), !this.canceled && he(this.getPos)) {
        for (var i = this.editorView.state.tr, o = Xu.offset(this.getPos() + 1), s = 0; s < a.length; s += 1)
          for (var l = a[s].steps, u = 0; u < l.length; u += 1)
            i.step(l[u].map(o));
        i.docChanged && this.editorView.dispatch(i);
      }
    }, t.prototype.update = function(e) {
      return e.sameMarkup(this.node) ? (this.node = e, this.innerEditorView || this.renderCustomBlock(), !0) : !1;
    }, t.prototype.stopEvent = function(e) {
      return !!this.innerEditorView && !!e.target && this.innerEditorView.dom.contains(e.target);
    }, t.prototype.ignoreMutation = function() {
      return !0;
    }, t.prototype.destroy = function() {
      this.dom.removeEventListener("dblclick", this.openEditor), this.closeEditor();
    }, t;
  })()
), To = "image-link", cK = (
  /** @class */
  (function() {
    function t(e, r, n, a) {
      var i = this, o;
      this.handleMousedown = function(s) {
        s.preventDefault();
        var l = s.target, u = s.offsetX, c = s.offsetY;
        if (i.imageLink && he(i.getPos) && Ws(l, To)) {
          var v = getComputedStyle(l, ":before");
          if (s.stopPropagation(), xa(v, u, c)) {
            var f = i.view.state.tr, d = i.getPos();
            f.setSelection(F(f, d, d + 1)), i.view.dispatch(f), i.eventEmitter.emit("openPopup", "link", i.imageLink.attrs);
          }
        }
      }, this.node = e, this.view = r, this.getPos = n, this.eventEmitter = a, this.imageLink = (o = e.marks.filter(function(s) {
        var l = s.type;
        return l.name === "link";
      })[0]) !== null && o !== void 0 ? o : null, this.dom = this.createElement(), this.bindEvent();
    }
    return t.prototype.createElement = function() {
      var e = this.createImageElement(this.node);
      if (this.imageLink) {
        var r = document.createElement("span");
        return r.className = To, r.appendChild(e), r;
      }
      return e;
    }, t.prototype.createImageElement = function(e) {
      var r = document.createElement("img"), n = e.attrs, a = n.imageUrl, i = n.altText, o = z(e.attrs);
      return r.src = a, i && (r.alt = i), Aa(o, r), r;
    }, t.prototype.bindEvent = function() {
      this.imageLink && this.dom.addEventListener("mousedown", this.handleMousedown);
    }, t.prototype.stopEvent = function() {
      return !0;
    }, t.prototype.destroy = function() {
      this.imageLink && this.dom.removeEventListener("mousedown", this.handleMousedown);
    }, t;
  })()
), vK = "toastui-editor-ww-code-block", fK = "toastui-editor-ww-code-block-language", dK = (
  /** @class */
  (function() {
    function t(e, r, n, a) {
      var i = this;
      this.contentDOM = null, this.input = null, this.timer = null, this.handleMousedown = function(o) {
        var s = o.target, l = getComputedStyle(s, ":after");
        if (l.backgroundImage !== "none" && he(i.getPos)) {
          var u = i.view.coordsAtPos(i.getPos()), c = u.top, v = u.right;
          i.createLanguageEditor({ top: c, right: v });
        }
      }, this.handleKeydown = function(o) {
        o.key === "Enter" && i.input && (o.preventDefault(), i.changeLanguage());
      }, this.node = e, this.view = r, this.getPos = n, this.eventEmitter = a, this.createElement(), this.bindDOMEvent(), this.bindEvent();
    }
    return t.prototype.createElement = function() {
      var e = this.node.attrs.language, r = document.createElement("div");
      r.setAttribute("data-language", e || "text"), r.className = vK;
      var n = this.createCodeBlockElement(), a = n.firstChild;
      r.appendChild(n), this.dom = r, this.contentDOM = a;
    }, t.prototype.createCodeBlockElement = function() {
      var e = document.createElement("pre"), r = document.createElement("code"), n = this.node.attrs.language, a = z(this.node.attrs);
      return n && r.setAttribute("data-language", n), Aa(a, e), e.appendChild(r), e;
    }, t.prototype.createLanguageEditor = function(e) {
      var r = this, n = e.top, a = e.right, i = document.createElement("span");
      i.className = fK;
      var o = document.createElement("input");
      o.type = "text", o.value = this.node.attrs.language, i.appendChild(o), this.view.dom.parentElement.appendChild(i);
      var s = i.clientWidth;
      Oe(i, {
        top: n + 10 + "px",
        left: a - s - 10 + "px",
        width: s + "px"
      }), this.input = o, this.input.addEventListener("blur", function() {
        return r.changeLanguage();
      }), this.input.addEventListener("keydown", this.handleKeydown), this.clearTimer(), this.timer = setTimeout(function() {
        r.input.focus();
      });
    }, t.prototype.bindDOMEvent = function() {
      this.dom && this.dom.addEventListener("click", this.handleMousedown);
    }, t.prototype.bindEvent = function() {
      var e = this;
      this.eventEmitter.listen("scroll", function() {
        e.input && e.reset();
      });
    }, t.prototype.changeLanguage = function() {
      if (this.input && he(this.getPos)) {
        var e = this.input.value;
        this.reset();
        var r = this.getPos(), n = this.view.state.tr;
        n.setNodeMarkup(r, null, { language: e }), this.view.dispatch(n);
      }
    }, t.prototype.reset = function() {
      var e;
      if (!((e = this.input) === null || e === void 0) && e.parentElement) {
        var r = this.input.parentElement;
        this.input = null, nt(r);
      }
    }, t.prototype.clearTimer = function() {
      this.timer && (clearTimeout(this.timer), this.timer = null);
    }, t.prototype.stopEvent = function() {
      return !0;
    }, t.prototype.update = function(e) {
      return e.sameMarkup(this.node) ? (this.node = e, !0) : !1;
    }, t.prototype.destroy = function() {
      this.reset(), this.clearTimer(), this.dom && this.dom.removeEventListener("click", this.handleMousedown);
    }, t;
  })()
), pK = /MsoListParagraph/, du = /style=(.|\n)*mso-/, pu = /mso-list:(.*)/, hK = /O:P/, mK = /^(n|u|l)/, gK = "p.MsoListParagraph";
function yK(t) {
  return du.test(t);
}
function bK(t) {
  for (var e = [], r = document.createTreeWalker(t, 1, null, !1); r.nextNode(); ) {
    var n = r.currentNode;
    if (jr(n)) {
      var a = n, i = a.outerHTML, o = a.textContent, s = du.test(i), l = pu.test(i);
      s && !l && o ? e.push([n, !0]) : (hK.test(n.nodeName) || s && !o || l) && e.push([n, !1]);
    }
  }
  return e.forEach(function(u) {
    var c = u[0], v = u[1];
    v ? Pv(c) : nt(c);
  }), t.innerHTML.trim();
}
function wK(t, e) {
  var r = t.getAttribute("style");
  if (r) {
    var n = r.match(pu), a = n[1], i = a.trim().split(" "), o = i[1], s = parseInt(o.replace("level", ""), 10), l = mK.test(t.textContent || "");
    return {
      id: e,
      level: s,
      prev: null,
      parent: null,
      children: [],
      unordered: l,
      contents: bK(t)
    };
  }
  return null;
}
function CK(t, e) {
  if (e.level < t.level)
    e.children.push(t), t.parent = e;
  else {
    for (; e && e.level !== t.level; )
      e = e.parent;
    e && (t.prev = e, t.parent = e.parent, t.parent && t.parent.children.push(t));
  }
}
function TK(t) {
  var e = [];
  return t.forEach(function(r, n) {
    var a = e[n - 1], i = wK(r, n);
    i && (a && CK(i, a), e.push(i));
  }), e;
}
function hu(t) {
  var e = t[0].unordered ? "ul" : "ol", r = document.createElement(e);
  return t.forEach(function(n) {
    var a = n.children, i = n.contents, o = document.createElement("li");
    o.innerHTML = i, r.appendChild(o), a.length && r.appendChild(hu(a));
  }), r;
}
function kK(t) {
  var e = TK(t), r = e.filter(function(n) {
    var a = n.parent;
    return !a;
  });
  return hu(r);
}
function EK(t) {
  for (; t && !jr(t); )
    t = t.nextSibling;
  return t ? !pK.test(t.className) : !0;
}
function xK(t) {
  var e = document.createElement("div");
  e.innerHTML = t;
  var r = [], n = Rv(e, gK);
  n.forEach(function(i) {
    var o = EK(i.nextSibling);
    if (r.push(i), o) {
      var s = kK(r), l = i.nextSibling;
      l ? Hv(s, l) : Bv(e, s), r = [];
    }
    nt(i);
  });
  var a = n.length ? "<p></p>" : "";
  return "" + a + e.innerHTML;
}
var ko = "<!--StartFragment-->", LK = "<!--EndFragment-->";
function MK(t) {
  var e = t.indexOf(ko), r = t.lastIndexOf(LK);
  return e > -1 && r > -1 && (t = t.slice(e + ko.length, r)), t.replace(/<br[^>]*>/g, Ys);
}
function AK(t) {
  return /<\/td>((?!<\/tr>)[\s\S])*$/i.test(t) && (t = "<tr>" + t + "</tr>"), /<\/tr>((?!<\/table>)[\s\S])*$/i.test(t) && (t = "<table>" + t + "</table>"), t;
}
function SK(t) {
  return t = MK(t), t = AK(t), yK(t) && (t = xK(t)), t;
}
function OK(t) {
  var e = t.reduce(function(r, n) {
    return r.childCount > n.childCount ? r : n;
  });
  return e.childCount;
}
function mu(t, e, r) {
  for (var n = [], a = t.childCount, i = 0; i < a; i += 1)
    if (!t.child(i).attrs.extended) {
      var o = i < a ? r.create(t.child(i).attrs, t.child(i).content) : r.createAndFill();
      n.push(o);
    }
  return n;
}
function gu(t, e, r) {
  var n = r.nodes, a = n.tableRow, i = n.tableHeadCell, o = mu(t, e, i);
  return a.create(null, o);
}
function yu(t, e, r) {
  var n = r.nodes, a = n.tableRow, i = n.tableBodyCell, o = mu(t, e, i);
  return a.create(null, o);
}
function DK(t, e) {
  for (var r = e.nodes, n = r.tableRow, a = r.tableBodyCell, i = [], o = 0; o < t; o += 1) {
    var s = a.createAndFill();
    i.push(s);
  }
  return n.create({ dummyRowForPasting: !0 }, i);
}
function bu(t) {
  var e = [], r = [];
  if (t.firstChild.type.name === "tableHead") {
    var n = t.firstChild;
    n.forEach(function(i) {
      return e.push(i);
    });
  }
  if (t.lastChild.type.name === "tableBody") {
    var a = t.lastChild;
    a.forEach(function(i) {
      return r.push(i);
    });
  }
  return ce(ce([], e), r);
}
function IK(t, e, r) {
  var n = gu(t, e, r);
  return r.nodes.tableHead.create(null, n);
}
function Eo(t, e, r) {
  var n = t.map(function(i) {
    return yu(i, e, r);
  });
  if (!t.length) {
    var a = DK(e, r);
    n.push(a);
  }
  return r.nodes.tableBody.create(null, n);
}
function NK(t, e, r, n) {
  var a = OK(t);
  if (r && n)
    return e.nodes.table.create(null, [Eo(t, a, e)]);
  var i = t[0], o = t.slice(1), s = [IK(i, a, e)];
  return o.length && s.push(Eo(o, a, e)), e.nodes.table.create(null, s);
}
function RK(t, e, r) {
  var n = [], a = t.content, i = t.openStart, o = t.openEnd;
  return a.forEach(function(s) {
    if (s.type.name === "table") {
      var l = cu(new Ce(q.from(s), 0, 0));
      if (l) {
        var u = bu(l), c = l.firstChild.type.name === "tableBody", v = NK(u, e, c, r);
        n.push(v);
      }
    } else
      n.push(s);
  }), new Ce(q.from(n), i, o);
}
var BK = 4, HK = 2;
function br(t) {
  return t * BK;
}
function PK(t, e, r) {
  var n = [], a = bu(t), i = a[0].childCount, o = a.length, s = e.startRowIdx === 0, l = a.slice(0, o);
  if (s) {
    var u = l.shift();
    if (u) {
      var c = gu(u, i, r).content;
      n.push(c);
    }
  }
  return l.forEach(function(v) {
    if (!v.attrs.dummyRowForPasting) {
      var f = yu(v, i, r).content;
      n.push(f);
    }
  }), n;
}
function _K(t, e, r) {
  for (var n = e.startRowIdx, a = e.startColIdx, i = r.length, o = 0, s = function(d) {
    var p = r[d].childCount;
    r[d].forEach(function(h) {
      var m = h.attrs, y = m.colspan;
      y > 1 && (p += y - 1);
    }), o = Math.max(o, p);
  }, l = 0; l < i; l += 1)
    s(l);
  var u = n + i - 1, c = a + o - 1, v = Math.max(u + 1 - t.totalRowCount, 0), f = Math.max(c + 1 - t.totalColumnCount, 0);
  return {
    startRowIdx: n,
    startColIdx: a,
    endRowIdx: u,
    endColIdx: c,
    addedRowCount: v,
    addedColumnCount: f
  };
}
function qK(t, e) {
  for (var r = t.startRowIdx, n = t.startColIdx, a = t.endRowIdx, i = t.endColIdx, o = t.addedRowCount, s = t.addedColumnCount, l = r; l <= a - o; l += 1)
    e.push({
      rowIdx: l,
      startColIdx: n,
      endColIdx: i - s
    });
}
function $K(t, e, r, n, a) {
  for (var i = n.startRowIdx, o = n.startColIdx, s = n.endRowIdx, l = n.endColIdx, u = n.addedRowCount, c = n.addedColumnCount, v = r.totalRowCount, f = 0, d = 0; d < v; d += 1) {
    var p = r.getCellInfo(d, l - c), h = p.offset, m = p.nodeSize, y = t.mapping.map(h + m), w = yr(c, d, e);
    if (t.insert(y, w), d >= i && d <= s - u) {
      var C = r.getCellInfo(d, l - c), T = t.mapping.map(C.offset), k = y + br(c);
      a[f] = {
        rowIdx: d,
        startColIdx: o,
        endColIdx: l,
        dummyOffsets: [T, k]
      }, f += 1;
    }
  }
}
function FK(t, e, r, n, a) {
  var i = n.addedRowCount, o = n.addedColumnCount, s = n.startColIdx, l = n.endColIdx, u = t.mapping.maps.length, c = r.tableEndOffset - 2, v = su(i, r.totalColumnCount + o, e), f = c;
  t.insert(t.mapping.slice(u).map(f), v);
  for (var d = 0; d < i; d += 1) {
    var p = f + br(s) + 1, h = f + br(l + 1) + 1, m = f + br(r.totalColumnCount + o) + HK;
    a.push({
      rowIdx: d + r.totalRowCount,
      startColIdx: s,
      endColIdx: l,
      dummyOffsets: [p, h]
    }), f = m;
  }
}
function UK(t, e, r, n) {
  var a = t.mapping.maps.length;
  r.forEach(function(i, o) {
    var s = i.rowIdx, l = i.startColIdx, u = i.endColIdx, c = i.dummyOffsets, v = t.mapping.slice(a), f = new Ce(e[o], 0, 0), d = c ? c[0] : n.getCellStartOffset(s, l), p = c ? c[1] : n.getCellEndOffset(s, u);
    t.replace(v.map(d), v.map(p), f);
  });
}
function VK(t, e) {
  var r = t.state, n = r.selection, a = r.schema, i = r.tr, o = Me(n), s = o.anchor, l = o.head;
  if (s && l) {
    var u = cu(e);
    if (!u)
      return !1;
    var c = Z.create(s), v = c.getRectOffsets(s, l), f = PK(u, v, a), d = _K(c, v, f), p = [];
    return zK(c, d) && (qK(d, p), d.addedColumnCount && $K(i, a, c, d, p), d.addedRowCount && FK(i, a, c, d, p), UK(i, f, p, c), t.dispatch(i), jK(t, p, c.getCellInfo(0, 0).offset)), !0;
  }
  return !1;
}
function jK(t, e, r) {
  var n = t.state, a = n.tr, i = n.doc, o = Z.create(i.resolve(r)), s = e[0], l = s.rowIdx, u = s.startColIdx, c = se(e), v = c.rowIdx, f = c.endColIdx, d = o.getCellInfo(l, u).offset, p = o.getCellInfo(v, f).offset;
  t.dispatch(a.setSelection(new Va(i.resolve(d), i.resolve(p))));
}
function zK(t, e) {
  var r = t.getSpannedOffsets(e), n = wt(r), a = n.rowCount, i = n.columnCount, o = wt(e), s = o.rowCount, l = o.columnCount;
  return a === s && i === l;
}
var WK = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "doc";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "block+"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), GK = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "paragraph";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "inline*",
          group: "block",
          attrs: b({}, K()),
          parseDOM: [{ tag: "p" }],
          toDOM: function(r) {
            var n = r.attrs;
            return ["p", z(n), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), XK = /\s{1,4}$/, QK = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "text";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          group: "inline"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addSpaces = function() {
      return function(r, n) {
        var a = r.selection, i = r.tr, o = a.$from, s = a.$to, l = o.blockRange(s);
        return l && !At(o) && !Hr(o) ? (n(i.insertText("    ", o.pos, s.pos)), !0) : !1;
      };
    }, e.prototype.removeSpaces = function() {
      return function(r, n) {
        var a = r.selection, i = r.tr, o = a.$from, s = a.$to, l = a.from, u = o.blockRange(s);
        if (u && !At(o) && !Hr(o)) {
          var c = o.nodeBefore;
          if (c && c.isText) {
            var v = c.text, f = v.replace(XK, ""), d = v.length - f.length;
            return n(i.delete(l - d, l)), !0;
          }
        }
        return !1;
      };
    }, e.prototype.keymaps = function() {
      return {
        Tab: this.addSpaces(),
        "Shift-Tab": this.removeSpaces()
      };
    }, e;
  })($)
), KK = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "heading";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "levels", {
      get: function() {
        return [1, 2, 3, 4, 5, 6];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        var r = this.levels.map(function(n) {
          return {
            tag: "h" + n,
            getAttrs: function(a) {
              var i = a.getAttribute("data-raw-html");
              return b({ level: n }, i && { rawHTML: i });
            }
          };
        });
        return {
          attrs: b({ level: { default: 1 }, headingType: { default: "atx" }, rawHTML: { default: null } }, K()),
          content: "inline*",
          group: "block",
          defining: !0,
          parseDOM: r,
          toDOM: function(n) {
            var a = n.attrs;
            return ["h" + a.level, z(a), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function(r) {
        return function(n, a) {
          var i = n.schema.nodes[r.level ? "heading" : "paragraph"];
          return ha(i, r)(n, a);
        };
      };
    }, e;
  })($)
), YK = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "codeBlock";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "text*",
          group: "block",
          attrs: b({ language: { default: null }, rawHTML: { default: null } }, K()),
          code: !0,
          defining: !0,
          marks: "",
          parseDOM: [
            {
              tag: "pre",
              preserveWhitespace: "full",
              getAttrs: function(r) {
                var n = r.getAttribute("data-raw-html"), a = r.firstElementChild;
                return b({ language: a?.getAttribute("data-language") || null }, n && { rawHTML: n });
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs;
            return [
              n.rawHTML || "pre",
              ["code", b({ "data-language": n.language }, z(n)), 0]
            ];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n) {
          return ha(r.schema.nodes.codeBlock)(r, n);
        };
      };
    }, e.prototype.moveCursor = function(r) {
      var n = this;
      return function(a, i) {
        var o = a.tr, s = a.doc, l = a.schema, u = a.selection.$from, c = n.context.view;
        if (c.endOfTextblock(r) && u.node().type.name === "codeBlock") {
          var v = u.parent.textContent.split(`
`), f = r === "up" ? u.start() : u.end(), d = r === "up" ? [f, v[0].length + f] : [f - se(v).length, f], p = s.resolve(r === "up" ? u.before() : u.after()), h = r === "up" ? p.nodeBefore : p.nodeAfter;
          if (rv(u.pos, d[0], d[1]) && !h) {
            var m = ka(o, p, l);
            if (m)
              return i(m), !0;
          }
        }
        return !1;
      };
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return {
        "Shift-Mod-p": r,
        "Shift-Mod-P": r,
        ArrowUp: this.moveCursor("up"),
        ArrowDown: this.moveCursor("down")
      };
    }, e;
  })($)
), ZK = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "bulletList";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "listItem+",
          group: "block",
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: [Yr("ul")],
          toDOM: function(r) {
            var n = r.attrs;
            return ["ul", z(n), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.changeList = function() {
      return function(r, n) {
        return ou(r.schema.nodes.bulletList)(r, n);
      };
    }, e.prototype.commands = function() {
      return {
        bulletList: this.changeList,
        taskList: NQ
      };
    }, e.prototype.keymaps = function() {
      var r = this.changeList(), n = Ua(), a = n.indent, i = n.outdent;
      return {
        "Mod-u": r,
        "Mod-U": r,
        Tab: a(),
        "Shift-Tab": i()
      };
    }, e;
  })($)
), JK = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "orderedList";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "listItem+",
          group: "block",
          attrs: b({ order: { default: 1 }, rawHTML: { default: null } }, K()),
          parseDOM: [
            {
              tag: "ol",
              getAttrs: function(r) {
                var n = r.getAttribute("start"), a = r.getAttribute("data-raw-html");
                return b({ order: r.hasAttribute("start") ? Number(n) : 1 }, a && { rawHTML: a });
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs;
            return [
              n.rawHTML || "ol",
              b({ start: n.order === 1 ? null : n.order }, z(n)),
              0
            ];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n) {
          return ou(r.schema.nodes.orderedList)(r, n);
        };
      };
    }, e.prototype.keymaps = function() {
      var r = this.commands()(), n = Ua(), a = n.indent, i = n.outdent;
      return {
        "Mod-o": r,
        "Mod-O": r,
        Tab: a(),
        "Shift-Tab": i()
      };
    }, e;
  })($)
), e7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "listItem";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "paragraph block*",
          selectable: !1,
          attrs: {
            task: { default: !1 },
            checked: { default: !1 },
            rawHTML: { default: null }
          },
          defining: !0,
          parseDOM: [
            {
              tag: "li",
              getAttrs: function(r) {
                var n = r.getAttribute("data-raw-html");
                return b({ task: r.hasAttribute("data-task"), checked: r.hasAttribute("data-task-checked") }, n && { rawHTML: n });
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs, a = n.task, i = n.checked;
            if (!a)
              return [n.rawHTML || "li", 0];
            var o = ["task-list-item"];
            return i && o.push("checked"), [
              n.rawHTML || "li",
              b({ class: o.join(" "), "data-task": a }, i && { "data-task-checked": i }),
              0
            ];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.liftToPrevListItem = function() {
      return function(r, n) {
        var a = r.selection, i = r.tr, o = r.schema, s = a.$from, l = a.empty, u = o.nodes.listItem, c = s.parent, v = s.node(-1);
        if (l && !c.childCount && v.type === u) {
          if (s.index(-2) >= 1)
            return i.delete(s.start(-1) - 1, s.end(-1)), n(i), !0;
          var f = s.node(-3);
          if (f.type === u)
            return i.delete(s.start(-2) - 1, s.end(-1)), n(i), !0;
        }
        return !1;
      };
    }, e.prototype.keymaps = function() {
      var r = function(n, a) {
        return _Q(n.schema.nodes.listItem)(n, a);
      };
      return {
        Backspace: this.liftToPrevListItem(),
        Enter: r
      };
    }, e;
  })($)
), t7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "blockQuote";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: b({ rawHTML: { default: null } }, K()),
          content: "block+",
          group: "block",
          parseDOM: [Yr("blockquote")],
          toDOM: function(r) {
            var n = r.attrs;
            return ["blockquote", z(n), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n) {
          return Zu(r.schema.nodes.blockQuote)(r, n);
        };
      };
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return {
        "Alt-q": r,
        "Alt-Q": r
      };
    }, e;
  })($)
), r7 = {
  left: c7,
  right: u7,
  up: v7,
  down: f7
};
function n7(t, e, r) {
  var n = r[0], a = r[1], i = e.resolve(t.before(n - 1));
  return a === n && !i.nodeBefore;
}
function a7(t) {
  for (var e, r = t.depth, n; r && (n = t.node(r), n.type.name !== "tableBodyCell"); ) {
    if (n.type.name === "listItem") {
      var a = t.node(r - 1), i = a.lastChild === n, o = ((e = n.lastChild) === null || e === void 0 ? void 0 : e.type.name) !== "paragraph";
      return i ? !o : !1;
    }
    r -= 1;
  }
  return !1;
}
function i7(t, e, r, n, a) {
  var i = e[0], o = e[1], s = e[2];
  if (t === "left" || t === "up") {
    if (a && !n7(r, n, [i, o]))
      return !1;
    var l = r.before(s), u = n.resolve(l).nodeBefore;
    if (u)
      return !1;
  }
  return !0;
}
function o7(t, e, r, n, a) {
  if (t === "right" || t === "down") {
    if (a && !a7(r))
      return !1;
    var i = r.after(e), o = n.resolve(i).nodeAfter;
    if (o)
      return !1;
  }
  return !0;
}
function s7(t, e, r, n) {
  var a = e[0], i = e[1], o = a + 3, s = i >= o, l = s ? a + 1 : i, u = i7(t, [i, o, l], r, n, s), c = o7(t, l, r, n, s);
  return u && c;
}
function xo(t, e, r) {
  var n = r[0], a = r[1], i = e.getRowspanStartInfo(n, a), o = t === "up" && n === 0, s = t === "down" && (i?.count > 1 ? n + i.count - 1 : n) === e.totalRowCount - 1;
  return o || s;
}
function l7(t, e, r) {
  var n = t.doc.resolve(e.tableStartOffset - 1);
  return n.nodeBefore ? t.setSelection(It.near(n, -1)) : ka(t, n, r);
}
function Bn(t, e, r, n) {
  n === void 0 && (n = !1);
  var a = t.doc.resolve(e.tableEndOffset);
  return n || !a.nodeAfter ? ka(t, a, r) : t.setSelection(It.near(a, 1));
}
function u7(t, e) {
  var r = t[0], n = t[1], a = e.totalRowCount, i = e.totalColumnCount, o = n === i - 1, s = r === a - 1 && o;
  if (!s) {
    var l = n + 1, u = e.getColspanStartInfo(r, n);
    u?.count > 1 && (l += u.count - 1), (o || l === i) && (r += 1, l = 0);
    var c = e.getCellInfo(r, l).offset;
    return c + 2;
  }
  return null;
}
function c7(t, e) {
  var r = t[0], n = t[1], a = e.totalColumnCount, i = n === 0, o = r === 0 && i;
  if (!o) {
    n -= 1, i && (r -= 1, n = a - 1);
    var s = e.getCellInfo(r, n), l = s.offset, u = s.nodeSize;
    return l + u - 2;
  }
  return null;
}
function v7(t, e) {
  var r = t[0], n = t[1];
  if (r > 0) {
    var a = e.getCellInfo(r - 1, n), i = a.offset, o = a.nodeSize;
    return i + o - 2;
  }
  return null;
}
function f7(t, e) {
  var r = t[0], n = t[1], a = e.totalRowCount;
  if (r < a - 1) {
    var i = r + 1, o = e.getRowspanStartInfo(r, n);
    o?.count > 1 && (i += o.count - 1);
    var s = e.getCellInfo(i, n).offset;
    return s + 2;
  }
  return null;
}
function Lo(t, e, r, n) {
  var a = r7[t], i = a(r, n);
  if (i) {
    var o = t === "right" || t === "down" ? 1 : -1;
    return e.setSelection(It.near(e.doc.resolve(i), o));
  }
  return null;
}
function d7(t, e, r) {
  var n = r[0], a = r[1];
  if (t === "up" || t === "down")
    return !1;
  var i = e.tableStartOffset, o = e.tableEndOffset, s = e.getCellInfo(n, a), l = s.offset, u = s.nodeSize, c = t === "left" ? i : o, v = t === "left" ? l - 2 : l + u + 3;
  return c === v;
}
function p7(t, e, r) {
  var n = t.doc.resolve(e.before(r - 3));
  return t.setSelection(new Qu(n));
}
function h7(t, e, r) {
  var n, a, i;
  return t === "up" ? (n = r.startRowIdx, a = 0, i = -1) : (n = r.endRowIdx, a = e.totalColumnCount - 1, i = e.getCellInfo(n, a).nodeSize + 1), { targetRowIdx: n, insertColIdx: a, nodeSize: i };
}
function m7(t, e, r) {
  var n = t.getCellInfo(e, 0).offset, a = t.getCellInfo(e, r - 1), i = a.offset, o = a.nodeSize;
  return { from: n, to: i + o };
}
var g7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "table";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "tableHead{1} tableBody{1}",
          group: "block",
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: [Yr("table")],
          toDOM: function(r) {
            var n = r.attrs;
            return ["table", z(n), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addTable = function() {
      return function(r) {
        return r === void 0 && (r = { rowCount: 2, columnCount: 1, data: [] }), function(n, a) {
          var i = r.rowCount, o = r.columnCount, s = r.data, l = n.schema, u = n.selection, c = n.tr, v = u.from, f = u.to, d = u.$from, p = v === f;
          if (p && !Hr(d)) {
            var h = l.nodes, m = h.tableHead, y = h.tableBody, w = s?.slice(0, o), C = s?.slice(o, s.length), T = jQ(o, l, w), k = su(i - 1, o, l, C), M = l.nodes.table.create(null, [
              m.create(null, T),
              y.create(null, k)
            ]);
            return a(c.replaceSelectionWith(M)), !0;
          }
          return !1;
        };
      };
    }, e.prototype.removeTable = function() {
      return function() {
        return function(r, n) {
          var a = r.selection, i = r.tr, o = Z.create(a.$anchor);
          if (o) {
            var s = o.tableStartOffset, l = o.tableEndOffset, u = s - 1, c = F(i.delete(u, l), u);
            return n(i.setSelection(c)), !0;
          }
          return !1;
        };
      };
    }, e.prototype.addColumn = function(r) {
      return function() {
        return function(n, a) {
          var i = n.selection, o = n.tr, s = n.schema, l = Me(i), u = l.anchor, c = l.head;
          if (u && c) {
            for (var v = Z.create(u), f = v.getRectOffsets(u, c), d = r === "left" ? f.startColIdx : f.endColIdx + 1, p = wt(f).columnCount, h = v.totalRowCount, m = 0; m < h; m += 1) {
              var y = yr(p, m, s);
              o.insert(o.mapping.map(v.posAt(m, d)), y);
            }
            return a(o), !0;
          }
          return !1;
        };
      };
    }, e.prototype.removeColumn = function() {
      return function() {
        return function(r, n) {
          var a = r.selection, i = r.tr, o = Me(a), s = o.anchor, l = o.head;
          if (s && l) {
            var u = Z.create(s), c = u.getRectOffsets(s, l), v = u.totalColumnCount, f = u.totalRowCount, d = wt(c).columnCount, p = d === v;
            if (p)
              return !1;
            for (var h = c.startColIdx, m = c.endColIdx, y = i.mapping.maps.length, w = 0; w < f; w += 1)
              for (var C = m; C >= h; C -= 1) {
                var T = u.getCellInfo(w, C), k = T.offset, M = T.nodeSize, O = i.mapping.slice(y).map(k), I = O + M;
                i.delete(O, I);
              }
            return n(i), !0;
          }
          return !1;
        };
      };
    }, e.prototype.addRow = function(r) {
      return function() {
        return function(n, a) {
          var i = n.selection, o = n.schema, s = n.tr, l = Me(i), u = l.anchor, c = l.head;
          if (u && c) {
            var v = Z.create(u), f = v.totalColumnCount, d = v.getRectOffsets(u, c), p = wt(d).rowCount, h = h7(r, v, d), m = h.targetRowIdx, y = h.insertColIdx, w = h.nodeSize, C = m === 0;
            if (!C) {
              for (var T = [], k = s.mapping.map(v.posAt(m, y)) + w, M = [], O = 0; O < f; O += 1)
                M = M.concat(yr(1, m, o));
              for (var I = 0; I < p; I += 1)
                T.push(o.nodes.tableRow.create(null, M));
              return a(s.insert(k, T)), !0;
            }
          }
          return !1;
        };
      };
    }, e.prototype.removeRow = function() {
      return function() {
        return function(r, n) {
          var a = r.selection, i = r.tr, o = Me(a), s = o.anchor, l = o.head;
          if (s && l) {
            var u = Z.create(s), c = u.totalRowCount, v = u.totalColumnCount, f = u.getRectOffsets(s, l), d = wt(f).rowCount, p = f.startRowIdx, h = f.endRowIdx, m = p === 0, y = d === c - 1;
            if (y || m)
              return !1;
            for (var w = h; w >= p; w -= 1) {
              var C = m7(u, w, v), T = C.from, k = C.to;
              i.delete(T - 1, k + 1);
            }
            return n(i), !0;
          }
          return !1;
        };
      };
    }, e.prototype.alignColumn = function() {
      return function(r) {
        return r === void 0 && (r = { align: "center" }), function(n, a) {
          var i = r.align, o = n.selection, s = n.tr, l = Me(o), u = l.anchor, c = l.head;
          if (u && c) {
            for (var v = Z.create(u), f = v.totalRowCount, d = v.getRectOffsets(u, c), p = d.startColIdx, h = d.endColIdx, m = 0; m < f; m += 1)
              for (var y = p; y <= h; y += 1)
                if (!v.extendedRowspan(m, y) && !v.extendedColspan(m, y)) {
                  var w = v.getNodeAndPos(m, y), C = w.node, T = w.pos, k = zQ(C, { align: i });
                  s.setNodeMarkup(T, null, k);
                }
            return a(s), !0;
          }
          return !1;
        };
      };
    }, e.prototype.moveToCell = function(r) {
      return function(n, a) {
        var i = n.selection, o = n.tr, s = n.schema, l = Me(i), u = l.anchor, c = l.head;
        if (u && c) {
          var v = Z.create(u), f = v.getCellIndex(u), d = void 0;
          if (xo(r, v, f) ? d = Bn(o, v, s) : d = Lo(r, o, f, v), d)
            return a(d), !0;
        }
        return !1;
      };
    }, e.prototype.moveInCell = function(r) {
      var n = this;
      return function(a, i) {
        var o = a.selection, s = a.tr, l = a.doc, u = a.schema, c = o.$from, v = n.context.view;
        if (!v.endOfTextblock(r))
          return !1;
        var f = Pe(c, function(C) {
          var T = C.type;
          return T.name === "tableHeadCell" || T.name === "tableBodyCell";
        });
        if (f) {
          var d = Pe(c, function(C) {
            var T = C.type;
            return T.name === "paragraph";
          }), p = f.depth;
          if (d && s7(r, [p, d.depth], c, l)) {
            var h = Me(o).anchor, m = Z.create(h), y = m.getCellIndex(h), w = void 0;
            if (d7(r, m, y) ? w = p7(s, c, p) : xo(r, m, y) ? r === "up" ? w = l7(s, m, u) : r === "down" && (w = Bn(s, m, u)) : w = Lo(r, s, y, m), w)
              return i(w), !0;
          }
        }
        return !1;
      };
    }, e.prototype.deleteCells = function() {
      return function(r, n) {
        var a = r.schema, i = r.selection, o = r.tr, s = Me(i), l = s.anchor, u = s.head, c = i instanceof Dt;
        if (l && u && !c) {
          for (var v = Z.create(l), f = v.getRectOffsets(l, u), d = f.startRowIdx, p = f.startColIdx, h = f.endRowIdx, m = f.endColIdx, y = d; y <= h; y += 1)
            for (var w = p; w <= m; w += 1)
              if (!v.extendedRowspan(y, w) && !v.extendedColspan(y, w)) {
                var C = v.getNodeAndPos(y, w), T = C.node, k = C.pos, M = yr(1, y, a, T.attrs);
                o.replaceWith(o.mapping.map(k), o.mapping.map(k + T.nodeSize), M);
              }
          return n(o), !0;
        }
        return !1;
      };
    }, e.prototype.exitTable = function() {
      return function(r, n) {
        var a = r.selection, i = r.tr, o = r.schema, s = a.$from, l = Pe(s, function(f) {
          var d = f.type;
          return d.name === "tableHeadCell" || d.name === "tableBodyCell";
        });
        if (l) {
          var u = Pe(s, function(f) {
            var d = f.type;
            return d.name === "paragraph";
          });
          if (u) {
            var c = Me(a).anchor, v = Z.create(c);
            return n(Bn(i, v, o, !0)), !0;
          }
        }
        return !1;
      };
    }, e.prototype.commands = function() {
      return {
        addTable: this.addTable(),
        removeTable: this.removeTable(),
        addColumnToLeft: this.addColumn(
          "left"
          /* LEFT */
        ),
        addColumnToRight: this.addColumn(
          "right"
          /* RIGHT */
        ),
        removeColumn: this.removeColumn(),
        addRowToUp: this.addRow(
          "up"
          /* UP */
        ),
        addRowToDown: this.addRow(
          "down"
          /* DOWN */
        ),
        removeRow: this.removeRow(),
        alignColumn: this.alignColumn()
      };
    }, e.prototype.keymaps = function() {
      var r = this.deleteCells();
      return {
        Tab: this.moveToCell(
          "right"
          /* RIGHT */
        ),
        "Shift-Tab": this.moveToCell(
          "left"
          /* LEFT */
        ),
        ArrowUp: this.moveInCell(
          "up"
          /* UP */
        ),
        ArrowDown: this.moveInCell(
          "down"
          /* DOWN */
        ),
        ArrowLeft: this.moveInCell(
          "left"
          /* LEFT */
        ),
        ArrowRight: this.moveInCell(
          "right"
          /* RIGHT */
        ),
        Backspace: r,
        "Mod-Backspace": r,
        Delete: r,
        "Mod-Delete": r,
        "Mod-Enter": this.exitTable()
      };
    }, e;
  })($)
), y7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "tableHead";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "tableRow{1}",
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: [Yr("thead")],
          toDOM: function(r) {
            var n = r.attrs;
            return ["thead", z(n), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), b7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "tableBody";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "tableRow+",
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: [
            {
              tag: "tbody",
              getAttrs: function(r) {
                var n = r.querySelectorAll("tr"), a = n[0].children.length, i = r.getAttribute("data-raw-html");
                return a ? b({}, i && { rawHTML: i }) : !1;
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs;
            return ["tbody", z(n), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), w7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "tableRow";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "(tableHeadCell | tableBodyCell)*",
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: [
            {
              tag: "tr",
              getAttrs: function(r) {
                var n = r.children.length, a = r.getAttribute("data-raw-html");
                return n ? b({}, a && { rawHTML: a }) : !1;
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs;
            return ["tr", z(n), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), C7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "tableHeadCell";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "paragraph+",
          attrs: b({ align: { default: null }, className: { default: null }, rawHTML: { default: null }, colspan: { default: null }, extended: { default: null } }, K()),
          isolating: !0,
          parseDOM: [nu("th")],
          toDOM: function(r) {
            var n = r.attrs, a = ru(n);
            return ["th", b(b({}, a), z(n)), 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), T7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "tableBodyCell";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "(paragraph | bulletList | orderedList)+",
          attrs: {
            align: { default: null },
            className: { default: null },
            rawHTML: { default: null },
            colspan: { default: null },
            rowspan: { default: null },
            extended: { default: null }
          },
          isolating: !0,
          parseDOM: [nu("td")],
          toDOM: function(r) {
            var n = r.attrs, a = ru(n);
            return ["td", a, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })($)
), k7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "image";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          inline: !0,
          attrs: b({ imageUrl: { default: "" }, altText: { default: null }, rawHTML: { default: null } }, K()),
          group: "inline",
          selectable: !1,
          parseDOM: [
            {
              tag: "img[src]",
              getAttrs: function(r) {
                var n = ot(r, { RETURN_DOM_FRAGMENT: !0 }).firstChild, a = n.getAttribute("src") || "", i = n.getAttribute("data-raw-html"), o = n.getAttribute("alt");
                return b({
                  imageUrl: a,
                  altText: o
                }, i && { rawHTML: i });
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs;
            return [
              n.rawHTML || "img",
              b(b({ src: bt(n.imageUrl) }, n.altText && { alt: n.altText }), z(n))
            ];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addImage = function() {
      return function(r) {
        return function(n, a) {
          var i = n.schema, o = n.tr, s = r, l = s.imageUrl, u = s.altText;
          if (!l)
            return !1;
          var c = i.nodes.image.createAndFill(b({ imageUrl: l }, u && { altText: u }));
          return a(o.replaceSelectionWith(c).scrollIntoView()), !0;
        };
      };
    }, e.prototype.commands = function() {
      return {
        addImage: this.addImage()
      };
    }, e;
  })($)
), Mo = 1, E7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "thematicBreak";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: b({ rawHTML: { default: null } }, K()),
          group: "block",
          parseDOM: [{ tag: "hr" }],
          selectable: !1,
          toDOM: function(r) {
            var n = r.attrs;
            return ["div", z(n), [n.rawHTML || "hr"]];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.hr = function() {
      var r = this;
      return function() {
        return function(n, a) {
          var i, o = n.selection, s = o.$from, l = o.$to;
          if (s === l) {
            var u = n.doc, c = n.schema.nodes, v = c.thematicBreak, f = c.paragraph, d = [v.create()], p = s.node(Mo), h = u.child(u.childCount - 1) === p, m = u.resolve(s.after(Mo)), y = ((i = s.nodeAfter) === null || i === void 0 ? void 0 : i.type.name) === r.name;
            return (h || y) && d.push(f.create()), a(n.tr.insert(m.pos, d).scrollIntoView()), !0;
          }
          return !1;
        };
      };
    }, e.prototype.commands = function() {
      return { hr: this.hr() };
    }, e.prototype.keymaps = function() {
      var r = this.hr()();
      return {
        "Mod-l": r,
        "Mod-L": r
      };
    }, e;
  })($)
), x7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "strong";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        var r = ["b", "strong"].map(function(n) {
          return {
            tag: n,
            getAttrs: function(a) {
              var i = a.getAttribute("data-raw-html");
              return b({}, i && { rawHTML: i });
            }
          };
        });
        return {
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: r,
          toDOM: function(n) {
            var a = n.attrs;
            return [a.rawHTML || "strong", z(a)];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.bold = function() {
      return function() {
        return function(r, n) {
          return Qt(r.schema.marks.strong)(r, n);
        };
      };
    }, e.prototype.commands = function() {
      return { bold: this.bold() };
    }, e.prototype.keymaps = function() {
      var r = this.bold()();
      return {
        "Mod-b": r,
        "Mod-B": r
      };
    }, e;
  })(U)
), L7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "emph";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        var r = ["i", "em"].map(function(n) {
          return {
            tag: n,
            getAttrs: function(a) {
              var i = a.getAttribute("data-raw-html");
              return b({}, i && { rawHTML: i });
            }
          };
        });
        return {
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: r,
          toDOM: function(n) {
            var a = n.attrs;
            return [a.rawHTML || "em", z(a)];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.italic = function() {
      return function() {
        return function(r, n) {
          return Qt(r.schema.marks.emph)(r, n);
        };
      };
    }, e.prototype.commands = function() {
      return { italic: this.italic() };
    }, e.prototype.keymaps = function() {
      var r = this.italic()();
      return {
        "Mod-i": r,
        "Mod-I": r
      };
    }, e;
  })(U)
), M7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "strike";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        var r = ["s", "del"].map(function(n) {
          return {
            tag: n,
            getAttrs: function(a) {
              var i = a.getAttribute("data-raw-html");
              return b({}, i && { rawHTML: i });
            }
          };
        });
        return {
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: r,
          toDOM: function(n) {
            var a = n.attrs;
            return [a.rawHTML || "del", z(a)];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n) {
          return Qt(r.schema.marks.strike)(r, n);
        };
      };
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return {
        "Mod-s": r,
        "Mod-S": r
      };
    }, e;
  })(U)
), A7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this) || this;
      return n.linkAttributes = r, n;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "link";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        var r = this;
        return {
          attrs: b({ linkUrl: { default: "" }, title: { default: null }, rawHTML: { default: null } }, K()),
          inclusive: !1,
          parseDOM: [
            {
              tag: "a[href]",
              getAttrs: function(n) {
                var a = ot(n, { RETURN_DOM_FRAGMENT: !0 }).firstChild, i = a.getAttribute("href") || "", o = a.getAttribute("title") || "", s = a.getAttribute("data-raw-html");
                return b({ linkUrl: i, title: o }, s && { rawHTML: s });
              }
            }
          ],
          toDOM: function(n) {
            var a = n.attrs;
            return [
              a.rawHTML || "a",
              b(b({ href: bt(a.linkUrl) }, r.linkAttributes), z(a))
            ];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addLink = function() {
      return function(r) {
        return function(n, a) {
          var i = r, o = i.linkUrl, s = i.linkText, l = s === void 0 ? "" : s, u = n.schema, c = n.tr, v = n.selection, f = v.empty, d = v.from, p = v.to;
          if (d && p && o) {
            var h = { linkUrl: o }, m = u.mark("link", h);
            if (f && l) {
              var y = ee(u, l, m);
              c.replaceRangeWith(d, p, y);
            } else
              c.addMark(d, p, m);
            return a(c.scrollIntoView()), !0;
          }
          return !1;
        };
      };
    }, e.prototype.toggleLink = function() {
      return function(r) {
        return function(n, a) {
          return Qt(n.schema.marks.link, r)(n, a);
        };
      };
    }, e.prototype.commands = function() {
      return {
        addLink: this.addLink(),
        toggleLink: this.toggleLink()
      };
    }, e;
  })(U)
), S7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "code";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          attrs: b({ rawHTML: { default: null } }, K()),
          parseDOM: [
            {
              tag: "code",
              getAttrs: function(r) {
                var n = r.getAttribute("data-raw-html");
                return b({}, n && { rawHTML: n });
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs;
            return [n.rawHTML || "code", z(n)];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n) {
          return Qt(r.schema.marks.code)(r, n);
        };
      };
    }, e.prototype.keymaps = function() {
      var r = this.commands()();
      return {
        "Shift-Mod-c": r,
        "Shift-Mod-C": r
      };
    }, e;
  })(U)
), O7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "customBlock";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "text*",
          group: "block",
          attrs: {
            info: { default: null }
          },
          atom: !0,
          code: !0,
          defining: !0,
          parseDOM: [
            {
              tag: "div[data-custom-info]",
              getAttrs: function(r) {
                var n = r.getAttribute("data-custom-info");
                return { info: n };
              }
            }
          ],
          toDOM: function(r) {
            var n = r.attrs;
            return ["div", { "data-custom-info": n.info || null }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function(r) {
        return function(n, a) {
          return r?.info ? ha(n.schema.nodes.customBlock, r)(n, a) : !1;
        };
      };
    }, e;
  })($)
), D7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "frontMatter";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "text*",
          group: "block",
          code: !0,
          defining: !0,
          parseDOM: [
            {
              preserveWhitespace: "full",
              tag: "div[data-front-matter]"
            }
          ],
          toDOM: function() {
            return ["div", { "data-front-matter": "true" }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n, a) {
          var i = r.selection.$from;
          return a.endOfTextblock("down") && i.node().type.name === "frontMatter" ? Ns(r, n) : !1;
        };
      };
    }, e.prototype.keymaps = function() {
      return {
        Enter: this.commands()()
      };
    }, e;
  })($)
), I7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return Object.defineProperty(e.prototype, "name", {
      get: function() {
        return "htmlComment";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "schema", {
      get: function() {
        return {
          content: "text*",
          group: "block",
          code: !0,
          defining: !0,
          parseDOM: [{ preserveWhitespace: "full", tag: "div[data-html-comment]" }],
          toDOM: function() {
            return ["div", { "data-html-comment": "true" }, 0];
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.commands = function() {
      return function() {
        return function(r, n, a) {
          var i = r.selection.$from;
          return a.endOfTextblock("down") && i.node().type.name === "htmlComment" ? Ns(r, n) : !1;
        };
      };
    }, e.prototype.keymaps = function() {
      return {
        Enter: this.commands()()
      };
    }, e;
  })($)
);
function N7(t) {
  return new ol([
    new WK(),
    new GK(),
    new QK(),
    new KK(),
    new YK(),
    new ZK(),
    new JK(),
    new e7(),
    new t7(),
    new g7(),
    new y7(),
    new b7(),
    new w7(),
    new C7(),
    new T7(),
    new k7(),
    new E7(),
    new x7(),
    new L7(),
    new M7(),
    new A7(t),
    new S7(),
    new O7(),
    new D7(),
    new al(),
    new I7()
  ]);
}
var R7 = L("contents"), B7 = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r, n) {
      var a = t.call(this, r) || this, i = n.toDOMAdaptor, o = n.htmlSchemaMap, s = o === void 0 ? {} : o, l = n.linkAttributes, u = l === void 0 ? {} : l, c = n.useCommandShortcut, v = c === void 0 ? !0 : c, f = n.wwPlugins, d = f === void 0 ? [] : f, p = n.wwNodeViews, h = p === void 0 ? {} : p;
      return a.editorType = "wysiwyg", a.el.classList.add("ww-mode"), a.toDOMAdaptor = i, a.linkAttributes = u, a.extraPlugins = d, a.pluginNodeViews = h, a.specs = a.createSpecs(), a.schema = a.createSchema(s), a.context = a.createContext(), a.keymaps = a.createKeymaps(v), a.view = a.createView(), a.commands = a.createCommands(), a.specs.setContext(b(b({}, a.context), { view: a.view })), a.initEvent(), a;
    }
    return e.prototype.createSpecs = function() {
      return N7(this.linkAttributes);
    }, e.prototype.createContext = function() {
      return {
        schema: this.schema,
        eventEmitter: this.eventEmitter
      };
    }, e.prototype.createSchema = function(r) {
      return new As({
        nodes: b(b({}, this.specs.nodes), r.nodes),
        marks: b(b({}, this.specs.marks), r.marks)
      });
    }, e.prototype.createPlugins = function() {
      return ce([
        KQ(),
        eK(this.eventEmitter),
        tK(),
        lK(this.eventEmitter)
      ], this.createPluginProps()).concat(this.defaultPlugins);
    }, e.prototype.createPluginNodeViews = function() {
      var r = this, n = r.eventEmitter, a = r.pluginNodeViews, i = {};
      return a && Object.keys(a).forEach(function(o) {
        i[o] = function(s, l, u) {
          return a[o](s, l, u, n);
        };
      }), i;
    }, e.prototype.createView = function() {
      var r = this, n = this, a = n.toDOMAdaptor, i = n.eventEmitter;
      return new da(this.el, {
        state: this.createState(),
        attributes: {
          class: R7
        },
        nodeViews: b({
          customBlock: function(o, s, l) {
            return new uK(o, s, l, a);
          },
          image: function(o, s, l) {
            return new cK(o, s, l, i);
          },
          codeBlock: function(o, s, l) {
            return new dK(o, s, l, i);
          },
          widget: nl
        }, this.createPluginNodeViews()),
        dispatchTransaction: function(o) {
          var s = r.view.state.applyTransaction(o).state;
          r.view.updateState(s), r.emitChangeEvent(o.scrollIntoView()), r.eventEmitter.emit("setFocusedNode", s.selection.$from.node(1));
        },
        transformPastedHTML: SK,
        transformPasted: function(o) {
          return RK(o, r.schema, Hr(r.view.state.selection.$from));
        },
        handlePaste: function(o, s, l) {
          return VK(o, l);
        },
        handleKeyDown: function(o, s) {
          return r.eventEmitter.emit("keydown", r.editorType, s), !1;
        },
        handleDOMEvents: {
          paste: function(o, s) {
            var l = s.clipboardData || window.clipboardData, u = l?.items;
            if (u) {
              var c = De(u).some(function(f) {
                return f.kind === "string" && f.type === "text/rtf";
              });
              if (!c) {
                var v = rl(u);
                v && (s.preventDefault(), Oa(r.eventEmitter, v, s.type));
              }
            }
            return !1;
          },
          keyup: function(o, s) {
            return r.eventEmitter.emit("keyup", r.editorType, s), !1;
          },
          scroll: function() {
            return r.eventEmitter.emit("scroll", "editor"), !0;
          }
        }
      });
    }, e.prototype.createCommands = function() {
      return this.specs.commands(this.view, Ua());
    }, e.prototype.getHTML = function() {
      return Sa(this.view.dom.innerHTML);
    }, e.prototype.getModel = function() {
      return this.view.state.doc;
    }, e.prototype.getSelection = function() {
      var r = this.view.state.selection, n = r.from, a = r.to;
      return [n, a];
    }, e.prototype.getSchema = function() {
      return this.view.state.schema;
    }, e.prototype.replaceSelection = function(r, n, a) {
      var i = this.view.state, o = i.schema, s = i.tr, l = r.split(`
`), u = l.map(function(f) {
        return Lr(o, et(f, o));
      }), c = new Ce(q.from(u), 1, 1), v = He(n) && He(a) ? s.replaceRange(n, a, c) : s.replaceSelection(c);
      this.view.dispatch(v), this.focus();
    }, e.prototype.deleteSelection = function(r, n) {
      var a = this.view.state.tr, i = He(r) && He(n) ? a.deleteRange(r, n) : a.deleteSelection();
      this.view.dispatch(i.scrollIntoView());
    }, e.prototype.getSelectedText = function(r, n) {
      var a = this.view.state, i = a.doc, o = a.selection, s = o.from, l = o.to;
      return He(r) && He(n) && (s = r, l = n), i.textBetween(s, l, `
`);
    }, e.prototype.setModel = function(r, n) {
      n === void 0 && (n = !1);
      var a = this.view.state, i = a.tr, o = a.doc;
      this.view.dispatch(i.replaceWith(0, o.content.size, r)), n && this.moveCursorToEnd(!0);
    }, e.prototype.setSelection = function(r, n) {
      n === void 0 && (n = r);
      var a = this.view.state.tr, i = F(a, r, n);
      this.view.dispatch(a.setSelection(i).scrollIntoView());
    }, e.prototype.addWidget = function(r, n, a) {
      var i = this.view, o = i.dispatch, s = i.state;
      o(s.tr.setMeta("widget", { pos: a ?? s.selection.to, node: r, style: n }));
    }, e.prototype.replaceWithWidget = function(r, n, a) {
      var i = this.view.state, o = i.tr, s = i.schema, l = et(a, s);
      this.view.dispatch(o.replaceWith(r, n, l));
    }, e.prototype.getRangeInfoOfNode = function(r) {
      var n = this.view.state, a = n.doc, i = n.selection, o = r ? a.resolve(r) : i.$from, s = o.marks(), l = o.node(), u = o.start(), c = o.end(), v = l.type.name;
      if (s.length || v === "paragraph") {
        var f = s[s.length - 1], d = function(p) {
          return p.length ? te(p, f) : !0;
        };
        v = f ? f.type.name : "text", l.forEach(function(p, h) {
          var m = p.isText, y = p.nodeSize, w = p.marks, C = o.pos - u;
          m && h <= C && h + y >= C && d(w) && (u = u + h, c = u + y);
        });
      }
      return { range: [u, c], type: v };
    }, e;
  })(il)
), H7 = Te, P7 = Tr;
function _7(t) {
  return !H7(t) && !P7(t);
}
var q7 = _7, $7 = q7;
function F7(t) {
  return $7(t) && t !== !1;
}
var U7 = F7, V7 = U7;
function j7(t) {
  return !V7(t);
}
var z7 = j7, Ao = [
  "afterPreviewRender",
  "updatePreview",
  "changeMode",
  "needChangeMode",
  "command",
  "changePreviewStyle",
  "changePreviewTabPreview",
  "changePreviewTabWrite",
  "scroll",
  "contextmenu",
  "show",
  "hide",
  "changeLanguage",
  "changeToolbarState",
  "toggleScrollSync",
  "mixinTableOffsetMapPrototype",
  "setFocusedNode",
  "removePopupWidget",
  "query",
  // provide event for user
  "openPopup",
  "closePopup",
  "addImageBlobHook",
  "beforePreviewRender",
  "beforeConvertWysiwygToMarkdown",
  "load",
  "loadUI",
  "change",
  "caretChange",
  "destroy",
  "focus",
  "blur",
  "keydown",
  "keyup"
], wu = (
  /** @class */
  (function() {
    function t() {
      var e = this;
      this.events = new vu(), this.eventTypes = Ao.reduce(function(r, n) {
        return b(b({}, r), { type: n });
      }, {}), this.hold = !1, Ao.forEach(function(r) {
        e.addEventType(r);
      });
    }
    return t.prototype.listen = function(e, r) {
      var n = this.getTypeInfo(e), a = this.events.get(n.type) || [];
      if (!this.hasEventType(n.type))
        throw new Error("There is no event type " + n.type);
      n.namespace && (r.namespace = n.namespace), a.push(r), this.events.set(n.type, a);
    }, t.prototype.emit = function(e) {
      for (var r = [], n = 1; n < arguments.length; n++)
        r[n - 1] = arguments[n];
      var a = this.getTypeInfo(e), i = this.events.get(a.type), o = [];
      return !this.hold && i && i.forEach(function(s) {
        var l = s.apply(void 0, r);
        Te(l) || o.push(l);
      }), o;
    }, t.prototype.emitReduce = function(e, r) {
      for (var n = [], a = 2; a < arguments.length; a++)
        n[a - 2] = arguments[a];
      var i = this.events.get(e);
      return !this.hold && i && i.forEach(function(o) {
        var s = o.apply(void 0, ce([r], n));
        z7(s) || (r = s);
      }), r;
    }, t.prototype.getTypeInfo = function(e) {
      var r = e.split(".");
      return {
        type: r[0],
        namespace: r[1]
      };
    }, t.prototype.hasEventType = function(e) {
      return !Te(this.eventTypes[this.getTypeInfo(e).type]);
    }, t.prototype.addEventType = function(e) {
      if (this.hasEventType(e))
        throw new Error("There is already have event type " + e);
      this.eventTypes[e] = e;
    }, t.prototype.removeEventHandler = function(e, r) {
      var n = this, a = this.getTypeInfo(e), i = a.type, o = a.namespace;
      i && r ? this.removeEventHandlerWithHandler(i, r) : i && !o ? this.events.delete(i) : !i && o ? this.events.forEach(function(s, l) {
        n.removeEventHandlerWithTypeInfo(l, o);
      }) : i && o && this.removeEventHandlerWithTypeInfo(i, o);
    }, t.prototype.removeEventHandlerWithHandler = function(e, r) {
      var n = this.events.get(e);
      if (n) {
        var a = n.indexOf(r);
        n.indexOf(r) >= 0 && n.splice(a, 1);
      }
    }, t.prototype.removeEventHandlerWithTypeInfo = function(e, r) {
      var n = [], a = this.events.get(e);
      a && (a.map(function(i) {
        return i.namespace !== r && n.push(i), null;
      }), this.events.set(e, n));
    }, t.prototype.getEvents = function() {
      return this.events;
    }, t.prototype.holdEventInvoke = function(e) {
      this.hold = !0, e(), this.hold = !1;
    }, t;
  })()
), W7 = (
  /** @class */
  (function() {
    function t(e, r, n, a) {
      this.eventEmitter = e, this.mdCommands = r, this.wwCommands = n, this.getEditorType = a, this.initEvent();
    }
    return t.prototype.initEvent = function() {
      var e = this;
      this.eventEmitter.listen("command", function(r, n) {
        e.exec(r, n);
      });
    }, t.prototype.addCommand = function(e, r, n) {
      e === "markdown" ? this.mdCommands[r] = n : this.wwCommands[r] = n;
    }, t.prototype.deleteCommand = function(e, r) {
      e === "markdown" ? delete this.mdCommands[r] : delete this.wwCommands[r];
    }, t.prototype.exec = function(e, r) {
      var n = this.getEditorType();
      n === "markdown" ? this.mdCommands[e](r) : this.wwCommands[e](r);
    }, t;
  })()
);
function wr(t) {
  return t[t.length - 1] === `
` ? t.slice(0, t.length - 1) : t;
}
function oa(t, e) {
  var r = t.schema, n = e.literal, a = n.match(Et);
  if (a) {
    var i = a[1], o = a[3], s = (i || o).toLowerCase();
    return e.type === "htmlInline" && !!(r.marks[s] || r.nodes[s]);
  }
  return !1;
}
function sa(t) {
  var e = t.type;
  return te(["text", "strong", "emph", "strike", "image", "link", "code"], e);
}
function So(t) {
  return t?.type === "softbreak";
}
function _t(t) {
  var e = t.type, r = t.literal, n = e === "htmlInline" && r.match(Et);
  if (n) {
    var a = n[1], i = n[3], o = a || i;
    if (o)
      return te(["ul", "ol", "li"], o.toLowerCase());
  }
  return !1;
}
function G7(t) {
  var e = t.literal, r = /data-task/.test(e), n = /data-task-checked/.test(e);
  return { task: r, checked: n };
}
function Oo(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  var n = document.createElement("div");
  n.innerHTML = ot(t);
  var a = n.firstChild;
  return e.map(function(i) {
    return a.getAttribute(i) || "";
  });
}
function X7(t) {
  var e = {};
  return Object.keys(t).forEach(function(r) {
    var n = r.split(", ");
    n.forEach(function(a) {
      var i = a.toLowerCase();
      e[i] = t[r];
    });
  }), e;
}
var Q7 = {
  "b, strong": function(t, e, r) {
    var n = t.schema.marks.strong;
    r ? t.openMark(n.create({ rawHTML: r })) : t.closeMark(n);
  },
  "i, em": function(t, e, r) {
    var n = t.schema.marks.emph;
    r ? t.openMark(n.create({ rawHTML: r })) : t.closeMark(n);
  },
  "s, del": function(t, e, r) {
    var n = t.schema.marks.strike;
    r ? t.openMark(n.create({ rawHTML: r })) : t.closeMark(n);
  },
  code: function(t, e, r) {
    var n = t.schema.marks.code;
    r ? t.openMark(n.create({ rawHTML: r })) : t.closeMark(n);
  },
  a: function(t, e, r) {
    var n = e.literal, a = t.schema.marks.link;
    if (r) {
      var i = Oo(n, "href")[0];
      t.openMark(a.create({
        linkUrl: i,
        rawHTML: r
      }));
    } else
      t.closeMark(a);
  },
  img: function(t, e, r) {
    var n = e.literal;
    if (r) {
      var a = Oo(n, "src", "alt"), i = a[0], o = a[1], s = t.schema.nodes.image;
      t.addNode(s, b({ rawHTML: r, imageUrl: i }, o && { altText: o }));
    }
  },
  hr: function(t, e, r) {
    t.addNode(t.schema.nodes.thematicBreak, { rawHTML: r });
  },
  br: function(t, e) {
    var r = t.schema.nodes.paragraph, n = e.parent, a = e.prev, i = e.next;
    n?.type === "paragraph" ? (So(a) && t.openNode(r), So(i) ? t.closeNode() : i && (t.closeNode(), t.openNode(r))) : n?.type === "tableCell" && (a && (sa(a) || oa(t, a)) && t.closeNode(), i && (sa(i) || oa(t, i)) && t.openNode(r));
  },
  pre: function(t, e, r) {
    var n, a, i = document.createElement("div");
    i.innerHTML = e.literal;
    var o = (a = (n = i.firstChild) === null || n === void 0 ? void 0 : n.firstChild) === null || a === void 0 ? void 0 : a.textContent;
    t.openNode(t.schema.nodes.codeBlock, { rawHTML: r }), t.addText(wr(o)), t.closeNode();
  },
  "ul, ol": function(t, e, r) {
    if (e.parent.type === "tableCell") {
      var n = t.schema.nodes, a = n.bulletList, i = n.orderedList, o = n.paragraph, s = r === "ul" ? a : i;
      r ? (e.prev && !_t(e.prev) && t.closeNode(), t.openNode(s, { rawHTML: r })) : (t.closeNode(), e.next && !_t(e.next) && t.openNode(o));
    }
  },
  li: function(t, e, r) {
    var n;
    if (((n = e.parent) === null || n === void 0 ? void 0 : n.type) === "tableCell") {
      var a = t.schema.nodes, i = a.listItem, o = a.paragraph;
      if (r) {
        var s = G7(e);
        e.prev && !_t(e.prev) && t.closeNode(), t.openNode(i, b({ rawHTML: r }, s)), e.next && !_t(e.next) && t.openNode(o);
      } else
        e.prev && !_t(e.prev) && t.closeNode(), t.closeNode();
    }
  }
}, K7 = X7(Q7);
function Do(t) {
  return t.type === "htmlInline" && Fn.test(t.literal);
}
function Cu(t) {
  De(t.childNodes).forEach(function(e) {
    if (jr(e)) {
      var r = e.nodeName.toLowerCase();
      e.setAttribute("data-raw-html", r), e.childNodes && Cu(e);
    }
  });
}
var Io = {
  text: function(t, e) {
    t.addText(e.literal || "");
  },
  paragraph: function(t, e, r, n) {
    var a, i = r.entering;
    if (i) {
      var o = t.schema.nodes.paragraph;
      ((a = e.prev) === null || a === void 0 ? void 0 : a.type) === "paragraph" && (t.openNode(o, n), t.closeNode()), t.openNode(o, n);
    } else
      t.closeNode();
  },
  heading: function(t, e, r, n) {
    var a = r.entering;
    if (a) {
      var i = e, o = i.level, s = i.headingType;
      t.openNode(t.schema.nodes.heading, b({ level: o, headingType: s }, n));
    } else
      t.closeNode();
  },
  codeBlock: function(t, e, r) {
    var n = t.schema.nodes.codeBlock, a = e, i = a.info, o = a.literal;
    t.openNode(n, b({ language: i }, r)), t.addText(wr(o || "")), t.closeNode();
  },
  list: function(t, e, r, n) {
    var a = r.entering;
    if (a) {
      var i = t.schema.nodes, o = i.bulletList, s = i.orderedList, l = e.listData, u = l.type, c = l.start;
      u === "bullet" ? t.openNode(o, n) : t.openNode(s, b({ order: c }, n));
    } else
      t.closeNode();
  },
  item: function(t, e, r, n) {
    var a = r.entering, i = t.schema.nodes.listItem, o = e.listData, s = o.task, l = o.checked;
    if (a) {
      var u = b(b(b({}, s && { task: s }), l && { checked: l }), n);
      t.openNode(i, u);
    } else
      t.closeNode();
  },
  blockQuote: function(t, e, r, n) {
    var a = r.entering;
    a ? t.openNode(t.schema.nodes.blockQuote, n) : t.closeNode();
  },
  image: function(t, e, r, n) {
    var a = r.entering, i = r.skipChildren, o = t.schema.nodes.image, s = e, l = s.destination, u = s.firstChild;
    a && i && i(), t.addNode(o, b(b({ imageUrl: l }, u && { altText: u.literal }), n));
  },
  thematicBreak: function(t, e, r, n) {
    t.addNode(t.schema.nodes.thematicBreak, n);
  },
  strong: function(t, e, r, n) {
    var a = r.entering, i = t.schema.marks.strong;
    a ? t.openMark(i.create(n)) : t.closeMark(i);
  },
  emph: function(t, e, r, n) {
    var a = r.entering, i = t.schema.marks.emph;
    a ? t.openMark(i.create(n)) : t.closeMark(i);
  },
  link: function(t, e, r, n) {
    var a = r.entering, i = t.schema.marks.link, o = e, s = o.destination, l = o.title;
    if (a) {
      var u = b({ linkUrl: s, title: l }, n);
      t.openMark(i.create(u));
    } else
      t.closeMark(i);
  },
  softbreak: function(t, e) {
    if (e.parent.type === "paragraph") {
      var r = e.prev, n = e.next;
      r && !Do(r) && t.closeNode(), n && !Do(n) && t.openNode(t.schema.nodes.paragraph);
    }
  },
  // GFM specifications node
  table: function(t, e, r, n) {
    var a = r.entering;
    a ? t.openNode(t.schema.nodes.table, n) : t.closeNode();
  },
  tableHead: function(t, e, r, n) {
    var a = r.entering;
    a ? t.openNode(t.schema.nodes.tableHead, n) : t.closeNode();
  },
  tableBody: function(t, e, r, n) {
    var a = r.entering;
    a ? t.openNode(t.schema.nodes.tableBody, n) : t.closeNode();
  },
  tableRow: function(t, e, r, n) {
    var a = r.entering;
    a ? t.openNode(t.schema.nodes.tableRow, n) : t.closeNode();
  },
  tableCell: function(t, e, r) {
    var n = r.entering;
    if (!e.ignored) {
      var a = function(p) {
        return p && (sa(p) || oa(t, p));
      };
      if (n) {
        var i = t.schema.nodes, o = i.tableHeadCell, s = i.tableBodyCell, l = i.paragraph, u = e.parent.parent, c = u.type === "tableHead" ? o : s, v = u.parent, f = (v.columns[e.startIdx] || {}).align, d = b({}, e.attrs);
        f && (d.align = f), t.openNode(c, d), a(e.firstChild) && t.openNode(l);
      } else
        a(e.lastChild) && t.closeNode(), t.closeNode();
    }
  },
  strike: function(t, e, r, n) {
    var a = r.entering, i = t.schema.marks.strike;
    a ? t.openMark(i.create(n)) : t.closeMark(i);
  },
  code: function(t, e, r, n) {
    var a = t.schema.marks.code;
    t.openMark(a.create(n)), t.addText(wr(e.literal || "")), t.closeMark(a);
  },
  customBlock: function(t, e) {
    var r = t.schema.nodes, n = r.customBlock, a = r.paragraph, i = e, o = i.info, s = i.literal;
    t.openNode(n, { info: o }), t.addText(wr(s || "")), t.closeNode(), e.next || (t.openNode(a), t.closeNode());
  },
  frontMatter: function(t, e) {
    t.openNode(t.schema.nodes.frontMatter), t.addText(e.literal), t.closeNode();
  },
  htmlInline: function(t, e) {
    var r = e.literal, n = r.match(Et), a = n[1], i = n[3], o = (a || i).toLowerCase(), s = t.schema.marks[o], l = ot(r);
    if (s?.spec.attrs.htmlInline)
      if (a) {
        var u = ra(l);
        t.openMark(s.create({ htmlAttrs: u }));
      } else
        t.closeMark(s);
    else {
      var c = K7[o];
      c && c(t, e, a);
    }
  },
  htmlBlock: function(t, e) {
    var r = e.literal, n = document.createElement("div"), a = Iv.test(r);
    if (a)
      t.openNode(t.schema.nodes.htmlComment), t.addText(e.literal), t.closeNode();
    else {
      var i = r.match(Et), o = i[1], s = i[3], l = (o || s).toLowerCase(), u = t.schema.nodes[l], c = ot(r);
      if (u?.spec.attrs.htmlBlock) {
        var v = ra(c), f = Jl(e, l);
        t.addNode(u, { htmlAttrs: v, childrenHTML: f });
      } else
        n.innerHTML = c, Cu(n), t.convertByDOMParser(n);
    }
  },
  customInline: function(t, e, r) {
    var n = r.entering, a = r.skipChildren, i = e, o = i.info, s = i.firstChild, l = t.schema;
    if (o.indexOf("widget") !== -1 && n) {
      var u = js(e);
      a(), t.addNode(l.nodes.widget, { info: o }, [
        l.text(Us(o, u))
      ]);
    } else {
      var c = "$$";
      n && (c += s ? o + " " : o), t.addText(c);
    }
  }
};
function Y7(t) {
  var e = Object.keys(t), r = b({}, Io), n = new $a({
    gfm: !0,
    nodeId: !0,
    convertors: t
  }), a = n.getConvertors();
  return e.forEach(function(i) {
    var o = Io[i];
    o && !te(["htmlBlock", "htmlInline"], i) && (r[i] = function(s, l, u) {
      u.origin = function() {
        return a[i](l, u, a);
      };
      var c = t[i](l, u), v;
      if (c) {
        var f = Array.isArray(c) ? c[0] : c, d = f.attributes, p = f.classNames;
        v = { htmlAttrs: d, classNames: p };
      }
      o(s, l, u, v);
    });
  }), r;
}
function Z7(t, e) {
  return t.isText && e.isText && _n.sameSet(t.marks, e.marks) ? t.withText(t.text + e.text) : !1;
}
var J7 = (
  /** @class */
  (function() {
    function t(e, r) {
      this.schema = e, this.convertors = r, this.stack = [{ type: this.schema.topNodeType, attrs: null, content: [] }], this.marks = _n.none;
    }
    return t.prototype.top = function() {
      return se(this.stack);
    }, t.prototype.push = function(e) {
      this.stack.length && this.top().content.push(e);
    }, t.prototype.addText = function(e) {
      if (e) {
        var r = this.top().content, n = se(r), a = this.schema.text(e, this.marks), i = n && Z7(n, a);
        i ? r[r.length - 1] = i : r.push(a);
      }
    }, t.prototype.openMark = function(e) {
      this.marks = e.addToSet(this.marks);
    }, t.prototype.closeMark = function(e) {
      this.marks = e.removeFromSet(this.marks);
    }, t.prototype.addNode = function(e, r, n) {
      var a = e.createAndFill(r, n, this.marks);
      return a ? (this.push(a), a) : null;
    }, t.prototype.openNode = function(e, r) {
      this.stack.push({ type: e, attrs: r, content: [] });
    }, t.prototype.closeNode = function() {
      this.marks.length && (this.marks = _n.none);
      var e = this.stack.pop(), r = e.type, n = e.attrs, a = e.content;
      return this.addNode(r, n, a);
    }, t.prototype.convertByDOMParser = function(e) {
      var r = this, n = Ss.fromSchema(this.schema).parse(e);
      n.content.forEach(function(a) {
        return r.push(a);
      });
    }, t.prototype.closeUnmatchedHTMLInline = function(e, r) {
      var n;
      if (!r && e.type !== "htmlInline")
        for (var a = this.stack.length - 1, i = a; i >= 0; i -= 1) {
          var o = this.stack[i];
          if (!((n = o.attrs) === null || n === void 0) && n.rawHTML)
            o.content.length ? this.closeNode() : this.stack.pop();
          else
            break;
        }
    }, t.prototype.convert = function(e, r) {
      for (var n = e.walker(), a = n.next(), i = function() {
        var s = a.node, l = a.entering, u = o.convertors[s.type], c = !1;
        if (u) {
          var v = {
            entering: l,
            leaf: !fv(s),
            getChildrenText: dv,
            options: { gfm: !0, nodeId: !1, tagFilter: !1, softbreak: `
` },
            skipChildren: function() {
              c = !0;
            }
          };
          if (o.closeUnmatchedHTMLInline(s, l), u(o, s, v), r?.node === s) {
            var f = o.stack.reduce(function(d, p) {
              return d + p.content.reduce(function(h, m) {
                return h + m.nodeSize;
              }, 0);
            }, 0) + 1;
            r.setMappedPos(f);
          }
        }
        c && (n.resumeAt(s, !1), n.next()), a = n.next();
      }, o = this; a; )
        i();
    }, t.prototype.convertNode = function(e, r) {
      return this.convert(e, r), this.stack.length ? this.closeNode() : null;
    }, t;
  })()
);
function eY(t, e, r) {
  var n = r[0], a = r[1];
  t.write(n), t.convertInline(e), t.write(a);
}
function tY(t, e, r) {
  var n = e.node, a = e.parent, i = r[0], o = r[1];
  t.stopNewline = !0, t.write(i), t.convertNode(n), t.write(o), a?.type.name === "doc" && (t.closeBlock(n), t.stopNewline = !1);
}
function rY(t, e) {
  var r = t.length, n = "", a = "";
  return e === "left" ? (n = ":", r -= 1) : e === "right" ? (a = ":", r -= 1) : e === "center" && (n = ":", a = ":", r -= 2), "" + n + kr("-", Math.max(r, 3)) + a;
}
var la = {
  text: function(t, e) {
    var r, n = e.node, a = (r = n.text) !== null && r !== void 0 ? r : "";
    (n.marks || []).some(function(i) {
      return i.type.name === "link";
    }) ? t.text(Er(a), !1) : t.text(a);
  },
  paragraph: function(t, e) {
    var r = e.node, n = e.parent, a = e.index, i = a === void 0 ? 0 : a;
    if (t.stopNewline)
      t.convertInline(r);
    else {
      var o = i === 0, s = !o && n.child(i - 1), l = s && s.childCount === 0, u = i < n.childCount - 1 && n.child(i + 1), c = u && u.type.name === "paragraph", v = r.childCount === 0;
      if (v && l)
        t.write(`<br>
`);
      else if (v && !l && !o) {
        if (n?.type.name === "listItem") {
          var f = t.getDelim();
          t.setDelim(""), t.write("<br>"), t.setDelim(f);
        }
        t.write(`
`);
      } else
        t.convertInline(r), c ? t.write(`
`) : t.closeBlock(r);
    }
  },
  heading: function(t, e, r) {
    var n = e.node, a = r.delim, i = n.attrs.headingType;
    i === "atx" ? (t.write(a + " "), t.convertInline(n), t.closeBlock(n)) : (t.convertInline(n), t.ensureNewLine(), t.write(a), t.closeBlock(n));
  },
  codeBlock: function(t, e, r) {
    var n = e.node, a = r.delim, i = r.text, o = a, s = o[0], l = o[1];
    t.write(s), t.ensureNewLine(), t.text(i, !1), t.ensureNewLine(), t.write(l), t.closeBlock(n);
  },
  blockQuote: function(t, e, r) {
    var n = e.node, a = e.parent, i = r.delim;
    a?.type.name === n.type.name && t.flushClose(1), t.wrapBlock(i, null, n, function() {
      return t.convertNode(n);
    });
  },
  bulletList: function(t, e, r) {
    var n = e.node, a = r.delim;
    t.convertList(n, kr(" ", 4), function() {
      return a + " ";
    });
  },
  orderedList: function(t, e) {
    var r = e.node, n = r.attrs.order || 1;
    t.convertList(r, kr(" ", 4), function(a) {
      var i = String(n + a);
      return i + ". ";
    });
  },
  listItem: function(t, e) {
    var r = e.node, n = r.attrs, a = n.task, i = n.checked;
    a && t.write("[" + (i ? "x" : " ") + "] "), t.convertNode(r);
  },
  image: function(t, e, r) {
    var n = r.attrs;
    t.write("![" + n?.altText + "](" + n?.imageUrl + ")");
  },
  thematicBreak: function(t, e, r) {
    var n = e.node, a = r.delim;
    t.write(a), t.closeBlock(n);
  },
  table: function(t, e) {
    var r = e.node;
    t.convertNode(r), t.closeBlock(r);
  },
  tableHead: function(t, e, r) {
    var n = e.node, a = r.delim, i = n.firstChild;
    t.convertNode(n);
    var o = a ?? "";
    !a && i && i.forEach(function(s) {
      var l = s.textContent, u = s.attrs, c = rY(l, u.align);
      o += "| " + c + " ";
    }), t.write(o + "|"), t.ensureNewLine();
  },
  tableBody: function(t, e) {
    var r = e.node;
    t.convertNode(r);
  },
  tableRow: function(t, e) {
    var r = e.node;
    t.convertNode(r), t.write("|"), t.ensureNewLine();
  },
  tableHeadCell: function(t, e, r) {
    var n = e.node, a = r.delim, i = a === void 0 ? "| " : a;
    t.write(i), t.convertTableCell(n), t.write(" ");
  },
  tableBodyCell: function(t, e, r) {
    var n = e.node, a = r.delim, i = a === void 0 ? "| " : a;
    t.write(i), t.convertTableCell(n), t.write(" ");
  },
  customBlock: function(t, e, r) {
    var n = e.node, a = r.delim, i = r.text, o = a, s = o[0], l = o[1];
    t.write(s), t.ensureNewLine(), t.text(i, !1), t.ensureNewLine(), t.write(l), t.closeBlock(n);
  },
  frontMatter: function(t, e, r) {
    var n = e.node, a = r.text;
    t.text(a, !1), t.closeBlock(n);
  },
  widget: function(t, e, r) {
    var n = r.text;
    t.write(n);
  },
  html: function(t, e, r) {
    var n = e.node, a = r.text;
    t.write(a), n.attrs.htmlBlock && t.closeBlock(n);
  },
  htmlComment: function(t, e, r) {
    var n = e.node, a = r.text;
    t.write(a), t.closeBlock(n);
  }
};
function nY(t, e) {
  var r = e.state, n = e.nodeInfo, a = e.params, i = a.rawHTML;
  i ? tt(t, ["heading", "codeBlock"]) > -1 ? eY(r, n.node, i) : tt(t, ["image", "thematicBreak"]) > -1 ? r.write(i) : tY(r, n, i) : la[t](r, n, a);
}
function No(t, e) {
  var r = t.text, n = /`+/g, a = 0;
  if (t.isText && r)
    for (var i = n.exec(r); i; )
      a = Math.max(a, i[0].length), i = n.exec(r);
  for (var o = a > 0 && e > 0 ? " `" : "`", s = 0; s < a; s += 1)
    o += "`";
  return a > 0 && e < 0 && (o += " "), o;
}
function ge(t) {
  return t ? ["<" + t + ">", "</" + t + ">"] : null;
}
function qt(t) {
  return t ? "<" + t + ">" : null;
}
function $t(t) {
  return t ? "</" + t + ">" : null;
}
var Ft = {
  heading: function(t) {
    var e = t.node, r = e.attrs, n = r.level, a = kr("#", n);
    return r.headingType === "setext" && (a = n === 1 ? "===" : "---"), {
      delim: a,
      rawHTML: ge(r.rawHTML)
    };
  },
  codeBlock: function(t) {
    var e = t.node, r = e, n = r.attrs, a = r.textContent;
    return {
      delim: ["```" + (n.language || ""), "```"],
      rawHTML: ge(n.rawHTML),
      text: a
    };
  },
  blockQuote: function(t) {
    var e = t.node;
    return {
      delim: "> ",
      rawHTML: ge(e.attrs.rawHTML)
    };
  },
  bulletList: function(t, e) {
    var r = t.node, n = e.inTable, a = r.attrs.rawHTML;
    return n && (a = a || "ul"), {
      delim: "*",
      rawHTML: ge(a)
    };
  },
  orderedList: function(t, e) {
    var r = t.node, n = e.inTable, a = r.attrs.rawHTML;
    return n && (a = a || "ol"), {
      rawHTML: ge(a)
    };
  },
  listItem: function(t, e) {
    var r = t.node, n = e.inTable, a = r.attrs, i = a.task, o = a.checked, s = r.attrs.rawHTML;
    n && (s = s || "li");
    var l = i ? ' class="task-list-item' + (o ? " checked" : "") + '"' : "", u = i ? " data-task" + (o ? " data-task-checked" : "") : "";
    return {
      rawHTML: s ? ["<" + s + l + u + ">", "</" + s + ">"] : null
    };
  },
  table: function(t) {
    var e = t.node;
    return {
      rawHTML: ge(e.attrs.rawHTML)
    };
  },
  tableHead: function(t) {
    var e = t.node;
    return {
      rawHTML: ge(e.attrs.rawHTML)
    };
  },
  tableBody: function(t) {
    var e = t.node;
    return {
      rawHTML: ge(e.attrs.rawHTML)
    };
  },
  tableRow: function(t) {
    var e = t.node;
    return {
      rawHTML: ge(e.attrs.rawHTML)
    };
  },
  tableHeadCell: function(t) {
    var e = t.node;
    return {
      rawHTML: ge(e.attrs.rawHTML)
    };
  },
  tableBodyCell: function(t) {
    var e = t.node;
    return {
      rawHTML: ge(e.attrs.rawHTML)
    };
  },
  image: function(t) {
    var e = t.node, r = e.attrs, n = r.rawHTML, a = r.altText, i = r.imageUrl.replace(/&amp;/g, "&"), o = a ? ' alt="' + bt(a) + '"' : "";
    return {
      rawHTML: n ? "<" + n + ' src="' + bt(i) + '"' + o + ">" : null,
      attrs: {
        altText: Er(a || ""),
        imageUrl: i
      }
    };
  },
  thematicBreak: function(t) {
    var e = t.node;
    return {
      delim: "***",
      rawHTML: qt(e.attrs.rawHTML)
    };
  },
  customBlock: function(t) {
    var e = t.node, r = e, n = r.attrs, a = r.textContent;
    return {
      delim: ["$$" + n.info, "$$"],
      text: a
    };
  },
  frontMatter: function(t) {
    var e = t.node;
    return {
      text: e.textContent
    };
  },
  widget: function(t) {
    var e = t.node;
    return {
      text: e.textContent
    };
  },
  strong: function(t, e) {
    var r = t.node, n = e.entering, a = r.attrs.rawHTML;
    return {
      delim: "**",
      rawHTML: n ? qt(a) : $t(a)
    };
  },
  emph: function(t, e) {
    var r = t.node, n = e.entering, a = r.attrs.rawHTML;
    return {
      delim: "*",
      rawHTML: n ? qt(a) : $t(a)
    };
  },
  strike: function(t, e) {
    var r = t.node, n = e.entering, a = r.attrs.rawHTML;
    return {
      delim: "~~",
      rawHTML: n ? qt(a) : $t(a)
    };
  },
  link: function(t, e) {
    var r = t.node, n = e.entering, a = r.attrs, i = a.title, o = a.rawHTML, s = a.linkUrl.replace(/&amp;/g, "&"), l = i ? ' title="' + bt(i) + '"' : "";
    return n ? {
      delim: "[",
      rawHTML: o ? "<" + o + ' href="' + bt(s) + '"' + l + ">" : null
    } : {
      delim: "](" + s + (i ? " " + tv(Er(i)) : "") + ")",
      rawHTML: $t(o)
    };
  },
  code: function(t, e) {
    var r = t.node, n = t.parent, a = t.index, i = a === void 0 ? 0 : a, o = e.entering, s = o ? No(n.child(i), -1) : No(n.child(i - 1), 1), l = o ? qt(r.attrs.rawHTML) : $t(r.attrs.rawHTML);
    return {
      delim: s,
      rawHTML: l
    };
  },
  htmlComment: function(t) {
    var e = t.node;
    return {
      text: e.textContent
    };
  },
  // html inline node, html block node
  html: function(t, e) {
    var r = t.node, n = e.entering, a = r.type.name, i = r.attrs.htmlAttrs, o = "<" + a, s = "</" + a + ">";
    return Object.keys(i).forEach(function(l) {
      o += " " + l + '="' + i[l].replace(/"/g, "'") + '"';
    }), o += ">", r.attrs.htmlInline ? {
      rawHTML: n ? o : s
    } : {
      text: "" + o + r.attrs.childrenHTML + s
    };
  }
}, Ro = {
  strong: {
    mixable: !0,
    removedEnclosingWhitespace: !0
  },
  emph: {
    mixable: !0,
    removedEnclosingWhitespace: !0
  },
  strike: {
    mixable: !0,
    removedEnclosingWhitespace: !0
  },
  code: {
    escape: !1
  },
  link: null,
  html: null
};
function aY(t) {
  var e = {}, r = Object.keys(la);
  return r.forEach(function(n) {
    e[n] = function(a, i) {
      var o = la[n];
      if (o) {
        var s = t[n], l = s ? s(i, {
          inTable: a.inTable
        }) : {};
        nY(n, { state: a, nodeInfo: i, params: l });
      }
    };
  }), e;
}
function iY(t) {
  var e = {}, r = Object.keys(Ro);
  return r.forEach(function(n) {
    e[n] = function(a, i) {
      var o = Ro[n], s = t[n], l = s && a && !Te(i), u = l ? s(a, { entering: i }) : {};
      return b(b({}, u), o);
    };
  }), e;
}
function oY(t) {
  var e = Object.keys(t);
  e.forEach(function(a) {
    var i = Ft[a], o = t[a];
    i ? Ft[a] = function(s, l) {
      return l.origin = function() {
        return i(s, l);
      }, o(s, l);
    } : Ft[a] = o, delete t[a];
  });
  var r = aY(Ft), n = iY(Ft);
  return {
    nodeTypeConvertors: r,
    markTypeConvertors: n
  };
}
var sY = (
  /** @class */
  (function() {
    function t(e) {
      var r = e.nodeTypeConvertors, n = e.markTypeConvertors;
      this.nodeTypeConvertors = r, this.markTypeConvertors = n, this.delim = "", this.result = "", this.closed = !1, this.tightList = !1, this.stopNewline = !1, this.inTable = !1;
    }
    return t.prototype.getMarkConvertor = function(e) {
      var r = e.attrs.htmlInline ? "html" : e.type.name;
      return this.markTypeConvertors[r];
    }, t.prototype.isInBlank = function() {
      return /(^|\n)$/.test(this.result);
    }, t.prototype.markText = function(e, r, n, a) {
      var i = this.getMarkConvertor(e);
      if (i) {
        var o = i({ node: e, parent: n, index: a }, r), s = o.delim, l = o.rawHTML;
        return l || s;
      }
      return "";
    }, t.prototype.setDelim = function(e) {
      this.delim = e;
    }, t.prototype.getDelim = function() {
      return this.delim;
    }, t.prototype.flushClose = function(e) {
      if (!this.stopNewline && this.closed) {
        if (this.isInBlank() || (this.result += `
`), e || (e = 2), e > 1) {
          var r = this.delim, n = /\s+$/.exec(r);
          n && (r = r.slice(0, r.length - n[0].length));
          for (var a = 1; a < e; a += 1)
            this.result += r + `
`;
        }
        this.closed = !1;
      }
    }, t.prototype.wrapBlock = function(e, r, n, a) {
      var i = this.getDelim();
      this.write(r || e), this.setDelim(this.getDelim() + e), a(), this.setDelim(i), this.closeBlock(n);
    }, t.prototype.ensureNewLine = function() {
      this.isInBlank() || (this.result += `
`);
    }, t.prototype.write = function(e) {
      e === void 0 && (e = ""), this.flushClose(), this.delim && this.isInBlank() && (this.result += this.delim), e && (this.result += e);
    }, t.prototype.closeBlock = function(e) {
      this.closed = e;
    }, t.prototype.text = function(e, r) {
      r === void 0 && (r = !0);
      for (var n = e.split(`
`), a = 0; a < n.length; a += 1)
        this.write(), this.result += r ? ev(n[a]) : n[a], a !== n.length - 1 && (this.result += `
`);
    }, t.prototype.convertBlock = function(e, r, n) {
      var a = e.type.name, i = this.nodeTypeConvertors[a], o = { node: e, parent: r, index: n };
      e.attrs.htmlBlock ? this.nodeTypeConvertors.html(this, o) : i && i(this, o);
    }, t.prototype.convertInline = function(e) {
      var r = this, n = [], a = "", i = function(o, s, l) {
        var u = o ? o.marks : [], c = a;
        a = "";
        var v = o && o.isText && u.some(function(V) {
          var Y = r.getMarkConvertor(V), pe = Y && Y();
          return pe && pe.removedEnclosingWhitespace;
        });
        if (v && o && o.text) {
          var f = /^(\s*)(.*?)(\s*)$/m.exec(o.text), d = f[1], p = f[2], h = f[3];
          c += d, a = h, (d || h) && (o = p ? o.withText(p) : null, o || (u = n));
        }
        for (var m = u.length && se(u), y = m && r.getMarkConvertor(m), w = y && y(), C = w && w.escape === !1, T = u.length - (C ? 1 : 0), k = 0; k < T; k += 1) {
          var p = u[k];
          if (w && !w.mixable)
            break;
          for (var M = 0; M < n.length; M += 1) {
            var O = n[M];
            if (w && !w.mixable)
              break;
            if (p.eq(O)) {
              k > M ? u = u.slice(0, M).concat(p).concat(u.slice(M, k)).concat(u.slice(k + 1, T)) : M > k && (u = u.slice(0, k).concat(u.slice(k + 1, M)).concat(p).concat(u.slice(M, T)));
              break;
            }
          }
        }
        for (var I = 0; I < Math.min(n.length, T) && u[I].eq(n[I]); )
          I += 1;
        for (; I < n.length; ) {
          var _ = n.pop();
          _ && r.text(r.markText(_, !1, e, l), !1);
        }
        if (c && r.text(c), o) {
          for (; n.length < T; ) {
            var p = u[n.length];
            n.push(p), r.text(r.markText(p, !0, e, l), !1);
          }
          C && o.isText ? r.text(r.markText(m, !0, e, l) + o.text + r.markText(m, !1, e, l + 1), !1) : r.convertBlock(o, e, l);
        }
      };
      e.forEach(i), i(null, null, e.childCount);
    }, t.prototype.convertList = function(e, r, n) {
      var a = this, i;
      this.closed && this.closed.type === e.type ? this.flushClose(3) : this.tightList && this.flushClose(1);
      var o = (i = e.attrs.tight) !== null && i !== void 0 ? i : !0, s = this.tightList;
      this.tightList = o, e.forEach(function(l, u, c) {
        c && o && a.flushClose(1), a.wrapBlock(r, n(c), e, function() {
          return a.convertBlock(l, e, c);
        });
      }), this.tightList = s;
    }, t.prototype.convertTableCell = function(e) {
      var r = this;
      this.stopNewline = !0, this.inTable = !0, e.forEach(function(n, a, i) {
        if (te(["bulletList", "orderedList"], n.type.name))
          r.convertBlock(n, e, i), r.closed = !1;
        else if (r.convertInline(n), i < e.childCount - 1) {
          var o = e.child(i + 1);
          o.type.name === "paragraph" && r.write("<br>");
        }
      }), this.stopNewline = !1, this.inTable = !1;
    }, t.prototype.convertNode = function(e, r) {
      var n = this;
      return e.forEach(function(a, i, o) {
        if (n.convertBlock(a, e, o), r?.node === a) {
          var s = n.result.split(`
`);
          r.setMappedPos([s.length, se(s).length + 1]);
        }
      }), this.result;
    }, t;
  })()
), lY = (
  /** @class */
  (function() {
    function t(e, r, n, a) {
      var i = this;
      this.setMappedPos = function(o) {
        i.mappedPosWhenConverting = o;
      }, this.schema = e, this.eventEmitter = a, this.focusedNode = null, this.mappedPosWhenConverting = null, this.toWwConvertors = Y7(n), this.toMdConvertors = oY(r || {}), this.eventEmitter.listen("setFocusedNode", function(o) {
        return i.focusedNode = o;
      });
    }
    return t.prototype.getMappedPos = function() {
      return this.mappedPosWhenConverting;
    }, t.prototype.getInfoForPosSync = function() {
      return { node: this.focusedNode, setMappedPos: this.setMappedPos };
    }, t.prototype.toWysiwygModel = function(e) {
      var r = new J7(this.schema, this.toWwConvertors);
      return r.convertNode(e, this.getInfoForPosSync());
    }, t.prototype.toMarkdownText = function(e) {
      var r = new sY(this.toMdConvertors), n = r.convertNode(e, this.getInfoForPosSync());
      return n = this.eventEmitter.emitReduce("beforeConvertWysiwygToMarkdown", n), n;
    }, t;
  })()
);
function uY(t) {
  var e = t.plugin, r = t.eventEmitter, n = t.usageStatistics, a = t.instance, i = { Plugin: Ee, PluginKey: pa, Selection: It, TextSelection: Dt }, o = { Decoration: fa, DecorationSet: va }, s = { Fragment: q }, l = { InputRule: Rs, inputRules: Bs, undoInputRule: nc }, u = { keymap: zt }, c = {
    eventEmitter: r,
    usageStatistics: n,
    instance: a,
    pmState: i,
    pmView: o,
    pmModel: s,
    pmRules: l,
    pmKeymap: u,
    i18n: D
  };
  if (Nt(e)) {
    var v = e[0], f = e[1], d = f === void 0 ? {} : f;
    return v(c, d);
  }
  return e(c);
}
function Tu(t) {
  var e = t.plugins, r = t.eventEmitter, n = t.usageStatistics, a = t.instance;
  return r.listen("mixinTableOffsetMapPrototype", FQ), (e ?? []).reduce(function(i, o) {
    var s = uY({
      plugin: o,
      eventEmitter: r,
      usageStatistics: n,
      instance: a
    });
    if (!s)
      throw new Error("The return value of the executed plugin is empty.");
    var l = s.markdownParsers, u = s.toHTMLRenderers, c = s.toMarkdownRenderers, v = s.markdownPlugins, f = s.wysiwygPlugins, d = s.wysiwygNodeViews, p = s.markdownCommands, h = s.wysiwygCommands, m = s.toolbarItems;
    return u && (i.toHTMLRenderers = xr(i.toHTMLRenderers, u)), c && (i.toMarkdownRenderers = xr(i.toMarkdownRenderers, c)), v && (i.mdPlugins = i.mdPlugins.concat(v)), f && (i.wwPlugins = i.wwPlugins.concat(f)), d && (i.wwNodeViews = b(b({}, i.wwNodeViews), d)), p && (i.mdCommands = b(b({}, i.mdCommands), p)), h && (i.wwCommands = b(b({}, i.wwCommands), h)), m && (i.toolbarItems = i.toolbarItems.concat(m)), l && (i.markdownParsers = b(b({}, i.markdownParsers), l)), i;
  }, {
    toHTMLRenderers: {},
    toMarkdownRenderers: {},
    mdPlugins: [],
    wwPlugins: [],
    wwNodeViews: {},
    mdCommands: {},
    wwCommands: {},
    toolbarItems: [],
    markdownParsers: {}
  });
}
var cY = "data-task", vY = "data-task-disabled", fY = "checked";
function dY(t) {
  ["htmlBlock", "htmlInline"].forEach(function(e) {
    t[e] && Object.keys(t[e]).forEach(function(r) {
      return Zl(r);
    });
  });
}
var ku = (
  /** @class */
  (function() {
    function t(e) {
      var r = this;
      this.options = ma({
        linkAttributes: null,
        extendedAutolinks: !1,
        customHTMLRenderer: null,
        referenceDefinition: !1,
        customHTMLSanitizer: null,
        frontMatter: !1,
        usageStatistics: !0,
        theme: "light"
      }, e), this.eventEmitter = new wu();
      var n = qs(this.options.linkAttributes), a = Tu({
        plugins: this.options.plugins,
        eventEmitter: this.eventEmitter,
        usageStatistics: this.options.usageStatistics,
        instance: this
      }) || {}, i = a.toHTMLRenderers, o = a.markdownParsers, s = this.options, l = s.customHTMLRenderer, u = s.extendedAutolinks, c = s.referenceDefinition, v = s.frontMatter, f = s.customHTMLSanitizer, d = {
        linkAttributes: n,
        customHTMLRenderer: b(b({}, i), l),
        extendedAutolinks: u,
        referenceDefinition: c,
        frontMatter: v,
        sanitizer: f || ot
      };
      dY(d.customHTMLRenderer), this.options.events && Ct(this.options.events, function(C, T) {
        r.on(T, C);
      });
      var p = this.options, h = p.el, m = p.initialValue, y = p.theme, w = h.innerHTML;
      y !== "light" && h.classList.add(L(y)), h.innerHTML = "", this.toastMark = new Xl("", {
        disallowedHtmlBlockTags: ["br", "img"],
        extendedAutolinks: u,
        referenceDefinition: c,
        disallowDeepHeading: !0,
        frontMatter: v,
        customParser: o
      }), this.preview = new tu(this.eventEmitter, b(b({}, d), { isViewer: !0 })), ml(this.preview.previewContent, "mousedown", this.toggleTask.bind(this)), m ? this.setMarkdown(m) : w && this.preview.setHTML(w), h.appendChild(this.preview.previewContent), this.eventEmitter.emit("load", this);
    }
    return t.prototype.toggleTask = function(e) {
      var r = e.target, n = getComputedStyle(r, ":before");
      !r.hasAttribute(vY) && r.hasAttribute(cY) && xa(n, e.offsetX, e.offsetY) && (La(r, fY), this.eventEmitter.emit("change", {
        source: "viewer",
        date: e
      }));
    }, t.prototype.setMarkdown = function(e) {
      var r = this.toastMark.getLineTexts(), n = r.length, a = se(r), i = [n, a.length + 1], o = this.toastMark.editMarkdown([1, 1], i, e || "");
      this.eventEmitter.emit("updatePreview", o);
    }, t.prototype.on = function(e, r) {
      this.eventEmitter.listen(e, r);
    }, t.prototype.off = function(e) {
      this.eventEmitter.removeEventHandler(e);
    }, t.prototype.addHook = function(e, r) {
      this.eventEmitter.removeEventHandler(e), this.eventEmitter.listen(e, r);
    }, t.prototype.destroy = function() {
      hl(this.preview.el, "mousedown", this.toggleTask.bind(this)), this.preview.destroy(), this.eventEmitter.emit("destroy");
    }, t.prototype.isViewer = function() {
      return !0;
    }, t.prototype.isMarkdownMode = function() {
      return !1;
    }, t.prototype.isWysiwygMode = function() {
      return !1;
    }, t;
  })()
);
function Cr(t) {
  return t instanceof Wu;
}
function Eu(t) {
  var e = [
    "document",
    "blockQuote",
    "bulletList",
    "orderedList",
    "listItem",
    "paragraph",
    "heading",
    "emph",
    "strong",
    "strike",
    "link",
    "image",
    "table",
    "tableHead",
    "tableBody",
    "tableRow",
    "tableHeadCell",
    "tableBodyCell"
  ];
  return te(e, t);
}
function pY(t) {
  var e = t.attrs, r = t.type, n = r.name, a = {
    type: n,
    wysiwygNode: !0,
    literal: !Eu(n) && Cr(t) ? t.textContent : null
  }, i = {
    heading: { level: e.level },
    link: { destination: e.linkUrl, title: e.title },
    image: { destination: e.imageUrl },
    codeBlock: { info: e.language },
    bulletList: { type: "list", listData: { type: "bullet" } },
    orderedList: { type: "list", listData: { type: "ordered", start: e.order } },
    listItem: { type: "item", listData: { task: e.task, checked: e.checked } },
    tableHeadCell: { type: "tableCell", cellType: "head", align: e.align },
    tableBodyCell: { type: "tableCell", cellType: "body", align: e.align },
    customBlock: { info: e.info }
  }, o = i[n], s = b(b({}, a), o), l = t.attrs, u = l.htmlAttrs, c = l.childrenHTML;
  return u ? b(b({}, s), { attrs: u, childrenHTML: c }) : s;
}
var hY = {
  openTag: function(t, e) {
    var r = t, n = r.tagName, a = r.classNames, i = r.attributes, o = document.createElement(n), s = {};
    a && (o.className = a.join(" ")), i && (s = b(b({}, s), i)), Aa(s, o), e.push(o);
  },
  closeTag: function(t, e) {
    if (e.length > 1) {
      var r = e.pop();
      se(e).appendChild(r);
    }
  },
  html: function(t, e) {
    se(e).insertAdjacentHTML("beforeend", t.content);
  },
  text: function(t, e) {
    var r = document.createTextNode(t.content);
    se(e).appendChild(r);
  }
}, mY = (
  /** @class */
  (function() {
    function t(e, r) {
      var n = Fa(e, r), a = b(b({}, r.htmlBlock), r.htmlInline);
      this.customConvertorKeys = Object.keys(r).concat(Object.keys(a)), this.renderer = new $a({
        gfm: !0,
        convertors: b(b({}, n), a)
      }), this.convertors = this.renderer.getConvertors();
    }
    return t.prototype.generateTokens = function(e) {
      var r = pY(e), n = {
        entering: !0,
        leaf: Cr(e) ? e.isLeaf : !1,
        options: this.renderer.getOptions(),
        getChildrenText: function() {
          return Cr(e) ? e.textContent : "";
        },
        skipChildren: function() {
          return !1;
        }
      }, a = this.convertors[e.type.name], i = a(r, n, this.convertors), o = Nt(i) ? i : [i];
      return (Eu(e.type.name) || e.attrs.htmlInline) && (n.entering = !1, o.push({ type: "text", content: Cr(e) ? e.textContent : "" }), o = o.concat(a(r, n, this.convertors))), o;
    }, t.prototype.toDOMNode = function(e) {
      var r = this.generateTokens(e), n = [];
      return r.forEach(function(a) {
        return hY[a.type](a, n);
      }), n[0];
    }, t.prototype.getToDOMNode = function(e) {
      return te(this.customConvertorKeys, e) ? this.toDOMNode.bind(this) : null;
    }, t;
  })()
), gY = 100, yY = 15, dr = null, Hn = null;
function Bo(t, e) {
  var r = e.syncScrollTop, n = e.releaseEventBlock;
  Hn && clearTimeout(Hn), r(t), Hn = setTimeout(function() {
    n();
  }, yY);
}
function bY(t, e, r) {
  var n = e - t, a = Date.now(), i = function() {
    var o = Date.now(), s = (o - a) / gY, l;
    dr && clearTimeout(dr), s < 1 ? (l = t + n * Math.cos((1 - s) * Math.PI / 2), Bo(Math.ceil(l), r), dr = setTimeout(i, 1)) : (Bo(e, r), dr = null);
  };
  i();
}
var wY = 18, CY = (
  /** @class */
  (function() {
    function t(e, r, n) {
      this.latestEditorScrollTop = null, this.latestPreviewScrollTop = null, this.blockedScroll = null, this.active = !0, this.timer = null;
      var a = r.previewContent, i = r.el;
      this.previewRoot = a, this.previewEl = i, this.mdEditor = e, this.editorView = e.view, this.toastMark = e.getToastMark(), this.eventEmitter = n, this.addScrollSyncEvent();
    }
    return t.prototype.addScrollSyncEvent = function() {
      var e = this;
      this.eventEmitter.listen("afterPreviewRender", function() {
        e.clearTimer(), e.timer = setTimeout(function() {
          e.syncPreviewScrollTop(!0);
        }, 200);
      }), this.eventEmitter.listen("scroll", function(r, n) {
        e.active && (r === "editor" && e.blockedScroll !== "editor" ? e.syncPreviewScrollTop() : r === "preview" && e.blockedScroll !== "preview" && e.syncEditorScrollTop(n));
      }), this.eventEmitter.listen("toggleScrollSync", function(r) {
        e.active = r;
      });
    }, t.prototype.getMdNodeAtPos = function(e, r) {
      var n = e.content.findIndex(r.pos), a = n.index;
      return this.toastMark.findFirstNodeAtLine(a + 1);
    }, t.prototype.getScrollTopByCaretPos = function() {
      var e = this.mdEditor.getSelection(), r = this.toastMark.findFirstNodeAtLine(e[0][0]), n = this.previewEl.clientHeight, a = In(this.previewRoot, r).el, i = Br(a, this.previewRoot) || a.offsetTop, o = a.clientHeight, s = i + o - n * 0.5;
      this.latestEditorScrollTop = null;
      var l = a.getBoundingClientRect().top - this.previewEl.getBoundingClientRect().top;
      return l < n ? null : s;
    }, t.prototype.syncPreviewScrollTop = function(e) {
      e === void 0 && (e = !1);
      var r = this, n = r.editorView, a = r.previewEl, i = r.previewRoot, o = n.dom.getBoundingClientRect(), s = o.left, l = o.top, u = n.posAtCoords({ left: s, top: l }), c = n.state.doc, v = this.getMdNodeAtPos(c, u);
      if (!(!v || iv(v))) {
        var f = a.scrollTop, d = n.dom, p = d.scrollTop, h = d.scrollHeight, m = d.clientHeight, y = d.children, w = h - p <= m + wY, C = w ? a.scrollHeight : 0;
        if (p && !w) {
          if (e) {
            var T = this.getScrollTopByCaretPos();
            if (!T)
              return;
            C = T;
          } else {
            var k = In(this.previewRoot, v), M = k.el, O = k.mdNode, I = wo(c, O, y), _ = I.height, V = I.rect, Y = Br(M, i) || M.offsetTop, pe = M.clientHeight, Zt = l > V.top ? Math.min((l - V.top) / _, 1) : 0;
            C = Y + pe * Zt;
          }
          C = this.getResolvedScrollTop("editor", p, C, f), this.latestEditorScrollTop = p;
        }
        C !== f && this.run("editor", C, f);
      }
    }, t.prototype.syncEditorScrollTop = function(e) {
      var r = this, n = r.toastMark, a = r.editorView, i = r.previewRoot, o = r.previewEl, s = a.dom, l = a.state, u = o.scrollTop, c = o.clientHeight, v = o.scrollHeight, f = v - u <= c, d = s.scrollTop, p = f ? s.scrollHeight : 0;
      if (u && e && !f) {
        if (e = gQ(e, i), !e.getAttribute("data-nodeid"))
          return;
        var h = s.children, m = Number(e.getAttribute("data-nodeid")), y = In(this.previewRoot, n.findNodeById(m)), w = y.mdNode, C = y.el, T = Kt(w);
        p = h[T - 1].offsetTop;
        var k = wo(l.doc, w, h).height, M = xQ(C, i, m), O = M.nodeHeight, I = M.offsetTop;
        p += bQ(u, I, O, k), p = this.getResolvedScrollTop("preview", u, p, d), this.latestPreviewScrollTop = u;
      }
      p !== d && this.run("preview", p, d);
    }, t.prototype.getResolvedScrollTop = function(e, r, n, a) {
      var i = e === "editor" ? this.latestEditorScrollTop : this.latestPreviewScrollTop;
      return i === null ? n : i < r ? Math.max(n, a) : Math.min(n, a);
    }, t.prototype.run = function(e, r, n) {
      var a = this, i;
      e === "editor" ? (i = this.previewEl, this.blockedScroll = "preview") : (i = this.editorView.dom, this.blockedScroll = "editor");
      var o = {
        syncScrollTop: function(s) {
          return i.scrollTop = s;
        },
        releaseEventBlock: function() {
          return a.blockedScroll = null;
        }
      };
      bY(n, r, o);
    }, t.prototype.clearTimer = function() {
      this.timer && (clearTimeout(this.timer), this.timer = null);
    }, t.prototype.destroy = function() {
      this.clearTimer(), this.eventEmitter.removeEventHandler("scroll"), this.eventEmitter.removeEventHandler("afterPreviewRender");
    }, t;
  })()
), TY = {
  getPopupInitialValues: function(t, e) {
    var r = e.popupName;
    return r === "link" ? { linkText: t.getSelectedText() } : {};
  }
};
function kY(t) {
  t.eventEmitter.listen("query", function(e, r) {
    return TY[e](t, r);
  });
}
var xu = (
  /** @class */
  (function() {
    function t(e) {
      var r = this;
      this.initialHTML = e.el.innerHTML, e.el.innerHTML = "", this.options = ma({
        previewStyle: "tab",
        previewHighlight: !0,
        initialEditType: "markdown",
        height: "300px",
        minHeight: "200px",
        language: "en-US",
        useCommandShortcut: !0,
        usageStatistics: !0,
        toolbarItems: [
          ["heading", "bold", "italic", "strike"],
          ["hr", "quote"],
          ["ul", "ol", "task", "indent", "outdent"],
          ["table", "image", "link"],
          ["code", "codeblock"],
          ["scrollSync"]
        ],
        hideModeSwitch: !1,
        linkAttributes: null,
        extendedAutolinks: !1,
        customHTMLRenderer: null,
        customMarkdownRenderer: null,
        referenceDefinition: !1,
        customHTMLSanitizer: null,
        frontMatter: !1,
        widgetRules: [],
        theme: "light",
        autofocus: !0
      }, e);
      var n = this.options, a = n.customHTMLRenderer, i = n.extendedAutolinks, o = n.referenceDefinition, s = n.frontMatter, l = n.customMarkdownRenderer, u = n.useCommandShortcut, c = n.initialEditType, v = n.widgetRules, f = n.customHTMLSanitizer;
      this.mode = c || "markdown", this.mdPreviewStyle = this.options.previewStyle, this.i18n = D, this.i18n.setCode(this.options.language), this.eventEmitter = new wu(), hv(v);
      var d = qs(this.options.linkAttributes);
      this.pluginInfo = Tu({
        plugins: this.options.plugins,
        eventEmitter: this.eventEmitter,
        usageStatistics: this.options.usageStatistics,
        instance: this
      });
      var p = this.pluginInfo, h = p.toHTMLRenderers, m = p.toMarkdownRenderers, y = p.mdPlugins, w = p.wwPlugins, C = p.wwNodeViews, T = p.mdCommands, k = p.wwCommands, M = p.markdownParsers, O = {
        linkAttributes: d,
        customHTMLRenderer: xr(h, a),
        extendedAutolinks: i,
        referenceDefinition: o,
        frontMatter: s,
        sanitizer: f || ot
      }, I = new mY(d, O.customHTMLRenderer), _ = cQ(O.customHTMLRenderer, O.sanitizer, I);
      this.toastMark = new Xl("", {
        disallowedHtmlBlockTags: ["br", "img"],
        extendedAutolinks: i,
        referenceDefinition: o,
        disallowDeepHeading: !0,
        frontMatter: s,
        customParser: M
      }), this.mdEditor = new yd(this.eventEmitter, {
        toastMark: this.toastMark,
        useCommandShortcut: u,
        mdPlugins: y
      }), this.preview = new tu(this.eventEmitter, b(b({}, O), { isViewer: !1, highlight: this.options.previewHighlight })), this.wwEditor = new B7(this.eventEmitter, {
        toDOMAdaptor: I,
        useCommandShortcut: u,
        htmlSchemaMap: _,
        linkAttributes: d,
        wwPlugins: w,
        wwNodeViews: C
      }), this.convertor = new lY(this.wwEditor.getSchema(), b(b({}, m), l), Fa(d, O.customHTMLRenderer), this.eventEmitter), this.setMinHeight(this.options.minHeight), this.setHeight(this.options.height), this.setMarkdown(this.options.initialValue, !1), this.options.placeholder && this.setPlaceholder(this.options.placeholder), this.options.initialValue || this.setHTML(this.initialHTML, !1), this.commandManager = new W7(this.eventEmitter, this.mdEditor.commands, this.wwEditor.commands, function() {
        return r.mode;
      }), this.options.usageStatistics && Kc(), this.scrollSync = new CY(this.mdEditor, this.preview, this.eventEmitter), this.addInitEvent(), this.addInitCommand(T, k), kY(this), this.options.hooks && Ct(this.options.hooks, function(V, Y) {
        return r.addHook(Y, V);
      }), this.options.events && Ct(this.options.events, function(V, Y) {
        return r.on(Y, V);
      }), this.eventEmitter.emit("load", this), this.moveCursorToStart(this.options.autofocus);
    }
    return t.prototype.addInitEvent = function() {
      var e = this;
      this.on("needChangeMode", this.changeMode.bind(this)), this.on("loadUI", function() {
        if (e.height !== "auto") {
          var r = Math.min(parseInt(e.minHeight, 10), parseInt(e.height, 10) - 75) + "px";
          e.setMinHeight(r);
        }
      }), Fv(this.eventEmitter);
    }, t.prototype.addInitCommand = function(e, r) {
      var n = this, a = function(i, o) {
        Object.keys(o).forEach(function(s) {
          n.addCommand(i, s, o[s]);
        });
      };
      this.addCommand("markdown", "toggleScrollSync", function(i) {
        return n.eventEmitter.emit("toggleScrollSync", i.active), !0;
      }), a("markdown", e), a("wysiwyg", r);
    }, t.prototype.getCurrentModeEditor = function() {
      return this.isMarkdownMode() ? this.mdEditor : this.wwEditor;
    }, t.factory = function(e) {
      return e.viewer ? new ku(e) : new t(e);
    }, t.setLanguage = function(e, r) {
      D.setLanguage(e, r);
    }, t.prototype.changePreviewStyle = function(e) {
      this.mdPreviewStyle !== e && (this.mdPreviewStyle = e, this.eventEmitter.emit("changePreviewStyle", e));
    }, t.prototype.exec = function(e, r) {
      this.commandManager.exec(e, r);
    }, t.prototype.addCommand = function(e, r, n) {
      var a = this, i = function(o) {
        o === void 0 && (o = {});
        var s = (e === "markdown" ? a.mdEditor : a.wwEditor).view;
        n(o, s.state, s.dispatch, s);
      };
      this.commandManager.addCommand(e, r, i);
    }, t.prototype.on = function(e, r) {
      this.eventEmitter.listen(e, r);
    }, t.prototype.off = function(e) {
      this.eventEmitter.removeEventHandler(e);
    }, t.prototype.addHook = function(e, r) {
      this.eventEmitter.removeEventHandler(e), this.eventEmitter.listen(e, r);
    }, t.prototype.removeHook = function(e) {
      this.eventEmitter.removeEventHandler(e);
    }, t.prototype.focus = function() {
      this.getCurrentModeEditor().focus();
    }, t.prototype.blur = function() {
      this.getCurrentModeEditor().blur();
    }, t.prototype.moveCursorToEnd = function(e) {
      e === void 0 && (e = !0), this.getCurrentModeEditor().moveCursorToEnd(e);
    }, t.prototype.moveCursorToStart = function(e) {
      e === void 0 && (e = !0), this.getCurrentModeEditor().moveCursorToStart(e);
    }, t.prototype.setMarkdown = function(e, r) {
      if (e === void 0 && (e = ""), r === void 0 && (r = !0), this.mdEditor.setMarkdown(e, r), this.isWysiwygMode()) {
        var n = this.toastMark.getRootNode(), a = this.convertor.toWysiwygModel(n);
        this.wwEditor.setModel(a, r);
      }
    }, t.prototype.setHTML = function(e, r) {
      e === void 0 && (e = ""), r === void 0 && (r = !0);
      var n = document.createElement("div");
      n.innerHTML = _v(e);
      var a = Ss.fromSchema(this.wwEditor.schema).parse(n);
      this.isMarkdownMode() ? this.mdEditor.setMarkdown(this.convertor.toMarkdownText(a), r) : this.wwEditor.setModel(a, r);
    }, t.prototype.getMarkdown = function() {
      return this.isMarkdownMode() ? this.mdEditor.getMarkdown() : this.convertor.toMarkdownText(this.wwEditor.getModel());
    }, t.prototype.getHTML = function() {
      var e = this;
      this.eventEmitter.holdEventInvoke(function() {
        if (e.isMarkdownMode()) {
          var a = e.toastMark.getRootNode(), i = e.convertor.toWysiwygModel(a);
          e.wwEditor.setModel(i);
        }
      });
      var r = Sa(this.wwEditor.view.dom.innerHTML);
      if (this.placeholder) {
        var n = new RegExp('<span class="placeholder[^>]+>' + this.placeholder + "</span>", "i");
        return r.replace(n, "");
      }
      return r;
    }, t.prototype.insertText = function(e) {
      this.getCurrentModeEditor().replaceSelection(e);
    }, t.prototype.setSelection = function(e, r) {
      this.getCurrentModeEditor().setSelection(e, r);
    }, t.prototype.replaceSelection = function(e, r, n) {
      this.getCurrentModeEditor().replaceSelection(e, r, n);
    }, t.prototype.deleteSelection = function(e, r) {
      this.getCurrentModeEditor().deleteSelection(e, r);
    }, t.prototype.getSelectedText = function(e, r) {
      return this.getCurrentModeEditor().getSelectedText(e, r);
    }, t.prototype.getRangeInfoOfNode = function(e) {
      return this.getCurrentModeEditor().getRangeInfoOfNode(e);
    }, t.prototype.addWidget = function(e, r, n) {
      this.getCurrentModeEditor().addWidget(e, r, n);
    }, t.prototype.replaceWithWidget = function(e, r, n) {
      this.getCurrentModeEditor().replaceWithWidget(e, r, n);
    }, t.prototype.setHeight = function(e) {
      var r = this.options.el;
      Fe(e) && (e === "auto" ? Ae(r, "auto-height") : ye(r, "auto-height"), this.setMinHeight(this.getMinHeight())), Oe(r, { height: e }), this.height = e;
    }, t.prototype.getHeight = function() {
      return this.height;
    }, t.prototype.setMinHeight = function(e) {
      if (e !== this.minHeight) {
        var r = this.height || this.options.height;
        r !== "auto" && this.options.el.querySelector("." + L("main")) && (e = Math.min(parseInt(e, 10), parseInt(r, 10) - 75) + "px");
        var n = parseInt(e, 10);
        this.minHeight = e, this.wwEditor.setMinHeight(n), this.mdEditor.setMinHeight(n), this.preview.setMinHeight(n);
      }
    }, t.prototype.getMinHeight = function() {
      return this.minHeight;
    }, t.prototype.isMarkdownMode = function() {
      return this.mode === "markdown";
    }, t.prototype.isWysiwygMode = function() {
      return this.mode === "wysiwyg";
    }, t.prototype.isViewer = function() {
      return !1;
    }, t.prototype.getCurrentPreviewStyle = function() {
      return this.mdPreviewStyle;
    }, t.prototype.changeMode = function(e, r) {
      if (this.mode !== e) {
        if (this.mode = e, this.isWysiwygMode()) {
          var n = this.toastMark.getRootNode(), a = this.convertor.toWysiwygModel(n);
          this.wwEditor.setModel(a);
        } else {
          var a = this.wwEditor.getModel();
          this.mdEditor.setMarkdown(this.convertor.toMarkdownText(a), !r);
        }
        if (this.eventEmitter.emit("removePopupWidget"), this.eventEmitter.emit("changeMode", e), !r) {
          var i = this.convertor.getMappedPos();
          this.focus(), this.isWysiwygMode() && He(i) ? this.wwEditor.setSelection(i) : Array.isArray(i) && this.mdEditor.setSelection(i);
        }
      }
    }, t.prototype.destroy = function() {
      var e = this;
      this.wwEditor.destroy(), this.mdEditor.destroy(), this.preview.destroy(), this.scrollSync.destroy(), this.eventEmitter.emit("destroy"), this.eventEmitter.getEvents().forEach(function(r, n) {
        return e.off(n);
      });
    }, t.prototype.hide = function() {
      this.eventEmitter.emit("hide");
    }, t.prototype.show = function() {
      this.eventEmitter.emit("show");
    }, t.prototype.setScrollTop = function(e) {
      this.getCurrentModeEditor().setScrollTop(e);
    }, t.prototype.getScrollTop = function() {
      return this.getCurrentModeEditor().getScrollTop();
    }, t.prototype.reset = function() {
      this.wwEditor.setModel([]), this.mdEditor.setMarkdown("");
    }, t.prototype.getSelection = function() {
      return this.getCurrentModeEditor().getSelection();
    }, t.prototype.setPlaceholder = function(e) {
      this.placeholder = e, this.mdEditor.setPlaceholder(e), this.wwEditor.setPlaceholder(e);
    }, t.prototype.getEditorElements = function() {
      return {
        mdEditor: this.mdEditor.getElement(),
        mdPreview: this.preview.getElement(),
        wwEditor: this.wwEditor.getElement()
      };
    }, t.prototype.convertPosToMatchEditorMode = function(e, r, n) {
      var a, i;
      r === void 0 && (r = e), n === void 0 && (n = this.mode);
      var o = this.mdEditor.view.state.doc, s = Array.isArray(e), l = Array.isArray(r), u = e, c = r;
      if (s !== l)
        throw new Error("Types of arguments must be same");
      return n === "markdown" && !s && !l ? (a = hr(o, e, r), u = a[0], c = a[1]) : n === "wysiwyg" && s && l && (i = Je(o, e, r), u = i[0], c = i[1]), [u, c];
    }, t;
  })()
);
function EY(t) {
  for (var e, r, n = arguments, a = 1, i = "", o = "", s = [0], l = function(c) {
    a === 1 && (c || (i = i.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? s.push(c ? n[c] : i) : a === 3 && (c || i) ? (s[1] = c ? n[c] : i, a = 2) : a === 2 && i === "..." && c ? s[2] = Ta(s[2] || {}, n[c]) : a === 2 && i && !c ? (s[2] = s[2] || {})[i] = !0 : a >= 5 && (a === 5 ? ((s[2] = s[2] || {})[r] = c ? i ? i + n[c] : n[c] : i, a = 6) : (c || i) && (s[2][r] += c ? i + n[c] : i)), i = "";
  }, u = 0; u < t.length; u++) {
    u && (a === 1 && l(), l(u));
    for (let c = 0; c < t[u].length; c++)
      e = t[u][c], a === 1 ? e === "<" ? (l(), s = [s, "", null], a = 3) : i += e : a === 4 ? i === "--" && e === ">" ? (a = 1, i = "") : i = e + i[0] : o ? e === o ? o = "" : i += e : e === '"' || e === "'" ? o = e : e === ">" ? (l(), a = 1) : a && (e === "=" ? (a = 5, r = i, i = "") : e === "/" && (a < 5 || t[u][c + 1] === ">") ? (l(), a === 3 && (s = s[0]), a = s, (s = s[0]).push(this.apply(null, a.slice(1))), a = 0) : e === " " || e === "	" || e === `
` || e === "\r" ? (l(), a = 2) : i += e), a === 3 && i === "!--" && (a = 4, s = s[0]);
  }
  return l(), s.length > 2 ? s.slice(1) : s[1];
}
function xY(t) {
  return typeof t == "boolean" || t instanceof Boolean;
}
var LY = xY, MY = (
  /** @class */
  (function() {
    function t(e) {
      this.current = e, this.root = e, this.entering = !0;
    }
    return t.prototype.walk = function() {
      var e = this, r = e.entering, n = e.current;
      return n ? (r ? n.firstChild ? (this.current = n.firstChild, this.entering = !0) : this.entering = !1 : n === this.root ? this.current = null : n.next ? (this.current = n.next, this.entering = !0) : (this.current = n.parent, this.entering = !1), { vnode: n, entering: r }) : null;
    }, t;
  })()
), we = (
  /** @class */
  (function() {
    function t(e, r, n) {
      this.parent = null, this.old = null, this.firstChild = null, this.next = null, this.skip = !1, this.type = e, this.props = r, this.children = n, this.props.children = n, r.ref && (this.ref = r.ref, delete r.ref), r.key && (this.key = r.key, delete r.key);
    }
    return t.prototype.walker = function() {
      return new MY(this);
    }, t.removalNodes = [], t;
  })()
);
function AY(t) {
  return new we("TEXT_NODE", { nodeValue: t }, []);
}
function Ho(t, e) {
  var r = t;
  LY(t) || t == null ? r = null : (Fe(t) || He(t)) && (r = AY(String(t))), r && e.push(r);
}
function SY(t, e) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var a = [];
  return r.forEach(function(i) {
    Array.isArray(i) ? i.forEach(function(o) {
      Ho(o, a);
    }) : Ho(i, a);
  }), new we(t, e || {}, a);
}
var B = EY.bind(SY);
function OY(t) {
  return t === Object(t);
}
var DY = OY;
function IY(t) {
  var e;
  return t.type === "TEXT_NODE" ? e = document.createTextNode(t.props.nodeValue) : (e = document.createElement(t.type), Mu(e, {}, t.props)), e;
}
function Lu(t, e) {
  t.node ? e.removeChild(t.node) : Lu(t.firstChild, e);
}
function NY(t, e, r) {
  Object.keys(e).forEach(function(n) {
    if (/^on/.test(n)) {
      if (!r[n] || e[n] !== r[n]) {
        var a = n.slice(2).toLowerCase();
        t.removeEventListener(a, e[n]);
      }
    } else n !== "children" && !r[n] && !Nv(t) && t.removeAttribute(n);
  }), Mu(t, e, r, function(n) {
    return !ya(e[n], r[n]);
  });
}
var RY = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
function Mu(t, e, r, n) {
  Object.keys(r).forEach(function(a) {
    if (!n || n(a))
      if (/^on/.test(a)) {
        var i = a.slice(2).toLowerCase();
        t.addEventListener(i, r[a]);
      } else a === "nodeValue" ? t[a] = r[a] : a === "style" && DY(r[a]) ? BY(t, e[a], r[a]) : a !== "children" && (r[a] === !1 ? t.removeAttribute(a) : t.setAttribute(a, r[a]));
  });
}
function BY(t, e, r) {
  e && Object.keys(e).forEach(function(n) {
    t.style[n] = "";
  }), Object.keys(r).forEach(function(n) {
    var a = r[n];
    t.style[n] = He(a) && !RY.test(n) ? a + "px" : a;
  });
}
function ja(t) {
  if (we.removalNodes.forEach(function(i) {
    return _o(i);
  }), t) {
    for (var e = void 0, r = t.walker(); e = r.walk(); )
      if (t = e.vnode, e.entering)
        _o(t);
      else if (he(t.type)) {
        var n = t.component;
        if (!t.old && n.mounted && n.mounted(), t.old && n.updated) {
          var a = n.prevProps || {};
          n.updated(a);
        }
      }
  }
}
function Po(t) {
  for (var e = t.parent; !e.node; )
    e = e.parent;
  return e.node;
}
function _o(t) {
  if (!(!t || !t.parent)) {
    if (t.node) {
      var e = Po(t);
      t.effect === "A" ? e.appendChild(t.node) : t.effect === "U" && NY(t.node, t.old.props, t.props);
    }
    if (t.effect === "D") {
      for (var r = void 0, n = t.walker(); r = n.walk(); )
        if (t = r.vnode, !r.entering)
          if (he(t.type)) {
            var a = t.component;
            a.beforeDestroy && a.beforeDestroy();
          } else {
            var e = Po(t);
            Lu(t, e);
          }
    }
    t.ref && (t.component ? t.ref(t.component) : t.node && t.ref(t.node));
  }
}
function HY(t, e) {
  var r = e.props, n = e.component;
  return n ? (n.prevProps = n.props, n.props = e.props, n) : new t(r);
}
function Au(t) {
  for (var e = t; t && !t.skip; ) {
    if (he(t.type)) {
      var r = HY(t.type, t);
      r.vnode = t, t.component = r, t.props.children = t.children = [r.render()], qo(t);
    } else
      t.node || (t.node = IY(t)), qo(t);
    if (t.firstChild)
      t = t.firstChild;
    else {
      for (; t && t.parent && !t.next && (t = t.parent, t !== e); )
        ;
      t = t.next;
    }
  }
}
function PY(t, e) {
  return t && e && e.type === t.type && (!e.key || e.key === t.key);
}
function qo(t) {
  var e = t.children, r = t.old ? t.old.firstChild : null, n = null;
  e.forEach(function(i, o) {
    var s = PY(r, i);
    s && (i.old = r, i.parent = t, i.node = r.node, i.component = r.component, i.effect = "U"), i && !s && (i.old = null, i.parent = t, i.node = null, i.effect = "A"), r && !s && (we.removalNodes.push(r), r.effect = "D"), r && (r = r.next), o === 0 ? t.firstChild = i : i && (n.next = i), n = i;
  });
  var a = se(e);
  if (!e.length)
    for (; r; )
      we.removalNodes.push(r), r.effect = "D", r = r.next;
  for (; r && a; )
    r && a.old !== r && (we.removalNodes.push(r), r.effect = "D", r = r.next);
}
function _Y(t) {
  t.effect = "D", we.removalNodes = [t], ja(), we.removalNodes = [];
}
function qY(t) {
  var e = t.vnode;
  e.effect = "U", e.old = e, e.next && (e.next.skip = !0), we.removalNodes = [], Au(e), ja(e), e.next && (e.next.skip = !1);
}
function $Y(t, e) {
  var r = new we(t.tagName.toLowerCase(), {}, [e]);
  return r.node = t, we.removalNodes = [], Au(r), ja(r), function() {
    return _Y(r.firstChild);
  };
}
var le = (
  /** @class */
  (function() {
    function t(e) {
      this.props = e, this.state = {}, this.refs = {};
    }
    return t.prototype.setState = function(e) {
      var r = b(b({}, this.state), e);
      ya(this.state, r) || (this.state = r, qY(this));
    }, t;
  })()
), FY = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.state = {
        hide: !1
      }, n;
    }
    return e.prototype.show = function() {
      this.setState({ hide: !1 });
    }, e.prototype.hide = function() {
      this.setState({ hide: !0 });
    }, e.prototype.render = function() {
      var r = this.props, n = r.editorType, a = r.eventEmitter;
      return B($o || ($o = R([`
      <div class="`, '" style="display: ', `">
        <div
          class="tab-item`, `"
          onClick=`, `
        >
          `, `
        </div>
        <div
          class="tab-item`, `"
          onClick=`, `
        >
          `, `
        </div>
      </div>
    `], [
        `
      <div class="`,
        '" style="display: ',
        `">
        <div
          class="tab-item`,
        `"
          onClick=`,
        `
        >
          `,
        `
        </div>
        <div
          class="tab-item`,
        `"
          onClick=`,
        `
        >
          `,
        `
        </div>
      </div>
    `
      ])), L("mode-switch"), this.state.hide ? "none" : "block", n === "markdown" ? " active" : "", function() {
        a.emit("needChangeMode", "markdown");
      }, D.get("Markdown"), n === "wysiwyg" ? " active" : "", function() {
        a.emit("needChangeMode", "wysiwyg");
      }, D.get("WYSIWYG"));
    }, e;
  })(le)
), $o;
function UY(t, e) {
  var r, n;
  e = e || 0;
  function a() {
    n = Array.prototype.slice.call(arguments), window.clearTimeout(r), r = window.setTimeout(function() {
      t.apply(null, n);
    }, e);
  }
  return a;
}
var VY = UY, jY = VY;
function zY(t, e) {
  var r, n = !0, a = function(c) {
    t.apply(null, c), r = null;
  }, i, o, s;
  e = e || 0, i = jY(a, e);
  function l() {
    if (s = Array.prototype.slice.call(arguments), n) {
      a(s), n = !1;
      return;
    }
    o = Number(/* @__PURE__ */ new Date()), r = r || o, i(s), o - r >= e && a(s);
  }
  function u() {
    n = !0, r = null;
  }
  return l.reset = u, l;
}
var WY = zY, Su = (function() {
  if (typeof Map < "u")
    return Map;
  function t(e, r) {
    var n = -1;
    return e.some(function(a, i) {
      return a[0] === r ? (n = i, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    (function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(r) {
        var n = t(this.__entries__, r), a = this.__entries__[n];
        return a && a[1];
      }, e.prototype.set = function(r, n) {
        var a = t(this.__entries__, r);
        ~a ? this.__entries__[a][1] = n : this.__entries__.push([r, n]);
      }, e.prototype.delete = function(r) {
        var n = this.__entries__, a = t(n, r);
        ~a && n.splice(a, 1);
      }, e.prototype.has = function(r) {
        return !!~t(this.__entries__, r);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var a = 0, i = this.__entries__; a < i.length; a++) {
          var o = i[a];
          r.call(n, o[1], o[0]);
        }
      }, e;
    })()
  );
})(), ua = typeof window < "u" && typeof document < "u" && window.document === document, Pr = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), GY = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Pr) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
})(), XY = 2;
function QY(t, e) {
  var r = !1, n = !1, a = 0;
  function i() {
    r && (r = !1, t()), n && s();
  }
  function o() {
    GY(i);
  }
  function s() {
    var l = Date.now();
    if (r) {
      if (l - a < XY)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(o, e);
    a = l;
  }
  return s;
}
var KY = 20, YY = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], ZY = typeof MutationObserver < "u", JY = (
  /** @class */
  (function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = QY(this.refresh.bind(this), KY);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var r = this.observers_, n = r.indexOf(e);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return e.forEach(function(r) {
        return r.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !ua || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), ZY ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !ua || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var r = e.propertyName, n = r === void 0 ? "" : r, a = YY.some(function(i) {
        return !!~n.indexOf(i);
      });
      a && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  })()
), Ou = (function(t, e) {
  for (var r = 0, n = Object.keys(e); r < n.length; r++) {
    var a = n[r];
    Object.defineProperty(t, a, {
      value: e[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}), Ot = (function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || Pr;
}), Du = Zr(0, 0, 0, 0);
function _r(t) {
  return parseFloat(t) || 0;
}
function Fo(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  return e.reduce(function(n, a) {
    var i = t["border-" + a + "-width"];
    return n + _r(i);
  }, 0);
}
function eZ(t) {
  for (var e = ["top", "right", "bottom", "left"], r = {}, n = 0, a = e; n < a.length; n++) {
    var i = a[n], o = t["padding-" + i];
    r[i] = _r(o);
  }
  return r;
}
function tZ(t) {
  var e = t.getBBox();
  return Zr(0, 0, e.width, e.height);
}
function rZ(t) {
  var e = t.clientWidth, r = t.clientHeight;
  if (!e && !r)
    return Du;
  var n = Ot(t).getComputedStyle(t), a = eZ(n), i = a.left + a.right, o = a.top + a.bottom, s = _r(n.width), l = _r(n.height);
  if (n.boxSizing === "border-box" && (Math.round(s + i) !== e && (s -= Fo(n, "left", "right") + i), Math.round(l + o) !== r && (l -= Fo(n, "top", "bottom") + o)), !aZ(t)) {
    var u = Math.round(s + i) - e, c = Math.round(l + o) - r;
    Math.abs(u) !== 1 && (s -= u), Math.abs(c) !== 1 && (l -= c);
  }
  return Zr(a.left, a.top, s, l);
}
var nZ = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof Ot(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof Ot(t).SVGElement && typeof t.getBBox == "function";
  };
})();
function aZ(t) {
  return t === Ot(t).document.documentElement;
}
function iZ(t) {
  return ua ? nZ(t) ? tZ(t) : rZ(t) : Du;
}
function oZ(t) {
  var e = t.x, r = t.y, n = t.width, a = t.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, o = Object.create(i.prototype);
  return Ou(o, {
    x: e,
    y: r,
    width: n,
    height: a,
    top: r,
    right: e + n,
    bottom: a + r,
    left: e
  }), o;
}
function Zr(t, e, r, n) {
  return { x: t, y: e, width: r, height: n };
}
var sZ = (
  /** @class */
  (function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Zr(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = iZ(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  })()
), lZ = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, r) {
      var n = oZ(r);
      Ou(this, { target: e, contentRect: n });
    }
    return t;
  })()
), uZ = (
  /** @class */
  (function() {
    function t(e, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new Su(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = r, this.callbackCtx_ = n;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Ot(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(e) || (r.set(e, new sZ(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Ot(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(e) && (r.delete(e), r.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && e.activeObservations_.push(r);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new lZ(n.target, n.broadcastRect());
        });
        this.callback_.call(e, r, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  })()
), Iu = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Su(), Nu = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = JY.getInstance(), n = new uZ(e, r, this);
      Iu.set(this, n);
    }
    return t;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  Nu.prototype[t] = function() {
    var e;
    return (e = Iu.get(this))[t].apply(e, arguments);
  };
});
var cZ = (function() {
  return typeof Pr.ResizeObserver < "u" ? Pr.ResizeObserver : Nu;
})(), vZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.execCommand = function(r) {
      var n = Se(r.target, "li");
      this.props.execCommand("heading", {
        level: Number(n.getAttribute("data-level"))
      });
    }, e.prototype.render = function() {
      var r = this;
      return B(Vo || (Vo = R([`
      <ul
        onClick=`, `
        aria-role="menu"
        aria-label="`, `"
      >
        `, `
        <li data-type="Paragraph" aria-role="menuitem">
          <div>`, `</div>
        </li>
      </ul>
    `], [
        `
      <ul
        onClick=`,
        `
        aria-role="menu"
        aria-label="`,
        `"
      >
        `,
        `
        <li data-type="Paragraph" aria-role="menuitem">
          <div>`,
        `</div>
        </li>
      </ul>
    `
      ])), function(n) {
        return r.execCommand(n);
      }, D.get("Headings"), [1, 2, 3, 4, 5, 6].map(function(n) {
        return B(Uo || (Uo = R([`
              <li data-level="`, `" data-type="Heading" aria-role="menuitem">
                <`, ">", " ", `</$>
              </li>
            `], [`
              <li data-level="`, `" data-type="Heading" aria-role="menuitem">
                <`, ">", " ", `</$>
              </li>
            `])), n, "h" + n, D.get("Heading"), n);
      }), D.get("Paragraph"));
    }, e;
  })(le)
), Uo, Vo, Ru = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.toggleTab = function(r, n) {
      this.props.onClick(r, n);
    }, e.prototype.render = function() {
      var r = this;
      return B(zo || (zo = R([`
      <div class="`, `" aria-role="tabpanel">
        `, `
      </div>
    `], [
        `
      <div class="`,
        `" aria-role="tabpanel">
        `,
        `
      </div>
    `
      ])), L("tabs"), this.props.tabs.map(function(n) {
        var a = n.name, i = n.text, o = r.props.activeTab === a;
        return B(jo || (jo = R([`
            <div
              class="tab-item`, `"
              onClick=`, `
              aria-role="tab"
              aria-label="`, `"
              aria-selected="`, `"
              tabindex="`, `"
            >
              `, `
            </div>
          `], [`
            <div
              class="tab-item`, `"
              onClick=`, `
              aria-role="tab"
              aria-label="`, `"
              aria-selected="`, `"
              tabindex="`, `"
            >
              `, `
            </div>
          `])), o ? " active" : "", function(s) {
          return r.toggleTab(s, a);
        }, D.get(i), o ? "true" : "false", o ? "0" : "-1", D.get(i));
      }));
    }, e;
  })(le)
), jo, zo, fZ = "ui", dZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.initialize = function(a) {
        a === void 0 && (a = "file");
        var i = n.refs.url;
        i.value = "", n.refs.altText.value = "", n.refs.file.value = "", ye(i, "wrong"), n.setState({ activeTab: a, file: null, fileNameElClassName: "" });
      }, n.execCommand = function() {
        n.state.activeTab === "file" ? n.emitAddImageBlob() : n.emitAddImage();
      }, n.toggleTab = function(a, i) {
        i !== n.state.activeTab && n.initialize(i);
      }, n.showFileSelectBox = function() {
        n.refs.file.click();
      }, n.changeFile = function(a) {
        var i = a.target.files;
        i?.length && n.setState({ file: i[0] });
      }, n.state = { activeTab: "file", file: null, fileNameElClassName: "" }, n.tabs = [
        { name: "file", text: "File" },
        { name: "url", text: "URL" }
      ], n;
    }
    return e.prototype.emitAddImageBlob = function() {
      var r = this, n = this.refs.file.files, a = this.refs.altText, i = " wrong";
      if (n?.length) {
        i = "";
        var o = n.item(0), s = function(l, u) {
          return r.props.execCommand("addImage", { imageUrl: l, altText: u || a.value });
        };
        this.props.eventEmitter.emit("addImageBlobHook", o, s, fZ);
      }
      this.setState({ fileNameElClassName: i });
    }, e.prototype.emitAddImage = function() {
      var r = this.refs.url, n = this.refs.altText, a = r.value, i = n.value || "image";
      if (ye(r, "wrong"), !a.length) {
        Ae(r, "wrong");
        return;
      }
      a && this.props.execCommand("addImage", { imageUrl: a, altText: i });
    }, e.prototype.preventSelectStart = function(r) {
      r.preventDefault();
    }, e.prototype.updated = function() {
      this.props.show || this.initialize();
    }, e.prototype.render = function() {
      var r = this, n = this.state, a = n.activeTab, i = n.file, o = n.fileNameElClassName;
      return B(Wo || (Wo = R([`
      <div aria-label="`, `">
        <`, " tabs=", " activeTab=", " onClick=", ` />
        <div style="display:`, `">
          <label for="toastuiImageUrlInput">`, `</label>
          <input
            id="toastuiImageUrlInput"
            type="text"
            ref=`, `
          />
        </div>
        <div style="display:`, `;position: relative;">
          <label for="toastuiImageFileInput">`, `</label>
          <span
            class="`, "", `"
            onClick=`, `
            onSelectstart=`, `
          >
            `, `
          </span>
          <button
            type="button"
            class="`, `"
            onClick=`, `
          >
            `, `
          </button>
          <input
            id="toastuiImageFileInput"
            type="file"
            accept="image/*"
            onChange=`, `
            ref=`, `
          />
        </div>
        <label for="toastuiAltTextInput">`, `</label>
        <input
          id="toastuiAltTextInput"
          type="text"
          ref=`, `
        />
        <div class="`, `">
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
        </div>
      </div>
    `], [`
      <div aria-label="`, `">
        <`, " tabs=", " activeTab=", " onClick=", ` />
        <div style="display:`, `">
          <label for="toastuiImageUrlInput">`, `</label>
          <input
            id="toastuiImageUrlInput"
            type="text"
            ref=`, `
          />
        </div>
        <div style="display:`, `;position: relative;">
          <label for="toastuiImageFileInput">`, `</label>
          <span
            class="`, "", `"
            onClick=`, `
            onSelectstart=`, `
          >
            `, `
          </span>
          <button
            type="button"
            class="`, `"
            onClick=`, `
          >
            `, `
          </button>
          <input
            id="toastuiImageFileInput"
            type="file"
            accept="image/*"
            onChange=`, `
            ref=`, `
          />
        </div>
        <label for="toastuiAltTextInput">`, `</label>
        <input
          id="toastuiAltTextInput"
          type="text"
          ref=`, `
        />
        <div class="`, `">
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
        </div>
      </div>
    `])), D.get("Insert image"), Ru, this.tabs, a, this.toggleTab, a === "url" ? "block" : "none", D.get("Image URL"), function(s) {
        return r.refs.url = s;
      }, a === "file" ? "block" : "none", D.get("Select image file"), L("file-name"), i ? " has-file" : o, this.showFileSelectBox, this.preventSelectStart, i ? i.name : D.get("No file"), L("file-select-button"), this.showFileSelectBox, D.get("Choose a file"), this.changeFile, function(s) {
        return r.refs.file = s;
      }, D.get("Description"), function(s) {
        return r.refs.altText = s;
      }, L("button-container"), L("close-button"), this.props.hidePopup, D.get("Cancel"), L("ok-button"), this.execCommand, D.get("OK"));
    }, e;
  })(le)
), Wo, pZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.execCommand = function() {
        var n = r.refs.url, a = r.refs.text;
        if (ye(n, "wrong"), ye(a, "wrong"), n.value.length < 1) {
          Ae(n, "wrong");
          return;
        }
        var i = Te(r.props.initialValues.linkUrl);
        if (i && a.value.length < 1) {
          Ae(a, "wrong");
          return;
        }
        r.props.execCommand("addLink", {
          linkUrl: n.value,
          linkText: a.value
        });
      }, r;
    }
    return e.prototype.initialize = function() {
      var r = this.props.initialValues, n = r.linkUrl, a = r.linkText, i = this.refs.url, o = this.refs.text;
      ye(i, "wrong"), ye(o, "wrong", "disabled"), o.removeAttribute("disabled"), n && (Ae(o, "disabled"), o.setAttribute("disabled", "disabled")), i.value = n || "", o.value = a || "";
    }, e.prototype.mounted = function() {
      this.initialize();
    }, e.prototype.updated = function(r) {
      !r.show && this.props.show && this.initialize();
    }, e.prototype.render = function() {
      var r = this;
      return B(Go || (Go = R([`
      <div aria-label="`, `">
        <label for="toastuiLinkUrlInput">`, `</label>
        <input
          id="toastuiLinkUrlInput"
          type="text"
          ref=`, `
        />
        <label for="toastuiLinkTextInput">`, `</label>
        <input
          id="toastuiLinkTextInput"
          type="text"
          ref=`, `
        />
        <div class="`, `">
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
        </div>
      </div>
    `], [`
      <div aria-label="`, `">
        <label for="toastuiLinkUrlInput">`, `</label>
        <input
          id="toastuiLinkUrlInput"
          type="text"
          ref=`, `
        />
        <label for="toastuiLinkTextInput">`, `</label>
        <input
          id="toastuiLinkTextInput"
          type="text"
          ref=`, `
        />
        <div class="`, `">
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
          <button type="button" class="`, '" onClick=', `>
            `, `
          </button>
        </div>
      </div>
    `])), D.get("Insert link"), D.get("URL"), function(n) {
        return r.refs.url = n;
      }, D.get("Link text"), function(n) {
        return r.refs.text = n;
      }, L("button-container"), L("close-button"), this.props.hidePopup, D.get("Cancel"), L("ok-button"), this.execCommand, D.get("OK"));
    }, e;
  })(le)
), Go, Xo = 20, Qo = 20, Ko = 5, Yo = 14, Zo = 5, Jo = 9, hZ = 1, mZ = 1, es = 1, gZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.extendSelectionRange = function(a) {
        var i = a.pageX, o = a.pageY, s = i - n.offsetRect.left, l = o - n.offsetRect.top, u = n.getSelectionRangeByOffset(s, l);
        n.setState(b({}, u));
      }, n.execCommand = function() {
        n.props.execCommand("addTable", {
          rowCount: n.state.rowIdx + 1,
          columnCount: n.state.colIdx + 1
        });
      }, n.state = {
        rowIdx: -1,
        colIdx: -1
      }, n;
    }
    return e.prototype.getDescription = function() {
      return this.state.colIdx === -1 ? "" : this.state.colIdx + 1 + " x " + (this.state.rowIdx + 1);
    }, e.prototype.getBoundByRange = function(r, n) {
      return {
        width: (r + 1) * Xo,
        height: (n + 1) * Qo
      };
    }, e.prototype.getRangeByOffset = function(r, n) {
      return {
        colIdx: Math.floor(r / Xo),
        rowIdx: Math.floor(n / Qo)
      };
    }, e.prototype.getTableRange = function() {
      var r = this.state, n = r.colIdx, a = r.rowIdx, i = Math.max(n, Zo), o = Math.max(a, Ko);
      return n >= Zo && i < Jo && (i += 1), a >= Ko && o < Yo && (o += 1), { colIdx: i + 1, rowIdx: o + 1 };
    }, e.prototype.getSelectionAreaBound = function() {
      var r = this.getBoundByRange(this.state.colIdx, this.state.rowIdx), n = r.width, a = r.height;
      return !n && !a ? { display: "none" } : { width: n - es, height: a - es, display: "block" };
    }, e.prototype.getSelectionRangeByOffset = function(r, n) {
      var a = this.getRangeByOffset(r, n);
      return a.rowIdx = Math.min(Math.max(a.rowIdx, hZ), Yo), a.colIdx = Math.min(Math.max(a.colIdx, mZ), Jo), a;
    }, e.prototype.updated = function() {
      if (!this.props.show)
        this.setState({ colIdx: -1, rowIdx: -1 });
      else if (this.state.colIdx === -1 && this.state.rowIdx === -1) {
        var r = this.refs.tableEl.getBoundingClientRect(), n = r.left, a = r.top;
        this.offsetRect = {
          left: window.pageXOffset + n,
          top: window.pageYOffset + a
        };
      }
    }, e.prototype.createTableArea = function(r) {
      for (var n = r.colIdx, a = r.rowIdx, i = [], o = 0; o < a; o += 1) {
        for (var s = [], l = 0; l < n; l += 1) {
          var u = "" + L("table-cell") + (o > 0 ? "" : " header");
          s.push(B(ts || (ts = R(['<div class="', '"></div>'], ['<div class="', '"></div>'])), u));
        }
        i.push(B(rs || (rs = R(['<div class="', '">', "</div>"], ['<div class="', '">', "</div>"])), L("table-row"), s));
      }
      return B(ns || (ns = R(['<div class="', '">', "</div>"], ['<div class="', '">', "</div>"])), L("table"), i);
    }, e.prototype.render = function() {
      var r = this, n = this.getTableRange(), a = this.getSelectionAreaBound();
      return B(as || (as = R([`
      <div aria-label="`, `">
        <div
          class="`, `"
          ref=`, `
          onMousemove=`, `
          onClick=`, `
        >
          `, `
          <div class="`, '" style=', `></div>
        </div>
        <p class="`, '">', `</p>
      </div>
    `], [`
      <div aria-label="`, `">
        <div
          class="`, `"
          ref=`, `
          onMousemove=`, `
          onClick=`, `
        >
          `, `
          <div class="`, '" style=', `></div>
        </div>
        <p class="`, '">', `</p>
      </div>
    `])), D.get("Insert table"), L("table-selection"), function(i) {
        return r.refs.tableEl = i;
      }, this.extendSelectionRange, this.execCommand, this.createTableArea(n), L("table-selection-layer"), a, L("table-description"), this.getDescription());
    }, e;
  })(le)
), ts, rs, ns, as, yZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.mounted = function() {
      this.refs.el.appendChild(this.props.body);
    }, e.prototype.updated = function(r) {
      this.refs.el.replaceChild(this.props.body, r.body);
    }, e.prototype.render = function() {
      var r = this;
      return B(is || (is = R(["<div ref=", "></div>"], ["<div ref=", "></div>"])), function(n) {
        return r.refs.el = n;
      });
    }, e;
  })(le)
), is;
function ca(t) {
  return Fe(t) ? wZ(t) : t;
}
function bZ() {
  var t = document.createElement("label"), e = document.createElement("input"), r = document.createElement("span");
  t.className = "scroll-sync active", e.type = "checkbox", e.checked = !0, r.className = "switch";
  var n = function(a) {
    return e.addEventListener("change", function(i) {
      var o = i.target.checked;
      o ? Ae(t, "active") : ye(t, "active"), a("toggleScrollSync", { active: o });
    });
  };
  return t.appendChild(e), t.appendChild(r), {
    name: "scrollSync",
    el: t,
    onMounted: n
  };
}
function wZ(t) {
  var e;
  switch (t) {
    case "heading":
      e = {
        name: "heading",
        className: "heading",
        tooltip: D.get("Headings"),
        state: "heading"
      };
      break;
    case "bold":
      e = {
        name: "bold",
        className: "bold",
        command: "bold",
        tooltip: D.get("Bold"),
        state: "strong"
      };
      break;
    case "italic":
      e = {
        name: "italic",
        className: "italic",
        command: "italic",
        tooltip: D.get("Italic"),
        state: "emph"
      };
      break;
    case "strike":
      e = {
        name: "strike",
        className: "strike",
        command: "strike",
        tooltip: D.get("Strike"),
        state: "strike"
      };
      break;
    case "hr":
      e = {
        name: "hr",
        className: "hrline",
        command: "hr",
        tooltip: D.get("Line"),
        state: "thematicBreak"
      };
      break;
    case "quote":
      e = {
        name: "quote",
        className: "quote",
        command: "blockQuote",
        tooltip: D.get("Blockquote"),
        state: "blockQuote"
      };
      break;
    case "ul":
      e = {
        name: "ul",
        className: "bullet-list",
        command: "bulletList",
        tooltip: D.get("Unordered list"),
        state: "bulletList"
      };
      break;
    case "ol":
      e = {
        name: "ol",
        className: "ordered-list",
        command: "orderedList",
        tooltip: D.get("Ordered list"),
        state: "orderedList"
      };
      break;
    case "task":
      e = {
        name: "task",
        className: "task-list",
        command: "taskList",
        tooltip: D.get("Task"),
        state: "taskList"
      };
      break;
    case "table":
      e = {
        name: "table",
        className: "table",
        tooltip: D.get("Insert table"),
        state: "table"
      };
      break;
    case "image":
      e = {
        name: "image",
        className: "image",
        tooltip: D.get("Insert image")
      };
      break;
    case "link":
      e = {
        name: "link",
        className: "link",
        tooltip: D.get("Insert link")
      };
      break;
    case "code":
      e = {
        name: "code",
        className: "code",
        command: "code",
        tooltip: D.get("Code"),
        state: "code"
      };
      break;
    case "codeblock":
      e = {
        name: "codeblock",
        className: "codeblock",
        command: "codeBlock",
        tooltip: D.get("Insert CodeBlock"),
        state: "codeBlock"
      };
      break;
    case "indent":
      e = {
        name: "indent",
        className: "indent",
        command: "indent",
        tooltip: D.get("Indent"),
        state: "indent"
      };
      break;
    case "outdent":
      e = {
        name: "outdent",
        className: "outdent",
        command: "outdent",
        tooltip: D.get("Outdent"),
        state: "outdent"
      };
      break;
    case "scrollSync":
      e = bZ();
      break;
    case "more":
      e = {
        name: "more",
        className: "more",
        tooltip: D.get("More")
      };
      break;
  }
  return e.name !== "scrollSync" && (e.className += " " + L("toolbar-icons")), e;
}
function za(t, e) {
  var r = e.el, n = e.pos, a = e.popup, i = e.initialValues;
  switch (t) {
    case "heading":
      return {
        render: function(o) {
          return B(os || (os = R(["<", " ...", " />"], ["<", " ...", " />"])), vZ, o);
        },
        className: L("popup-add-heading"),
        fromEl: r,
        pos: n
      };
    case "link":
      return {
        render: function(o) {
          return B(ss || (ss = R(["<", " ...", " />"], ["<", " ...", " />"])), pZ, o);
        },
        className: L("popup-add-link"),
        fromEl: r,
        pos: n,
        initialValues: i
      };
    case "image":
      return {
        render: function(o) {
          return B(ls || (ls = R(["<", " ...", " />"], ["<", " ...", " />"])), dZ, o);
        },
        className: L("popup-add-image"),
        fromEl: r,
        pos: n
      };
    case "table":
      return {
        render: function(o) {
          return B(us || (us = R(["<", " ...", " />"], ["<", " ...", " />"])), gZ, o);
        },
        className: L("popup-add-table"),
        fromEl: r,
        pos: n
      };
    case "customPopupBody":
      return a ? b({ render: function(o) {
        return B(cs || (cs = R(["<", " ...", " body=", " />"], ["<", " ...", " body=", " />"])), yZ, o, a.body);
      }, fromEl: r, pos: n }, a) : null;
    default:
      return null;
  }
}
function qr(t) {
  t.hidden = t.length === t.filter(function(e) {
    return e.hidden;
  }).length;
}
function CZ(t, e) {
  var r = function(n) {
    return n.hidden = n.name === "scrollSync" && e, n;
  };
  return t.reduce(function(n, a) {
    n.push(a.map(function(o) {
      return r(ca(o));
    }));
    var i = n[(n.length || 1) - 1];
    return i && qr(i), n;
  }, []);
}
function TZ(t, e) {
  t.forEach(function(r) {
    r.forEach(function(n) {
      return n.hidden = n.name === "scrollSync" && e;
    }), qr(r);
  });
}
var os, ss, ls, us, cs, kZ = 20, EZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.handleMousedown = function(n) {
        !Se(n.target, "." + L("popup")) && !Se(n.target, r.props.info.fromEl) && r.props.hidePopup();
      }, r;
    }
    return e.prototype.mounted = function() {
      document.addEventListener("mousedown", this.handleMousedown), this.props.eventEmitter.listen("closePopup", this.props.hidePopup);
    }, e.prototype.beforeDestroy = function() {
      document.removeEventListener("mousedown", this.handleMousedown);
    }, e.prototype.updated = function(r) {
      var n = this.props, a = n.show, i = n.info;
      if (a && i.pos && r.show !== a) {
        var o = b({}, i.pos), s = this.refs.el.offsetWidth, l = Se(this.refs.el, "." + L("toolbar")), u = l.offsetWidth;
        o.left + s >= u && (o.left = u - s - kZ), ya(this.state.popupPos, o) || this.setState({ popupPos: o });
      }
    }, e.prototype.render = function() {
      var r = this, n = this.props, a = n.info, i = n.show, o = n.hidePopup, s = n.eventEmitter, l = n.execCommand, u = a || {}, c = u.className, v = c === void 0 ? "" : c, f = u.style, d = u.render, p = u.initialValues, h = p === void 0 ? {} : p, m = b(b({ display: i ? "block" : "none" }, f), this.state.popupPos);
      return B(vs || (vs = R([`
      <div
        class="`, " ", `"
        style=`, `
        ref=`, `
        aria-role="dialog"
      >
        <div class="`, `">
          `, `
        </div>
      </div>
    `], [`
      <div
        class="`, " ", `"
        style=`, `
        ref=`, `
        aria-role="dialog"
      >
        <div class="`, `">
          `, `
        </div>
      </div>
    `])), L("popup"), v, m, function(y) {
        return r.refs.el = y;
      }, L("popup-body"), d && d({ eventEmitter: s, show: i, hidePopup: o, execCommand: l, initialValues: h }));
    }, e;
  })(le)
), vs, fs = 6;
function Wa(t) {
  return (
    /** @class */
    (function(e) {
      x(r, e);
      function r(n) {
        var a = e.call(this, n) || this;
        return a.showTooltip = function(i) {
          var o = a.props.item.tooltip;
          if (!a.props.disabled && o) {
            var s = a.getBound(i), l = s.left + fs + "px", u = s.top + fs + "px";
            Oe(a.props.tooltipRef.current, { display: "block", left: l, top: u }), a.props.tooltipRef.current.querySelector(".text").textContent = o;
          }
        }, a.hideTooltip = function() {
          Oe(a.props.tooltipRef.current, "display", "none");
        }, a.state = { active: !1, disabled: n.disabled }, a.addEvent(), a;
      }
      return r.prototype.addEvent = function() {
        var n = this, a = this.props, i = a.item, o = a.eventEmitter;
        i.state && o.listen("changeToolbarState", function(s) {
          var l, u = s.toolbarState, c = (l = u[i.state]) !== null && l !== void 0 ? l : {}, v = c.active, f = c.disabled;
          n.setState({ active: !!v, disabled: f ?? n.props.disabled });
        });
      }, r.prototype.getBound = function(n) {
        var a = el(n, Se(n, "." + L("toolbar"))), i = a.offsetLeft, o = a.offsetTop;
        return { left: i, top: n.offsetHeight + o };
      }, r.prototype.render = function() {
        return B(ds || (ds = R([`
        <`, `
          ...`, `
          active=`, `
          showTooltip=`, `
          hideTooltip=`, `
          getBound=`, `
          disabled=`, `
        />
      `], [`
        <`, `
          ...`, `
          active=`, `
          showTooltip=`, `
          hideTooltip=`, `
          getBound=`, `
          disabled=`, `
        />
      `])), t, this.props, this.state.active, this.showTooltip, this.hideTooltip, this.getBound, this.state.disabled || this.props.disabled);
      }, r;
    })(le)
  );
}
var ds, xZ = 80, LZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.showTooltip = function() {
        r.props.showTooltip(r.refs.el);
      }, r.execCommand = function() {
        var n = r.props, a = n.item, i = n.execCommand, o = n.setPopupInfo, s = n.getBound, l = n.eventEmitter, u = a.command, c = a.name, v = a.popup;
        if (u)
          i(u);
        else {
          var f = v ? "customPopupBody" : c, d = l.emit("query", "getPopupInitialValues", { popupName: f })[0], p = za(f, {
            el: r.refs.el,
            pos: s(r.refs.el),
            popup: v,
            initialValues: d
          });
          p && o(p);
        }
      }, r;
    }
    return e.prototype.mounted = function() {
      this.setItemWidth();
    }, e.prototype.updated = function(r) {
      r.item.name !== this.props.item.name && this.setItemWidth();
    }, e.prototype.setItemWidth = function() {
      var r = this.props, n = r.setItemWidth, a = r.item;
      n && n(a.name, Ma(this.refs.el) + (a.hidden ? xZ : 0));
    }, e.prototype.render = function() {
      var r = this, n = this.props, a = n.hideTooltip, i = n.disabled, o = n.item, s = n.active, l = b({ display: o.hidden ? "none" : null }, o.style), u = "" + (o.className || "") + (s ? " active" : "");
      return B(ps || (ps = R([`
      <button
        ref=`, `
        type="button"
        style=`, `
        class=`, `
        onClick=`, `
        onMouseover=`, `
        onMouseout=`, `
        disabled=`, `
        aria-label=`, `
      >
        `, `
      </button>
    `], [`
      <button
        ref=`, `
        type="button"
        style=`, `
        class=`, `
        onClick=`, `
        onMouseover=`, `
        onMouseout=`, `
        disabled=`, `
        aria-label=`, `
      >
        `, `
      </button>
    `])), function(c) {
        return r.refs.el = c;
      }, l, u, this.execCommand, this.showTooltip, a, !!i, o.text || o.tooltip || "", o.text || "");
    }, e;
  })(le)
), MZ = Wa(LZ), ps, AZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.showTooltip = function() {
        r.props.showTooltip(r.refs.el);
      }, r.showPopup = function() {
        var n = za("customPopupBody", {
          el: r.refs.el,
          pos: r.props.getBound(r.refs.el),
          popup: r.props.item.popup
        });
        n && r.props.setPopupInfo(n);
      }, r;
    }
    return e.prototype.mounted = function() {
      var r = this.props, n = r.setItemWidth, a = r.item;
      this.refs.el.appendChild(a.el), n && n(a.name, Ma(this.refs.el)), a.onMounted && a.onMounted(this.props.execCommand);
    }, e.prototype.updated = function(r) {
      var n, a = this.props, i = a.item, o = a.active, s = a.disabled;
      (r.active !== o || r.disabled !== s) && ((n = i.onUpdated) === null || n === void 0 || n.call(i, { active: o, disabled: s }));
    }, e.prototype.render = function() {
      var r = this, n = this.props, a = n.disabled, i = n.item, o = { display: i.hidden ? "none" : "inline-block" }, s = function(l) {
        return a ? null : l;
      };
      return B(hs || (hs = R([`
      <div
        ref=`, `
        style=`, `
        class=`, `
        onClick=`, `
        onMouseover=`, `
        onMouseout=`, `
      ></div>
    `], [`
      <div
        ref=`, `
        style=`, `
        class=`, `
        onClick=`, `
        onMouseover=`, `
        onMouseout=`, `
      ></div>
    `])), function(l) {
        return r.refs.el = l;
      }, o, L("toolbar-item-wrapper"), s(this.showPopup), s(this.showTooltip), s(this.props.hideTooltip));
    }, e;
  })(le)
), SZ = Wa(AZ), hs, Bu = (
  /** @class */
  (function(t) {
    x(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.render = function() {
      var r = this, n = this.props, a = n.group, i = n.hiddenDivider, o = a.hidden ? { display: "none" } : null, s = i ? { display: "none" } : null;
      return B(gs || (gs = R([`
      <div class="`, '" style=', `>
        `, `
        <div class="`, '" style=', `></div>
      </div>
    `], [
        `
      <div class="`,
        '" style=',
        `>
        `,
        `
        <div class="`,
        '" style=',
        `></div>
      </div>
    `
      ])), L("toolbar-group"), o, a.map(function(l) {
        var u = l.el ? SZ : MZ;
        return B(ms || (ms = R(["<", " key=", " ...", " item=", " />"], ["<", " key=", " ...", " item=", " />"])), u, l.name, r.props, l);
      }), L("toolbar-divider"), s);
    }, e;
  })(le)
), ms, gs, OZ = 4, DZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.handleClickDocument = function(a) {
        var i = a.target;
        !Se(i, "." + L("dropdown-toolbar")) && !Se(i, ".more") && n.setState({ showDropdown: !1, dropdownPos: null });
      }, n.showTooltip = function() {
        n.props.showTooltip(n.refs.el);
      }, n.state = { showDropdown: !1, dropdownPos: null }, n;
    }
    return e.prototype.getBound = function() {
      var r = this.props.getBound(this.refs.el);
      return r.top += OZ, b(b({}, r), { left: null, right: 10 });
    }, e.prototype.mounted = function() {
      document.addEventListener("click", this.handleClickDocument);
    }, e.prototype.updated = function() {
      this.state.showDropdown && !this.state.dropdownPos && this.setState({ dropdownPos: this.getBound() });
    }, e.prototype.beforeDestroy = function() {
      document.removeEventListener("click", this.handleClickDocument);
    }, e.prototype.render = function() {
      var r = this, n = this.state, a = n.showDropdown, i = n.dropdownPos, o = this.props, s = o.disabled, l = o.item, u = o.items, c = o.hideTooltip, v = u.filter(function(p) {
        return !p.hidden;
      }), f = v.length ? null : { display: "none" }, d = a ? null : { display: "none" };
      return B(bs || (bs = R([`
      <div class="`, '" style=', `>
        <button
          ref=`, `
          type="button"
          class=`, `
          onClick=`, `
          onMouseover=`, `
          onMouseout=`, `
          disabled=`, `
        ></button>
        <div
          class="`, `"
          style=`, `
          ref=`, `
        >
          `, `
        </div>
      </div>
    `], [
        `
      <div class="`,
        '" style=',
        `>
        <button
          ref=`,
        `
          type="button"
          class=`,
        `
          onClick=`,
        `
          onMouseover=`,
        `
          onMouseout=`,
        `
          disabled=`,
        `
        ></button>
        <div
          class="`,
        `"
          style=`,
        `
          ref=`,
        `
        >
          `,
        `
        </div>
      </div>
    `
      ])), L("toolbar-group"), f, function(p) {
        return r.refs.el = p;
      }, l.className, function() {
        return r.setState({ showDropdown: !0 });
      }, this.showTooltip, c, s, L("dropdown-toolbar"), b(b({}, d), i), function(p) {
        return r.refs.dropdownEl = p;
      }, v.length ? v.map(function(p, h) {
        var m;
        return B(ys || (ys = R([`
                  <`, `
                    group=`, `
                    hiddenDivider=`, `
                    ...`, `
                  />
                `], [
          `
                  <`,
          `
                    group=`,
          `
                    hiddenDivider=`,
          `
                    ...`,
          `
                  />
                `
        ])), Bu, p, h === v.length - 1 || ((m = v[h + 1]) === null || m === void 0 ? void 0 : m.hidden), r.props);
      }) : null);
    }, e;
  })(le)
), IZ = Wa(DZ), ys, bs, NZ = 50, RZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.toggleTab = function(a, i) {
        var o = n.props.eventEmitter;
        if (n.state.activeTab !== i) {
          var s = i === "write" ? "changePreviewTabWrite" : "changePreviewTabPreview";
          o.emit(s), n.setState({ activeTab: i });
        }
      }, n.setItemWidth = function(a, i) {
        n.itemWidthMap[a] = i;
      }, n.setPopupInfo = function(a) {
        n.setState({ showPopup: !0, popupInfo: a });
      }, n.openPopup = function(a, i) {
        i === void 0 && (i = {});
        var o = n.refs.el.querySelector("." + L("toolbar-group") + " ." + a);
        if (o) {
          var s = el(o, Se(o, "." + L("toolbar"))), l = s.offsetLeft, u = s.offsetTop, c = za(a, {
            el: o,
            pos: { left: l, top: o.offsetHeight + u },
            initialValues: i
          });
          c && n.setPopupInfo(c);
        }
      }, n.hidePopup = function() {
        n.state.showPopup && n.setState({ showPopup: !1 });
      }, n.execCommand = function(a, i) {
        var o = n.props.eventEmitter;
        o.emit("command", a, i), n.hidePopup();
      }, n.tabs = [
        { name: "write", text: "Write" },
        { name: "preview", text: "Preview" }
      ], n.itemWidthMap = {}, n.initialItems = CZ(r.toolbarItems || [], n.hiddenScrollSync()), n.state = {
        items: n.initialItems,
        dropdownItems: [],
        showPopup: !1,
        popupInfo: {},
        activeTab: "write"
      }, n.tooltipRef = { current: null }, n.resizeObserver = new cZ(function() {
        return n.handleResize();
      }), n.addEvent(), n;
    }
    return e.prototype.insertToolbarItem = function(r, n) {
      var a = r.groupIndex, i = r.itemIndex, o = this.initialItems[a];
      n = ca(n), o ? o.splice(i, 0, n) : this.initialItems.push([n]), this.setState(this.classifyToolbarItems());
    }, e.prototype.removeToolbarItem = function(r) {
      var n = this;
      Tt(this.initialItems, function(a) {
        var i = !1;
        return Tt(a, function(o, s) {
          return o.name === r ? (i = !0, a.splice(s, 1), n.setState(n.classifyToolbarItems()), !1) : !0;
        }), !i;
      });
    }, e.prototype.addEvent = function() {
      var r = this, n = this.props.eventEmitter;
      this.handleResize = WY(function() {
        r.setState({ items: r.initialItems, dropdownItems: [] }), r.setState(r.classifyToolbarItems());
      }, 200), n.listen("openPopup", this.openPopup);
    }, e.prototype.appendTooltipToRoot = function() {
      var r = '<div class="' + L("tooltip") + `" style="display:none">
        <div class="arrow"></div>
        <span class="text"></span>
      </div>`;
      this.tooltipRef.current = Js(r, this.refs.el);
    }, e.prototype.hiddenScrollSync = function() {
      return this.props.editorType === "wysiwyg" || this.props.previewStyle === "tab";
    }, e.prototype.movePrevItemToDropdownToolbar = function(r, n, a, i) {
      var o = function(l) {
        var u = l.pop();
        u && i.push(u);
      };
      if (r > 1)
        o(a);
      else {
        var s = se(n);
        s && o(s);
      }
    }, e.prototype.classifyToolbarItems = function() {
      var r = this, n = 0, a = this.refs.el.clientWidth, i = this.refs.el.querySelector("." + L("toolbar-divider")), o = i ? Ma(i) : 0, s = [], l = [], u = !1;
      return this.initialItems.forEach(function(c, v) {
        var f = [], d = [];
        c.forEach(function(p, h) {
          p.hidden || (n += r.itemWidthMap[p.name], n > a - NZ ? (u || (r.movePrevItemToDropdownToolbar(h, s, f, d), u = !0), d.push(p)) : f.push(p));
        }), f.length && (qr(f), s.push(f)), d.length && (qr(d), l.push(d)), v < r.state.items.length - 1 && (n += o);
      }), { items: s, dropdownItems: l };
    }, e.prototype.mounted = function() {
      this.props.previewStyle === "tab" && this.props.eventEmitter.emit("changePreviewTabWrite", !0), this.setState(this.classifyToolbarItems()), this.appendTooltipToRoot(), this.resizeObserver.observe(this.refs.el);
    }, e.prototype.updated = function(r) {
      var n = this.props, a = n.editorType, i = n.previewStyle, o = n.eventEmitter, s = i !== r.previewStyle, l = a !== r.editorType;
      if (s || l) {
        TZ(this.initialItems, this.hiddenScrollSync());
        var u = this.classifyToolbarItems();
        (s || i === "tab" && a === "markdown") && (o.emit("changePreviewTabWrite"), u.activeTab = "write"), this.setState(u);
      }
    }, e.prototype.beforeDestroy = function() {
      window.removeEventListener("resize", this.handleResize), this.resizeObserver.disconnect(), nt(this.tooltipRef.current);
    }, e.prototype.render = function() {
      var r = this, n = this.props, a = n.previewStyle, i = n.eventEmitter, o = n.editorType, s = this.state, l = s.popupInfo, u = s.showPopup, c = s.activeTab, v = s.items, f = s.dropdownItems, d = {
        eventEmitter: i,
        tooltipRef: this.tooltipRef,
        disabled: o === "markdown" && a === "tab" && c === "preview",
        execCommand: this.execCommand,
        setPopupInfo: this.setPopupInfo
      }, p = a === "tab" ? { borderTopLeftRadius: 0 } : null;
      return B(Cs || (Cs = R([`
      <div class="`, `">
        <div
          class="`, `"
          style="display: `, `"
        >
          <`, " tabs=", " activeTab=", " onClick=", ` />
        </div>
        <div
          class="`, `"
          ref=`, `
          style=`, `
        >
          `, `
          <`, `
            item=`, `
            items=`, `
            ...`, `
          />
        </div>
        <`, `
          info=`, `
          show=`, `
          eventEmitter=`, `
          hidePopup=`, `
          execCommand=`, `
        />
      </div>
    `], [
        `
      <div class="`,
        `">
        <div
          class="`,
        `"
          style="display: `,
        `"
        >
          <`,
        " tabs=",
        " activeTab=",
        " onClick=",
        ` />
        </div>
        <div
          class="`,
        `"
          ref=`,
        `
          style=`,
        `
        >
          `,
        `
          <`,
        `
            item=`,
        `
            items=`,
        `
            ...`,
        `
          />
        </div>
        <`,
        `
          info=`,
        `
          show=`,
        `
          eventEmitter=`,
        `
          hidePopup=`,
        `
          execCommand=`,
        `
        />
      </div>
    `
      ])), L("toolbar"), L("md-tab-container"), o === "wysiwyg" || a === "vertical" ? "none" : "block", Ru, this.tabs, c, this.toggleTab, L("defaultUI-toolbar"), function(h) {
        return r.refs.el = h;
      }, p, v.map(function(h, m) {
        var y;
        return B(ws || (ws = R([`
              <`, `
                group=`, `
                hiddenDivider=`, `
                setItemWidth=`, `
                ...`, `
              />
            `], [`
              <`, `
                group=`, `
                hiddenDivider=`, `
                setItemWidth=`, `
                ...`, `
              />
            `])), Bu, h, m === v.length - 1 || ((y = v[m + 1]) === null || y === void 0 ? void 0 : y.hidden), r.setItemWidth, d);
      }), IZ, ca("more"), f, d, EZ, l, u, i, this.hidePopup, this.execCommand);
    }, e;
  })(le)
), ws, Cs, BZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      return n.handleClickDocument = function(a) {
        Se(a.target, "." + L("context-menu")) || n.setState({ pos: null });
      }, n.state = {
        pos: null,
        menuGroups: []
      }, n.addEvent(), n;
    }
    return e.prototype.addEvent = function() {
      var r = this;
      this.props.eventEmitter.listen("contextmenu", function(n) {
        var a = n.pos, i = n.menuGroups;
        r.setState({ pos: a, menuGroups: i });
      });
    }, e.prototype.mounted = function() {
      document.addEventListener("click", this.handleClickDocument);
    }, e.prototype.beforeDestroy = function() {
      document.removeEventListener("click", this.handleClickDocument);
    }, e.prototype.getMenuGroupElements = function() {
      var r = this, n = this.state, a = n.pos, i = n.menuGroups;
      return a ? i.reduce(function(o, s) {
        var l = [];
        return s.forEach(function(u) {
          var c = u.label, v = u.className, f = v === void 0 ? !1 : v, d = u.disabled, p = u.onClick, h = function() {
            d || (p(), r.setState({ pos: null }));
          };
          l.push(B(Ts || (Ts = R([`
                <li
                  onClick=`, `
                  class="menu-item`, `"
                  aria-role="menuitem"
                >
                  <span class="`, '">', `</span>
                </li>
              `], [`
                <li
                  onClick=`, `
                  class="menu-item`, `"
                  aria-role="menuitem"
                >
                  <span class="`, '">', `</span>
                </li>
              `])), h, d ? " disabled" : "", f, c));
        }), o.push(B(ks || (ks = R([`<ul class="menu-group">
              `, `
            </ul>`], [`<ul class="menu-group">
              `, `
            </ul>`])), l)), o;
      }, []) : [];
    }, e.prototype.render = function() {
      var r = b({ display: this.state.pos ? "block" : "none" }, this.state.pos);
      return B(Es || (Es = R(['<div class="', '" style=', ` aria-role="menu">
      `, `
    </div>`], ['<div class="', '" style=', ` aria-role="menu">
      `, `
    </div>`])), L("context-menu"), r, this.getMenuGroupElements());
    }, e;
  })(le)
), Ts, ks, Es, HZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n = t.call(this, r) || this;
      n.changeMode = function(o) {
        o !== n.state.editorType && n.setState({ editorType: o });
      }, n.changePreviewStyle = function(o) {
        o !== n.state.previewStyle && n.setState({ previewStyle: o });
      }, n.hide = function() {
        n.setState({ hide: !0 });
      }, n.show = function() {
        n.setState({ hide: !1 });
      };
      var a = r.editorType, i = r.previewStyle;
      return n.state = {
        editorType: a,
        previewStyle: i,
        hide: !1
      }, n.addEvent(), n;
    }
    return e.prototype.mounted = function() {
      var r = this.props.slots, n = r.wwEditor, a = r.mdEditor, i = r.mdPreview;
      this.refs.wwContainer.appendChild(n), this.refs.mdContainer.insertAdjacentElement("afterbegin", a), this.refs.mdContainer.appendChild(i);
    }, e.prototype.insertToolbarItem = function(r, n) {
      this.toolbar.insertToolbarItem(r, n);
    }, e.prototype.removeToolbarItem = function(r) {
      this.toolbar.removeToolbarItem(r);
    }, e.prototype.render = function() {
      var r = this, n = this.props, a = n.eventEmitter, i = n.hideModeSwitch, o = n.toolbarItems, s = n.theme, l = this.state, u = l.hide, c = l.previewStyle, v = l.editorType, f = u ? " hidden" : "", d = L(v === "markdown" ? "md-mode" : "ww-mode"), p = L("md") + "-" + c + "-style", h = L([s !== "light", s + " "]);
      return B(Ls || (Ls = R([`
      <div
        class="`, "", "", `"
        ref=`, `
      >
        <`, `
          ref=`, `
          eventEmitter=`, `
          previewStyle=`, `
          toolbarItems=`, `
          editorType=`, `
        />
        <div
          class="`, " ", `"
          ref=`, `
        >
          <div class="`, `">
            <div
              class="`, " ", `"
              ref=`, `
            >
              <div class="`, `"></div>
            </div>
            <div
              class="`, `"
              ref=`, `
            />
          </div>
        </div>
        `, `
        <`, " eventEmitter=", ` />
      </div>
    `], [
        `
      <div
        class="`,
        "",
        "",
        `"
        ref=`,
        `
      >
        <`,
        `
          ref=`,
        `
          eventEmitter=`,
        `
          previewStyle=`,
        `
          toolbarItems=`,
        `
          editorType=`,
        `
        />
        <div
          class="`,
        " ",
        `"
          ref=`,
        `
        >
          <div class="`,
        `">
            <div
              class="`,
        " ",
        `"
              ref=`,
        `
            >
              <div class="`,
        `"></div>
            </div>
            <div
              class="`,
        `"
              ref=`,
        `
            />
          </div>
        </div>
        `,
        `
        <`,
        " eventEmitter=",
        ` />
      </div>
    `
      ])), h, L("defaultUI"), f, function(m) {
        return r.refs.el = m;
      }, RZ, function(m) {
        return r.toolbar = m;
      }, a, c, o, v, L("main"), d, function(m) {
        return r.refs.editorSection = m;
      }, L("main-container"), L("md-container"), p, function(m) {
        return r.refs.mdContainer = m;
      }, L("md-splitter"), L("ww-container"), function(m) {
        return r.refs.wwContainer = m;
      }, !i && B(xs || (xs = R(["<", " eventEmitter=", " editorType=", " />"], ["<", " eventEmitter=", " editorType=", " />"])), FY, a, v), BZ, a);
    }, e.prototype.addEvent = function() {
      var r = this.props.eventEmitter;
      r.listen("hide", this.hide), r.listen("show", this.show), r.listen("changeMode", this.changeMode), r.listen("changePreviewStyle", this.changePreviewStyle);
    }, e;
  })(le)
), xs, Ls, WZ = (
  /** @class */
  (function(t) {
    x(e, t);
    function e(r) {
      var n, a = t.call(this, r) || this, i, o = $Y(a.options.el, B(Ms || (Ms = R([`
        <`, `
          ref=`, `
          eventEmitter=`, `
          slots=`, `
          hideModeSwitch=`, `
          toolbarItems=`, `
          previewStyle=`, `
          editorType=`, `
          theme=`, `
        />
      `], [`
        <`, `
          ref=`, `
          eventEmitter=`, `
          slots=`, `
          hideModeSwitch=`, `
          toolbarItems=`, `
          previewStyle=`, `
          editorType=`, `
          theme=`, `
        />
      `])), HZ, function(s) {
        return i = s;
      }, a.eventEmitter, a.getEditorElements(), a.options.hideModeSwitch, a.options.toolbarItems, a.options.previewStyle, a.options.initialEditType, a.options.theme));
      return a.setMinHeight(a.options.minHeight), a.setHeight(a.options.height), a.defaultUI = {
        insertToolbarItem: i.insertToolbarItem.bind(i),
        removeToolbarItem: i.removeToolbarItem.bind(i),
        destroy: o
      }, (n = a.pluginInfo.toolbarItems) === null || n === void 0 || n.forEach(function(s) {
        var l = s.groupIndex, u = s.itemIndex, c = s.item;
        a.defaultUI.insertToolbarItem({ groupIndex: l, itemIndex: u }, c);
      }), a.eventEmitter.emit("loadUI", a), a;
    }
    return e.factory = function(r) {
      return r.viewer ? new ku(r) : new e(r);
    }, e.prototype.insertToolbarItem = function(r, n) {
      this.defaultUI.insertToolbarItem(r, n);
    }, e.prototype.removeToolbarItem = function(r) {
      this.defaultUI.removeToolbarItem(r);
    }, e.prototype.destroy = function() {
      t.prototype.destroy.call(this), this.defaultUI.destroy();
    }, e;
  })(xu)
), Ms;
xu.setLanguage(["en", "en-US"], {
  Markdown: "Markdown",
  WYSIWYG: "WYSIWYG",
  Write: "Write",
  Preview: "Preview",
  Headings: "Headings",
  Paragraph: "Paragraph",
  Bold: "Bold",
  Italic: "Italic",
  Strike: "Strike",
  Code: "Inline code",
  Line: "Line",
  Blockquote: "Blockquote",
  "Unordered list": "Unordered list",
  "Ordered list": "Ordered list",
  Task: "Task",
  Indent: "Indent",
  Outdent: "Outdent",
  "Insert link": "Insert link",
  "Insert CodeBlock": "Insert codeBlock",
  "Insert table": "Insert table",
  "Insert image": "Insert image",
  Heading: "Heading",
  "Image URL": "Image URL",
  "Select image file": "Select image file",
  "Choose a file": "Choose a file",
  "No file": "No file",
  Description: "Description",
  OK: "OK",
  More: "More",
  Cancel: "Cancel",
  File: "File",
  URL: "URL",
  "Link text": "Link text",
  "Add row to up": "Add row to up",
  "Add row to down": "Add row to down",
  "Add column to left": "Add column to left",
  "Add column to right": "Add column to right",
  "Remove row": "Remove row",
  "Remove column": "Remove column",
  "Align column to left": "Align column to left",
  "Align column to center": "Align column to center",
  "Align column to right": "Align column to right",
  "Remove table": "Remove table",
  "Would you like to paste as table?": "Would you like to paste as table?",
  "Text color": "Text color",
  "Auto scroll enabled": "Auto scroll enabled",
  "Auto scroll disabled": "Auto scroll disabled",
  "Choose language": "Choose language"
});
export {
  WZ as Editor,
  xu as EditorCore,
  WZ as default
};
